/**
 * GQty AUTO-GENERATED CODE: PLEASE DO NOT MODIFY MANUALLY
 */

import type * as scalars from '../scalars.ts';
type Position = scalars.Position;

import { SchemaUnionsKey, type ScalarsEnumsHash } from 'gqty';

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** The `Byte` scalar type represents non-fractional whole numeric values. Byte can represent values between 0 and 255. */
  Byte: { input: any; output: any };
  /** A coordinate is an array of positions. */
  Coordinates: { input: any; output: any };
  /**
   * Represents a time zone - a mapping between UTC and local time.
   * A time zone maps UTC instants to local times - or, equivalently, to the offset from UTC at any particular instant.
   *
   * Example: `Europe/Zurich`
   */
  DateTimeZone: { input: scalars.DateTimeZone; output: scalars.DateTimeZone };
  /** The `Decimal` scalar type represents a decimal floating-point number. */
  Decimal: { input: any; output: any };
  /**
   * Represents a fixed (and calendar-independent) length of time.
   *
   * Allowed patterns:
   * - `-D:hh:mm:ss.sssssssss`
   *
   * Examples:
   * - `-1:20:00:00.999999999`
   */
  Duration: { input: scalars.Duration; output: scalars.Duration };
  Geometry: { input: any; output: any };
  /**
   * Represents an instant on the global timeline, with nanosecond resolution.
   *
   * Allowed patterns:
   * - `YYYY-MM-DDThh:mm:ss.sssssssss±hh:mm`
   *
   * Examples:
   * - `2000-01-01T20:00:00.999999999Z`
   */
  Instant: { input: scalars.Instant; output: scalars.Instant };
  /**
   * Equates the days of the week with their numerical value according to ISO-8601.
   *  Monday = 1, Tuesday = 2, Wednesday = 3, Thursday = 4, Friday = 5, Saturday = 6, Sunday = 7.
   */
  IsoDayOfWeek: { input: scalars.IsoDayOfWeek; output: scalars.IsoDayOfWeek };
  JSON: { input: scalars.JSON; output: scalars.JSON };
  /** The `LocalDate` scalar type represents a ISO date string, represented as UTF-8 character sequences YYYY-MM-DD. The scalar follows the specification defined in RFC3339 */
  LocalDate: { input: any; output: any };
  /**
   * LocalTime represents a time of day, with no reference to a particular calendar, time zone, or date.
   *
   * Allowed patterns:
   * - `hh:mm:ss.sssssssss`
   *
   * Examples:
   * - `20:00:00.999`
   */
  LocalTime: { input: any; output: any };
  /** The `Long` scalar type represents non-fractional signed whole 64-bit numeric values. Long can represent values between -(2^63) and 2^63 - 1. */
  Long: { input: scalars.Long; output: scalars.Long };
  /**
   * An offset from UTC in seconds.
   *  A positive value means that the local time is ahead of UTC (e.g. for Europe); a negative value means that the local time is behind UTC (e.g. for America).
   *
   * Allowed patterns:
   * - `Z`
   *
   * Examples:
   * - `Z`
   */
  Offset: { input: scalars.Offset; output: scalars.Offset };
  /**
   * A combination of a LocalDate and an Offset, to represent a date at a specific offset from UTC but without any time-of-day information.
   *
   * Allowed patterns:
   * - `YYYY-MM-DD±hh:mm`
   *
   * Examples:
   * - `2000-01-01Z`
   */
  OffsetDate: { input: scalars.OffsetDate; output: scalars.OffsetDate };
  /**
   * A local date and time in a particular calendar system, combined with an offset from UTC.
   *
   * Allowed patterns:
   * - `YYYY-MM-DDThh:mm:ss.sssssssss±hh:mm`
   *
   * Examples:
   * - `2000-01-01T20:00:00.999Z`
   */
  OffsetDateTime: {
    input: scalars.OffsetDateTime;
    output: scalars.OffsetDateTime;
  };
  /**
   * A combination of a LocalTime and an Offset, to represent a time-of-day at a specific offset from UTC but without any date information.
   *
   * Allowed patterns:
   * - `hh:mm:ss±hh:mm`
   *
   * Examples:
   * - `20:00:00Z`
   */
  OffsetTime: { input: scalars.OffsetTime; output: scalars.OffsetTime };
  /**
   * Represents a period of time expressed in human chronological terms: hours, days, weeks, months and so on.
   *
   * Pattern: `PnYnMnDTnHnMnS`
   * Example: `P3Y6M4DT12H30M5S`
   */
  Period: { input: scalars.Period; output: scalars.Period };
  /** A position is an array of numbers. There MUST be two or more elements. The first two elements are longitude and latitude, or easting and northing, precisely in that order and using decimal numbers. Altitude or elevation MAY be included as an optional third element. */
  Position: { input: scalars.Position; output: scalars.Position };
  UUID: { input: scalars.UUID; output: scalars.UUID };
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: scalars.Upload; output: scalars.Upload };
  /**
   * A LocalDateTime in a specific time zone and with a particular offset to distinguish between otherwise-ambiguous instants.
   * A ZonedDateTime is global, in that it maps to a single Instant.
   */
  ZonedDateTime: {
    input: scalars.ZonedDateTime;
    output: scalars.ZonedDateTime;
  };
}

export interface AccountFilterInput {
  and?: InputMaybe<Array<AccountFilterInput>>;
  deletedAt?: InputMaybe<ComparableNullableOfInstantOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  isEnabled?: InputMaybe<BooleanOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AccountFilterInput>>;
  role?: InputMaybe<RoleNameOperationFilterInput>;
  search?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<AccountStatusOperationFilterInput>;
  unconfirmedEmail?: InputMaybe<StringOperationFilterInput>;
}

export interface AccountSortInput {
  deletedAt?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  isEnabled?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  role?: InputMaybe<SortEnumType>;
  search?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  unconfirmedEmail?: InputMaybe<SortEnumType>;
}

export enum AccountStatus {
  ACTIVE = 'ACTIVE',
  INVITATION_EXPIRED = 'INVITATION_EXPIRED',
  PENDING_INVITATION = 'PENDING_INVITATION',
  SUSPENDED = 'SUSPENDED',
}

export interface AccountStatusOperationFilterInput {
  eq?: InputMaybe<AccountStatus>;
  in?: InputMaybe<Array<AccountStatus>>;
  neq?: InputMaybe<AccountStatus>;
  nin?: InputMaybe<Array<AccountStatus>>;
}

export interface AddressFilterInput {
  /** Province / Region */
  administrativeArea?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<AddressFilterInput>>;
  country?: InputMaybe<StringOperationFilterInput>;
  /** City / Town */
  locality?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AddressFilterInput>>;
  postalCode?: InputMaybe<StringOperationFilterInput>;
  streetAddress?: InputMaybe<StringOperationFilterInput>;
  streetNumber?: InputMaybe<StringOperationFilterInput>;
}

export interface AddressInput {
  /** Province / Region */
  administrativeArea?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  /** City / Town */
  locality?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  streetAddress?: InputMaybe<Scalars['String']['input']>;
  streetNumber?: InputMaybe<Scalars['String']['input']>;
}

export interface AddressSortInput {
  /** Province / Region */
  administrativeArea?: InputMaybe<SortEnumType>;
  country?: InputMaybe<SortEnumType>;
  /** City / Town */
  locality?: InputMaybe<SortEnumType>;
  postalCode?: InputMaybe<SortEnumType>;
  streetAddress?: InputMaybe<SortEnumType>;
  streetNumber?: InputMaybe<SortEnumType>;
}

export interface AdminFilterInput {
  and?: InputMaybe<Array<AdminFilterInput>>;
  deletedAt?: InputMaybe<ComparableNullableOfInstantOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  isEnabled?: InputMaybe<BooleanOperationFilterInput>;
  labelsIds?: InputMaybe<ListUuidOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AdminFilterInput>>;
  role?: InputMaybe<RoleNameOperationFilterInput>;
  search?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<AccountStatusOperationFilterInput>;
  unconfirmedEmail?: InputMaybe<StringOperationFilterInput>;
}

export interface AdminSortInput {
  deletedAt?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  isEnabled?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  role?: InputMaybe<SortEnumType>;
  search?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  unconfirmedEmail?: InputMaybe<SortEnumType>;
}

export interface ApiKeyFilterInput {
  additionalData?: InputMaybe<JsonElementFilterInput>;
  and?: InputMaybe<Array<ApiKeyFilterInput>>;
  createdAt?: InputMaybe<ComparableInstantOperationFilterInput>;
  createdBy?: InputMaybe<AccountFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  key?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ApiKeyFilterInput>>;
  ownerId?: InputMaybe<UuidOperationFilterInput>;
  search?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<ComparableInstantOperationFilterInput>;
  updatedBy?: InputMaybe<AccountFilterInput>;
  updatedById?: InputMaybe<UuidOperationFilterInput>;
}

export interface ApiKeySortInput {
  additionalData?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<AccountSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  key?: InputMaybe<SortEnumType>;
  ownerId?: InputMaybe<SortEnumType>;
  search?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<AccountSortInput>;
  updatedById?: InputMaybe<SortEnumType>;
}

export interface ApplyLabelsToSelectionInput {
  addLabelIds: Array<Scalars['UUID']['input']>;
  assetSelections: Array<AssetSelectionInput>;
  removeLabelIds: Array<Scalars['UUID']['input']>;
  surveyId: Scalars['UUID']['input'];
}

/** Defines when a policy shall be executed. */
export enum ApplyPolicy {
  /** After the resolver was executed. */
  AFTER_RESOLVER = 'AFTER_RESOLVER',
  /** Before the resolver was executed. */
  BEFORE_RESOLVER = 'BEFORE_RESOLVER',
  /** The policy is applied in the validation step before the execution. */
  VALIDATION = 'VALIDATION',
}

export interface AssetConfigFilterInput {
  and?: InputMaybe<Array<AssetConfigFilterInput>>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AssetConfigFilterInput>>;
  pathConfigs?: InputMaybe<ListFilterInputTypeOfPathConfigFilterInput>;
  tgm?: InputMaybe<TgmOperationFilterInput>;
}

export interface AssetConfigInput {
  name: Scalars['String']['input'];
  pathConfigs: Array<PathConfigInput>;
  tgm: Tgm;
}

export interface AssetFilterInput {
  additionalData?: InputMaybe<JsonElementFilterInput>;
  and?: InputMaybe<Array<AssetFilterInput>>;
  associatedSurveysIds?: InputMaybe<ListUuidOperationFilterInput>;
  bounds?: InputMaybe<BoundsFilterInput>;
  createdAt?: InputMaybe<ComparableInstantOperationFilterInput>;
  createdBy?: InputMaybe<AccountFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  labels?: InputMaybe<ListFilterInputTypeOfLabelFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AssetFilterInput>>;
  paths?: InputMaybe<ListFilterInputTypeOfPathFilterInput>;
  projectId?: InputMaybe<UuidOperationFilterInput>;
  search?: InputMaybe<StringOperationFilterInput>;
  tgm?: InputMaybe<TgmOperationFilterInput>;
  updatedAt?: InputMaybe<ComparableInstantOperationFilterInput>;
  updatedBy?: InputMaybe<AccountFilterInput>;
  updatedById?: InputMaybe<UuidOperationFilterInput>;
}

export interface AssetSelectionFilterInput {
  and?: InputMaybe<Array<AssetSelectionFilterInput>>;
  assetId?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<AssetSelectionFilterInput>>;
  pathSelections?: InputMaybe<ListFilterInputTypeOfPathSelectionFilterInput>;
}

export interface AssetSelectionInput {
  assetId: Scalars['UUID']['input'];
  pathSelections?: InputMaybe<Array<PathSelectionInput>>;
}

export interface AssetSortInput {
  additionalData?: InputMaybe<SortEnumType>;
  bounds?: InputMaybe<BoundsSortInput>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<AccountSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  projectId?: InputMaybe<SortEnumType>;
  search?: InputMaybe<SortEnumType>;
  tgm?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<AccountSortInput>;
  updatedById?: InputMaybe<SortEnumType>;
}

export interface BackgroundJobFilterInput {
  additionalData?: InputMaybe<JsonElementFilterInput>;
  and?: InputMaybe<Array<BackgroundJobFilterInput>>;
  createdAt?: InputMaybe<ComparableInstantOperationFilterInput>;
  createdBy?: InputMaybe<AccountFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<BackgroundJobFilterInput>>;
  projectName?: InputMaybe<StringOperationFilterInput>;
  search?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<JobStatusOperationFilterInput>;
  surveyId?: InputMaybe<UuidOperationFilterInput>;
  type?: InputMaybe<JobTypeOperationFilterInput>;
  updatedAt?: InputMaybe<ComparableInstantOperationFilterInput>;
  updatedBy?: InputMaybe<AccountFilterInput>;
  updatedById?: InputMaybe<UuidOperationFilterInput>;
}

export interface BlobFilterInput {
  additionalData?: InputMaybe<JsonElementFilterInput>;
  and?: InputMaybe<Array<BlobFilterInput>>;
  contentLength?: InputMaybe<LongOperationFilterInput>;
  contentType?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<ComparableInstantOperationFilterInput>;
  createdBy?: InputMaybe<AccountFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  fileName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<BlobFilterInput>>;
  search?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<ComparableInstantOperationFilterInput>;
  updatedBy?: InputMaybe<AccountFilterInput>;
  updatedById?: InputMaybe<UuidOperationFilterInput>;
  uri?: InputMaybe<StringOperationFilterInput>;
}

export interface BlobSortInput {
  additionalData?: InputMaybe<SortEnumType>;
  contentLength?: InputMaybe<SortEnumType>;
  contentType?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<AccountSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  fileName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  search?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<AccountSortInput>;
  updatedById?: InputMaybe<SortEnumType>;
  uri?: InputMaybe<SortEnumType>;
}

export interface BlockchainNotarizationJobFilterInput {
  additionalData?: InputMaybe<JsonElementFilterInput>;
  and?: InputMaybe<Array<BlockchainNotarizationJobFilterInput>>;
  createdAt?: InputMaybe<ComparableInstantOperationFilterInput>;
  createdBy?: InputMaybe<AccountFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  notarization?: InputMaybe<NotarizationFilterInput>;
  notarizationId?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<BlockchainNotarizationJobFilterInput>>;
  projectName?: InputMaybe<StringOperationFilterInput>;
  search?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<JobStatusOperationFilterInput>;
  surveyId?: InputMaybe<UuidOperationFilterInput>;
  type?: InputMaybe<JobTypeOperationFilterInput>;
  updatedAt?: InputMaybe<ComparableInstantOperationFilterInput>;
  updatedBy?: InputMaybe<AccountFilterInput>;
  updatedById?: InputMaybe<UuidOperationFilterInput>;
}

export interface BlockchainNotarizationJobSortInput {
  additionalData?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<AccountSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  notarization?: InputMaybe<NotarizationSortInput>;
  notarizationId?: InputMaybe<SortEnumType>;
  projectName?: InputMaybe<SortEnumType>;
  search?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  surveyId?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<AccountSortInput>;
  updatedById?: InputMaybe<SortEnumType>;
}

export interface BooleanOperationFilterInput {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface BoundsFilterInput {
  and?: InputMaybe<Array<BoundsFilterInput>>;
  maxLatitude?: InputMaybe<DecimalOperationFilterInput>;
  maxLongitude?: InputMaybe<DecimalOperationFilterInput>;
  minLatitude?: InputMaybe<DecimalOperationFilterInput>;
  minLongitude?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<BoundsFilterInput>>;
}

export interface BoundsSortInput {
  maxLatitude?: InputMaybe<SortEnumType>;
  maxLongitude?: InputMaybe<SortEnumType>;
  minLatitude?: InputMaybe<SortEnumType>;
  minLongitude?: InputMaybe<SortEnumType>;
}

export interface BulkAssignProjectsToOperatorsInput {
  operatorsIds: Array<Scalars['UUID']['input']>;
  projectsIds: Array<Scalars['UUID']['input']>;
}

export interface BulkAssignProjectsToOrganizationInput {
  organizationId: Scalars['UUID']['input'];
  projectsIds: Array<Scalars['UUID']['input']>;
}

export interface BulkDeleteAccountInput {
  accountsIds: Array<Scalars['UUID']['input']>;
}

export interface BulkSetAccountStatusInput {
  accountsIds: Array<Scalars['UUID']['input']>;
  isEnabled: Scalars['Boolean']['input'];
}

export interface BulkSetLabelsInput {
  labelIds: Array<Scalars['UUID']['input']>;
  targetIds: Array<Scalars['UUID']['input']>;
  targetType: Scalars['String']['input'];
}

export interface BulkUnassignOrganizationProjectsInput {
  organizationId: Scalars['UUID']['input'];
  projectsIds: Array<Scalars['UUID']['input']>;
}

export interface ByteOperationFilterInput {
  eq?: InputMaybe<Scalars['Byte']['input']>;
  gt?: InputMaybe<Scalars['Byte']['input']>;
  gte?: InputMaybe<Scalars['Byte']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Byte']['input']>>>;
  lt?: InputMaybe<Scalars['Byte']['input']>;
  lte?: InputMaybe<Scalars['Byte']['input']>;
  neq?: InputMaybe<Scalars['Byte']['input']>;
  ngt?: InputMaybe<Scalars['Byte']['input']>;
  ngte?: InputMaybe<Scalars['Byte']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Byte']['input']>>>;
  nlt?: InputMaybe<Scalars['Byte']['input']>;
  nlte?: InputMaybe<Scalars['Byte']['input']>;
}

export interface CloneProjectInput {
  newProjectName: Scalars['String']['input'];
  projectId: Scalars['UUID']['input'];
}

export interface ComparableInstantOperationFilterInput {
  eq?: InputMaybe<Scalars['Instant']['input']>;
  gt?: InputMaybe<Scalars['Instant']['input']>;
  gte?: InputMaybe<Scalars['Instant']['input']>;
  in?: InputMaybe<Array<Scalars['Instant']['input']>>;
  lt?: InputMaybe<Scalars['Instant']['input']>;
  lte?: InputMaybe<Scalars['Instant']['input']>;
  neq?: InputMaybe<Scalars['Instant']['input']>;
  ngt?: InputMaybe<Scalars['Instant']['input']>;
  ngte?: InputMaybe<Scalars['Instant']['input']>;
  nin?: InputMaybe<Array<Scalars['Instant']['input']>>;
  nlt?: InputMaybe<Scalars['Instant']['input']>;
  nlte?: InputMaybe<Scalars['Instant']['input']>;
}

export interface ComparableNullableOfInstantOperationFilterInput {
  eq?: InputMaybe<Scalars['Instant']['input']>;
  gt?: InputMaybe<Scalars['Instant']['input']>;
  gte?: InputMaybe<Scalars['Instant']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Instant']['input']>>>;
  lt?: InputMaybe<Scalars['Instant']['input']>;
  lte?: InputMaybe<Scalars['Instant']['input']>;
  neq?: InputMaybe<Scalars['Instant']['input']>;
  ngt?: InputMaybe<Scalars['Instant']['input']>;
  ngte?: InputMaybe<Scalars['Instant']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Instant']['input']>>>;
  nlt?: InputMaybe<Scalars['Instant']['input']>;
  nlte?: InputMaybe<Scalars['Instant']['input']>;
}

export interface ConfirmAccountInput {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
}

export interface ConfirmEmailAddressInput {
  token: Scalars['String']['input'];
}

export interface CoordinateSequenceSortInput {
  count?: InputMaybe<SortEnumType>;
  dimension?: InputMaybe<SortEnumType>;
  first?: InputMaybe<CoordinateSortInput>;
  hasM?: InputMaybe<SortEnumType>;
  hasZ?: InputMaybe<SortEnumType>;
  last?: InputMaybe<CoordinateSortInput>;
  mOrdinateIndex?: InputMaybe<SortEnumType>;
  measures?: InputMaybe<SortEnumType>;
  ordinates?: InputMaybe<SortEnumType>;
  spatial?: InputMaybe<SortEnumType>;
  zOrdinateIndex?: InputMaybe<SortEnumType>;
}

export interface CoordinateSortInput {
  coordinateValue?: InputMaybe<CoordinateSortInput>;
  isValid?: InputMaybe<SortEnumType>;
  m?: InputMaybe<SortEnumType>;
  x?: InputMaybe<SortEnumType>;
  y?: InputMaybe<SortEnumType>;
  z?: InputMaybe<SortEnumType>;
}

export interface CreateBlockchainNotarizationJobInput {
  additionalData?: InputMaybe<Scalars['JSON']['input']>;
  surveyId?: InputMaybe<Scalars['UUID']['input']>;
}

export interface CreateCustomLayerUploadJobInput {
  additionalData?: InputMaybe<Scalars['JSON']['input']>;
  csvFileId: Scalars['UUID']['input'];
  layerName: Scalars['String']['input'];
  styleId?: InputMaybe<Scalars['UUID']['input']>;
  surveyId?: InputMaybe<Scalars['UUID']['input']>;
}

export interface CreateCustomStyleInput {
  additionalData?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  parameter?: InputMaybe<Parameter>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  style: Scalars['JSON']['input'];
}

export interface CreateDatasetPreparationJobInput {
  additionalData?: InputMaybe<Scalars['JSON']['input']>;
  archiveFileId: Scalars['UUID']['input'];
  resolveToponyms: Scalars['Boolean']['input'];
  surveyId?: InputMaybe<Scalars['UUID']['input']>;
}

export interface CreateInterventionInput {
  actualCost: Scalars['Decimal']['input'];
  additionalData?: InputMaybe<Scalars['JSON']['input']>;
  category: InterventionCategory;
  effectiveEndDate: Scalars['LocalDate']['input'];
  effectiveStartDate: Scalars['LocalDate']['input'];
  estimatedCost: Scalars['Decimal']['input'];
  labelsIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  name: Scalars['String']['input'];
  notes: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  plannedEndDate: Scalars['LocalDate']['input'];
  plannedStartDate: Scalars['LocalDate']['input'];
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  selections: Array<AssetSelectionInput>;
  status: InterventionStatus;
  surveyId?: InputMaybe<Scalars['UUID']['input']>;
}

export interface CreateLabelInput {
  additionalData?: InputMaybe<Scalars['JSON']['input']>;
  isAdminLabel: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  targetType?: InputMaybe<Scalars['String']['input']>;
}

export interface CreateMediaUploadJobInput {
  additionalData?: InputMaybe<Scalars['JSON']['input']>;
  mFVDataFileId: Scalars['UUID']['input'];
  surveyId?: InputMaybe<Scalars['UUID']['input']>;
}

export interface CreateOrganizationInput {
  additionalData?: InputMaybe<Scalars['JSON']['input']>;
  address?: InputMaybe<AddressInput>;
  certifiedEmailAddress?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fiscalCode?: InputMaybe<Scalars['String']['input']>;
  labelsIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  logoId?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  pointOfContact?: InputMaybe<Scalars['String']['input']>;
  sDICode?: InputMaybe<Scalars['String']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
}

export interface CreateParametersComputationJobInput {
  additionalData?: InputMaybe<Scalars['JSON']['input']>;
  assetConfigs: Array<AssetConfigInput>;
  csvFileId?: InputMaybe<Scalars['UUID']['input']>;
  mFVDataFileId: Scalars['UUID']['input'];
  parameterConfig: ParameterConfigInput;
  surveyDate?: InputMaybe<Scalars['Instant']['input']>;
  surveyId?: InputMaybe<Scalars['UUID']['input']>;
}

export interface CreateProjectConfigurationInput {
  additionalData?: InputMaybe<Scalars['JSON']['input']>;
  baseCostPerCmMq: Scalars['Decimal']['input'];
  baseThicknessCm: Scalars['Decimal']['input'];
  binderCostPerCmMq: Scalars['Decimal']['input'];
  binderThicknessCm: Scalars['Decimal']['input'];
  foundationCostPerCmMq: Scalars['Decimal']['input'];
  foundationThicknessCm: Scalars['Decimal']['input'];
  laneWidth: Scalars['Decimal']['input'];
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  rpPciThreshold: Scalars['Decimal']['input'];
  rs1PciThreshold: Scalars['Decimal']['input'];
  rs2PciThreshold: Scalars['Decimal']['input'];
  rssPciThreshold: Scalars['Decimal']['input'];
  tgm: Tgm;
  wearCostPerCmMq: Scalars['Decimal']['input'];
  wearThicknessCm: Scalars['Decimal']['input'];
}

export interface CreateProjectInput {
  additionalData?: InputMaybe<Scalars['JSON']['input']>;
  labelsIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  name: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
}

export interface CreateReportGenerationJobInput {
  additionalData?: InputMaybe<Scalars['JSON']['input']>;
  interventionsIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  reportName: Scalars['String']['input'];
  reportType: ReportType;
  sectionsSelection: Array<Scalars['String']['input']>;
  selections: Array<AssetSelectionInput>;
  surveyId?: InputMaybe<Scalars['UUID']['input']>;
}

export interface CreateSurveyDataBulkUploadJobInput {
  additionalData?: InputMaybe<Scalars['JSON']['input']>;
  csvFileId: Scalars['UUID']['input'];
  surveyId?: InputMaybe<Scalars['UUID']['input']>;
}

export interface CreateSurveyDataDeletionJobInput {
  additionalData?: InputMaybe<Scalars['JSON']['input']>;
  surveyId?: InputMaybe<Scalars['UUID']['input']>;
}

export interface CreateSurveyInput {
  additionalData?: InputMaybe<Scalars['JSON']['input']>;
  endDate: Scalars['LocalDate']['input'];
  labelsIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  name: Scalars['String']['input'];
  projectId: Scalars['UUID']['input'];
  startDate: Scalars['LocalDate']['input'];
  status: SurveyStatus;
}

export interface CustomLayerFilterInput {
  additionalData?: InputMaybe<JsonElementFilterInput>;
  and?: InputMaybe<Array<CustomLayerFilterInput>>;
  createdAt?: InputMaybe<ComparableInstantOperationFilterInput>;
  createdBy?: InputMaybe<AccountFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  items?: InputMaybe<ListFilterInputTypeOfCustomLayerItemFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CustomLayerFilterInput>>;
  search?: InputMaybe<StringOperationFilterInput>;
  surveyId?: InputMaybe<UuidOperationFilterInput>;
  updatedAt?: InputMaybe<ComparableInstantOperationFilterInput>;
  updatedBy?: InputMaybe<AccountFilterInput>;
  updatedById?: InputMaybe<UuidOperationFilterInput>;
}

export interface CustomLayerItemFilterInput {
  additionalData?: InputMaybe<JsonElementFilterInput>;
  and?: InputMaybe<Array<CustomLayerItemFilterInput>>;
  color?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<ComparableInstantOperationFilterInput>;
  createdBy?: InputMaybe<AccountFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  customLayerId?: InputMaybe<UuidOperationFilterInput>;
  geometryType?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  lineString?: InputMaybe<LineStringFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CustomLayerItemFilterInput>>;
  outlineColor?: InputMaybe<StringOperationFilterInput>;
  point?: InputMaybe<PointFilterInput>;
  polygon?: InputMaybe<PolygonFilterInput>;
  search?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<ComparableInstantOperationFilterInput>;
  updatedBy?: InputMaybe<AccountFilterInput>;
  updatedById?: InputMaybe<UuidOperationFilterInput>;
  value?: InputMaybe<StringOperationFilterInput>;
}

export interface CustomLayerItemSortInput {
  additionalData?: InputMaybe<SortEnumType>;
  color?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<AccountSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  customLayerId?: InputMaybe<SortEnumType>;
  geometryType?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lineString?: InputMaybe<LineStringSortInput>;
  note?: InputMaybe<SortEnumType>;
  outlineColor?: InputMaybe<SortEnumType>;
  point?: InputMaybe<PointSortInput>;
  polygon?: InputMaybe<PolygonSortInput>;
  search?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<AccountSortInput>;
  updatedById?: InputMaybe<SortEnumType>;
  value?: InputMaybe<SortEnumType>;
}

export interface CustomLayerSortInput {
  additionalData?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<AccountSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  search?: InputMaybe<SortEnumType>;
  surveyId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<AccountSortInput>;
  updatedById?: InputMaybe<SortEnumType>;
}

export interface CustomLayerUploadJobFilterInput {
  additionalData?: InputMaybe<JsonElementFilterInput>;
  and?: InputMaybe<Array<CustomLayerUploadJobFilterInput>>;
  createdAt?: InputMaybe<ComparableInstantOperationFilterInput>;
  createdBy?: InputMaybe<AccountFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  csvFileId?: InputMaybe<UuidOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  layerName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CustomLayerUploadJobFilterInput>>;
  projectName?: InputMaybe<StringOperationFilterInput>;
  search?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<JobStatusOperationFilterInput>;
  styleId?: InputMaybe<UuidOperationFilterInput>;
  surveyId?: InputMaybe<UuidOperationFilterInput>;
  type?: InputMaybe<JobTypeOperationFilterInput>;
  updatedAt?: InputMaybe<ComparableInstantOperationFilterInput>;
  updatedBy?: InputMaybe<AccountFilterInput>;
  updatedById?: InputMaybe<UuidOperationFilterInput>;
}

export interface CustomLayerUploadJobSortInput {
  additionalData?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<AccountSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  csvFileId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  layerName?: InputMaybe<SortEnumType>;
  projectName?: InputMaybe<SortEnumType>;
  search?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  styleId?: InputMaybe<SortEnumType>;
  surveyId?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<AccountSortInput>;
  updatedById?: InputMaybe<SortEnumType>;
}

export interface CustomStyleFilterInput {
  additionalData?: InputMaybe<JsonElementFilterInput>;
  and?: InputMaybe<Array<CustomStyleFilterInput>>;
  createdAt?: InputMaybe<ComparableInstantOperationFilterInput>;
  createdBy?: InputMaybe<AccountFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isGlobal?: InputMaybe<BooleanOperationFilterInput>;
  isKnownParameterStyle?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CustomStyleFilterInput>>;
  parameter?: InputMaybe<NullableOfParameterOperationFilterInput>;
  projectId?: InputMaybe<UuidOperationFilterInput>;
  search?: InputMaybe<StringOperationFilterInput>;
  style?: InputMaybe<JsonElementFilterInput>;
  updatedAt?: InputMaybe<ComparableInstantOperationFilterInput>;
  updatedBy?: InputMaybe<AccountFilterInput>;
  updatedById?: InputMaybe<UuidOperationFilterInput>;
}

export interface CustomStyleSortInput {
  additionalData?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<AccountSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isGlobal?: InputMaybe<SortEnumType>;
  isKnownParameterStyle?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  parameter?: InputMaybe<SortEnumType>;
  projectId?: InputMaybe<SortEnumType>;
  search?: InputMaybe<SortEnumType>;
  style?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<AccountSortInput>;
  updatedById?: InputMaybe<SortEnumType>;
}

export interface DatasetPreparationJobFilterInput {
  additionalData?: InputMaybe<JsonElementFilterInput>;
  and?: InputMaybe<Array<DatasetPreparationJobFilterInput>>;
  archiveFile?: InputMaybe<BlobFilterInput>;
  archiveFileId?: InputMaybe<UuidOperationFilterInput>;
  createdAt?: InputMaybe<ComparableInstantOperationFilterInput>;
  createdBy?: InputMaybe<AccountFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<DatasetPreparationJobFilterInput>>;
  outputCsvFile?: InputMaybe<BlobFilterInput>;
  outputCsvFileId?: InputMaybe<UuidOperationFilterInput>;
  projectName?: InputMaybe<StringOperationFilterInput>;
  resolveToponyms?: InputMaybe<BooleanOperationFilterInput>;
  search?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<JobStatusOperationFilterInput>;
  surveyId?: InputMaybe<UuidOperationFilterInput>;
  type?: InputMaybe<JobTypeOperationFilterInput>;
  updatedAt?: InputMaybe<ComparableInstantOperationFilterInput>;
  updatedBy?: InputMaybe<AccountFilterInput>;
  updatedById?: InputMaybe<UuidOperationFilterInput>;
}

export interface DatasetPreparationJobSortInput {
  additionalData?: InputMaybe<SortEnumType>;
  archiveFile?: InputMaybe<BlobSortInput>;
  archiveFileId?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<AccountSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  outputCsvFile?: InputMaybe<BlobSortInput>;
  outputCsvFileId?: InputMaybe<SortEnumType>;
  projectName?: InputMaybe<SortEnumType>;
  resolveToponyms?: InputMaybe<SortEnumType>;
  search?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  surveyId?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<AccountSortInput>;
  updatedById?: InputMaybe<SortEnumType>;
}

export interface DecimalOperationFilterInput {
  eq?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  neq?: InputMaybe<Scalars['Decimal']['input']>;
  ngt?: InputMaybe<Scalars['Decimal']['input']>;
  ngte?: InputMaybe<Scalars['Decimal']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  nlt?: InputMaybe<Scalars['Decimal']['input']>;
  nlte?: InputMaybe<Scalars['Decimal']['input']>;
}

export interface DeleteAccountInput {
  id: Scalars['UUID']['input'];
}

export interface DeleteApiKeyInput {
  id: Scalars['UUID']['input'];
}

export interface DeleteAssetInput {
  id: Scalars['UUID']['input'];
}

export interface DeleteBlobInput {
  id: Scalars['UUID']['input'];
}

export interface DeleteBlockchainNotarizationJobInput {
  id: Scalars['UUID']['input'];
}

export interface DeleteCustomLayerInput {
  id: Scalars['UUID']['input'];
}

export interface DeleteCustomLayerItemInput {
  id: Scalars['UUID']['input'];
}

export interface DeleteCustomLayerUploadJobInput {
  id: Scalars['UUID']['input'];
}

export interface DeleteCustomStyleInput {
  id: Scalars['UUID']['input'];
}

export interface DeleteDatasetPreparationJobInput {
  id: Scalars['UUID']['input'];
}

export interface DeleteEventInput {
  id: Scalars['UUID']['input'];
}

export interface DeleteInterventionInput {
  id: Scalars['UUID']['input'];
}

export interface DeleteItemInput {
  id: Scalars['UUID']['input'];
}

export interface DeleteLabelInput {
  id: Scalars['UUID']['input'];
}

export interface DeleteMediaUploadJobInput {
  id: Scalars['UUID']['input'];
}

export interface DeleteOrganizationInput {
  deleteProjects: Scalars['Boolean']['input'];
  id: Scalars['UUID']['input'];
}

export interface DeleteParametersComputationJobInput {
  id: Scalars['UUID']['input'];
}

export interface DeletePathInput {
  id: Scalars['UUID']['input'];
}

export interface DeleteProjectConfigurationInput {
  id: Scalars['UUID']['input'];
}

export interface DeleteProjectInput {
  id: Scalars['UUID']['input'];
}

export interface DeleteReportGenerationJobInput {
  id: Scalars['UUID']['input'];
}

export interface DeleteReportInput {
  id: Scalars['UUID']['input'];
}

export interface DeleteSurveyDataBulkUploadJobInput {
  id: Scalars['UUID']['input'];
}

export interface DeleteSurveyDataDeletionJobInput {
  id: Scalars['UUID']['input'];
}

export interface DeleteSurveyInput {
  id: Scalars['UUID']['input'];
}

export enum Dimension {
  COLLAPSE = 'COLLAPSE',
  CURVE = 'CURVE',
  DONTCARE = 'DONTCARE',
  FALSE = 'FALSE',
  POINT = 'POINT',
  SURFACE = 'SURFACE',
  TRUE = 'TRUE',
}

export interface DimensionOperationFilterInput {
  eq?: InputMaybe<Dimension>;
  in?: InputMaybe<Array<Dimension>>;
  neq?: InputMaybe<Dimension>;
  nin?: InputMaybe<Array<Dimension>>;
}

export interface EnvelopeSortInput {
  area?: InputMaybe<SortEnumType>;
  centre?: InputMaybe<CoordinateSortInput>;
  diameter?: InputMaybe<SortEnumType>;
  height?: InputMaybe<SortEnumType>;
  isNull?: InputMaybe<SortEnumType>;
  maxExtent?: InputMaybe<SortEnumType>;
  maxX?: InputMaybe<SortEnumType>;
  maxY?: InputMaybe<SortEnumType>;
  minExtent?: InputMaybe<SortEnumType>;
  minX?: InputMaybe<SortEnumType>;
  minY?: InputMaybe<SortEnumType>;
  width?: InputMaybe<SortEnumType>;
}

export enum EtdFormula {
  ASTM = 'ASTM',
  ISO = 'ISO',
}

export interface EventFilterInput {
  and?: InputMaybe<Array<EventFilterInput>>;
  data?: InputMaybe<JsonElementFilterInput>;
  firedAt?: InputMaybe<ComparableInstantOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<EventFilterInput>>;
  targetId?: InputMaybe<UuidOperationFilterInput>;
  targetType?: InputMaybe<StringOperationFilterInput>;
  type?: InputMaybe<StringOperationFilterInput>;
}

export interface EventSortInput {
  data?: InputMaybe<SortEnumType>;
  firedAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  targetId?: InputMaybe<SortEnumType>;
  targetType?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
}

export interface FloatOperationFilterInput {
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  neq?: InputMaybe<Scalars['Float']['input']>;
  ngt?: InputMaybe<Scalars['Float']['input']>;
  ngte?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  nlt?: InputMaybe<Scalars['Float']['input']>;
  nlte?: InputMaybe<Scalars['Float']['input']>;
}

export interface ForceDeleteCustomStyleInput {
  id: Scalars['UUID']['input'];
}

export interface ForcePasswordResetInput {
  accountId: Scalars['UUID']['input'];
}

export enum GeoJSONGeometryType {
  GeometryCollection = 'GeometryCollection',
  LineString = 'LineString',
  MultiLineString = 'MultiLineString',
  MultiPoint = 'MultiPoint',
  MultiPolygon = 'MultiPolygon',
  Point = 'Point',
  Polygon = 'Polygon',
}

export interface GeoJSONLineStringInput {
  /** The "coordinates" field is an array of two or more positions. */
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['Position']['input']>>>;
  /** The coordinate reference system integer identifier */
  crs?: InputMaybe<Scalars['Int']['input']>;
  /** The geometry type of the GeoJson object */
  type?: InputMaybe<GeoJSONGeometryType>;
}

export interface GeoJSONMultiLineStringInput {
  /** The "coordinates" field is an array of LineString coordinate arrays. */
  coordinates?: InputMaybe<
    Array<InputMaybe<Array<InputMaybe<Scalars['Position']['input']>>>>
  >;
  /** The coordinate reference system integer identifier */
  crs?: InputMaybe<Scalars['Int']['input']>;
  /** The geometry type of the GeoJson object */
  type?: InputMaybe<GeoJSONGeometryType>;
}

export interface GeoJSONMultiPointInput {
  /** The "coordinates" field is an array of positions. */
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['Position']['input']>>>;
  /** The coordinate reference system integer identifier */
  crs?: InputMaybe<Scalars['Int']['input']>;
  /** The geometry type of the GeoJson object */
  type?: InputMaybe<GeoJSONGeometryType>;
}

export interface GeoJSONMultiPolygonInput {
  /** The "coordinates" field is an array of Polygon coordinate arrays. */
  coordinates?: InputMaybe<Scalars['Coordinates']['input']>;
  /** The coordinate reference system integer identifier */
  crs?: InputMaybe<Scalars['Int']['input']>;
  /** The geometry type of the GeoJson object */
  type?: InputMaybe<GeoJSONGeometryType>;
}

export interface GeoJSONPointInput {
  /** The "coordinates" field is a single position. */
  coordinates?: InputMaybe<Scalars['Position']['input']>;
  /** The coordinate reference system integer identifier */
  crs?: InputMaybe<Scalars['Int']['input']>;
  /** The geometry type of the GeoJson object */
  type?: InputMaybe<GeoJSONGeometryType>;
}

export interface GeoJSONPolygonInput {
  /** The "coordinates" field MUST be an array of linear ring coordinate arrays. For Polygons with more than one of these rings, the first MUST be the exterior ring, and any others MUST be interior rings. The exterior ring bounds the surface, and the interior rings (if present) bound holes within the surface. */
  coordinates?: InputMaybe<
    Array<InputMaybe<Array<InputMaybe<Scalars['Position']['input']>>>>
  >;
  /** The coordinate reference system integer identifier */
  crs?: InputMaybe<Scalars['Int']['input']>;
  /** The geometry type of the GeoJson object */
  type?: InputMaybe<GeoJSONGeometryType>;
}

export interface GeometryContainsOperationFilterInput {
  buffer?: InputMaybe<Scalars['Float']['input']>;
  geometry: Scalars['Geometry']['input'];
}

export interface GeometryDistanceOperationFilterInput {
  buffer?: InputMaybe<Scalars['Float']['input']>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  geometry: Scalars['Geometry']['input'];
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  neq?: InputMaybe<Scalars['Float']['input']>;
  ngt?: InputMaybe<Scalars['Float']['input']>;
  ngte?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<Scalars['Float']['input']>>;
  nlt?: InputMaybe<Scalars['Float']['input']>;
  nlte?: InputMaybe<Scalars['Float']['input']>;
}

export interface GeometryFilterInput {
  and?: InputMaybe<Array<GeometryFilterInput>>;
  area?: InputMaybe<FloatOperationFilterInput>;
  boundary?: InputMaybe<GeometryFilterInput>;
  centroid?: InputMaybe<PointFilterInput>;
  contains?: InputMaybe<GeometryContainsOperationFilterInput>;
  dimension?: InputMaybe<DimensionOperationFilterInput>;
  distance?: InputMaybe<GeometryDistanceOperationFilterInput>;
  envelope?: InputMaybe<GeometryFilterInput>;
  geometryType?: InputMaybe<StringOperationFilterInput>;
  interiorPoint?: InputMaybe<PointFilterInput>;
  intersects?: InputMaybe<GeometryIntersectsOperationFilterInput>;
  isSimple?: InputMaybe<BooleanOperationFilterInput>;
  isValid?: InputMaybe<BooleanOperationFilterInput>;
  length?: InputMaybe<FloatOperationFilterInput>;
  ncontains?: InputMaybe<GeometryContainsOperationFilterInput>;
  nintersects?: InputMaybe<GeometryIntersectsOperationFilterInput>;
  noverlaps?: InputMaybe<GeometryOverlapsOperationFilterInput>;
  ntouches?: InputMaybe<GeometryTouchesOperationFilterInput>;
  numPoints?: InputMaybe<IntOperationFilterInput>;
  nwithin?: InputMaybe<GeometryWithinOperationFilterInput>;
  ogcGeometryType?: InputMaybe<OgcGeometryTypeOperationFilterInput>;
  or?: InputMaybe<Array<GeometryFilterInput>>;
  overlaps?: InputMaybe<GeometryOverlapsOperationFilterInput>;
  pointOnSurface?: InputMaybe<PointFilterInput>;
  srid?: InputMaybe<IntOperationFilterInput>;
  touches?: InputMaybe<GeometryTouchesOperationFilterInput>;
  within?: InputMaybe<GeometryWithinOperationFilterInput>;
}

export interface GeometryIntersectsOperationFilterInput {
  buffer?: InputMaybe<Scalars['Float']['input']>;
  geometry: Scalars['Geometry']['input'];
}

export interface GeometryOverlapsOperationFilterInput {
  buffer?: InputMaybe<Scalars['Float']['input']>;
  geometry: Scalars['Geometry']['input'];
}

export interface GeometryTouchesOperationFilterInput {
  buffer?: InputMaybe<Scalars['Float']['input']>;
  geometry: Scalars['Geometry']['input'];
}

export interface GeometryWithinOperationFilterInput {
  buffer?: InputMaybe<Scalars['Float']['input']>;
  geometry: Scalars['Geometry']['input'];
}

export interface InitUpdateEmailAddressInput {
  email: Scalars['String']['input'];
  id: Scalars['UUID']['input'];
}

export interface IntOperationFilterInput {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  ngt?: InputMaybe<Scalars['Int']['input']>;
  ngte?: InputMaybe<Scalars['Int']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  nlt?: InputMaybe<Scalars['Int']['input']>;
  nlte?: InputMaybe<Scalars['Int']['input']>;
}

export enum InterventionCategory {
  REPAVING = 'REPAVING',
}

export interface InterventionCategoryOperationFilterInput {
  eq?: InputMaybe<InterventionCategory>;
  in?: InputMaybe<Array<InterventionCategory>>;
  neq?: InputMaybe<InterventionCategory>;
  nin?: InputMaybe<Array<InterventionCategory>>;
}

export interface InterventionFilterInput {
  actualCost?: InputMaybe<DecimalOperationFilterInput>;
  additionalData?: InputMaybe<JsonElementFilterInput>;
  and?: InputMaybe<Array<InterventionFilterInput>>;
  category?: InputMaybe<InterventionCategoryOperationFilterInput>;
  createdAt?: InputMaybe<ComparableInstantOperationFilterInput>;
  createdBy?: InputMaybe<AccountFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  effectiveEndDate?: InputMaybe<LocalDateOperationFilterInput>;
  effectiveStartDate?: InputMaybe<LocalDateOperationFilterInput>;
  estimatedCost?: InputMaybe<DecimalOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  labels?: InputMaybe<ListFilterInputTypeOfLabelFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<InterventionFilterInput>>;
  organizationId?: InputMaybe<UuidOperationFilterInput>;
  plannedEndDate?: InputMaybe<LocalDateOperationFilterInput>;
  plannedStartDate?: InputMaybe<LocalDateOperationFilterInput>;
  projectId?: InputMaybe<UuidOperationFilterInput>;
  search?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<InterventionStatusOperationFilterInput>;
  surveyId?: InputMaybe<UuidOperationFilterInput>;
  updatedAt?: InputMaybe<ComparableInstantOperationFilterInput>;
  updatedBy?: InputMaybe<AccountFilterInput>;
  updatedById?: InputMaybe<UuidOperationFilterInput>;
}

export interface InterventionSortInput {
  actualCost?: InputMaybe<SortEnumType>;
  additionalData?: InputMaybe<SortEnumType>;
  category?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<AccountSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  effectiveEndDate?: InputMaybe<SortEnumType>;
  effectiveStartDate?: InputMaybe<SortEnumType>;
  estimatedCost?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  organizationId?: InputMaybe<SortEnumType>;
  plannedEndDate?: InputMaybe<SortEnumType>;
  plannedStartDate?: InputMaybe<SortEnumType>;
  projectId?: InputMaybe<SortEnumType>;
  search?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  surveyId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<AccountSortInput>;
  updatedById?: InputMaybe<SortEnumType>;
}

export enum InterventionStatus {
  ENDED = 'ENDED',
  ONGOING = 'ONGOING',
  PLANNED = 'PLANNED',
}

export interface InterventionStatusOperationFilterInput {
  eq?: InputMaybe<InterventionStatus>;
  in?: InputMaybe<Array<InterventionStatus>>;
  neq?: InputMaybe<InterventionStatus>;
  nin?: InputMaybe<Array<InterventionStatus>>;
}

export interface InviteNewAccountInput {
  email: Scalars['String']['input'];
  role: RoleName;
}

export interface ItemFilterInput {
  additionalData?: InputMaybe<JsonElementFilterInput>;
  and?: InputMaybe<Array<ItemFilterInput>>;
  assetId?: InputMaybe<UuidOperationFilterInput>;
  createdAt?: InputMaybe<ComparableInstantOperationFilterInput>;
  createdBy?: InputMaybe<AccountFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  end?: InputMaybe<DecimalOperationFilterInput>;
  geometry?: InputMaybe<LineStringFilterInput>;
  grain?: InputMaybe<DecimalOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  index?: InputMaybe<IntOperationFilterInput>;
  isForward?: InputMaybe<BooleanOperationFilterInput>;
  length?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<ItemFilterInput>>;
  parameter?: InputMaybe<ParameterOperationFilterInput>;
  pathId?: InputMaybe<UuidOperationFilterInput>;
  projectId?: InputMaybe<UuidOperationFilterInput>;
  search?: InputMaybe<StringOperationFilterInput>;
  simplifiedGeometry?: InputMaybe<LineStringFilterInput>;
  start?: InputMaybe<DecimalOperationFilterInput>;
  surveyId?: InputMaybe<UuidOperationFilterInput>;
  updatedAt?: InputMaybe<ComparableInstantOperationFilterInput>;
  updatedBy?: InputMaybe<AccountFilterInput>;
  updatedById?: InputMaybe<UuidOperationFilterInput>;
  value?: InputMaybe<DecimalOperationFilterInput>;
}

export interface ItemSortInput {
  additionalData?: InputMaybe<SortEnumType>;
  assetId?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<AccountSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  end?: InputMaybe<SortEnumType>;
  geometry?: InputMaybe<LineStringSortInput>;
  grain?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  index?: InputMaybe<SortEnumType>;
  isForward?: InputMaybe<SortEnumType>;
  length?: InputMaybe<SortEnumType>;
  parameter?: InputMaybe<SortEnumType>;
  pathId?: InputMaybe<SortEnumType>;
  projectId?: InputMaybe<SortEnumType>;
  search?: InputMaybe<SortEnumType>;
  simplifiedGeometry?: InputMaybe<LineStringSortInput>;
  start?: InputMaybe<SortEnumType>;
  surveyId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<AccountSortInput>;
  updatedById?: InputMaybe<SortEnumType>;
  value?: InputMaybe<SortEnumType>;
}

export enum JobStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  QUEUED = 'QUEUED',
  RUNNING = 'RUNNING',
  STARTING = 'STARTING',
}

export interface JobStatusOperationFilterInput {
  eq?: InputMaybe<JobStatus>;
  in?: InputMaybe<Array<JobStatus>>;
  neq?: InputMaybe<JobStatus>;
  nin?: InputMaybe<Array<JobStatus>>;
}

export enum JobType {
  BLOCKCHAIN_NOTARIZATION = 'BLOCKCHAIN_NOTARIZATION',
  CUSTOM_LAYER_UPLOAD = 'CUSTOM_LAYER_UPLOAD',
  DATASET_PREPARATION = 'DATASET_PREPARATION',
  MEDIA_UPLOAD = 'MEDIA_UPLOAD',
  PARAMETERS_COMPUTATION = 'PARAMETERS_COMPUTATION',
  REPORT_GENERATION = 'REPORT_GENERATION',
  SURVEY_DATA_BULK_UPLOAD = 'SURVEY_DATA_BULK_UPLOAD',
  SURVEY_DATA_DELETION = 'SURVEY_DATA_DELETION',
}

export interface JobTypeOperationFilterInput {
  eq?: InputMaybe<JobType>;
  in?: InputMaybe<Array<JobType>>;
  neq?: InputMaybe<JobType>;
  nin?: InputMaybe<Array<JobType>>;
}

export interface JsonElementFilterInput {
  and?: InputMaybe<Array<JsonElementFilterInput>>;
  or?: InputMaybe<Array<JsonElementFilterInput>>;
  valueKind?: InputMaybe<JsonValueKindOperationFilterInput>;
}

export enum JsonValueKind {
  ARRAY = 'ARRAY',
  FALSE = 'FALSE',
  NULL = 'NULL',
  NUMBER = 'NUMBER',
  OBJECT = 'OBJECT',
  STRING = 'STRING',
  TRUE = 'TRUE',
  UNDEFINED = 'UNDEFINED',
}

export interface JsonValueKindOperationFilterInput {
  eq?: InputMaybe<JsonValueKind>;
  in?: InputMaybe<Array<JsonValueKind>>;
  neq?: InputMaybe<JsonValueKind>;
  nin?: InputMaybe<Array<JsonValueKind>>;
}

export interface LabelFilterInput {
  additionalData?: InputMaybe<JsonElementFilterInput>;
  and?: InputMaybe<Array<LabelFilterInput>>;
  createdAt?: InputMaybe<ComparableInstantOperationFilterInput>;
  createdBy?: InputMaybe<AccountFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isAdminLabel?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<LabelFilterInput>>;
  projectId?: InputMaybe<UuidOperationFilterInput>;
  targetType?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<ComparableInstantOperationFilterInput>;
  updatedBy?: InputMaybe<AccountFilterInput>;
  updatedById?: InputMaybe<UuidOperationFilterInput>;
}

export interface LabelSortInput {
  additionalData?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<AccountSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isAdminLabel?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  projectId?: InputMaybe<SortEnumType>;
  targetType?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<AccountSortInput>;
  updatedById?: InputMaybe<SortEnumType>;
}

export interface LineStringFilterInput {
  and?: InputMaybe<Array<LineStringFilterInput>>;
  area?: InputMaybe<FloatOperationFilterInput>;
  boundary?: InputMaybe<GeometryFilterInput>;
  centroid?: InputMaybe<PointFilterInput>;
  contains?: InputMaybe<GeometryContainsOperationFilterInput>;
  dimension?: InputMaybe<DimensionOperationFilterInput>;
  distance?: InputMaybe<GeometryDistanceOperationFilterInput>;
  envelope?: InputMaybe<GeometryFilterInput>;
  geometryType?: InputMaybe<StringOperationFilterInput>;
  interiorPoint?: InputMaybe<PointFilterInput>;
  intersects?: InputMaybe<GeometryIntersectsOperationFilterInput>;
  isSimple?: InputMaybe<BooleanOperationFilterInput>;
  isValid?: InputMaybe<BooleanOperationFilterInput>;
  length?: InputMaybe<FloatOperationFilterInput>;
  ncontains?: InputMaybe<GeometryContainsOperationFilterInput>;
  nintersects?: InputMaybe<GeometryIntersectsOperationFilterInput>;
  noverlaps?: InputMaybe<GeometryOverlapsOperationFilterInput>;
  ntouches?: InputMaybe<GeometryTouchesOperationFilterInput>;
  numPoints?: InputMaybe<IntOperationFilterInput>;
  nwithin?: InputMaybe<GeometryWithinOperationFilterInput>;
  ogcGeometryType?: InputMaybe<OgcGeometryTypeOperationFilterInput>;
  or?: InputMaybe<Array<LineStringFilterInput>>;
  overlaps?: InputMaybe<GeometryOverlapsOperationFilterInput>;
  pointOnSurface?: InputMaybe<PointFilterInput>;
  srid?: InputMaybe<IntOperationFilterInput>;
  touches?: InputMaybe<GeometryTouchesOperationFilterInput>;
  within?: InputMaybe<GeometryWithinOperationFilterInput>;
}

export interface LineStringSortInput {
  endPoint?: InputMaybe<PointSortInput>;
  startPoint?: InputMaybe<PointSortInput>;
}

export interface ListByteOperationFilterInput {
  all?: InputMaybe<ByteOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ByteOperationFilterInput>;
  some?: InputMaybe<ByteOperationFilterInput>;
}

export interface ListFilterInputTypeOfAssetConfigFilterInput {
  all?: InputMaybe<AssetConfigFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AssetConfigFilterInput>;
  some?: InputMaybe<AssetConfigFilterInput>;
}

export interface ListFilterInputTypeOfAssetSelectionFilterInput {
  all?: InputMaybe<AssetSelectionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AssetSelectionFilterInput>;
  some?: InputMaybe<AssetSelectionFilterInput>;
}

export interface ListFilterInputTypeOfBackgroundJobFilterInput {
  all?: InputMaybe<BackgroundJobFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<BackgroundJobFilterInput>;
  some?: InputMaybe<BackgroundJobFilterInput>;
}

export interface ListFilterInputTypeOfCustomLayerItemFilterInput {
  all?: InputMaybe<CustomLayerItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CustomLayerItemFilterInput>;
  some?: InputMaybe<CustomLayerItemFilterInput>;
}

export interface ListFilterInputTypeOfCustomStyleFilterInput {
  all?: InputMaybe<CustomStyleFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CustomStyleFilterInput>;
  some?: InputMaybe<CustomStyleFilterInput>;
}

export interface ListFilterInputTypeOfInterventionFilterInput {
  all?: InputMaybe<InterventionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<InterventionFilterInput>;
  some?: InputMaybe<InterventionFilterInput>;
}

export interface ListFilterInputTypeOfItemFilterInput {
  all?: InputMaybe<ItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ItemFilterInput>;
  some?: InputMaybe<ItemFilterInput>;
}

export interface ListFilterInputTypeOfLabelFilterInput {
  all?: InputMaybe<LabelFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<LabelFilterInput>;
  some?: InputMaybe<LabelFilterInput>;
}

export interface ListFilterInputTypeOfOperatorFilterInput {
  all?: InputMaybe<OperatorFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OperatorFilterInput>;
  some?: InputMaybe<OperatorFilterInput>;
}

export interface ListFilterInputTypeOfPathConfigFilterInput {
  all?: InputMaybe<PathConfigFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PathConfigFilterInput>;
  some?: InputMaybe<PathConfigFilterInput>;
}

export interface ListFilterInputTypeOfPathFilterInput {
  all?: InputMaybe<PathFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PathFilterInput>;
  some?: InputMaybe<PathFilterInput>;
}

export interface ListFilterInputTypeOfPathMediaFilterInput {
  all?: InputMaybe<PathMediaFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PathMediaFilterInput>;
  some?: InputMaybe<PathMediaFilterInput>;
}

export interface ListFilterInputTypeOfPathRangeFilterInput {
  all?: InputMaybe<PathRangeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PathRangeFilterInput>;
  some?: InputMaybe<PathRangeFilterInput>;
}

export interface ListFilterInputTypeOfPathSelectionFilterInput {
  all?: InputMaybe<PathSelectionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PathSelectionFilterInput>;
  some?: InputMaybe<PathSelectionFilterInput>;
}

export interface ListFilterInputTypeOfPointConfigFilterInput {
  all?: InputMaybe<PointConfigFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PointConfigFilterInput>;
  some?: InputMaybe<PointConfigFilterInput>;
}

export interface ListFilterInputTypeOfSurveyFilterInput {
  all?: InputMaybe<SurveyFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<SurveyFilterInput>;
  some?: InputMaybe<SurveyFilterInput>;
}

export interface ListPciDistressOperationFilterInput {
  all?: InputMaybe<PciDistressOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PciDistressOperationFilterInput>;
  some?: InputMaybe<PciDistressOperationFilterInput>;
}

export interface ListStringOperationFilterInput {
  all?: InputMaybe<StringOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<StringOperationFilterInput>;
  some?: InputMaybe<StringOperationFilterInput>;
}

export interface ListUuidOperationFilterInput {
  all?: InputMaybe<UuidOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<UuidOperationFilterInput>;
  some?: InputMaybe<UuidOperationFilterInput>;
}

export interface LocalDateOperationFilterInput {
  eq?: InputMaybe<Scalars['LocalDate']['input']>;
  gt?: InputMaybe<Scalars['LocalDate']['input']>;
  gte?: InputMaybe<Scalars['LocalDate']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['LocalDate']['input']>>>;
  lt?: InputMaybe<Scalars['LocalDate']['input']>;
  lte?: InputMaybe<Scalars['LocalDate']['input']>;
  neq?: InputMaybe<Scalars['LocalDate']['input']>;
  ngt?: InputMaybe<Scalars['LocalDate']['input']>;
  ngte?: InputMaybe<Scalars['LocalDate']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['LocalDate']['input']>>>;
  nlt?: InputMaybe<Scalars['LocalDate']['input']>;
  nlte?: InputMaybe<Scalars['LocalDate']['input']>;
}

export enum LogSeverity {
  CRITICAL = 'CRITICAL',
  DEBUG = 'DEBUG',
  ERROR = 'ERROR',
  INFO = 'INFO',
  WARNING = 'WARNING',
}

export interface LongOperationFilterInput {
  eq?: InputMaybe<Scalars['Long']['input']>;
  gt?: InputMaybe<Scalars['Long']['input']>;
  gte?: InputMaybe<Scalars['Long']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  lt?: InputMaybe<Scalars['Long']['input']>;
  lte?: InputMaybe<Scalars['Long']['input']>;
  neq?: InputMaybe<Scalars['Long']['input']>;
  ngt?: InputMaybe<Scalars['Long']['input']>;
  ngte?: InputMaybe<Scalars['Long']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  nlt?: InputMaybe<Scalars['Long']['input']>;
  nlte?: InputMaybe<Scalars['Long']['input']>;
}

export interface MediaFilterInput {
  and?: InputMaybe<Array<MediaFilterInput>>;
  blob?: InputMaybe<BlobFilterInput>;
  blobId?: InputMaybe<UuidOperationFilterInput>;
  mediaType?: InputMaybe<MediaTypeOperationFilterInput>;
  or?: InputMaybe<Array<MediaFilterInput>>;
  rspId?: InputMaybe<StringOperationFilterInput>;
  surveyId?: InputMaybe<UuidOperationFilterInput>;
}

export interface MediaSortInput {
  blob?: InputMaybe<BlobSortInput>;
  blobId?: InputMaybe<SortEnumType>;
  mediaType?: InputMaybe<SortEnumType>;
  rspId?: InputMaybe<SortEnumType>;
  surveyId?: InputMaybe<SortEnumType>;
}

export enum MediaType {
  FRONT_CAMERA = 'FRONT_CAMERA',
  ROAD = 'ROAD',
  ROAD_OVERLAY = 'ROAD_OVERLAY',
}

export interface MediaTypeOperationFilterInput {
  eq?: InputMaybe<MediaType>;
  in?: InputMaybe<Array<MediaType>>;
  neq?: InputMaybe<MediaType>;
  nin?: InputMaybe<Array<MediaType>>;
}

export interface MediaUploadJobFilterInput {
  additionalData?: InputMaybe<JsonElementFilterInput>;
  and?: InputMaybe<Array<MediaUploadJobFilterInput>>;
  createdAt?: InputMaybe<ComparableInstantOperationFilterInput>;
  createdBy?: InputMaybe<AccountFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  mfvDataFileId?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<MediaUploadJobFilterInput>>;
  projectName?: InputMaybe<StringOperationFilterInput>;
  search?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<JobStatusOperationFilterInput>;
  surveyId?: InputMaybe<UuidOperationFilterInput>;
  type?: InputMaybe<JobTypeOperationFilterInput>;
  updatedAt?: InputMaybe<ComparableInstantOperationFilterInput>;
  updatedBy?: InputMaybe<AccountFilterInput>;
  updatedById?: InputMaybe<UuidOperationFilterInput>;
}

export interface MediaUploadJobSortInput {
  additionalData?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<AccountSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  mfvDataFileId?: InputMaybe<SortEnumType>;
  projectName?: InputMaybe<SortEnumType>;
  search?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  surveyId?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<AccountSortInput>;
  updatedById?: InputMaybe<SortEnumType>;
}

export interface NotarizationFilterInput {
  and?: InputMaybe<Array<NotarizationFilterInput>>;
  blockHash?: InputMaybe<StringOperationFilterInput>;
  data?: InputMaybe<ListByteOperationFilterInput>;
  date?: InputMaybe<ComparableInstantOperationFilterInput>;
  hash?: InputMaybe<ListByteOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<NotarizationFilterInput>>;
  payload?: InputMaybe<ListByteOperationFilterInput>;
  transactionHash?: InputMaybe<StringOperationFilterInput>;
}

export interface NotarizationSortInput {
  blockHash?: InputMaybe<SortEnumType>;
  date?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  transactionHash?: InputMaybe<SortEnumType>;
}

export interface NullableOfEtdFormulaOperationFilterInput {
  eq?: InputMaybe<EtdFormula>;
  in?: InputMaybe<Array<InputMaybe<EtdFormula>>>;
  neq?: InputMaybe<EtdFormula>;
  nin?: InputMaybe<Array<InputMaybe<EtdFormula>>>;
}

export interface NullableOfParameterOperationFilterInput {
  eq?: InputMaybe<Parameter>;
  in?: InputMaybe<Array<InputMaybe<Parameter>>>;
  neq?: InputMaybe<Parameter>;
  nin?: InputMaybe<Array<InputMaybe<Parameter>>>;
}

export enum OgcGeometryType {
  CIRCULAR_STRING = 'CIRCULAR_STRING',
  COMPOUND_CURVE = 'COMPOUND_CURVE',
  CURVE = 'CURVE',
  CURVE_POLYGON = 'CURVE_POLYGON',
  GEOMETRY_COLLECTION = 'GEOMETRY_COLLECTION',
  LINE_STRING = 'LINE_STRING',
  MULTI_CURVE = 'MULTI_CURVE',
  MULTI_LINE_STRING = 'MULTI_LINE_STRING',
  MULTI_POINT = 'MULTI_POINT',
  MULTI_POLYGON = 'MULTI_POLYGON',
  MULTI_SURFACE = 'MULTI_SURFACE',
  POINT = 'POINT',
  POLYGON = 'POLYGON',
  POLYHEDRAL_SURFACE = 'POLYHEDRAL_SURFACE',
  SURFACE = 'SURFACE',
  TIN = 'TIN',
}

export interface OgcGeometryTypeOperationFilterInput {
  eq?: InputMaybe<OgcGeometryType>;
  in?: InputMaybe<Array<OgcGeometryType>>;
  neq?: InputMaybe<OgcGeometryType>;
  nin?: InputMaybe<Array<OgcGeometryType>>;
}

export interface OperatorFilterInput {
  and?: InputMaybe<Array<OperatorFilterInput>>;
  deletedAt?: InputMaybe<ComparableNullableOfInstantOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  isEnabled?: InputMaybe<BooleanOperationFilterInput>;
  labelsIds?: InputMaybe<ListUuidOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OperatorFilterInput>>;
  projectsCount?: InputMaybe<IntOperationFilterInput>;
  projectsIds?: InputMaybe<ListUuidOperationFilterInput>;
  role?: InputMaybe<RoleNameOperationFilterInput>;
  search?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<AccountStatusOperationFilterInput>;
  unconfirmedEmail?: InputMaybe<StringOperationFilterInput>;
}

export interface OperatorSortInput {
  deletedAt?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  isEnabled?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  projectsCount?: InputMaybe<SortEnumType>;
  role?: InputMaybe<SortEnumType>;
  search?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  unconfirmedEmail?: InputMaybe<SortEnumType>;
}

export enum OrderDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

export interface OrganizationFilterInput {
  additionalData?: InputMaybe<JsonElementFilterInput>;
  address?: InputMaybe<AddressFilterInput>;
  and?: InputMaybe<Array<OrganizationFilterInput>>;
  certifiedEmailAddress?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<ComparableInstantOperationFilterInput>;
  createdBy?: InputMaybe<AccountFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  deletedAt?: InputMaybe<ComparableNullableOfInstantOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  fiscalCode?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  labels?: InputMaybe<ListFilterInputTypeOfLabelFilterInput>;
  legalName?: InputMaybe<StringOperationFilterInput>;
  logo?: InputMaybe<BlobFilterInput>;
  logoId?: InputMaybe<UuidOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OrganizationFilterInput>>;
  phoneNumber?: InputMaybe<StringOperationFilterInput>;
  pointOfContact?: InputMaybe<StringOperationFilterInput>;
  projectsCount?: InputMaybe<IntOperationFilterInput>;
  sdiCode?: InputMaybe<StringOperationFilterInput>;
  search?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<OrganizationStatusOperationFilterInput>;
  updatedAt?: InputMaybe<ComparableInstantOperationFilterInput>;
  updatedBy?: InputMaybe<AccountFilterInput>;
  updatedById?: InputMaybe<UuidOperationFilterInput>;
  vatNumber?: InputMaybe<StringOperationFilterInput>;
}

export interface OrganizationSortInput {
  additionalData?: InputMaybe<SortEnumType>;
  address?: InputMaybe<AddressSortInput>;
  certifiedEmailAddress?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<AccountSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  deletedAt?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  fiscalCode?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  legalName?: InputMaybe<SortEnumType>;
  logo?: InputMaybe<BlobSortInput>;
  logoId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  phoneNumber?: InputMaybe<SortEnumType>;
  pointOfContact?: InputMaybe<SortEnumType>;
  projectsCount?: InputMaybe<SortEnumType>;
  sdiCode?: InputMaybe<SortEnumType>;
  search?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<AccountSortInput>;
  updatedById?: InputMaybe<SortEnumType>;
  vatNumber?: InputMaybe<SortEnumType>;
}

export enum OrganizationStatus {
  ACTIVE = 'ACTIVE',
  SUSPENDED = 'SUSPENDED',
}

export interface OrganizationStatusOperationFilterInput {
  eq?: InputMaybe<OrganizationStatus>;
  in?: InputMaybe<Array<OrganizationStatus>>;
  neq?: InputMaybe<OrganizationStatus>;
  nin?: InputMaybe<Array<OrganizationStatus>>;
}

export enum Parameter {
  ETD = 'ETD',
  IRI_LEFT = 'IRI_LEFT',
  IRI_RIGHT = 'IRI_RIGHT',
  IRI_VALUE = 'IRI_VALUE',
  MPD = 'MPD',
  PCI = 'PCI',
  RUT_LEFT = 'RUT_LEFT',
  RUT_RIGHT = 'RUT_RIGHT',
  RUT_VALUE = 'RUT_VALUE',
}

export interface ParameterConfigFilterInput {
  and?: InputMaybe<Array<ParameterConfigFilterInput>>;
  etdFormula?: InputMaybe<NullableOfEtdFormulaOperationFilterInput>;
  etdGrain?: InputMaybe<IntOperationFilterInput>;
  iriGrain?: InputMaybe<IntOperationFilterInput>;
  maxEtd?: InputMaybe<DecimalOperationFilterInput>;
  maxIri?: InputMaybe<DecimalOperationFilterInput>;
  maxRut?: InputMaybe<DecimalOperationFilterInput>;
  mpdGrain?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ParameterConfigFilterInput>>;
  pciDistresses?: InputMaybe<ListPciDistressOperationFilterInput>;
  pciGrain?: InputMaybe<IntOperationFilterInput>;
  rutGrain?: InputMaybe<IntOperationFilterInput>;
}

export interface ParameterConfigInput {
  etdFormula?: InputMaybe<EtdFormula>;
  etdGrain?: InputMaybe<Scalars['Int']['input']>;
  iriGrain?: InputMaybe<Scalars['Int']['input']>;
  maxEtd?: InputMaybe<Scalars['Decimal']['input']>;
  maxIri?: InputMaybe<Scalars['Decimal']['input']>;
  maxRut?: InputMaybe<Scalars['Decimal']['input']>;
  mpdGrain?: InputMaybe<Scalars['Int']['input']>;
  pciDistresses?: InputMaybe<Array<PciDistress>>;
  pciGrain?: InputMaybe<Scalars['Int']['input']>;
  rutGrain?: InputMaybe<Scalars['Int']['input']>;
}

export interface ParameterConfigSortInput {
  etdFormula?: InputMaybe<SortEnumType>;
  etdGrain?: InputMaybe<SortEnumType>;
  iriGrain?: InputMaybe<SortEnumType>;
  maxEtd?: InputMaybe<SortEnumType>;
  maxIri?: InputMaybe<SortEnumType>;
  maxRut?: InputMaybe<SortEnumType>;
  mpdGrain?: InputMaybe<SortEnumType>;
  pciGrain?: InputMaybe<SortEnumType>;
  rutGrain?: InputMaybe<SortEnumType>;
}

export interface ParameterOperationFilterInput {
  eq?: InputMaybe<Parameter>;
  in?: InputMaybe<Array<Parameter>>;
  neq?: InputMaybe<Parameter>;
  nin?: InputMaybe<Array<Parameter>>;
}

export interface ParametersComputationJobFilterInput {
  additionalData?: InputMaybe<JsonElementFilterInput>;
  and?: InputMaybe<Array<ParametersComputationJobFilterInput>>;
  assetConfigs?: InputMaybe<ListFilterInputTypeOfAssetConfigFilterInput>;
  createdAt?: InputMaybe<ComparableInstantOperationFilterInput>;
  createdBy?: InputMaybe<AccountFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  csvFileId?: InputMaybe<UuidOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  mfvDataFileId?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<ParametersComputationJobFilterInput>>;
  parameterConfig?: InputMaybe<ParameterConfigFilterInput>;
  parametersZipId?: InputMaybe<UuidOperationFilterInput>;
  projectName?: InputMaybe<StringOperationFilterInput>;
  search?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<JobStatusOperationFilterInput>;
  surveyDate?: InputMaybe<ComparableNullableOfInstantOperationFilterInput>;
  surveyId?: InputMaybe<UuidOperationFilterInput>;
  type?: InputMaybe<JobTypeOperationFilterInput>;
  updatedAt?: InputMaybe<ComparableInstantOperationFilterInput>;
  updatedBy?: InputMaybe<AccountFilterInput>;
  updatedById?: InputMaybe<UuidOperationFilterInput>;
}

export interface ParametersComputationJobSortInput {
  additionalData?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<AccountSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  csvFileId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  mfvDataFileId?: InputMaybe<SortEnumType>;
  parameterConfig?: InputMaybe<ParameterConfigSortInput>;
  parametersZipId?: InputMaybe<SortEnumType>;
  projectName?: InputMaybe<SortEnumType>;
  search?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  surveyDate?: InputMaybe<SortEnumType>;
  surveyId?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<AccountSortInput>;
  updatedById?: InputMaybe<SortEnumType>;
}

export interface PathConfigFilterInput {
  and?: InputMaybe<Array<PathConfigFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  isForward?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  offset?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<PathConfigFilterInput>>;
}

export interface PathConfigInput {
  id?: InputMaybe<Scalars['String']['input']>;
  isForward: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Decimal']['input']>;
}

export interface PathFilterInput {
  additionalData?: InputMaybe<JsonElementFilterInput>;
  and?: InputMaybe<Array<PathFilterInput>>;
  assetId?: InputMaybe<UuidOperationFilterInput>;
  assetName?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<ComparableInstantOperationFilterInput>;
  createdBy?: InputMaybe<AccountFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  geometry?: InputMaybe<LineStringFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  index?: InputMaybe<IntOperationFilterInput>;
  isForward?: InputMaybe<BooleanOperationFilterInput>;
  items?: InputMaybe<ListFilterInputTypeOfItemFilterInput>;
  length?: InputMaybe<DecimalOperationFilterInput>;
  media?: InputMaybe<ListFilterInputTypeOfPathMediaFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  offset?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<PathFilterInput>>;
  points?: InputMaybe<ListFilterInputTypeOfPointConfigFilterInput>;
  search?: InputMaybe<StringOperationFilterInput>;
  surveys?: InputMaybe<ListFilterInputTypeOfSurveyFilterInput>;
  updatedAt?: InputMaybe<ComparableInstantOperationFilterInput>;
  updatedBy?: InputMaybe<AccountFilterInput>;
  updatedById?: InputMaybe<UuidOperationFilterInput>;
}

export interface PathMediaFilterInput {
  and?: InputMaybe<Array<PathMediaFilterInput>>;
  media?: InputMaybe<MediaFilterInput>;
  mediaId?: InputMaybe<UuidOperationFilterInput>;
  offset?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<PathMediaFilterInput>>;
  pathId?: InputMaybe<UuidOperationFilterInput>;
}

export interface PathMediaSortInput {
  media?: InputMaybe<MediaSortInput>;
  mediaId?: InputMaybe<SortEnumType>;
  offset?: InputMaybe<SortEnumType>;
  pathId?: InputMaybe<SortEnumType>;
}

export interface PathRangeFilterInput {
  and?: InputMaybe<Array<PathRangeFilterInput>>;
  end?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<PathRangeFilterInput>>;
  start?: InputMaybe<DecimalOperationFilterInput>;
}

export interface PathRangeInput {
  end: Scalars['Decimal']['input'];
  start: Scalars['Decimal']['input'];
}

export interface PathSelectionFilterInput {
  and?: InputMaybe<Array<PathSelectionFilterInput>>;
  or?: InputMaybe<Array<PathSelectionFilterInput>>;
  pathId?: InputMaybe<UuidOperationFilterInput>;
  ranges?: InputMaybe<ListFilterInputTypeOfPathRangeFilterInput>;
}

export interface PathSelectionInput {
  pathId: Scalars['UUID']['input'];
  ranges?: InputMaybe<Array<PathRangeInput>>;
}

export interface PathSortInput {
  additionalData?: InputMaybe<SortEnumType>;
  assetId?: InputMaybe<SortEnumType>;
  assetName?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<AccountSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  geometry?: InputMaybe<LineStringSortInput>;
  id?: InputMaybe<SortEnumType>;
  index?: InputMaybe<SortEnumType>;
  isForward?: InputMaybe<SortEnumType>;
  length?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  offset?: InputMaybe<SortEnumType>;
  search?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<AccountSortInput>;
  updatedById?: InputMaybe<SortEnumType>;
}

export enum PciDistress {
  CRACK = 'CRACK',
  POTHOLE = 'POTHOLE',
}

export interface PciDistressOperationFilterInput {
  eq?: InputMaybe<PciDistress>;
  in?: InputMaybe<Array<PciDistress>>;
  neq?: InputMaybe<PciDistress>;
  nin?: InputMaybe<Array<PciDistress>>;
}

export interface PointConfigFilterInput {
  altitude?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<PointConfigFilterInput>>;
  latitude?: InputMaybe<DecimalOperationFilterInput>;
  longitude?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<PointConfigFilterInput>>;
  rspId?: InputMaybe<StringOperationFilterInput>;
  rspIndex?: InputMaybe<IntOperationFilterInput>;
  rspStart?: InputMaybe<DecimalOperationFilterInput>;
  toponym?: InputMaybe<StringOperationFilterInput>;
}

export interface PointFilterInput {
  and?: InputMaybe<Array<PointFilterInput>>;
  area?: InputMaybe<FloatOperationFilterInput>;
  boundary?: InputMaybe<GeometryFilterInput>;
  centroid?: InputMaybe<PointFilterInput>;
  contains?: InputMaybe<GeometryContainsOperationFilterInput>;
  dimension?: InputMaybe<DimensionOperationFilterInput>;
  distance?: InputMaybe<GeometryDistanceOperationFilterInput>;
  envelope?: InputMaybe<GeometryFilterInput>;
  geometryType?: InputMaybe<StringOperationFilterInput>;
  interiorPoint?: InputMaybe<PointFilterInput>;
  intersects?: InputMaybe<GeometryIntersectsOperationFilterInput>;
  isSimple?: InputMaybe<BooleanOperationFilterInput>;
  isValid?: InputMaybe<BooleanOperationFilterInput>;
  length?: InputMaybe<FloatOperationFilterInput>;
  m?: InputMaybe<FloatOperationFilterInput>;
  ncontains?: InputMaybe<GeometryContainsOperationFilterInput>;
  nintersects?: InputMaybe<GeometryIntersectsOperationFilterInput>;
  noverlaps?: InputMaybe<GeometryOverlapsOperationFilterInput>;
  ntouches?: InputMaybe<GeometryTouchesOperationFilterInput>;
  numPoints?: InputMaybe<IntOperationFilterInput>;
  nwithin?: InputMaybe<GeometryWithinOperationFilterInput>;
  ogcGeometryType?: InputMaybe<OgcGeometryTypeOperationFilterInput>;
  or?: InputMaybe<Array<PointFilterInput>>;
  overlaps?: InputMaybe<GeometryOverlapsOperationFilterInput>;
  pointOnSurface?: InputMaybe<PointFilterInput>;
  srid?: InputMaybe<IntOperationFilterInput>;
  touches?: InputMaybe<GeometryTouchesOperationFilterInput>;
  within?: InputMaybe<GeometryWithinOperationFilterInput>;
  x?: InputMaybe<FloatOperationFilterInput>;
  y?: InputMaybe<FloatOperationFilterInput>;
  z?: InputMaybe<FloatOperationFilterInput>;
}

export interface PointSortInput {
  area?: InputMaybe<SortEnumType>;
  boundaryDimension?: InputMaybe<SortEnumType>;
  centroid?: InputMaybe<PointSortInput>;
  coordinate?: InputMaybe<CoordinateSortInput>;
  coordinateSequence?: InputMaybe<CoordinateSequenceSortInput>;
  dimension?: InputMaybe<SortEnumType>;
  envelopeInternal?: InputMaybe<EnvelopeSortInput>;
  geometryType?: InputMaybe<SortEnumType>;
  interiorPoint?: InputMaybe<PointSortInput>;
  isEmpty?: InputMaybe<SortEnumType>;
  isRectangle?: InputMaybe<SortEnumType>;
  isSimple?: InputMaybe<SortEnumType>;
  isValid?: InputMaybe<SortEnumType>;
  length?: InputMaybe<SortEnumType>;
  m?: InputMaybe<SortEnumType>;
  numGeometries?: InputMaybe<SortEnumType>;
  numPoints?: InputMaybe<SortEnumType>;
  ogcGeometryType?: InputMaybe<SortEnumType>;
  pointOnSurface?: InputMaybe<PointSortInput>;
  precisionModel?: InputMaybe<PrecisionModelSortInput>;
  srid?: InputMaybe<SortEnumType>;
  x?: InputMaybe<SortEnumType>;
  y?: InputMaybe<SortEnumType>;
  z?: InputMaybe<SortEnumType>;
}

export interface PolygonFilterInput {
  and?: InputMaybe<Array<PolygonFilterInput>>;
  area?: InputMaybe<FloatOperationFilterInput>;
  boundary?: InputMaybe<GeometryFilterInput>;
  centroid?: InputMaybe<PointFilterInput>;
  contains?: InputMaybe<GeometryContainsOperationFilterInput>;
  dimension?: InputMaybe<DimensionOperationFilterInput>;
  distance?: InputMaybe<GeometryDistanceOperationFilterInput>;
  envelope?: InputMaybe<GeometryFilterInput>;
  geometryType?: InputMaybe<StringOperationFilterInput>;
  interiorPoint?: InputMaybe<PointFilterInput>;
  intersects?: InputMaybe<GeometryIntersectsOperationFilterInput>;
  isSimple?: InputMaybe<BooleanOperationFilterInput>;
  isValid?: InputMaybe<BooleanOperationFilterInput>;
  length?: InputMaybe<FloatOperationFilterInput>;
  ncontains?: InputMaybe<GeometryContainsOperationFilterInput>;
  nintersects?: InputMaybe<GeometryIntersectsOperationFilterInput>;
  noverlaps?: InputMaybe<GeometryOverlapsOperationFilterInput>;
  ntouches?: InputMaybe<GeometryTouchesOperationFilterInput>;
  numPoints?: InputMaybe<IntOperationFilterInput>;
  nwithin?: InputMaybe<GeometryWithinOperationFilterInput>;
  ogcGeometryType?: InputMaybe<OgcGeometryTypeOperationFilterInput>;
  or?: InputMaybe<Array<PolygonFilterInput>>;
  overlaps?: InputMaybe<GeometryOverlapsOperationFilterInput>;
  pointOnSurface?: InputMaybe<PointFilterInput>;
  srid?: InputMaybe<IntOperationFilterInput>;
  touches?: InputMaybe<GeometryTouchesOperationFilterInput>;
  within?: InputMaybe<GeometryWithinOperationFilterInput>;
}

export interface PolygonSortInput {
  area?: InputMaybe<SortEnumType>;
  boundaryDimension?: InputMaybe<SortEnumType>;
  centroid?: InputMaybe<PointSortInput>;
  coordinate?: InputMaybe<CoordinateSortInput>;
  dimension?: InputMaybe<SortEnumType>;
  envelopeInternal?: InputMaybe<EnvelopeSortInput>;
  exteriorRing?: InputMaybe<LineStringSortInput>;
  geometryType?: InputMaybe<SortEnumType>;
  interiorPoint?: InputMaybe<PointSortInput>;
  isEmpty?: InputMaybe<SortEnumType>;
  isRectangle?: InputMaybe<SortEnumType>;
  isSimple?: InputMaybe<SortEnumType>;
  isValid?: InputMaybe<SortEnumType>;
  length?: InputMaybe<SortEnumType>;
  numGeometries?: InputMaybe<SortEnumType>;
  numInteriorRings?: InputMaybe<SortEnumType>;
  numPoints?: InputMaybe<SortEnumType>;
  ogcGeometryType?: InputMaybe<SortEnumType>;
  pointOnSurface?: InputMaybe<PointSortInput>;
  precisionModel?: InputMaybe<PrecisionModelSortInput>;
  srid?: InputMaybe<SortEnumType>;
}

export interface PrecisionModelSortInput {
  gridSize?: InputMaybe<SortEnumType>;
  isFloating?: InputMaybe<SortEnumType>;
  maximumSignificantDigits?: InputMaybe<SortEnumType>;
  precisionModelType?: InputMaybe<SortEnumType>;
  scale?: InputMaybe<SortEnumType>;
}

export interface ProjectConfigurationFilterInput {
  additionalData?: InputMaybe<JsonElementFilterInput>;
  and?: InputMaybe<Array<ProjectConfigurationFilterInput>>;
  baseCostPerCmMq?: InputMaybe<DecimalOperationFilterInput>;
  baseThicknessCm?: InputMaybe<DecimalOperationFilterInput>;
  binderCostPerCmMq?: InputMaybe<DecimalOperationFilterInput>;
  binderThicknessCm?: InputMaybe<DecimalOperationFilterInput>;
  createdAt?: InputMaybe<ComparableInstantOperationFilterInput>;
  createdBy?: InputMaybe<AccountFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  foundationCostPerCmMq?: InputMaybe<DecimalOperationFilterInput>;
  foundationThicknessCm?: InputMaybe<DecimalOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isGlobalConfiguration?: InputMaybe<BooleanOperationFilterInput>;
  laneWidth?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<ProjectConfigurationFilterInput>>;
  projectId?: InputMaybe<UuidOperationFilterInput>;
  rpPciThreshold?: InputMaybe<DecimalOperationFilterInput>;
  rs1PciThreshold?: InputMaybe<DecimalOperationFilterInput>;
  rs2PciThreshold?: InputMaybe<DecimalOperationFilterInput>;
  rssPciThreshold?: InputMaybe<DecimalOperationFilterInput>;
  search?: InputMaybe<StringOperationFilterInput>;
  tgm?: InputMaybe<TgmOperationFilterInput>;
  updatedAt?: InputMaybe<ComparableInstantOperationFilterInput>;
  updatedBy?: InputMaybe<AccountFilterInput>;
  updatedById?: InputMaybe<UuidOperationFilterInput>;
  wearCostPerCmMq?: InputMaybe<DecimalOperationFilterInput>;
  wearThicknessCm?: InputMaybe<DecimalOperationFilterInput>;
}

export interface ProjectConfigurationSortInput {
  additionalData?: InputMaybe<SortEnumType>;
  baseCostPerCmMq?: InputMaybe<SortEnumType>;
  baseThicknessCm?: InputMaybe<SortEnumType>;
  binderCostPerCmMq?: InputMaybe<SortEnumType>;
  binderThicknessCm?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<AccountSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  foundationCostPerCmMq?: InputMaybe<SortEnumType>;
  foundationThicknessCm?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isGlobalConfiguration?: InputMaybe<SortEnumType>;
  laneWidth?: InputMaybe<SortEnumType>;
  projectId?: InputMaybe<SortEnumType>;
  rpPciThreshold?: InputMaybe<SortEnumType>;
  rs1PciThreshold?: InputMaybe<SortEnumType>;
  rs2PciThreshold?: InputMaybe<SortEnumType>;
  rssPciThreshold?: InputMaybe<SortEnumType>;
  search?: InputMaybe<SortEnumType>;
  tgm?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<AccountSortInput>;
  updatedById?: InputMaybe<SortEnumType>;
  wearCostPerCmMq?: InputMaybe<SortEnumType>;
  wearThicknessCm?: InputMaybe<SortEnumType>;
}

export interface ProjectFilterInput {
  additionalData?: InputMaybe<JsonElementFilterInput>;
  and?: InputMaybe<Array<ProjectFilterInput>>;
  assetsCount?: InputMaybe<IntOperationFilterInput>;
  bounds?: InputMaybe<BoundsFilterInput>;
  cig?: InputMaybe<StringOperationFilterInput>;
  completedSurveysCount?: InputMaybe<IntOperationFilterInput>;
  createdAt?: InputMaybe<ComparableInstantOperationFilterInput>;
  createdBy?: InputMaybe<AccountFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  cup?: InputMaybe<StringOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  labels?: InputMaybe<ListFilterInputTypeOfLabelFilterInput>;
  lastSurvey?: InputMaybe<SurveyInfoFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  nextSurvey?: InputMaybe<SurveyInfoFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  operators?: InputMaybe<ListFilterInputTypeOfOperatorFilterInput>;
  operatorsCount?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ProjectFilterInput>>;
  organization?: InputMaybe<OrganizationFilterInput>;
  organizationId?: InputMaybe<UuidOperationFilterInput>;
  pciCurvesFileId?: InputMaybe<UuidOperationFilterInput>;
  phoneNumber?: InputMaybe<StringOperationFilterInput>;
  pointOfContact?: InputMaybe<StringOperationFilterInput>;
  projectValue?: InputMaybe<FloatOperationFilterInput>;
  search?: InputMaybe<StringOperationFilterInput>;
  styles?: InputMaybe<ListFilterInputTypeOfCustomStyleFilterInput>;
  surveys?: InputMaybe<ListFilterInputTypeOfSurveyFilterInput>;
  surveysCount?: InputMaybe<IntOperationFilterInput>;
  updatedAt?: InputMaybe<ComparableInstantOperationFilterInput>;
  updatedBy?: InputMaybe<AccountFilterInput>;
  updatedById?: InputMaybe<UuidOperationFilterInput>;
}

export interface ProjectSortInput {
  additionalData?: InputMaybe<SortEnumType>;
  assetsCount?: InputMaybe<SortEnumType>;
  bounds?: InputMaybe<BoundsSortInput>;
  cig?: InputMaybe<SortEnumType>;
  completedSurveysCount?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<AccountSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  cup?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastSurvey?: InputMaybe<SurveyInfoSortInput>;
  name?: InputMaybe<SortEnumType>;
  nextSurvey?: InputMaybe<SurveyInfoSortInput>;
  note?: InputMaybe<SortEnumType>;
  operatorsCount?: InputMaybe<SortEnumType>;
  organization?: InputMaybe<OrganizationSortInput>;
  organizationId?: InputMaybe<SortEnumType>;
  pciCurvesFileId?: InputMaybe<SortEnumType>;
  phoneNumber?: InputMaybe<SortEnumType>;
  pointOfContact?: InputMaybe<SortEnumType>;
  projectValue?: InputMaybe<SortEnumType>;
  search?: InputMaybe<SortEnumType>;
  surveysCount?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<AccountSortInput>;
  updatedById?: InputMaybe<SortEnumType>;
}

export interface ReportFilterInput {
  additionalData?: InputMaybe<JsonElementFilterInput>;
  and?: InputMaybe<Array<ReportFilterInput>>;
  createdAt?: InputMaybe<ComparableInstantOperationFilterInput>;
  createdBy?: InputMaybe<AccountFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  labels?: InputMaybe<ListFilterInputTypeOfLabelFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ReportFilterInput>>;
  pdfFile?: InputMaybe<BlobFilterInput>;
  pdfFileId?: InputMaybe<UuidOperationFilterInput>;
  projectId?: InputMaybe<UuidOperationFilterInput>;
  search?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<ReportStatusOperationFilterInput>;
  surveyId?: InputMaybe<UuidOperationFilterInput>;
  surveyName?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<ComparableInstantOperationFilterInput>;
  updatedBy?: InputMaybe<AccountFilterInput>;
  updatedById?: InputMaybe<UuidOperationFilterInput>;
}

export interface ReportGenerationJobFilterInput {
  additionalData?: InputMaybe<JsonElementFilterInput>;
  and?: InputMaybe<Array<ReportGenerationJobFilterInput>>;
  createdAt?: InputMaybe<ComparableInstantOperationFilterInput>;
  createdBy?: InputMaybe<AccountFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  interventions?: InputMaybe<ListFilterInputTypeOfInterventionFilterInput>;
  or?: InputMaybe<Array<ReportGenerationJobFilterInput>>;
  projectName?: InputMaybe<StringOperationFilterInput>;
  reportName?: InputMaybe<StringOperationFilterInput>;
  reportType?: InputMaybe<ReportTypeOperationFilterInput>;
  search?: InputMaybe<StringOperationFilterInput>;
  sectionsSelection?: InputMaybe<ListStringOperationFilterInput>;
  selections?: InputMaybe<ListFilterInputTypeOfAssetSelectionFilterInput>;
  status?: InputMaybe<JobStatusOperationFilterInput>;
  surveyId?: InputMaybe<UuidOperationFilterInput>;
  type?: InputMaybe<JobTypeOperationFilterInput>;
  updatedAt?: InputMaybe<ComparableInstantOperationFilterInput>;
  updatedBy?: InputMaybe<AccountFilterInput>;
  updatedById?: InputMaybe<UuidOperationFilterInput>;
}

export interface ReportGenerationJobSortInput {
  additionalData?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<AccountSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  projectName?: InputMaybe<SortEnumType>;
  reportName?: InputMaybe<SortEnumType>;
  reportType?: InputMaybe<SortEnumType>;
  search?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  surveyId?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<AccountSortInput>;
  updatedById?: InputMaybe<SortEnumType>;
}

export interface ReportSortInput {
  additionalData?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<AccountSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  pdfFile?: InputMaybe<BlobSortInput>;
  pdfFileId?: InputMaybe<SortEnumType>;
  projectId?: InputMaybe<SortEnumType>;
  search?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  surveyId?: InputMaybe<SortEnumType>;
  surveyName?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<AccountSortInput>;
  updatedById?: InputMaybe<SortEnumType>;
}

export enum ReportStatus {
  AVAILABLE = 'AVAILABLE',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
}

export interface ReportStatusOperationFilterInput {
  eq?: InputMaybe<ReportStatus>;
  in?: InputMaybe<Array<ReportStatus>>;
  neq?: InputMaybe<ReportStatus>;
  nin?: InputMaybe<Array<ReportStatus>>;
}

export enum ReportType {
  ASSET = 'ASSET',
  CUSTOM = 'CUSTOM',
  SURVEY = 'SURVEY',
}

export interface ReportTypeOperationFilterInput {
  eq?: InputMaybe<ReportType>;
  in?: InputMaybe<Array<ReportType>>;
  neq?: InputMaybe<ReportType>;
  nin?: InputMaybe<Array<ReportType>>;
}

export interface ResendAccountInvitationInput {
  accountId: Scalars['UUID']['input'];
}

export enum RoleName {
  ADMIN = 'ADMIN',
  USER = 'USER',
}

export interface RoleNameOperationFilterInput {
  eq?: InputMaybe<RoleName>;
  in?: InputMaybe<Array<RoleName>>;
  neq?: InputMaybe<RoleName>;
  nin?: InputMaybe<Array<RoleName>>;
}

export interface SetOperatorProjectsInput {
  operatorId: Scalars['UUID']['input'];
  projectIds: Array<Scalars['UUID']['input']>;
}

export enum SortEnumType {
  ASC = 'ASC',
  DESC = 'DESC',
}

export interface StopJobInput {
  id: Scalars['UUID']['input'];
}

export interface StringOperationFilterInput {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ncontains?: InputMaybe<Scalars['String']['input']>;
  nendsWith?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nstartsWith?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
}

export interface SurveyDataBulkUploadJobFilterInput {
  additionalData?: InputMaybe<JsonElementFilterInput>;
  and?: InputMaybe<Array<SurveyDataBulkUploadJobFilterInput>>;
  createdAt?: InputMaybe<ComparableInstantOperationFilterInput>;
  createdBy?: InputMaybe<AccountFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  csvFileId?: InputMaybe<UuidOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<SurveyDataBulkUploadJobFilterInput>>;
  projectName?: InputMaybe<StringOperationFilterInput>;
  search?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<JobStatusOperationFilterInput>;
  surveyId?: InputMaybe<UuidOperationFilterInput>;
  type?: InputMaybe<JobTypeOperationFilterInput>;
  updatedAt?: InputMaybe<ComparableInstantOperationFilterInput>;
  updatedBy?: InputMaybe<AccountFilterInput>;
  updatedById?: InputMaybe<UuidOperationFilterInput>;
}

export interface SurveyDataBulkUploadJobSortInput {
  additionalData?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<AccountSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  csvFileId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  projectName?: InputMaybe<SortEnumType>;
  search?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  surveyId?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<AccountSortInput>;
  updatedById?: InputMaybe<SortEnumType>;
}

export interface SurveyDataDeletionJobFilterInput {
  additionalData?: InputMaybe<JsonElementFilterInput>;
  and?: InputMaybe<Array<SurveyDataDeletionJobFilterInput>>;
  createdAt?: InputMaybe<ComparableInstantOperationFilterInput>;
  createdBy?: InputMaybe<AccountFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<SurveyDataDeletionJobFilterInput>>;
  projectName?: InputMaybe<StringOperationFilterInput>;
  search?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<JobStatusOperationFilterInput>;
  surveyId?: InputMaybe<UuidOperationFilterInput>;
  type?: InputMaybe<JobTypeOperationFilterInput>;
  updatedAt?: InputMaybe<ComparableInstantOperationFilterInput>;
  updatedBy?: InputMaybe<AccountFilterInput>;
  updatedById?: InputMaybe<UuidOperationFilterInput>;
}

export interface SurveyDataDeletionJobSortInput {
  additionalData?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<AccountSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  projectName?: InputMaybe<SortEnumType>;
  search?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  surveyId?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<AccountSortInput>;
  updatedById?: InputMaybe<SortEnumType>;
}

export interface SurveyFilterInput {
  additionalData?: InputMaybe<JsonElementFilterInput>;
  and?: InputMaybe<Array<SurveyFilterInput>>;
  backgroundJobs?: InputMaybe<ListFilterInputTypeOfBackgroundJobFilterInput>;
  createdAt?: InputMaybe<ComparableInstantOperationFilterInput>;
  createdBy?: InputMaybe<AccountFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  endDate?: InputMaybe<LocalDateOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  labels?: InputMaybe<ListFilterInputTypeOfLabelFilterInput>;
  maxTileZoom?: InputMaybe<IntOperationFilterInput>;
  minTileZoom?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SurveyFilterInput>>;
  projectId?: InputMaybe<UuidOperationFilterInput>;
  search?: InputMaybe<StringOperationFilterInput>;
  startDate?: InputMaybe<LocalDateOperationFilterInput>;
  status?: InputMaybe<SurveyStatusOperationFilterInput>;
  surveyDate?: InputMaybe<ComparableNullableOfInstantOperationFilterInput>;
  updatedAt?: InputMaybe<ComparableInstantOperationFilterInput>;
  updatedBy?: InputMaybe<AccountFilterInput>;
  updatedById?: InputMaybe<UuidOperationFilterInput>;
}

export interface SurveyInfoFilterInput {
  and?: InputMaybe<Array<SurveyInfoFilterInput>>;
  endDate?: InputMaybe<LocalDateOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SurveyInfoFilterInput>>;
  startDate?: InputMaybe<LocalDateOperationFilterInput>;
}

export interface SurveyInfoSortInput {
  endDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
}

export interface SurveySortInput {
  additionalData?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<AccountSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  maxTileZoom?: InputMaybe<SortEnumType>;
  minTileZoom?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  projectId?: InputMaybe<SortEnumType>;
  search?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  surveyDate?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<AccountSortInput>;
  updatedById?: InputMaybe<SortEnumType>;
}

export enum SurveyStatus {
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
  SCHEDULED = 'SCHEDULED',
}

export interface SurveyStatusOperationFilterInput {
  eq?: InputMaybe<SurveyStatus>;
  in?: InputMaybe<Array<SurveyStatus>>;
  neq?: InputMaybe<SurveyStatus>;
  nin?: InputMaybe<Array<SurveyStatus>>;
}

export enum Tgm {
  HIGH = 'HIGH',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
}

export interface TgmOperationFilterInput {
  eq?: InputMaybe<Tgm>;
  in?: InputMaybe<Array<Tgm>>;
  neq?: InputMaybe<Tgm>;
  nin?: InputMaybe<Array<Tgm>>;
}

export interface UnassignProjectInput {
  operatorsIds: Array<Scalars['UUID']['input']>;
  projectId: Scalars['UUID']['input'];
}

export interface UpdateAccountInput {
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  labelsIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateAssetInput {
  additionalData?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['UUID']['input'];
  labelsIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  tgm?: InputMaybe<Tgm>;
}

export interface UpdateBlobInput {
  additionalData?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['UUID']['input'];
}

export interface UpdateCustomStyleInput {
  additionalData?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  parameter?: InputMaybe<Parameter>;
  style?: InputMaybe<Scalars['JSON']['input']>;
}

export interface UpdateGlobalConfigInput {
  pciCurvesFileId?: InputMaybe<Scalars['UUID']['input']>;
}

export interface UpdateInterventionInput {
  actualCost?: InputMaybe<Scalars['Decimal']['input']>;
  additionalData?: InputMaybe<Scalars['JSON']['input']>;
  category?: InputMaybe<InterventionCategory>;
  effectiveEndDate?: InputMaybe<Scalars['LocalDate']['input']>;
  effectiveStartDate?: InputMaybe<Scalars['LocalDate']['input']>;
  estimatedCost?: InputMaybe<Scalars['Decimal']['input']>;
  id: Scalars['UUID']['input'];
  labelsIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  plannedEndDate?: InputMaybe<Scalars['LocalDate']['input']>;
  plannedStartDate?: InputMaybe<Scalars['LocalDate']['input']>;
  selections?: InputMaybe<Array<AssetSelectionInput>>;
  status?: InputMaybe<InterventionStatus>;
}

export interface UpdateLabelInput {
  additionalData?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['UUID']['input'];
  isAdminLabel?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateMediaUploadJobInput {
  additionalData?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['UUID']['input'];
}

export interface UpdateOrganizationInput {
  additionalData?: InputMaybe<Scalars['JSON']['input']>;
  address?: InputMaybe<AddressInput>;
  certifiedEmailAddress?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fiscalCode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  labelsIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  logoId?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  pointOfContact?: InputMaybe<Scalars['String']['input']>;
  sDICode?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OrganizationStatus>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateParametersComputationJobInput {
  additionalData?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['UUID']['input'];
}

export interface UpdatePendingAccountEmailInput {
  email: Scalars['String']['input'];
  id: Scalars['UUID']['input'];
}

export interface UpdateProjectConfigurationInput {
  additionalData?: InputMaybe<Scalars['JSON']['input']>;
  baseCostPerCmMq?: InputMaybe<Scalars['Decimal']['input']>;
  baseThicknessCm?: InputMaybe<Scalars['Decimal']['input']>;
  binderCostPerCmMq?: InputMaybe<Scalars['Decimal']['input']>;
  binderThicknessCm?: InputMaybe<Scalars['Decimal']['input']>;
  foundationCostPerCmMq?: InputMaybe<Scalars['Decimal']['input']>;
  foundationThicknessCm?: InputMaybe<Scalars['Decimal']['input']>;
  id: Scalars['UUID']['input'];
  laneWidth?: InputMaybe<Scalars['Decimal']['input']>;
  rpPciThreshold?: InputMaybe<Scalars['Decimal']['input']>;
  rs1PciThreshold?: InputMaybe<Scalars['Decimal']['input']>;
  rs2PciThreshold?: InputMaybe<Scalars['Decimal']['input']>;
  rssPciThreshold?: InputMaybe<Scalars['Decimal']['input']>;
  wearCostPerCmMq?: InputMaybe<Scalars['Decimal']['input']>;
  wearThicknessCm?: InputMaybe<Scalars['Decimal']['input']>;
}

export interface UpdateProjectInput {
  additionalData?: InputMaybe<Scalars['JSON']['input']>;
  cIG?: InputMaybe<Scalars['String']['input']>;
  cUP?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  labelsIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  pciCurvesFileId?: InputMaybe<Scalars['UUID']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  pointOfContact?: InputMaybe<Scalars['String']['input']>;
  projectValue?: InputMaybe<Scalars['Float']['input']>;
}

export interface UpdateReportInput {
  additionalData?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['UUID']['input'];
  labelsIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateSurveyInput {
  additionalData?: InputMaybe<Scalars['JSON']['input']>;
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  id: Scalars['UUID']['input'];
  labelsIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['LocalDate']['input']>;
  status?: InputMaybe<SurveyStatus>;
}

export interface UploadBlobInput {
  data?: InputMaybe<Scalars['JSON']['input']>;
  file: Scalars['Upload']['input'];
  labelsIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
}

export interface UuidOperationFilterInput {
  eq?: InputMaybe<Scalars['UUID']['input']>;
  gt?: InputMaybe<Scalars['UUID']['input']>;
  gte?: InputMaybe<Scalars['UUID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  lt?: InputMaybe<Scalars['UUID']['input']>;
  lte?: InputMaybe<Scalars['UUID']['input']>;
  neq?: InputMaybe<Scalars['UUID']['input']>;
  ngt?: InputMaybe<Scalars['UUID']['input']>;
  ngte?: InputMaybe<Scalars['UUID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  nlt?: InputMaybe<Scalars['UUID']['input']>;
  nlte?: InputMaybe<Scalars['UUID']['input']>;
}

export const scalarsEnumsHash: ScalarsEnumsHash = {
  AccountStatus: true,
  ApplyPolicy: true,
  Boolean: true,
  Byte: true,
  Coordinates: true,
  DateTimeZone: true,
  Decimal: true,
  Dimension: true,
  Duration: true,
  EtdFormula: true,
  Float: true,
  GeoJSONGeometryType: true,
  Geometry: true,
  Instant: true,
  Int: true,
  InterventionCategory: true,
  InterventionStatus: true,
  IsoDayOfWeek: true,
  JSON: true,
  JobStatus: true,
  JobType: true,
  JsonValueKind: true,
  LocalDate: true,
  LocalTime: true,
  LogSeverity: true,
  Long: true,
  MediaType: true,
  Offset: true,
  OffsetDate: true,
  OffsetDateTime: true,
  OffsetTime: true,
  OgcGeometryType: true,
  OrderDirection: true,
  OrganizationStatus: true,
  Parameter: true,
  PciDistress: true,
  Period: true,
  Position: true,
  ReportStatus: true,
  ReportType: true,
  RoleName: true,
  SortEnumType: true,
  String: true,
  SurveyStatus: true,
  Tgm: true,
  UUID: true,
  Upload: true,
  ZonedDateTime: true,
};
export const generatedSchema = {
  Account: {
    __typename: { __type: 'String!' },
    deletedAt: { __type: 'Instant' },
    email: { __type: 'String' },
    firstName: { __type: 'String' },
    id: { __type: 'UUID!' },
    isDeleted: { __type: 'Boolean!' },
    isEnabled: { __type: 'Boolean!' },
    lastName: { __type: 'String' },
    role: { __type: 'RoleName!' },
    search: { __type: 'String' },
    status: { __type: 'AccountStatus!' },
    unconfirmedEmail: { __type: 'String' },
  },
  AccountFilterInput: {
    and: { __type: '[AccountFilterInput!]' },
    deletedAt: { __type: 'ComparableNullableOfInstantOperationFilterInput' },
    email: { __type: 'StringOperationFilterInput' },
    firstName: { __type: 'StringOperationFilterInput' },
    id: { __type: 'UuidOperationFilterInput' },
    isDeleted: { __type: 'BooleanOperationFilterInput' },
    isEnabled: { __type: 'BooleanOperationFilterInput' },
    lastName: { __type: 'StringOperationFilterInput' },
    or: { __type: '[AccountFilterInput!]' },
    role: { __type: 'RoleNameOperationFilterInput' },
    search: { __type: 'StringOperationFilterInput' },
    status: { __type: 'AccountStatusOperationFilterInput' },
    unconfirmedEmail: { __type: 'StringOperationFilterInput' },
  },
  AccountSortInput: {
    deletedAt: { __type: 'SortEnumType' },
    email: { __type: 'SortEnumType' },
    firstName: { __type: 'SortEnumType' },
    id: { __type: 'SortEnumType' },
    isDeleted: { __type: 'SortEnumType' },
    isEnabled: { __type: 'SortEnumType' },
    lastName: { __type: 'SortEnumType' },
    role: { __type: 'SortEnumType' },
    search: { __type: 'SortEnumType' },
    status: { __type: 'SortEnumType' },
    unconfirmedEmail: { __type: 'SortEnumType' },
  },
  AccountStatusOperationFilterInput: {
    eq: { __type: 'AccountStatus' },
    in: { __type: '[AccountStatus!]' },
    neq: { __type: 'AccountStatus' },
    nin: { __type: '[AccountStatus!]' },
  },
  Address: {
    __typename: { __type: 'String!' },
    administrativeArea: { __type: 'String' },
    country: { __type: 'String' },
    locality: { __type: 'String' },
    postalCode: { __type: 'String' },
    streetAddress: { __type: 'String' },
    streetNumber: { __type: 'String' },
  },
  AddressFilterInput: {
    administrativeArea: { __type: 'StringOperationFilterInput' },
    and: { __type: '[AddressFilterInput!]' },
    country: { __type: 'StringOperationFilterInput' },
    locality: { __type: 'StringOperationFilterInput' },
    or: { __type: '[AddressFilterInput!]' },
    postalCode: { __type: 'StringOperationFilterInput' },
    streetAddress: { __type: 'StringOperationFilterInput' },
    streetNumber: { __type: 'StringOperationFilterInput' },
  },
  AddressInput: {
    administrativeArea: { __type: 'String' },
    country: { __type: 'String' },
    locality: { __type: 'String' },
    postalCode: { __type: 'String' },
    streetAddress: { __type: 'String' },
    streetNumber: { __type: 'String' },
  },
  AddressSortInput: {
    administrativeArea: { __type: 'SortEnumType' },
    country: { __type: 'SortEnumType' },
    locality: { __type: 'SortEnumType' },
    postalCode: { __type: 'SortEnumType' },
    streetAddress: { __type: 'SortEnumType' },
    streetNumber: { __type: 'SortEnumType' },
  },
  Admin: {
    __typename: { __type: 'String!' },
    deletedAt: { __type: 'Instant' },
    email: { __type: 'String' },
    firstName: { __type: 'String' },
    id: { __type: 'UUID!' },
    isDeleted: { __type: 'Boolean!' },
    isEnabled: { __type: 'Boolean!' },
    labels: { __type: '[Label!]!' },
    labelsIds: { __type: '[UUID!]!' },
    lastName: { __type: 'String' },
    role: { __type: 'RoleName!' },
    search: { __type: 'String' },
    status: { __type: 'AccountStatus!' },
    unconfirmedEmail: { __type: 'String' },
  },
  AdminFilterInput: {
    and: { __type: '[AdminFilterInput!]' },
    deletedAt: { __type: 'ComparableNullableOfInstantOperationFilterInput' },
    email: { __type: 'StringOperationFilterInput' },
    firstName: { __type: 'StringOperationFilterInput' },
    id: { __type: 'UuidOperationFilterInput' },
    isDeleted: { __type: 'BooleanOperationFilterInput' },
    isEnabled: { __type: 'BooleanOperationFilterInput' },
    labelsIds: { __type: 'ListUuidOperationFilterInput' },
    lastName: { __type: 'StringOperationFilterInput' },
    or: { __type: '[AdminFilterInput!]' },
    role: { __type: 'RoleNameOperationFilterInput' },
    search: { __type: 'StringOperationFilterInput' },
    status: { __type: 'AccountStatusOperationFilterInput' },
    unconfirmedEmail: { __type: 'StringOperationFilterInput' },
  },
  AdminSortInput: {
    deletedAt: { __type: 'SortEnumType' },
    email: { __type: 'SortEnumType' },
    firstName: { __type: 'SortEnumType' },
    id: { __type: 'SortEnumType' },
    isDeleted: { __type: 'SortEnumType' },
    isEnabled: { __type: 'SortEnumType' },
    lastName: { __type: 'SortEnumType' },
    role: { __type: 'SortEnumType' },
    search: { __type: 'SortEnumType' },
    status: { __type: 'SortEnumType' },
    unconfirmedEmail: { __type: 'SortEnumType' },
  },
  AdminsCollectionSegment: {
    __typename: { __type: 'String!' },
    items: { __type: '[Admin!]' },
    pageInfo: { __type: 'CollectionSegmentInfo!' },
    totalCount: { __type: 'Int!' },
  },
  ApiKey: {
    __typename: { __type: 'String!' },
    additionalData: { __type: 'JSON' },
    createdAt: { __type: 'Instant!' },
    createdBy: { __type: 'Account' },
    createdById: { __type: 'UUID' },
    events: {
      __type: 'EventsCollectionSegment',
      __args: { skip: 'Int', take: 'Int' },
    },
    id: { __type: 'UUID!' },
    key: { __type: 'String!' },
    ownerId: { __type: 'UUID!' },
    search: { __type: 'String' },
    updatedAt: { __type: 'Instant!' },
    updatedBy: { __type: 'Account' },
    updatedById: { __type: 'UUID' },
  },
  ApiKeyFilterInput: {
    additionalData: { __type: 'JsonElementFilterInput' },
    and: { __type: '[ApiKeyFilterInput!]' },
    createdAt: { __type: 'ComparableInstantOperationFilterInput' },
    createdBy: { __type: 'AccountFilterInput' },
    createdById: { __type: 'UuidOperationFilterInput' },
    id: { __type: 'UuidOperationFilterInput' },
    key: { __type: 'StringOperationFilterInput' },
    or: { __type: '[ApiKeyFilterInput!]' },
    ownerId: { __type: 'UuidOperationFilterInput' },
    search: { __type: 'StringOperationFilterInput' },
    updatedAt: { __type: 'ComparableInstantOperationFilterInput' },
    updatedBy: { __type: 'AccountFilterInput' },
    updatedById: { __type: 'UuidOperationFilterInput' },
  },
  ApiKeySortInput: {
    additionalData: { __type: 'SortEnumType' },
    createdAt: { __type: 'SortEnumType' },
    createdBy: { __type: 'AccountSortInput' },
    createdById: { __type: 'SortEnumType' },
    id: { __type: 'SortEnumType' },
    key: { __type: 'SortEnumType' },
    ownerId: { __type: 'SortEnumType' },
    search: { __type: 'SortEnumType' },
    updatedAt: { __type: 'SortEnumType' },
    updatedBy: { __type: 'AccountSortInput' },
    updatedById: { __type: 'SortEnumType' },
  },
  ApiKeysCollectionSegment: {
    __typename: { __type: 'String!' },
    items: { __type: '[ApiKey!]' },
    pageInfo: { __type: 'CollectionSegmentInfo!' },
    totalCount: { __type: 'Int!' },
  },
  ApplyLabelsToSelectionError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$ApplyLabelsToSelectionError!' },
  },
  ApplyLabelsToSelectionInput: {
    addLabelIds: { __type: '[UUID!]!' },
    assetSelections: { __type: '[AssetSelectionInput!]!' },
    removeLabelIds: { __type: '[UUID!]!' },
    surveyId: { __type: 'UUID!' },
  },
  ApplyLabelsToSelectionPayload: {
    __typename: { __type: 'String!' },
    applyLabelsToSelectionResult: { __type: 'ApplyLabelsToSelectionResult' },
    errors: { __type: '[ApplyLabelsToSelectionError!]' },
  },
  ApplyLabelsToSelectionResult: {
    __typename: { __type: 'String!' },
    affectedItemCount: { __type: 'Int!' },
  },
  Asset: {
    __typename: { __type: 'String!' },
    additionalData: { __type: 'JSON' },
    associatedSurveysIds: { __type: '[UUID!]!' },
    bounds: { __type: 'Bounds' },
    createdAt: { __type: 'Instant!' },
    createdBy: { __type: 'Account' },
    createdById: { __type: 'UUID' },
    events: {
      __type: 'EventsCollectionSegment',
      __args: { skip: 'Int', take: 'Int' },
    },
    id: { __type: 'UUID!' },
    labels: { __type: '[Label!]!' },
    name: { __type: 'String!' },
    paths: { __type: '[Path!]!' },
    projectId: { __type: 'UUID!' },
    search: { __type: 'String' },
    tgm: { __type: 'Tgm!' },
    updatedAt: { __type: 'Instant!' },
    updatedBy: { __type: 'Account' },
    updatedById: { __type: 'UUID' },
  },
  AssetConfig: {
    __typename: { __type: 'String!' },
    name: { __type: 'String!' },
    pathConfigs: { __type: '[PathConfig!]!' },
    tgm: { __type: 'Tgm!' },
  },
  AssetConfigFilterInput: {
    and: { __type: '[AssetConfigFilterInput!]' },
    name: { __type: 'StringOperationFilterInput' },
    or: { __type: '[AssetConfigFilterInput!]' },
    pathConfigs: { __type: 'ListFilterInputTypeOfPathConfigFilterInput' },
    tgm: { __type: 'TgmOperationFilterInput' },
  },
  AssetConfigInput: {
    name: { __type: 'String!' },
    pathConfigs: { __type: '[PathConfigInput!]!' },
    tgm: { __type: 'Tgm!' },
  },
  AssetFilterInput: {
    additionalData: { __type: 'JsonElementFilterInput' },
    and: { __type: '[AssetFilterInput!]' },
    associatedSurveysIds: { __type: 'ListUuidOperationFilterInput' },
    bounds: { __type: 'BoundsFilterInput' },
    createdAt: { __type: 'ComparableInstantOperationFilterInput' },
    createdBy: { __type: 'AccountFilterInput' },
    createdById: { __type: 'UuidOperationFilterInput' },
    id: { __type: 'UuidOperationFilterInput' },
    labels: { __type: 'ListFilterInputTypeOfLabelFilterInput' },
    name: { __type: 'StringOperationFilterInput' },
    or: { __type: '[AssetFilterInput!]' },
    paths: { __type: 'ListFilterInputTypeOfPathFilterInput' },
    projectId: { __type: 'UuidOperationFilterInput' },
    search: { __type: 'StringOperationFilterInput' },
    tgm: { __type: 'TgmOperationFilterInput' },
    updatedAt: { __type: 'ComparableInstantOperationFilterInput' },
    updatedBy: { __type: 'AccountFilterInput' },
    updatedById: { __type: 'UuidOperationFilterInput' },
  },
  AssetSelection: {
    __typename: { __type: 'String!' },
    assetId: { __type: 'UUID!' },
    pathSelections: { __type: '[PathSelection!]' },
  },
  AssetSelectionFilterInput: {
    and: { __type: '[AssetSelectionFilterInput!]' },
    assetId: { __type: 'UuidOperationFilterInput' },
    or: { __type: '[AssetSelectionFilterInput!]' },
    pathSelections: { __type: 'ListFilterInputTypeOfPathSelectionFilterInput' },
  },
  AssetSelectionInput: {
    assetId: { __type: 'UUID!' },
    pathSelections: { __type: '[PathSelectionInput!]' },
  },
  AssetSortInput: {
    additionalData: { __type: 'SortEnumType' },
    bounds: { __type: 'BoundsSortInput' },
    createdAt: { __type: 'SortEnumType' },
    createdBy: { __type: 'AccountSortInput' },
    createdById: { __type: 'SortEnumType' },
    id: { __type: 'SortEnumType' },
    name: { __type: 'SortEnumType' },
    projectId: { __type: 'SortEnumType' },
    search: { __type: 'SortEnumType' },
    tgm: { __type: 'SortEnumType' },
    updatedAt: { __type: 'SortEnumType' },
    updatedBy: { __type: 'AccountSortInput' },
    updatedById: { __type: 'SortEnumType' },
  },
  AssetsCollectionSegment: {
    __typename: { __type: 'String!' },
    items: { __type: '[Asset!]' },
    pageInfo: { __type: 'CollectionSegmentInfo!' },
    totalCount: { __type: 'Int!' },
  },
  BackgroundJob: {
    __typename: { __type: 'String!' },
    additionalData: { __type: 'JSON' },
    createdAt: { __type: 'Instant!' },
    createdBy: { __type: 'Account' },
    createdById: { __type: 'UUID' },
    events: {
      __type: 'EventsCollectionSegment',
      __args: { skip: 'Int', take: 'Int' },
    },
    id: { __type: 'UUID!' },
    lastLogs: { __type: '[Log!]!', __args: { count: 'Int!' } },
    logs: { __type: '[Log!]!' },
    projectName: { __type: 'String' },
    search: { __type: 'String' },
    status: { __type: 'JobStatus!' },
    surveyId: { __type: 'UUID' },
    type: { __type: 'JobType!' },
    updatedAt: { __type: 'Instant!' },
    updatedBy: { __type: 'Account' },
    updatedById: { __type: 'UUID' },
  },
  BackgroundJobFilterInput: {
    additionalData: { __type: 'JsonElementFilterInput' },
    and: { __type: '[BackgroundJobFilterInput!]' },
    createdAt: { __type: 'ComparableInstantOperationFilterInput' },
    createdBy: { __type: 'AccountFilterInput' },
    createdById: { __type: 'UuidOperationFilterInput' },
    id: { __type: 'UuidOperationFilterInput' },
    or: { __type: '[BackgroundJobFilterInput!]' },
    projectName: { __type: 'StringOperationFilterInput' },
    search: { __type: 'StringOperationFilterInput' },
    status: { __type: 'JobStatusOperationFilterInput' },
    surveyId: { __type: 'UuidOperationFilterInput' },
    type: { __type: 'JobTypeOperationFilterInput' },
    updatedAt: { __type: 'ComparableInstantOperationFilterInput' },
    updatedBy: { __type: 'AccountFilterInput' },
    updatedById: { __type: 'UuidOperationFilterInput' },
  },
  BackgroundJobsCollectionSegment: {
    __typename: { __type: 'String!' },
    items: { __type: '[IBackgroundJob]' },
    pageInfo: { __type: 'CollectionSegmentInfo!' },
    totalCount: { __type: 'Int!' },
  },
  BadRequestError: {
    __typename: { __type: 'String!' },
    errors: { __type: '[KeyValuePairOfStringAndString__!]!' },
    message: { __type: 'String!' },
  },
  Blob: {
    __typename: { __type: 'String!' },
    additionalData: { __type: 'JSON' },
    contentLength: { __type: 'Long!' },
    contentType: { __type: 'String!' },
    createdAt: { __type: 'Instant!' },
    createdBy: { __type: 'Account' },
    createdById: { __type: 'UUID' },
    events: {
      __type: 'EventsCollectionSegment',
      __args: { skip: 'Int', take: 'Int' },
    },
    fileName: { __type: 'String!' },
    id: { __type: 'UUID!' },
    search: { __type: 'String' },
    updatedAt: { __type: 'Instant!' },
    updatedBy: { __type: 'Account' },
    updatedById: { __type: 'UUID' },
    uri: { __type: 'String!' },
  },
  BlobFilterInput: {
    additionalData: { __type: 'JsonElementFilterInput' },
    and: { __type: '[BlobFilterInput!]' },
    contentLength: { __type: 'LongOperationFilterInput' },
    contentType: { __type: 'StringOperationFilterInput' },
    createdAt: { __type: 'ComparableInstantOperationFilterInput' },
    createdBy: { __type: 'AccountFilterInput' },
    createdById: { __type: 'UuidOperationFilterInput' },
    fileName: { __type: 'StringOperationFilterInput' },
    id: { __type: 'UuidOperationFilterInput' },
    or: { __type: '[BlobFilterInput!]' },
    search: { __type: 'StringOperationFilterInput' },
    updatedAt: { __type: 'ComparableInstantOperationFilterInput' },
    updatedBy: { __type: 'AccountFilterInput' },
    updatedById: { __type: 'UuidOperationFilterInput' },
    uri: { __type: 'StringOperationFilterInput' },
  },
  BlobSortInput: {
    additionalData: { __type: 'SortEnumType' },
    contentLength: { __type: 'SortEnumType' },
    contentType: { __type: 'SortEnumType' },
    createdAt: { __type: 'SortEnumType' },
    createdBy: { __type: 'AccountSortInput' },
    createdById: { __type: 'SortEnumType' },
    fileName: { __type: 'SortEnumType' },
    id: { __type: 'SortEnumType' },
    search: { __type: 'SortEnumType' },
    updatedAt: { __type: 'SortEnumType' },
    updatedBy: { __type: 'AccountSortInput' },
    updatedById: { __type: 'SortEnumType' },
    uri: { __type: 'SortEnumType' },
  },
  BlobsCollectionSegment: {
    __typename: { __type: 'String!' },
    items: { __type: '[Blob!]' },
    pageInfo: { __type: 'CollectionSegmentInfo!' },
    totalCount: { __type: 'Int!' },
  },
  BlockchainNotarizationJob: {
    __typename: { __type: 'String!' },
    additionalData: { __type: 'JSON' },
    createdAt: { __type: 'Instant!' },
    createdBy: { __type: 'Account' },
    createdById: { __type: 'UUID' },
    events: {
      __type: 'EventsCollectionSegment',
      __args: { skip: 'Int', take: 'Int' },
    },
    id: { __type: 'UUID!' },
    lastLogs: { __type: '[Log!]!', __args: { count: 'Int!' } },
    logs: { __type: '[Log!]!' },
    notarization: { __type: 'Notarization' },
    notarizationId: { __type: 'UUID' },
    projectName: { __type: 'String' },
    search: { __type: 'String' },
    status: { __type: 'JobStatus!' },
    surveyId: { __type: 'UUID' },
    type: { __type: 'JobType!' },
    updatedAt: { __type: 'Instant!' },
    updatedBy: { __type: 'Account' },
    updatedById: { __type: 'UUID' },
  },
  BlockchainNotarizationJobFilterInput: {
    additionalData: { __type: 'JsonElementFilterInput' },
    and: { __type: '[BlockchainNotarizationJobFilterInput!]' },
    createdAt: { __type: 'ComparableInstantOperationFilterInput' },
    createdBy: { __type: 'AccountFilterInput' },
    createdById: { __type: 'UuidOperationFilterInput' },
    id: { __type: 'UuidOperationFilterInput' },
    notarization: { __type: 'NotarizationFilterInput' },
    notarizationId: { __type: 'UuidOperationFilterInput' },
    or: { __type: '[BlockchainNotarizationJobFilterInput!]' },
    projectName: { __type: 'StringOperationFilterInput' },
    search: { __type: 'StringOperationFilterInput' },
    status: { __type: 'JobStatusOperationFilterInput' },
    surveyId: { __type: 'UuidOperationFilterInput' },
    type: { __type: 'JobTypeOperationFilterInput' },
    updatedAt: { __type: 'ComparableInstantOperationFilterInput' },
    updatedBy: { __type: 'AccountFilterInput' },
    updatedById: { __type: 'UuidOperationFilterInput' },
  },
  BlockchainNotarizationJobSortInput: {
    additionalData: { __type: 'SortEnumType' },
    createdAt: { __type: 'SortEnumType' },
    createdBy: { __type: 'AccountSortInput' },
    createdById: { __type: 'SortEnumType' },
    id: { __type: 'SortEnumType' },
    notarization: { __type: 'NotarizationSortInput' },
    notarizationId: { __type: 'SortEnumType' },
    projectName: { __type: 'SortEnumType' },
    search: { __type: 'SortEnumType' },
    status: { __type: 'SortEnumType' },
    surveyId: { __type: 'SortEnumType' },
    type: { __type: 'SortEnumType' },
    updatedAt: { __type: 'SortEnumType' },
    updatedBy: { __type: 'AccountSortInput' },
    updatedById: { __type: 'SortEnumType' },
  },
  BlockchainNotarizationJobsCollectionSegment: {
    __typename: { __type: 'String!' },
    items: { __type: '[BlockchainNotarizationJob!]' },
    pageInfo: { __type: 'CollectionSegmentInfo!' },
    totalCount: { __type: 'Int!' },
  },
  BooleanOperationFilterInput: {
    eq: { __type: 'Boolean' },
    neq: { __type: 'Boolean' },
  },
  Bounds: {
    __typename: { __type: 'String!' },
    maxLatitude: { __type: 'Decimal' },
    maxLongitude: { __type: 'Decimal' },
    minLatitude: { __type: 'Decimal' },
    minLongitude: { __type: 'Decimal' },
  },
  BoundsFilterInput: {
    and: { __type: '[BoundsFilterInput!]' },
    maxLatitude: { __type: 'DecimalOperationFilterInput' },
    maxLongitude: { __type: 'DecimalOperationFilterInput' },
    minLatitude: { __type: 'DecimalOperationFilterInput' },
    minLongitude: { __type: 'DecimalOperationFilterInput' },
    or: { __type: '[BoundsFilterInput!]' },
  },
  BoundsSortInput: {
    maxLatitude: { __type: 'SortEnumType' },
    maxLongitude: { __type: 'SortEnumType' },
    minLatitude: { __type: 'SortEnumType' },
    minLongitude: { __type: 'SortEnumType' },
  },
  BulkAssignProjectsToOperatorsError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$BulkAssignProjectsToOperatorsError!' },
  },
  BulkAssignProjectsToOperatorsInput: {
    operatorsIds: { __type: '[UUID!]!' },
    projectsIds: { __type: '[UUID!]!' },
  },
  BulkAssignProjectsToOperatorsPayload: {
    __typename: { __type: 'String!' },
    boolean: { __type: 'Boolean' },
    errors: { __type: '[BulkAssignProjectsToOperatorsError!]' },
  },
  BulkAssignProjectsToOrganizationError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$BulkAssignProjectsToOrganizationError!' },
  },
  BulkAssignProjectsToOrganizationInput: {
    organizationId: { __type: 'UUID!' },
    projectsIds: { __type: '[UUID!]!' },
  },
  BulkAssignProjectsToOrganizationPayload: {
    __typename: { __type: 'String!' },
    errors: { __type: '[BulkAssignProjectsToOrganizationError!]' },
    organization: { __type: 'Organization' },
  },
  BulkDeleteAccountInput: { accountsIds: { __type: '[UUID!]!' } },
  BulkDeleteAccountPayload: {
    __typename: { __type: 'String!' },
    uuid: { __type: '[UUID!]' },
  },
  BulkSetAccountStatusInput: {
    accountsIds: { __type: '[UUID!]!' },
    isEnabled: { __type: 'Boolean!' },
  },
  BulkSetAccountStatusPayload: {
    __typename: { __type: 'String!' },
    uuid: { __type: '[UUID!]' },
  },
  BulkSetLabelsError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$BulkSetLabelsError!' },
  },
  BulkSetLabelsInput: {
    labelIds: { __type: '[UUID!]!' },
    targetIds: { __type: '[UUID!]!' },
    targetType: { __type: 'String!' },
  },
  BulkSetLabelsPayload: {
    __typename: { __type: 'String!' },
    errors: { __type: '[BulkSetLabelsError!]' },
    itemIds: { __type: 'ItemIds' },
  },
  BulkUnassignOrganizationProjectsError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$BulkUnassignOrganizationProjectsError!' },
  },
  BulkUnassignOrganizationProjectsInput: {
    organizationId: { __type: 'UUID!' },
    projectsIds: { __type: '[UUID!]!' },
  },
  BulkUnassignOrganizationProjectsPayload: {
    __typename: { __type: 'String!' },
    errors: { __type: '[BulkUnassignOrganizationProjectsError!]' },
    int: { __type: 'Int' },
  },
  ByteOperationFilterInput: {
    eq: { __type: 'Byte' },
    gt: { __type: 'Byte' },
    gte: { __type: 'Byte' },
    in: { __type: '[Byte]' },
    lt: { __type: 'Byte' },
    lte: { __type: 'Byte' },
    neq: { __type: 'Byte' },
    ngt: { __type: 'Byte' },
    ngte: { __type: 'Byte' },
    nin: { __type: '[Byte]' },
    nlt: { __type: 'Byte' },
    nlte: { __type: 'Byte' },
  },
  CloneProjectError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$CloneProjectError!' },
  },
  CloneProjectInput: {
    newProjectName: { __type: 'String!' },
    projectId: { __type: 'UUID!' },
  },
  CloneProjectPayload: {
    __typename: { __type: 'String!' },
    errors: { __type: '[CloneProjectError!]' },
    project: { __type: 'Project' },
  },
  CollectionSegmentInfo: {
    __typename: { __type: 'String!' },
    hasNextPage: { __type: 'Boolean!' },
    hasPreviousPage: { __type: 'Boolean!' },
  },
  ComparableInstantOperationFilterInput: {
    eq: { __type: 'Instant' },
    gt: { __type: 'Instant' },
    gte: { __type: 'Instant' },
    in: { __type: '[Instant!]' },
    lt: { __type: 'Instant' },
    lte: { __type: 'Instant' },
    neq: { __type: 'Instant' },
    ngt: { __type: 'Instant' },
    ngte: { __type: 'Instant' },
    nin: { __type: '[Instant!]' },
    nlt: { __type: 'Instant' },
    nlte: { __type: 'Instant' },
  },
  ComparableNullableOfInstantOperationFilterInput: {
    eq: { __type: 'Instant' },
    gt: { __type: 'Instant' },
    gte: { __type: 'Instant' },
    in: { __type: '[Instant]' },
    lt: { __type: 'Instant' },
    lte: { __type: 'Instant' },
    neq: { __type: 'Instant' },
    ngt: { __type: 'Instant' },
    ngte: { __type: 'Instant' },
    nin: { __type: '[Instant]' },
    nlt: { __type: 'Instant' },
    nlte: { __type: 'Instant' },
  },
  ConfirmAccountError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$ConfirmAccountError!' },
  },
  ConfirmAccountInput: {
    firstName: { __type: 'String!' },
    lastName: { __type: 'String!' },
    password: { __type: 'String!' },
    token: { __type: 'String!' },
  },
  ConfirmAccountPayload: {
    __typename: { __type: 'String!' },
    account: { __type: 'Account' },
    errors: { __type: '[ConfirmAccountError!]' },
  },
  ConfirmEmailAddressError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$ConfirmEmailAddressError!' },
  },
  ConfirmEmailAddressInput: { token: { __type: 'String!' } },
  ConfirmEmailAddressPayload: {
    __typename: { __type: 'String!' },
    account: { __type: 'Account' },
    errors: { __type: '[ConfirmEmailAddressError!]' },
  },
  ConflictError: {
    __typename: { __type: 'String!' },
    message: { __type: 'String!' },
  },
  CoordinateSequenceSortInput: {
    count: { __type: 'SortEnumType' },
    dimension: { __type: 'SortEnumType' },
    first: { __type: 'CoordinateSortInput' },
    hasM: { __type: 'SortEnumType' },
    hasZ: { __type: 'SortEnumType' },
    last: { __type: 'CoordinateSortInput' },
    mOrdinateIndex: { __type: 'SortEnumType' },
    measures: { __type: 'SortEnumType' },
    ordinates: { __type: 'SortEnumType' },
    spatial: { __type: 'SortEnumType' },
    zOrdinateIndex: { __type: 'SortEnumType' },
  },
  CoordinateSortInput: {
    coordinateValue: { __type: 'CoordinateSortInput' },
    isValid: { __type: 'SortEnumType' },
    m: { __type: 'SortEnumType' },
    x: { __type: 'SortEnumType' },
    y: { __type: 'SortEnumType' },
    z: { __type: 'SortEnumType' },
  },
  CreateApiKeyError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$CreateApiKeyError!' },
  },
  CreateApiKeyPayload: {
    __typename: { __type: 'String!' },
    apiKey: { __type: 'ApiKey' },
    errors: { __type: '[CreateApiKeyError!]' },
  },
  CreateBlockchainNotarizationJobError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$CreateBlockchainNotarizationJobError!' },
  },
  CreateBlockchainNotarizationJobInput: {
    additionalData: { __type: 'JSON' },
    surveyId: { __type: 'UUID' },
  },
  CreateBlockchainNotarizationJobPayload: {
    __typename: { __type: 'String!' },
    blockchainNotarizationJob: { __type: 'BlockchainNotarizationJob' },
    errors: { __type: '[CreateBlockchainNotarizationJobError!]' },
  },
  CreateCustomLayerUploadJobError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$CreateCustomLayerUploadJobError!' },
  },
  CreateCustomLayerUploadJobInput: {
    additionalData: { __type: 'JSON' },
    csvFileId: { __type: 'UUID!' },
    layerName: { __type: 'String!' },
    styleId: { __type: 'UUID' },
    surveyId: { __type: 'UUID' },
  },
  CreateCustomLayerUploadJobPayload: {
    __typename: { __type: 'String!' },
    customLayerUploadJob: { __type: 'CustomLayerUploadJob' },
    errors: { __type: '[CreateCustomLayerUploadJobError!]' },
  },
  CreateCustomStyleError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$CreateCustomStyleError!' },
  },
  CreateCustomStyleInput: {
    additionalData: { __type: 'JSON' },
    name: { __type: 'String!' },
    parameter: { __type: 'Parameter' },
    projectId: { __type: 'UUID' },
    style: { __type: 'JSON!' },
  },
  CreateCustomStylePayload: {
    __typename: { __type: 'String!' },
    customStyle: { __type: 'CustomStyle' },
    errors: { __type: '[CreateCustomStyleError!]' },
  },
  CreateDatasetPreparationJobError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$CreateDatasetPreparationJobError!' },
  },
  CreateDatasetPreparationJobInput: {
    additionalData: { __type: 'JSON' },
    archiveFileId: { __type: 'UUID!' },
    resolveToponyms: { __type: 'Boolean!' },
    surveyId: { __type: 'UUID' },
  },
  CreateDatasetPreparationJobPayload: {
    __typename: { __type: 'String!' },
    datasetPreparationJob: { __type: 'DatasetPreparationJob' },
    errors: { __type: '[CreateDatasetPreparationJobError!]' },
  },
  CreateInterventionError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$CreateInterventionError!' },
  },
  CreateInterventionInput: {
    actualCost: { __type: 'Decimal!' },
    additionalData: { __type: 'JSON' },
    category: { __type: 'InterventionCategory!' },
    effectiveEndDate: { __type: 'LocalDate!' },
    effectiveStartDate: { __type: 'LocalDate!' },
    estimatedCost: { __type: 'Decimal!' },
    labelsIds: { __type: '[UUID!]' },
    name: { __type: 'String!' },
    notes: { __type: 'String!' },
    organizationId: { __type: 'UUID' },
    plannedEndDate: { __type: 'LocalDate!' },
    plannedStartDate: { __type: 'LocalDate!' },
    projectId: { __type: 'UUID' },
    selections: { __type: '[AssetSelectionInput!]!' },
    status: { __type: 'InterventionStatus!' },
    surveyId: { __type: 'UUID' },
  },
  CreateInterventionPayload: {
    __typename: { __type: 'String!' },
    errors: { __type: '[CreateInterventionError!]' },
    intervention: { __type: 'Intervention' },
  },
  CreateLabelError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$CreateLabelError!' },
  },
  CreateLabelInput: {
    additionalData: { __type: 'JSON' },
    isAdminLabel: { __type: 'Boolean!' },
    name: { __type: 'String!' },
    projectId: { __type: 'UUID' },
    targetType: { __type: 'String' },
  },
  CreateLabelPayload: {
    __typename: { __type: 'String!' },
    errors: { __type: '[CreateLabelError!]' },
    label: { __type: 'Label' },
  },
  CreateMediaUploadJobError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$CreateMediaUploadJobError!' },
  },
  CreateMediaUploadJobInput: {
    additionalData: { __type: 'JSON' },
    mFVDataFileId: { __type: 'UUID!' },
    surveyId: { __type: 'UUID' },
  },
  CreateMediaUploadJobPayload: {
    __typename: { __type: 'String!' },
    errors: { __type: '[CreateMediaUploadJobError!]' },
    mediaUploadJob: { __type: 'MediaUploadJob' },
  },
  CreateOrganizationError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$CreateOrganizationError!' },
  },
  CreateOrganizationInput: {
    additionalData: { __type: 'JSON' },
    address: { __type: 'AddressInput' },
    certifiedEmailAddress: { __type: 'String' },
    email: { __type: 'String' },
    fiscalCode: { __type: 'String' },
    labelsIds: { __type: '[UUID!]' },
    legalName: { __type: 'String' },
    logoId: { __type: 'UUID' },
    name: { __type: 'String' },
    note: { __type: 'String' },
    phoneNumber: { __type: 'String' },
    pointOfContact: { __type: 'String' },
    sDICode: { __type: 'String' },
    vatNumber: { __type: 'String' },
  },
  CreateOrganizationPayload: {
    __typename: { __type: 'String!' },
    errors: { __type: '[CreateOrganizationError!]' },
    organization: { __type: 'Organization' },
  },
  CreateParametersComputationJobError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$CreateParametersComputationJobError!' },
  },
  CreateParametersComputationJobInput: {
    additionalData: { __type: 'JSON' },
    assetConfigs: { __type: '[AssetConfigInput!]!' },
    csvFileId: { __type: 'UUID' },
    mFVDataFileId: { __type: 'UUID!' },
    parameterConfig: { __type: 'ParameterConfigInput!' },
    surveyDate: { __type: 'Instant' },
    surveyId: { __type: 'UUID' },
  },
  CreateParametersComputationJobPayload: {
    __typename: { __type: 'String!' },
    errors: { __type: '[CreateParametersComputationJobError!]' },
    parametersComputationJob: { __type: 'ParametersComputationJob' },
  },
  CreateProjectConfigurationError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$CreateProjectConfigurationError!' },
  },
  CreateProjectConfigurationInput: {
    additionalData: { __type: 'JSON' },
    baseCostPerCmMq: { __type: 'Decimal!' },
    baseThicknessCm: { __type: 'Decimal!' },
    binderCostPerCmMq: { __type: 'Decimal!' },
    binderThicknessCm: { __type: 'Decimal!' },
    foundationCostPerCmMq: { __type: 'Decimal!' },
    foundationThicknessCm: { __type: 'Decimal!' },
    laneWidth: { __type: 'Decimal!' },
    projectId: { __type: 'UUID' },
    rpPciThreshold: { __type: 'Decimal!' },
    rs1PciThreshold: { __type: 'Decimal!' },
    rs2PciThreshold: { __type: 'Decimal!' },
    rssPciThreshold: { __type: 'Decimal!' },
    tgm: { __type: 'Tgm!' },
    wearCostPerCmMq: { __type: 'Decimal!' },
    wearThicknessCm: { __type: 'Decimal!' },
  },
  CreateProjectConfigurationPayload: {
    __typename: { __type: 'String!' },
    errors: { __type: '[CreateProjectConfigurationError!]' },
    projectConfiguration: { __type: 'ProjectConfiguration' },
  },
  CreateProjectError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$CreateProjectError!' },
  },
  CreateProjectInput: {
    additionalData: { __type: 'JSON' },
    labelsIds: { __type: '[UUID!]' },
    name: { __type: 'String!' },
    organizationId: { __type: 'UUID' },
  },
  CreateProjectPayload: {
    __typename: { __type: 'String!' },
    errors: { __type: '[CreateProjectError!]' },
    project: { __type: 'Project' },
  },
  CreateReportGenerationJobError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$CreateReportGenerationJobError!' },
  },
  CreateReportGenerationJobInput: {
    additionalData: { __type: 'JSON' },
    interventionsIds: { __type: '[UUID!]' },
    reportName: { __type: 'String!' },
    reportType: { __type: 'ReportType!' },
    sectionsSelection: { __type: '[String!]!' },
    selections: { __type: '[AssetSelectionInput!]!' },
    surveyId: { __type: 'UUID' },
  },
  CreateReportGenerationJobPayload: {
    __typename: { __type: 'String!' },
    errors: { __type: '[CreateReportGenerationJobError!]' },
    reportGenerationJob: { __type: 'ReportGenerationJob' },
  },
  CreateSurveyDataBulkUploadJobError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$CreateSurveyDataBulkUploadJobError!' },
  },
  CreateSurveyDataBulkUploadJobInput: {
    additionalData: { __type: 'JSON' },
    csvFileId: { __type: 'UUID!' },
    surveyId: { __type: 'UUID' },
  },
  CreateSurveyDataBulkUploadJobPayload: {
    __typename: { __type: 'String!' },
    errors: { __type: '[CreateSurveyDataBulkUploadJobError!]' },
    surveyDataBulkUploadJob: { __type: 'SurveyDataBulkUploadJob' },
  },
  CreateSurveyDataDeletionJobError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$CreateSurveyDataDeletionJobError!' },
  },
  CreateSurveyDataDeletionJobInput: {
    additionalData: { __type: 'JSON' },
    surveyId: { __type: 'UUID' },
  },
  CreateSurveyDataDeletionJobPayload: {
    __typename: { __type: 'String!' },
    errors: { __type: '[CreateSurveyDataDeletionJobError!]' },
    surveyDataDeletionJob: { __type: 'SurveyDataDeletionJob' },
  },
  CreateSurveyError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$CreateSurveyError!' },
  },
  CreateSurveyInput: {
    additionalData: { __type: 'JSON' },
    endDate: { __type: 'LocalDate!' },
    labelsIds: { __type: '[UUID!]' },
    name: { __type: 'String!' },
    projectId: { __type: 'UUID!' },
    startDate: { __type: 'LocalDate!' },
    status: { __type: 'SurveyStatus!' },
  },
  CreateSurveyPayload: {
    __typename: { __type: 'String!' },
    errors: { __type: '[CreateSurveyError!]' },
    survey: { __type: 'Survey' },
  },
  CustomLayer: {
    __typename: { __type: 'String!' },
    additionalData: { __type: 'JSON' },
    createdAt: { __type: 'Instant!' },
    createdBy: { __type: 'Account' },
    createdById: { __type: 'UUID' },
    events: {
      __type: 'EventsCollectionSegment',
      __args: { skip: 'Int', take: 'Int' },
    },
    id: { __type: 'UUID!' },
    items: { __type: '[CustomLayerItem!]!' },
    name: { __type: 'String!' },
    search: { __type: 'String' },
    surveyId: { __type: 'UUID!' },
    updatedAt: { __type: 'Instant!' },
    updatedBy: { __type: 'Account' },
    updatedById: { __type: 'UUID' },
  },
  CustomLayerFilterInput: {
    additionalData: { __type: 'JsonElementFilterInput' },
    and: { __type: '[CustomLayerFilterInput!]' },
    createdAt: { __type: 'ComparableInstantOperationFilterInput' },
    createdBy: { __type: 'AccountFilterInput' },
    createdById: { __type: 'UuidOperationFilterInput' },
    id: { __type: 'UuidOperationFilterInput' },
    items: { __type: 'ListFilterInputTypeOfCustomLayerItemFilterInput' },
    name: { __type: 'StringOperationFilterInput' },
    or: { __type: '[CustomLayerFilterInput!]' },
    search: { __type: 'StringOperationFilterInput' },
    surveyId: { __type: 'UuidOperationFilterInput' },
    updatedAt: { __type: 'ComparableInstantOperationFilterInput' },
    updatedBy: { __type: 'AccountFilterInput' },
    updatedById: { __type: 'UuidOperationFilterInput' },
  },
  CustomLayerItem: {
    __typename: { __type: 'String!' },
    additionalData: { __type: 'JSON' },
    color: { __type: 'String' },
    createdAt: { __type: 'Instant!' },
    createdBy: { __type: 'Account' },
    createdById: { __type: 'UUID' },
    customLayerId: { __type: 'UUID!' },
    events: {
      __type: 'EventsCollectionSegment',
      __args: { skip: 'Int', take: 'Int' },
    },
    geometryType: { __type: 'String!' },
    id: { __type: 'UUID!' },
    lineString: { __type: 'GeoJSONLineStringType' },
    note: { __type: 'String!' },
    outlineColor: { __type: 'String' },
    point: { __type: 'GeoJSONPointType' },
    polygon: { __type: 'GeoJSONPolygonType' },
    search: { __type: 'String' },
    updatedAt: { __type: 'Instant!' },
    updatedBy: { __type: 'Account' },
    updatedById: { __type: 'UUID' },
    value: { __type: 'String!' },
  },
  CustomLayerItemFilterInput: {
    additionalData: { __type: 'JsonElementFilterInput' },
    and: { __type: '[CustomLayerItemFilterInput!]' },
    color: { __type: 'StringOperationFilterInput' },
    createdAt: { __type: 'ComparableInstantOperationFilterInput' },
    createdBy: { __type: 'AccountFilterInput' },
    createdById: { __type: 'UuidOperationFilterInput' },
    customLayerId: { __type: 'UuidOperationFilterInput' },
    geometryType: { __type: 'StringOperationFilterInput' },
    id: { __type: 'UuidOperationFilterInput' },
    lineString: { __type: 'LineStringFilterInput' },
    note: { __type: 'StringOperationFilterInput' },
    or: { __type: '[CustomLayerItemFilterInput!]' },
    outlineColor: { __type: 'StringOperationFilterInput' },
    point: { __type: 'PointFilterInput' },
    polygon: { __type: 'PolygonFilterInput' },
    search: { __type: 'StringOperationFilterInput' },
    updatedAt: { __type: 'ComparableInstantOperationFilterInput' },
    updatedBy: { __type: 'AccountFilterInput' },
    updatedById: { __type: 'UuidOperationFilterInput' },
    value: { __type: 'StringOperationFilterInput' },
  },
  CustomLayerItemSortInput: {
    additionalData: { __type: 'SortEnumType' },
    color: { __type: 'SortEnumType' },
    createdAt: { __type: 'SortEnumType' },
    createdBy: { __type: 'AccountSortInput' },
    createdById: { __type: 'SortEnumType' },
    customLayerId: { __type: 'SortEnumType' },
    geometryType: { __type: 'SortEnumType' },
    id: { __type: 'SortEnumType' },
    lineString: { __type: 'LineStringSortInput' },
    note: { __type: 'SortEnumType' },
    outlineColor: { __type: 'SortEnumType' },
    point: { __type: 'PointSortInput' },
    polygon: { __type: 'PolygonSortInput' },
    search: { __type: 'SortEnumType' },
    updatedAt: { __type: 'SortEnumType' },
    updatedBy: { __type: 'AccountSortInput' },
    updatedById: { __type: 'SortEnumType' },
    value: { __type: 'SortEnumType' },
  },
  CustomLayerItemsCollectionSegment: {
    __typename: { __type: 'String!' },
    items: { __type: '[CustomLayerItem!]' },
    pageInfo: { __type: 'CollectionSegmentInfo!' },
    totalCount: { __type: 'Int!' },
  },
  CustomLayerSortInput: {
    additionalData: { __type: 'SortEnumType' },
    createdAt: { __type: 'SortEnumType' },
    createdBy: { __type: 'AccountSortInput' },
    createdById: { __type: 'SortEnumType' },
    id: { __type: 'SortEnumType' },
    name: { __type: 'SortEnumType' },
    search: { __type: 'SortEnumType' },
    surveyId: { __type: 'SortEnumType' },
    updatedAt: { __type: 'SortEnumType' },
    updatedBy: { __type: 'AccountSortInput' },
    updatedById: { __type: 'SortEnumType' },
  },
  CustomLayerUploadJob: {
    __typename: { __type: 'String!' },
    additionalData: { __type: 'JSON' },
    createdAt: { __type: 'Instant!' },
    createdBy: { __type: 'Account' },
    createdById: { __type: 'UUID' },
    csvFileId: { __type: 'UUID!' },
    events: {
      __type: 'EventsCollectionSegment',
      __args: { skip: 'Int', take: 'Int' },
    },
    id: { __type: 'UUID!' },
    lastLogs: { __type: '[Log!]!', __args: { count: 'Int!' } },
    layerName: { __type: 'String!' },
    logs: { __type: '[Log!]!' },
    projectName: { __type: 'String' },
    search: { __type: 'String' },
    status: { __type: 'JobStatus!' },
    styleId: { __type: 'UUID' },
    surveyId: { __type: 'UUID' },
    type: { __type: 'JobType!' },
    updatedAt: { __type: 'Instant!' },
    updatedBy: { __type: 'Account' },
    updatedById: { __type: 'UUID' },
  },
  CustomLayerUploadJobFilterInput: {
    additionalData: { __type: 'JsonElementFilterInput' },
    and: { __type: '[CustomLayerUploadJobFilterInput!]' },
    createdAt: { __type: 'ComparableInstantOperationFilterInput' },
    createdBy: { __type: 'AccountFilterInput' },
    createdById: { __type: 'UuidOperationFilterInput' },
    csvFileId: { __type: 'UuidOperationFilterInput' },
    id: { __type: 'UuidOperationFilterInput' },
    layerName: { __type: 'StringOperationFilterInput' },
    or: { __type: '[CustomLayerUploadJobFilterInput!]' },
    projectName: { __type: 'StringOperationFilterInput' },
    search: { __type: 'StringOperationFilterInput' },
    status: { __type: 'JobStatusOperationFilterInput' },
    styleId: { __type: 'UuidOperationFilterInput' },
    surveyId: { __type: 'UuidOperationFilterInput' },
    type: { __type: 'JobTypeOperationFilterInput' },
    updatedAt: { __type: 'ComparableInstantOperationFilterInput' },
    updatedBy: { __type: 'AccountFilterInput' },
    updatedById: { __type: 'UuidOperationFilterInput' },
  },
  CustomLayerUploadJobSortInput: {
    additionalData: { __type: 'SortEnumType' },
    createdAt: { __type: 'SortEnumType' },
    createdBy: { __type: 'AccountSortInput' },
    createdById: { __type: 'SortEnumType' },
    csvFileId: { __type: 'SortEnumType' },
    id: { __type: 'SortEnumType' },
    layerName: { __type: 'SortEnumType' },
    projectName: { __type: 'SortEnumType' },
    search: { __type: 'SortEnumType' },
    status: { __type: 'SortEnumType' },
    styleId: { __type: 'SortEnumType' },
    surveyId: { __type: 'SortEnumType' },
    type: { __type: 'SortEnumType' },
    updatedAt: { __type: 'SortEnumType' },
    updatedBy: { __type: 'AccountSortInput' },
    updatedById: { __type: 'SortEnumType' },
  },
  CustomLayerUploadJobsCollectionSegment: {
    __typename: { __type: 'String!' },
    items: { __type: '[CustomLayerUploadJob!]' },
    pageInfo: { __type: 'CollectionSegmentInfo!' },
    totalCount: { __type: 'Int!' },
  },
  CustomLayersCollectionSegment: {
    __typename: { __type: 'String!' },
    items: { __type: '[CustomLayer!]' },
    pageInfo: { __type: 'CollectionSegmentInfo!' },
    totalCount: { __type: 'Int!' },
  },
  CustomStyle: {
    __typename: { __type: 'String!' },
    additionalData: { __type: 'JSON' },
    createdAt: { __type: 'Instant!' },
    createdBy: { __type: 'Account' },
    createdById: { __type: 'UUID' },
    events: {
      __type: 'EventsCollectionSegment',
      __args: { skip: 'Int', take: 'Int' },
    },
    id: { __type: 'UUID!' },
    isGlobal: { __type: 'Boolean!' },
    isKnownParameterStyle: { __type: 'Boolean!' },
    name: { __type: 'String!' },
    parameter: { __type: 'Parameter' },
    projectId: { __type: 'UUID' },
    search: { __type: 'String' },
    style: { __type: 'JSON!' },
    updatedAt: { __type: 'Instant!' },
    updatedBy: { __type: 'Account' },
    updatedById: { __type: 'UUID' },
  },
  CustomStyleFilterInput: {
    additionalData: { __type: 'JsonElementFilterInput' },
    and: { __type: '[CustomStyleFilterInput!]' },
    createdAt: { __type: 'ComparableInstantOperationFilterInput' },
    createdBy: { __type: 'AccountFilterInput' },
    createdById: { __type: 'UuidOperationFilterInput' },
    id: { __type: 'UuidOperationFilterInput' },
    isGlobal: { __type: 'BooleanOperationFilterInput' },
    isKnownParameterStyle: { __type: 'BooleanOperationFilterInput' },
    name: { __type: 'StringOperationFilterInput' },
    or: { __type: '[CustomStyleFilterInput!]' },
    parameter: { __type: 'NullableOfParameterOperationFilterInput' },
    projectId: { __type: 'UuidOperationFilterInput' },
    search: { __type: 'StringOperationFilterInput' },
    style: { __type: 'JsonElementFilterInput' },
    updatedAt: { __type: 'ComparableInstantOperationFilterInput' },
    updatedBy: { __type: 'AccountFilterInput' },
    updatedById: { __type: 'UuidOperationFilterInput' },
  },
  CustomStyleSortInput: {
    additionalData: { __type: 'SortEnumType' },
    createdAt: { __type: 'SortEnumType' },
    createdBy: { __type: 'AccountSortInput' },
    createdById: { __type: 'SortEnumType' },
    id: { __type: 'SortEnumType' },
    isGlobal: { __type: 'SortEnumType' },
    isKnownParameterStyle: { __type: 'SortEnumType' },
    name: { __type: 'SortEnumType' },
    parameter: { __type: 'SortEnumType' },
    projectId: { __type: 'SortEnumType' },
    search: { __type: 'SortEnumType' },
    style: { __type: 'SortEnumType' },
    updatedAt: { __type: 'SortEnumType' },
    updatedBy: { __type: 'AccountSortInput' },
    updatedById: { __type: 'SortEnumType' },
  },
  CustomStylesCollectionSegment: {
    __typename: { __type: 'String!' },
    items: { __type: '[CustomStyle!]' },
    pageInfo: { __type: 'CollectionSegmentInfo!' },
    totalCount: { __type: 'Int!' },
  },
  DatasetPreparationJob: {
    __typename: { __type: 'String!' },
    additionalData: { __type: 'JSON' },
    archiveFile: { __type: 'Blob!' },
    archiveFileId: { __type: 'UUID!' },
    createdAt: { __type: 'Instant!' },
    createdBy: { __type: 'Account' },
    createdById: { __type: 'UUID' },
    events: {
      __type: 'EventsCollectionSegment',
      __args: { skip: 'Int', take: 'Int' },
    },
    id: { __type: 'UUID!' },
    lastLogs: { __type: '[Log!]!', __args: { count: 'Int!' } },
    logs: { __type: '[Log!]!' },
    outputCsvFile: { __type: 'Blob' },
    outputCsvFileId: { __type: 'UUID' },
    projectName: { __type: 'String' },
    resolveToponyms: { __type: 'Boolean!' },
    search: { __type: 'String' },
    status: { __type: 'JobStatus!' },
    surveyId: { __type: 'UUID' },
    type: { __type: 'JobType!' },
    updatedAt: { __type: 'Instant!' },
    updatedBy: { __type: 'Account' },
    updatedById: { __type: 'UUID' },
  },
  DatasetPreparationJobFilterInput: {
    additionalData: { __type: 'JsonElementFilterInput' },
    and: { __type: '[DatasetPreparationJobFilterInput!]' },
    archiveFile: { __type: 'BlobFilterInput' },
    archiveFileId: { __type: 'UuidOperationFilterInput' },
    createdAt: { __type: 'ComparableInstantOperationFilterInput' },
    createdBy: { __type: 'AccountFilterInput' },
    createdById: { __type: 'UuidOperationFilterInput' },
    id: { __type: 'UuidOperationFilterInput' },
    or: { __type: '[DatasetPreparationJobFilterInput!]' },
    outputCsvFile: { __type: 'BlobFilterInput' },
    outputCsvFileId: { __type: 'UuidOperationFilterInput' },
    projectName: { __type: 'StringOperationFilterInput' },
    resolveToponyms: { __type: 'BooleanOperationFilterInput' },
    search: { __type: 'StringOperationFilterInput' },
    status: { __type: 'JobStatusOperationFilterInput' },
    surveyId: { __type: 'UuidOperationFilterInput' },
    type: { __type: 'JobTypeOperationFilterInput' },
    updatedAt: { __type: 'ComparableInstantOperationFilterInput' },
    updatedBy: { __type: 'AccountFilterInput' },
    updatedById: { __type: 'UuidOperationFilterInput' },
  },
  DatasetPreparationJobSortInput: {
    additionalData: { __type: 'SortEnumType' },
    archiveFile: { __type: 'BlobSortInput' },
    archiveFileId: { __type: 'SortEnumType' },
    createdAt: { __type: 'SortEnumType' },
    createdBy: { __type: 'AccountSortInput' },
    createdById: { __type: 'SortEnumType' },
    id: { __type: 'SortEnumType' },
    outputCsvFile: { __type: 'BlobSortInput' },
    outputCsvFileId: { __type: 'SortEnumType' },
    projectName: { __type: 'SortEnumType' },
    resolveToponyms: { __type: 'SortEnumType' },
    search: { __type: 'SortEnumType' },
    status: { __type: 'SortEnumType' },
    surveyId: { __type: 'SortEnumType' },
    type: { __type: 'SortEnumType' },
    updatedAt: { __type: 'SortEnumType' },
    updatedBy: { __type: 'AccountSortInput' },
    updatedById: { __type: 'SortEnumType' },
  },
  DatasetPreparationJobsCollectionSegment: {
    __typename: { __type: 'String!' },
    items: { __type: '[DatasetPreparationJob!]' },
    pageInfo: { __type: 'CollectionSegmentInfo!' },
    totalCount: { __type: 'Int!' },
  },
  DecimalOperationFilterInput: {
    eq: { __type: 'Decimal' },
    gt: { __type: 'Decimal' },
    gte: { __type: 'Decimal' },
    in: { __type: '[Decimal]' },
    lt: { __type: 'Decimal' },
    lte: { __type: 'Decimal' },
    neq: { __type: 'Decimal' },
    ngt: { __type: 'Decimal' },
    ngte: { __type: 'Decimal' },
    nin: { __type: '[Decimal]' },
    nlt: { __type: 'Decimal' },
    nlte: { __type: 'Decimal' },
  },
  DeleteAccountError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$DeleteAccountError!' },
  },
  DeleteAccountInput: { id: { __type: 'UUID!' } },
  DeleteAccountPayload: {
    __typename: { __type: 'String!' },
    account: { __type: 'Account' },
    errors: { __type: '[DeleteAccountError!]' },
  },
  DeleteApiKeyError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$DeleteApiKeyError!' },
  },
  DeleteApiKeyInput: { id: { __type: 'UUID!' } },
  DeleteApiKeyPayload: {
    __typename: { __type: 'String!' },
    deleted: { __type: 'Deleted' },
    errors: { __type: '[DeleteApiKeyError!]' },
  },
  DeleteAssetError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$DeleteAssetError!' },
  },
  DeleteAssetInput: { id: { __type: 'UUID!' } },
  DeleteAssetPayload: {
    __typename: { __type: 'String!' },
    deleted: { __type: 'Deleted' },
    errors: { __type: '[DeleteAssetError!]' },
  },
  DeleteBlobError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$DeleteBlobError!' },
  },
  DeleteBlobInput: { id: { __type: 'UUID!' } },
  DeleteBlobPayload: {
    __typename: { __type: 'String!' },
    deleted: { __type: 'Deleted' },
    errors: { __type: '[DeleteBlobError!]' },
  },
  DeleteBlockchainNotarizationJobError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$DeleteBlockchainNotarizationJobError!' },
  },
  DeleteBlockchainNotarizationJobInput: { id: { __type: 'UUID!' } },
  DeleteBlockchainNotarizationJobPayload: {
    __typename: { __type: 'String!' },
    deleted: { __type: 'Deleted' },
    errors: { __type: '[DeleteBlockchainNotarizationJobError!]' },
  },
  DeleteCustomLayerError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$DeleteCustomLayerError!' },
  },
  DeleteCustomLayerInput: { id: { __type: 'UUID!' } },
  DeleteCustomLayerItemError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$DeleteCustomLayerItemError!' },
  },
  DeleteCustomLayerItemInput: { id: { __type: 'UUID!' } },
  DeleteCustomLayerItemPayload: {
    __typename: { __type: 'String!' },
    deleted: { __type: 'Deleted' },
    errors: { __type: '[DeleteCustomLayerItemError!]' },
  },
  DeleteCustomLayerPayload: {
    __typename: { __type: 'String!' },
    deleted: { __type: 'Deleted' },
    errors: { __type: '[DeleteCustomLayerError!]' },
  },
  DeleteCustomLayerUploadJobError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$DeleteCustomLayerUploadJobError!' },
  },
  DeleteCustomLayerUploadJobInput: { id: { __type: 'UUID!' } },
  DeleteCustomLayerUploadJobPayload: {
    __typename: { __type: 'String!' },
    deleted: { __type: 'Deleted' },
    errors: { __type: '[DeleteCustomLayerUploadJobError!]' },
  },
  DeleteCustomStyleError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$DeleteCustomStyleError!' },
  },
  DeleteCustomStyleInput: { id: { __type: 'UUID!' } },
  DeleteCustomStylePayload: {
    __typename: { __type: 'String!' },
    deleted: { __type: 'Deleted' },
    errors: { __type: '[DeleteCustomStyleError!]' },
  },
  DeleteDatasetPreparationJobError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$DeleteDatasetPreparationJobError!' },
  },
  DeleteDatasetPreparationJobInput: { id: { __type: 'UUID!' } },
  DeleteDatasetPreparationJobPayload: {
    __typename: { __type: 'String!' },
    deleted: { __type: 'Deleted' },
    errors: { __type: '[DeleteDatasetPreparationJobError!]' },
  },
  DeleteEventError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$DeleteEventError!' },
  },
  DeleteEventInput: { id: { __type: 'UUID!' } },
  DeleteEventPayload: {
    __typename: { __type: 'String!' },
    deleted: { __type: 'Deleted' },
    errors: { __type: '[DeleteEventError!]' },
  },
  DeleteInterventionError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$DeleteInterventionError!' },
  },
  DeleteInterventionInput: { id: { __type: 'UUID!' } },
  DeleteInterventionPayload: {
    __typename: { __type: 'String!' },
    deleted: { __type: 'Deleted' },
    errors: { __type: '[DeleteInterventionError!]' },
  },
  DeleteItemError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$DeleteItemError!' },
  },
  DeleteItemInput: { id: { __type: 'UUID!' } },
  DeleteItemPayload: {
    __typename: { __type: 'String!' },
    deleted: { __type: 'Deleted' },
    errors: { __type: '[DeleteItemError!]' },
  },
  DeleteLabelError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$DeleteLabelError!' },
  },
  DeleteLabelInput: { id: { __type: 'UUID!' } },
  DeleteLabelPayload: {
    __typename: { __type: 'String!' },
    deleted: { __type: 'Deleted' },
    errors: { __type: '[DeleteLabelError!]' },
  },
  DeleteMediaUploadJobError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$DeleteMediaUploadJobError!' },
  },
  DeleteMediaUploadJobInput: { id: { __type: 'UUID!' } },
  DeleteMediaUploadJobPayload: {
    __typename: { __type: 'String!' },
    deleted: { __type: 'Deleted' },
    errors: { __type: '[DeleteMediaUploadJobError!]' },
  },
  DeleteOrganizationError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$DeleteOrganizationError!' },
  },
  DeleteOrganizationInput: {
    deleteProjects: { __type: 'Boolean!' },
    id: { __type: 'UUID!' },
  },
  DeleteOrganizationPayload: {
    __typename: { __type: 'String!' },
    errors: { __type: '[DeleteOrganizationError!]' },
    organization: { __type: 'Organization' },
  },
  DeleteParametersComputationJobError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$DeleteParametersComputationJobError!' },
  },
  DeleteParametersComputationJobInput: { id: { __type: 'UUID!' } },
  DeleteParametersComputationJobPayload: {
    __typename: { __type: 'String!' },
    deleted: { __type: 'Deleted' },
    errors: { __type: '[DeleteParametersComputationJobError!]' },
  },
  DeletePathError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$DeletePathError!' },
  },
  DeletePathInput: { id: { __type: 'UUID!' } },
  DeletePathPayload: {
    __typename: { __type: 'String!' },
    deleted: { __type: 'Deleted' },
    errors: { __type: '[DeletePathError!]' },
  },
  DeleteProjectConfigurationError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$DeleteProjectConfigurationError!' },
  },
  DeleteProjectConfigurationInput: { id: { __type: 'UUID!' } },
  DeleteProjectConfigurationPayload: {
    __typename: { __type: 'String!' },
    deleted: { __type: 'Deleted' },
    errors: { __type: '[DeleteProjectConfigurationError!]' },
  },
  DeleteProjectError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$DeleteProjectError!' },
  },
  DeleteProjectInput: { id: { __type: 'UUID!' } },
  DeleteProjectPayload: {
    __typename: { __type: 'String!' },
    deleted: { __type: 'Deleted' },
    errors: { __type: '[DeleteProjectError!]' },
  },
  DeleteReportError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$DeleteReportError!' },
  },
  DeleteReportGenerationJobError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$DeleteReportGenerationJobError!' },
  },
  DeleteReportGenerationJobInput: { id: { __type: 'UUID!' } },
  DeleteReportGenerationJobPayload: {
    __typename: { __type: 'String!' },
    deleted: { __type: 'Deleted' },
    errors: { __type: '[DeleteReportGenerationJobError!]' },
  },
  DeleteReportInput: { id: { __type: 'UUID!' } },
  DeleteReportPayload: {
    __typename: { __type: 'String!' },
    deleted: { __type: 'Deleted' },
    errors: { __type: '[DeleteReportError!]' },
  },
  DeleteSurveyDataBulkUploadJobError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$DeleteSurveyDataBulkUploadJobError!' },
  },
  DeleteSurveyDataBulkUploadJobInput: { id: { __type: 'UUID!' } },
  DeleteSurveyDataBulkUploadJobPayload: {
    __typename: { __type: 'String!' },
    deleted: { __type: 'Deleted' },
    errors: { __type: '[DeleteSurveyDataBulkUploadJobError!]' },
  },
  DeleteSurveyDataDeletionJobError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$DeleteSurveyDataDeletionJobError!' },
  },
  DeleteSurveyDataDeletionJobInput: { id: { __type: 'UUID!' } },
  DeleteSurveyDataDeletionJobPayload: {
    __typename: { __type: 'String!' },
    deleted: { __type: 'Deleted' },
    errors: { __type: '[DeleteSurveyDataDeletionJobError!]' },
  },
  DeleteSurveyError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$DeleteSurveyError!' },
  },
  DeleteSurveyInput: { id: { __type: 'UUID!' } },
  DeleteSurveyPayload: {
    __typename: { __type: 'String!' },
    deleted: { __type: 'Deleted' },
    errors: { __type: '[DeleteSurveyError!]' },
  },
  Deleted: {
    __typename: { __type: 'String!' },
    deletedAt: { __type: 'Instant' },
    deletedById: { __type: 'UUID' },
    id: { __type: 'UUID!' },
  },
  DimensionOperationFilterInput: {
    eq: { __type: 'Dimension' },
    in: { __type: '[Dimension!]' },
    neq: { __type: 'Dimension' },
    nin: { __type: '[Dimension!]' },
  },
  EnvelopeSortInput: {
    area: { __type: 'SortEnumType' },
    centre: { __type: 'CoordinateSortInput' },
    diameter: { __type: 'SortEnumType' },
    height: { __type: 'SortEnumType' },
    isNull: { __type: 'SortEnumType' },
    maxExtent: { __type: 'SortEnumType' },
    maxX: { __type: 'SortEnumType' },
    maxY: { __type: 'SortEnumType' },
    minExtent: { __type: 'SortEnumType' },
    minX: { __type: 'SortEnumType' },
    minY: { __type: 'SortEnumType' },
    width: { __type: 'SortEnumType' },
  },
  Error: {
    __typename: { __type: 'String!' },
    message: { __type: 'String!' },
    $on: { __type: '$Error!' },
  },
  Event: {
    __typename: { __type: 'String!' },
    data: { __type: 'JSON' },
    firedAt: { __type: 'Instant!' },
    id: { __type: 'UUID!' },
    targetId: { __type: 'UUID' },
    targetType: { __type: 'String' },
    type: { __type: 'String!' },
  },
  EventFilterInput: {
    and: { __type: '[EventFilterInput!]' },
    data: { __type: 'JsonElementFilterInput' },
    firedAt: { __type: 'ComparableInstantOperationFilterInput' },
    id: { __type: 'UuidOperationFilterInput' },
    or: { __type: '[EventFilterInput!]' },
    targetId: { __type: 'UuidOperationFilterInput' },
    targetType: { __type: 'StringOperationFilterInput' },
    type: { __type: 'StringOperationFilterInput' },
  },
  EventSortInput: {
    data: { __type: 'SortEnumType' },
    firedAt: { __type: 'SortEnumType' },
    id: { __type: 'SortEnumType' },
    targetId: { __type: 'SortEnumType' },
    targetType: { __type: 'SortEnumType' },
    type: { __type: 'SortEnumType' },
  },
  EventsCollectionSegment: {
    __typename: { __type: 'String!' },
    items: { __type: '[Event!]' },
    pageInfo: { __type: 'CollectionSegmentInfo!' },
    totalCount: { __type: 'Int!' },
  },
  FloatOperationFilterInput: {
    eq: { __type: 'Float' },
    gt: { __type: 'Float' },
    gte: { __type: 'Float' },
    in: { __type: '[Float]' },
    lt: { __type: 'Float' },
    lte: { __type: 'Float' },
    neq: { __type: 'Float' },
    ngt: { __type: 'Float' },
    ngte: { __type: 'Float' },
    nin: { __type: '[Float]' },
    nlt: { __type: 'Float' },
    nlte: { __type: 'Float' },
  },
  ForbiddenError: {
    __typename: { __type: 'String!' },
    message: { __type: 'String!' },
  },
  ForceDeleteCustomStyleInput: { id: { __type: 'UUID!' } },
  ForceDeleteCustomStylePayload: {
    __typename: { __type: 'String!' },
    int: { __type: 'Int' },
  },
  ForcePasswordResetError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$ForcePasswordResetError!' },
  },
  ForcePasswordResetInput: { accountId: { __type: 'UUID!' } },
  ForcePasswordResetPayload: {
    __typename: { __type: 'String!' },
    account: { __type: 'Account' },
    errors: { __type: '[ForcePasswordResetError!]' },
  },
  GeoJSONInterface: {
    __typename: { __type: 'String!' },
    bbox: { __type: '[Float]' },
    crs: { __type: 'Int' },
    type: { __type: 'GeoJSONGeometryType!' },
    $on: { __type: '$GeoJSONInterface!' },
  },
  GeoJSONLineStringInput: {
    coordinates: { __type: '[Position]' },
    crs: { __type: 'Int' },
    type: { __type: 'GeoJSONGeometryType' },
  },
  GeoJSONLineStringType: {
    __typename: { __type: 'String!' },
    bbox: { __type: '[Float!]!' },
    coordinates: { __type: '[Position]' },
    crs: { __type: 'Int!' },
    type: { __type: 'GeoJSONGeometryType!' },
  },
  GeoJSONMultiLineStringInput: {
    coordinates: { __type: '[[Position]]' },
    crs: { __type: 'Int' },
    type: { __type: 'GeoJSONGeometryType' },
  },
  GeoJSONMultiLineStringType: {
    __typename: { __type: 'String!' },
    bbox: { __type: '[Float!]!' },
    coordinates: { __type: '[Position]' },
    crs: { __type: 'Int!' },
    type: { __type: 'GeoJSONGeometryType!' },
  },
  GeoJSONMultiPointInput: {
    coordinates: { __type: '[Position]' },
    crs: { __type: 'Int' },
    type: { __type: 'GeoJSONGeometryType' },
  },
  GeoJSONMultiPointType: {
    __typename: { __type: 'String!' },
    bbox: { __type: '[Float!]!' },
    coordinates: { __type: '[Position]' },
    crs: { __type: 'Int!' },
    type: { __type: 'GeoJSONGeometryType!' },
  },
  GeoJSONMultiPolygonInput: {
    coordinates: { __type: 'Coordinates' },
    crs: { __type: 'Int' },
    type: { __type: 'GeoJSONGeometryType' },
  },
  GeoJSONMultiPolygonType: {
    __typename: { __type: 'String!' },
    bbox: { __type: '[Float!]!' },
    coordinates: { __type: 'Coordinates' },
    crs: { __type: 'Int!' },
    type: { __type: 'GeoJSONGeometryType!' },
  },
  GeoJSONPointInput: {
    coordinates: { __type: 'Position' },
    crs: { __type: 'Int' },
    type: { __type: 'GeoJSONGeometryType' },
  },
  GeoJSONPointType: {
    __typename: { __type: 'String!' },
    bbox: { __type: '[Float!]!' },
    coordinates: { __type: 'Position' },
    crs: { __type: 'Int!' },
    type: { __type: 'GeoJSONGeometryType!' },
  },
  GeoJSONPolygonInput: {
    coordinates: { __type: '[[Position]]' },
    crs: { __type: 'Int' },
    type: { __type: 'GeoJSONGeometryType' },
  },
  GeoJSONPolygonType: {
    __typename: { __type: 'String!' },
    bbox: { __type: '[Float!]!' },
    coordinates: { __type: '[[Position]]' },
    crs: { __type: 'Int!' },
    type: { __type: 'GeoJSONGeometryType!' },
  },
  GeometryContainsOperationFilterInput: {
    buffer: { __type: 'Float' },
    geometry: { __type: 'Geometry!' },
  },
  GeometryDistanceOperationFilterInput: {
    buffer: { __type: 'Float' },
    eq: { __type: 'Float' },
    geometry: { __type: 'Geometry!' },
    gt: { __type: 'Float' },
    gte: { __type: 'Float' },
    in: { __type: '[Float!]' },
    lt: { __type: 'Float' },
    lte: { __type: 'Float' },
    neq: { __type: 'Float' },
    ngt: { __type: 'Float' },
    ngte: { __type: 'Float' },
    nin: { __type: '[Float!]' },
    nlt: { __type: 'Float' },
    nlte: { __type: 'Float' },
  },
  GeometryFilterInput: {
    and: { __type: '[GeometryFilterInput!]' },
    area: { __type: 'FloatOperationFilterInput' },
    boundary: { __type: 'GeometryFilterInput' },
    centroid: { __type: 'PointFilterInput' },
    contains: { __type: 'GeometryContainsOperationFilterInput' },
    dimension: { __type: 'DimensionOperationFilterInput' },
    distance: { __type: 'GeometryDistanceOperationFilterInput' },
    envelope: { __type: 'GeometryFilterInput' },
    geometryType: { __type: 'StringOperationFilterInput' },
    interiorPoint: { __type: 'PointFilterInput' },
    intersects: { __type: 'GeometryIntersectsOperationFilterInput' },
    isSimple: { __type: 'BooleanOperationFilterInput' },
    isValid: { __type: 'BooleanOperationFilterInput' },
    length: { __type: 'FloatOperationFilterInput' },
    ncontains: { __type: 'GeometryContainsOperationFilterInput' },
    nintersects: { __type: 'GeometryIntersectsOperationFilterInput' },
    noverlaps: { __type: 'GeometryOverlapsOperationFilterInput' },
    ntouches: { __type: 'GeometryTouchesOperationFilterInput' },
    numPoints: { __type: 'IntOperationFilterInput' },
    nwithin: { __type: 'GeometryWithinOperationFilterInput' },
    ogcGeometryType: { __type: 'OgcGeometryTypeOperationFilterInput' },
    or: { __type: '[GeometryFilterInput!]' },
    overlaps: { __type: 'GeometryOverlapsOperationFilterInput' },
    pointOnSurface: { __type: 'PointFilterInput' },
    srid: { __type: 'IntOperationFilterInput' },
    touches: { __type: 'GeometryTouchesOperationFilterInput' },
    within: { __type: 'GeometryWithinOperationFilterInput' },
  },
  GeometryIntersectsOperationFilterInput: {
    buffer: { __type: 'Float' },
    geometry: { __type: 'Geometry!' },
  },
  GeometryOverlapsOperationFilterInput: {
    buffer: { __type: 'Float' },
    geometry: { __type: 'Geometry!' },
  },
  GeometryTouchesOperationFilterInput: {
    buffer: { __type: 'Float' },
    geometry: { __type: 'Geometry!' },
  },
  GeometryWithinOperationFilterInput: {
    buffer: { __type: 'Float' },
    geometry: { __type: 'Geometry!' },
  },
  GetAdminOverviewPayload: {
    __typename: { __type: 'String!' },
    accountsCount: { __type: 'Int!' },
    lastSurvey: { __type: 'Survey' },
    nextSurvey: { __type: 'Survey' },
    organizationsCount: { __type: 'Int!' },
    projectsCount: { __type: 'Int!' },
  },
  GetInvitationByTokenPayload: {
    __typename: { __type: 'String!' },
    email: { __type: 'String!' },
  },
  GetOperatorOverviewPayload: {
    __typename: { __type: 'String!' },
    lastSurvey: { __type: 'Survey' },
    nextSurvey: { __type: 'Survey' },
    projectsCount: { __type: 'Int!' },
  },
  GlobalConfig: {
    __typename: { __type: 'String!' },
    pciCurvesFileId: { __type: 'UUID' },
  },
  IBackgroundJob: {
    __typename: { __type: 'String!' },
    additionalData: { __type: 'JSON' },
    createdAt: { __type: 'Instant!' },
    createdBy: { __type: 'Account' },
    createdById: { __type: 'UUID' },
    id: { __type: 'UUID!' },
    lastLogs: { __type: '[Log!]!', __args: { count: 'Int!' } },
    logs: { __type: '[Log!]!' },
    projectName: { __type: 'String' },
    search: { __type: 'String' },
    status: { __type: 'JobStatus!' },
    surveyId: { __type: 'UUID' },
    type: { __type: 'JobType!' },
    updatedAt: { __type: 'Instant!' },
    updatedBy: { __type: 'Account' },
    updatedById: { __type: 'UUID' },
    $on: { __type: '$IBackgroundJob!' },
  },
  InitUpdateEmailAddressError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$InitUpdateEmailAddressError!' },
  },
  InitUpdateEmailAddressInput: {
    email: { __type: 'String!' },
    id: { __type: 'UUID!' },
  },
  InitUpdateEmailAddressPayload: {
    __typename: { __type: 'String!' },
    account: { __type: 'Account' },
    errors: { __type: '[InitUpdateEmailAddressError!]' },
  },
  IntOperationFilterInput: {
    eq: { __type: 'Int' },
    gt: { __type: 'Int' },
    gte: { __type: 'Int' },
    in: { __type: '[Int]' },
    lt: { __type: 'Int' },
    lte: { __type: 'Int' },
    neq: { __type: 'Int' },
    ngt: { __type: 'Int' },
    ngte: { __type: 'Int' },
    nin: { __type: '[Int]' },
    nlt: { __type: 'Int' },
    nlte: { __type: 'Int' },
  },
  Intervention: {
    __typename: { __type: 'String!' },
    actualCost: { __type: 'Decimal!' },
    additionalData: { __type: 'JSON' },
    category: { __type: 'InterventionCategory!' },
    createdAt: { __type: 'Instant!' },
    createdBy: { __type: 'Account' },
    createdById: { __type: 'UUID' },
    effectiveEndDate: { __type: 'LocalDate!' },
    effectiveStartDate: { __type: 'LocalDate!' },
    estimatedCost: { __type: 'Decimal!' },
    events: {
      __type: 'EventsCollectionSegment',
      __args: { skip: 'Int', take: 'Int' },
    },
    id: { __type: 'UUID!' },
    labels: { __type: '[Label!]!' },
    name: { __type: 'String!' },
    notes: { __type: 'String!' },
    organizationId: { __type: 'UUID' },
    plannedEndDate: { __type: 'LocalDate!' },
    plannedStartDate: { __type: 'LocalDate!' },
    projectId: { __type: 'UUID' },
    search: { __type: 'String' },
    selections: { __type: '[AssetSelection!]!' },
    status: { __type: 'InterventionStatus!' },
    surveyId: { __type: 'UUID' },
    updatedAt: { __type: 'Instant!' },
    updatedBy: { __type: 'Account' },
    updatedById: { __type: 'UUID' },
  },
  InterventionCategoryOperationFilterInput: {
    eq: { __type: 'InterventionCategory' },
    in: { __type: '[InterventionCategory!]' },
    neq: { __type: 'InterventionCategory' },
    nin: { __type: '[InterventionCategory!]' },
  },
  InterventionFilterInput: {
    actualCost: { __type: 'DecimalOperationFilterInput' },
    additionalData: { __type: 'JsonElementFilterInput' },
    and: { __type: '[InterventionFilterInput!]' },
    category: { __type: 'InterventionCategoryOperationFilterInput' },
    createdAt: { __type: 'ComparableInstantOperationFilterInput' },
    createdBy: { __type: 'AccountFilterInput' },
    createdById: { __type: 'UuidOperationFilterInput' },
    effectiveEndDate: { __type: 'LocalDateOperationFilterInput' },
    effectiveStartDate: { __type: 'LocalDateOperationFilterInput' },
    estimatedCost: { __type: 'DecimalOperationFilterInput' },
    id: { __type: 'UuidOperationFilterInput' },
    labels: { __type: 'ListFilterInputTypeOfLabelFilterInput' },
    name: { __type: 'StringOperationFilterInput' },
    notes: { __type: 'StringOperationFilterInput' },
    or: { __type: '[InterventionFilterInput!]' },
    organizationId: { __type: 'UuidOperationFilterInput' },
    plannedEndDate: { __type: 'LocalDateOperationFilterInput' },
    plannedStartDate: { __type: 'LocalDateOperationFilterInput' },
    projectId: { __type: 'UuidOperationFilterInput' },
    search: { __type: 'StringOperationFilterInput' },
    status: { __type: 'InterventionStatusOperationFilterInput' },
    surveyId: { __type: 'UuidOperationFilterInput' },
    updatedAt: { __type: 'ComparableInstantOperationFilterInput' },
    updatedBy: { __type: 'AccountFilterInput' },
    updatedById: { __type: 'UuidOperationFilterInput' },
  },
  InterventionSortInput: {
    actualCost: { __type: 'SortEnumType' },
    additionalData: { __type: 'SortEnumType' },
    category: { __type: 'SortEnumType' },
    createdAt: { __type: 'SortEnumType' },
    createdBy: { __type: 'AccountSortInput' },
    createdById: { __type: 'SortEnumType' },
    effectiveEndDate: { __type: 'SortEnumType' },
    effectiveStartDate: { __type: 'SortEnumType' },
    estimatedCost: { __type: 'SortEnumType' },
    id: { __type: 'SortEnumType' },
    name: { __type: 'SortEnumType' },
    notes: { __type: 'SortEnumType' },
    organizationId: { __type: 'SortEnumType' },
    plannedEndDate: { __type: 'SortEnumType' },
    plannedStartDate: { __type: 'SortEnumType' },
    projectId: { __type: 'SortEnumType' },
    search: { __type: 'SortEnumType' },
    status: { __type: 'SortEnumType' },
    surveyId: { __type: 'SortEnumType' },
    updatedAt: { __type: 'SortEnumType' },
    updatedBy: { __type: 'AccountSortInput' },
    updatedById: { __type: 'SortEnumType' },
  },
  InterventionStatusOperationFilterInput: {
    eq: { __type: 'InterventionStatus' },
    in: { __type: '[InterventionStatus!]' },
    neq: { __type: 'InterventionStatus' },
    nin: { __type: '[InterventionStatus!]' },
  },
  InterventionsCollectionSegment: {
    __typename: { __type: 'String!' },
    items: { __type: '[Intervention!]' },
    pageInfo: { __type: 'CollectionSegmentInfo!' },
    totalCount: { __type: 'Int!' },
  },
  InviteNewAccountError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$InviteNewAccountError!' },
  },
  InviteNewAccountInput: {
    email: { __type: 'String!' },
    role: { __type: 'RoleName!' },
  },
  InviteNewAccountPayload: {
    __typename: { __type: 'String!' },
    account: { __type: 'Account' },
    errors: { __type: '[InviteNewAccountError!]' },
  },
  Item: {
    __typename: { __type: 'String!' },
    additionalData: { __type: 'JSON' },
    assetId: { __type: 'UUID!' },
    createdAt: { __type: 'Instant!' },
    createdBy: { __type: 'Account' },
    createdById: { __type: 'UUID' },
    end: { __type: 'Decimal!' },
    events: {
      __type: 'EventsCollectionSegment',
      __args: { skip: 'Int', take: 'Int' },
    },
    geometry: { __type: 'GeoJSONLineStringType' },
    grain: { __type: 'Decimal!' },
    id: { __type: 'UUID!' },
    index: { __type: 'Int!' },
    isForward: { __type: 'Boolean!' },
    length: { __type: 'Decimal!' },
    parameter: { __type: 'Parameter!' },
    pathId: { __type: 'UUID!' },
    projectId: { __type: 'UUID!' },
    search: { __type: 'String' },
    simplifiedGeometry: { __type: 'GeoJSONLineStringType' },
    start: { __type: 'Decimal!' },
    surveyId: { __type: 'UUID!' },
    updatedAt: { __type: 'Instant!' },
    updatedBy: { __type: 'Account' },
    updatedById: { __type: 'UUID' },
    value: { __type: 'Decimal!' },
  },
  ItemFilterInput: {
    additionalData: { __type: 'JsonElementFilterInput' },
    and: { __type: '[ItemFilterInput!]' },
    assetId: { __type: 'UuidOperationFilterInput' },
    createdAt: { __type: 'ComparableInstantOperationFilterInput' },
    createdBy: { __type: 'AccountFilterInput' },
    createdById: { __type: 'UuidOperationFilterInput' },
    end: { __type: 'DecimalOperationFilterInput' },
    geometry: { __type: 'LineStringFilterInput' },
    grain: { __type: 'DecimalOperationFilterInput' },
    id: { __type: 'UuidOperationFilterInput' },
    index: { __type: 'IntOperationFilterInput' },
    isForward: { __type: 'BooleanOperationFilterInput' },
    length: { __type: 'DecimalOperationFilterInput' },
    or: { __type: '[ItemFilterInput!]' },
    parameter: { __type: 'ParameterOperationFilterInput' },
    pathId: { __type: 'UuidOperationFilterInput' },
    projectId: { __type: 'UuidOperationFilterInput' },
    search: { __type: 'StringOperationFilterInput' },
    simplifiedGeometry: { __type: 'LineStringFilterInput' },
    start: { __type: 'DecimalOperationFilterInput' },
    surveyId: { __type: 'UuidOperationFilterInput' },
    updatedAt: { __type: 'ComparableInstantOperationFilterInput' },
    updatedBy: { __type: 'AccountFilterInput' },
    updatedById: { __type: 'UuidOperationFilterInput' },
    value: { __type: 'DecimalOperationFilterInput' },
  },
  ItemIds: { __typename: { __type: 'String!' }, ids: { __type: '[UUID!]!' } },
  ItemSortInput: {
    additionalData: { __type: 'SortEnumType' },
    assetId: { __type: 'SortEnumType' },
    createdAt: { __type: 'SortEnumType' },
    createdBy: { __type: 'AccountSortInput' },
    createdById: { __type: 'SortEnumType' },
    end: { __type: 'SortEnumType' },
    geometry: { __type: 'LineStringSortInput' },
    grain: { __type: 'SortEnumType' },
    id: { __type: 'SortEnumType' },
    index: { __type: 'SortEnumType' },
    isForward: { __type: 'SortEnumType' },
    length: { __type: 'SortEnumType' },
    parameter: { __type: 'SortEnumType' },
    pathId: { __type: 'SortEnumType' },
    projectId: { __type: 'SortEnumType' },
    search: { __type: 'SortEnumType' },
    simplifiedGeometry: { __type: 'LineStringSortInput' },
    start: { __type: 'SortEnumType' },
    surveyId: { __type: 'SortEnumType' },
    updatedAt: { __type: 'SortEnumType' },
    updatedBy: { __type: 'AccountSortInput' },
    updatedById: { __type: 'SortEnumType' },
    value: { __type: 'SortEnumType' },
  },
  JobStatusOperationFilterInput: {
    eq: { __type: 'JobStatus' },
    in: { __type: '[JobStatus!]' },
    neq: { __type: 'JobStatus' },
    nin: { __type: '[JobStatus!]' },
  },
  JobTypeOperationFilterInput: {
    eq: { __type: 'JobType' },
    in: { __type: '[JobType!]' },
    neq: { __type: 'JobType' },
    nin: { __type: '[JobType!]' },
  },
  JsonElementFilterInput: {
    and: { __type: '[JsonElementFilterInput!]' },
    or: { __type: '[JsonElementFilterInput!]' },
    valueKind: { __type: 'JsonValueKindOperationFilterInput' },
  },
  JsonValueKindOperationFilterInput: {
    eq: { __type: 'JsonValueKind' },
    in: { __type: '[JsonValueKind!]' },
    neq: { __type: 'JsonValueKind' },
    nin: { __type: '[JsonValueKind!]' },
  },
  KeyValuePairOfStringAndString__: {
    __typename: { __type: 'String!' },
    key: { __type: 'String!' },
    value: { __type: '[String!]!' },
  },
  Label: {
    __typename: { __type: 'String!' },
    additionalData: { __type: 'JSON' },
    createdAt: { __type: 'Instant!' },
    createdBy: { __type: 'Account' },
    createdById: { __type: 'UUID' },
    events: {
      __type: 'EventsCollectionSegment',
      __args: { skip: 'Int', take: 'Int' },
    },
    id: { __type: 'UUID!' },
    isAdminLabel: { __type: 'Boolean!' },
    name: { __type: 'String!' },
    projectId: { __type: 'UUID' },
    targetType: { __type: 'String' },
    updatedAt: { __type: 'Instant!' },
    updatedBy: { __type: 'Account' },
    updatedById: { __type: 'UUID' },
  },
  LabelFilterInput: {
    additionalData: { __type: 'JsonElementFilterInput' },
    and: { __type: '[LabelFilterInput!]' },
    createdAt: { __type: 'ComparableInstantOperationFilterInput' },
    createdBy: { __type: 'AccountFilterInput' },
    createdById: { __type: 'UuidOperationFilterInput' },
    id: { __type: 'UuidOperationFilterInput' },
    isAdminLabel: { __type: 'BooleanOperationFilterInput' },
    name: { __type: 'StringOperationFilterInput' },
    or: { __type: '[LabelFilterInput!]' },
    projectId: { __type: 'UuidOperationFilterInput' },
    targetType: { __type: 'StringOperationFilterInput' },
    updatedAt: { __type: 'ComparableInstantOperationFilterInput' },
    updatedBy: { __type: 'AccountFilterInput' },
    updatedById: { __type: 'UuidOperationFilterInput' },
  },
  LabelSortInput: {
    additionalData: { __type: 'SortEnumType' },
    createdAt: { __type: 'SortEnumType' },
    createdBy: { __type: 'AccountSortInput' },
    createdById: { __type: 'SortEnumType' },
    id: { __type: 'SortEnumType' },
    isAdminLabel: { __type: 'SortEnumType' },
    name: { __type: 'SortEnumType' },
    projectId: { __type: 'SortEnumType' },
    targetType: { __type: 'SortEnumType' },
    updatedAt: { __type: 'SortEnumType' },
    updatedBy: { __type: 'AccountSortInput' },
    updatedById: { __type: 'SortEnumType' },
  },
  LabelsCollectionSegment: {
    __typename: { __type: 'String!' },
    items: { __type: '[Label!]' },
    pageInfo: { __type: 'CollectionSegmentInfo!' },
    totalCount: { __type: 'Int!' },
  },
  LineStringFilterInput: {
    and: { __type: '[LineStringFilterInput!]' },
    area: { __type: 'FloatOperationFilterInput' },
    boundary: { __type: 'GeometryFilterInput' },
    centroid: { __type: 'PointFilterInput' },
    contains: { __type: 'GeometryContainsOperationFilterInput' },
    dimension: { __type: 'DimensionOperationFilterInput' },
    distance: { __type: 'GeometryDistanceOperationFilterInput' },
    envelope: { __type: 'GeometryFilterInput' },
    geometryType: { __type: 'StringOperationFilterInput' },
    interiorPoint: { __type: 'PointFilterInput' },
    intersects: { __type: 'GeometryIntersectsOperationFilterInput' },
    isSimple: { __type: 'BooleanOperationFilterInput' },
    isValid: { __type: 'BooleanOperationFilterInput' },
    length: { __type: 'FloatOperationFilterInput' },
    ncontains: { __type: 'GeometryContainsOperationFilterInput' },
    nintersects: { __type: 'GeometryIntersectsOperationFilterInput' },
    noverlaps: { __type: 'GeometryOverlapsOperationFilterInput' },
    ntouches: { __type: 'GeometryTouchesOperationFilterInput' },
    numPoints: { __type: 'IntOperationFilterInput' },
    nwithin: { __type: 'GeometryWithinOperationFilterInput' },
    ogcGeometryType: { __type: 'OgcGeometryTypeOperationFilterInput' },
    or: { __type: '[LineStringFilterInput!]' },
    overlaps: { __type: 'GeometryOverlapsOperationFilterInput' },
    pointOnSurface: { __type: 'PointFilterInput' },
    srid: { __type: 'IntOperationFilterInput' },
    touches: { __type: 'GeometryTouchesOperationFilterInput' },
    within: { __type: 'GeometryWithinOperationFilterInput' },
  },
  LineStringSortInput: {
    endPoint: { __type: 'PointSortInput' },
    startPoint: { __type: 'PointSortInput' },
  },
  ListByteOperationFilterInput: {
    all: { __type: 'ByteOperationFilterInput' },
    any: { __type: 'Boolean' },
    none: { __type: 'ByteOperationFilterInput' },
    some: { __type: 'ByteOperationFilterInput' },
  },
  ListFilterInputTypeOfAssetConfigFilterInput: {
    all: { __type: 'AssetConfigFilterInput' },
    any: { __type: 'Boolean' },
    none: { __type: 'AssetConfigFilterInput' },
    some: { __type: 'AssetConfigFilterInput' },
  },
  ListFilterInputTypeOfAssetSelectionFilterInput: {
    all: { __type: 'AssetSelectionFilterInput' },
    any: { __type: 'Boolean' },
    none: { __type: 'AssetSelectionFilterInput' },
    some: { __type: 'AssetSelectionFilterInput' },
  },
  ListFilterInputTypeOfBackgroundJobFilterInput: {
    all: { __type: 'BackgroundJobFilterInput' },
    any: { __type: 'Boolean' },
    none: { __type: 'BackgroundJobFilterInput' },
    some: { __type: 'BackgroundJobFilterInput' },
  },
  ListFilterInputTypeOfCustomLayerItemFilterInput: {
    all: { __type: 'CustomLayerItemFilterInput' },
    any: { __type: 'Boolean' },
    none: { __type: 'CustomLayerItemFilterInput' },
    some: { __type: 'CustomLayerItemFilterInput' },
  },
  ListFilterInputTypeOfCustomStyleFilterInput: {
    all: { __type: 'CustomStyleFilterInput' },
    any: { __type: 'Boolean' },
    none: { __type: 'CustomStyleFilterInput' },
    some: { __type: 'CustomStyleFilterInput' },
  },
  ListFilterInputTypeOfInterventionFilterInput: {
    all: { __type: 'InterventionFilterInput' },
    any: { __type: 'Boolean' },
    none: { __type: 'InterventionFilterInput' },
    some: { __type: 'InterventionFilterInput' },
  },
  ListFilterInputTypeOfItemFilterInput: {
    all: { __type: 'ItemFilterInput' },
    any: { __type: 'Boolean' },
    none: { __type: 'ItemFilterInput' },
    some: { __type: 'ItemFilterInput' },
  },
  ListFilterInputTypeOfLabelFilterInput: {
    all: { __type: 'LabelFilterInput' },
    any: { __type: 'Boolean' },
    none: { __type: 'LabelFilterInput' },
    some: { __type: 'LabelFilterInput' },
  },
  ListFilterInputTypeOfOperatorFilterInput: {
    all: { __type: 'OperatorFilterInput' },
    any: { __type: 'Boolean' },
    none: { __type: 'OperatorFilterInput' },
    some: { __type: 'OperatorFilterInput' },
  },
  ListFilterInputTypeOfPathConfigFilterInput: {
    all: { __type: 'PathConfigFilterInput' },
    any: { __type: 'Boolean' },
    none: { __type: 'PathConfigFilterInput' },
    some: { __type: 'PathConfigFilterInput' },
  },
  ListFilterInputTypeOfPathFilterInput: {
    all: { __type: 'PathFilterInput' },
    any: { __type: 'Boolean' },
    none: { __type: 'PathFilterInput' },
    some: { __type: 'PathFilterInput' },
  },
  ListFilterInputTypeOfPathMediaFilterInput: {
    all: { __type: 'PathMediaFilterInput' },
    any: { __type: 'Boolean' },
    none: { __type: 'PathMediaFilterInput' },
    some: { __type: 'PathMediaFilterInput' },
  },
  ListFilterInputTypeOfPathRangeFilterInput: {
    all: { __type: 'PathRangeFilterInput' },
    any: { __type: 'Boolean' },
    none: { __type: 'PathRangeFilterInput' },
    some: { __type: 'PathRangeFilterInput' },
  },
  ListFilterInputTypeOfPathSelectionFilterInput: {
    all: { __type: 'PathSelectionFilterInput' },
    any: { __type: 'Boolean' },
    none: { __type: 'PathSelectionFilterInput' },
    some: { __type: 'PathSelectionFilterInput' },
  },
  ListFilterInputTypeOfPointConfigFilterInput: {
    all: { __type: 'PointConfigFilterInput' },
    any: { __type: 'Boolean' },
    none: { __type: 'PointConfigFilterInput' },
    some: { __type: 'PointConfigFilterInput' },
  },
  ListFilterInputTypeOfSurveyFilterInput: {
    all: { __type: 'SurveyFilterInput' },
    any: { __type: 'Boolean' },
    none: { __type: 'SurveyFilterInput' },
    some: { __type: 'SurveyFilterInput' },
  },
  ListPciDistressOperationFilterInput: {
    all: { __type: 'PciDistressOperationFilterInput' },
    any: { __type: 'Boolean' },
    none: { __type: 'PciDistressOperationFilterInput' },
    some: { __type: 'PciDistressOperationFilterInput' },
  },
  ListStringOperationFilterInput: {
    all: { __type: 'StringOperationFilterInput' },
    any: { __type: 'Boolean' },
    none: { __type: 'StringOperationFilterInput' },
    some: { __type: 'StringOperationFilterInput' },
  },
  ListUuidOperationFilterInput: {
    all: { __type: 'UuidOperationFilterInput' },
    any: { __type: 'Boolean' },
    none: { __type: 'UuidOperationFilterInput' },
    some: { __type: 'UuidOperationFilterInput' },
  },
  LocalDateOperationFilterInput: {
    eq: { __type: 'LocalDate' },
    gt: { __type: 'LocalDate' },
    gte: { __type: 'LocalDate' },
    in: { __type: '[LocalDate]' },
    lt: { __type: 'LocalDate' },
    lte: { __type: 'LocalDate' },
    neq: { __type: 'LocalDate' },
    ngt: { __type: 'LocalDate' },
    ngte: { __type: 'LocalDate' },
    nin: { __type: '[LocalDate]' },
    nlt: { __type: 'LocalDate' },
    nlte: { __type: 'LocalDate' },
  },
  Log: {
    __typename: { __type: 'String!' },
    exception: { __type: 'String' },
    id: { __type: 'UUID!' },
    loggedAt: { __type: 'Instant!' },
    message: { __type: 'String!' },
    severity: { __type: 'LogSeverity!' },
  },
  LongOperationFilterInput: {
    eq: { __type: 'Long' },
    gt: { __type: 'Long' },
    gte: { __type: 'Long' },
    in: { __type: '[Long]' },
    lt: { __type: 'Long' },
    lte: { __type: 'Long' },
    neq: { __type: 'Long' },
    ngt: { __type: 'Long' },
    ngte: { __type: 'Long' },
    nin: { __type: '[Long]' },
    nlt: { __type: 'Long' },
    nlte: { __type: 'Long' },
  },
  Media: {
    __typename: { __type: 'String!' },
    blob: { __type: 'Blob!' },
    blobId: { __type: 'UUID!' },
    mediaType: { __type: 'MediaType!' },
    rspId: { __type: 'String!' },
    surveyId: { __type: 'UUID!' },
  },
  MediaFilterInput: {
    and: { __type: '[MediaFilterInput!]' },
    blob: { __type: 'BlobFilterInput' },
    blobId: { __type: 'UuidOperationFilterInput' },
    mediaType: { __type: 'MediaTypeOperationFilterInput' },
    or: { __type: '[MediaFilterInput!]' },
    rspId: { __type: 'StringOperationFilterInput' },
    surveyId: { __type: 'UuidOperationFilterInput' },
  },
  MediaSortInput: {
    blob: { __type: 'BlobSortInput' },
    blobId: { __type: 'SortEnumType' },
    mediaType: { __type: 'SortEnumType' },
    rspId: { __type: 'SortEnumType' },
    surveyId: { __type: 'SortEnumType' },
  },
  MediaTypeOperationFilterInput: {
    eq: { __type: 'MediaType' },
    in: { __type: '[MediaType!]' },
    neq: { __type: 'MediaType' },
    nin: { __type: '[MediaType!]' },
  },
  MediaUploadJob: {
    __typename: { __type: 'String!' },
    additionalData: { __type: 'JSON' },
    createdAt: { __type: 'Instant!' },
    createdBy: { __type: 'Account' },
    createdById: { __type: 'UUID' },
    events: {
      __type: 'EventsCollectionSegment',
      __args: { skip: 'Int', take: 'Int' },
    },
    id: { __type: 'UUID!' },
    lastLogs: { __type: '[Log!]!', __args: { count: 'Int!' } },
    logs: { __type: '[Log!]!' },
    mfvDataFileId: { __type: 'UUID!' },
    projectName: { __type: 'String' },
    search: { __type: 'String' },
    status: { __type: 'JobStatus!' },
    surveyId: { __type: 'UUID' },
    type: { __type: 'JobType!' },
    updatedAt: { __type: 'Instant!' },
    updatedBy: { __type: 'Account' },
    updatedById: { __type: 'UUID' },
  },
  MediaUploadJobFilterInput: {
    additionalData: { __type: 'JsonElementFilterInput' },
    and: { __type: '[MediaUploadJobFilterInput!]' },
    createdAt: { __type: 'ComparableInstantOperationFilterInput' },
    createdBy: { __type: 'AccountFilterInput' },
    createdById: { __type: 'UuidOperationFilterInput' },
    id: { __type: 'UuidOperationFilterInput' },
    mfvDataFileId: { __type: 'UuidOperationFilterInput' },
    or: { __type: '[MediaUploadJobFilterInput!]' },
    projectName: { __type: 'StringOperationFilterInput' },
    search: { __type: 'StringOperationFilterInput' },
    status: { __type: 'JobStatusOperationFilterInput' },
    surveyId: { __type: 'UuidOperationFilterInput' },
    type: { __type: 'JobTypeOperationFilterInput' },
    updatedAt: { __type: 'ComparableInstantOperationFilterInput' },
    updatedBy: { __type: 'AccountFilterInput' },
    updatedById: { __type: 'UuidOperationFilterInput' },
  },
  MediaUploadJobSortInput: {
    additionalData: { __type: 'SortEnumType' },
    createdAt: { __type: 'SortEnumType' },
    createdBy: { __type: 'AccountSortInput' },
    createdById: { __type: 'SortEnumType' },
    id: { __type: 'SortEnumType' },
    mfvDataFileId: { __type: 'SortEnumType' },
    projectName: { __type: 'SortEnumType' },
    search: { __type: 'SortEnumType' },
    status: { __type: 'SortEnumType' },
    surveyId: { __type: 'SortEnumType' },
    type: { __type: 'SortEnumType' },
    updatedAt: { __type: 'SortEnumType' },
    updatedBy: { __type: 'AccountSortInput' },
    updatedById: { __type: 'SortEnumType' },
  },
  MediaUploadJobsCollectionSegment: {
    __typename: { __type: 'String!' },
    items: { __type: '[MediaUploadJob!]' },
    pageInfo: { __type: 'CollectionSegmentInfo!' },
    totalCount: { __type: 'Int!' },
  },
  NotFoundError: {
    __typename: { __type: 'String!' },
    message: { __type: 'String!' },
  },
  Notarization: {
    __typename: { __type: 'String!' },
    blockHash: { __type: 'String!' },
    data: { __type: '[Byte!]!' },
    date: { __type: 'Instant!' },
    hash: { __type: '[Byte!]!' },
    id: { __type: 'UUID!' },
    payload: { __type: '[Byte!]!' },
    transactionHash: { __type: 'String!' },
  },
  NotarizationFilterInput: {
    and: { __type: '[NotarizationFilterInput!]' },
    blockHash: { __type: 'StringOperationFilterInput' },
    data: { __type: 'ListByteOperationFilterInput' },
    date: { __type: 'ComparableInstantOperationFilterInput' },
    hash: { __type: 'ListByteOperationFilterInput' },
    id: { __type: 'UuidOperationFilterInput' },
    or: { __type: '[NotarizationFilterInput!]' },
    payload: { __type: 'ListByteOperationFilterInput' },
    transactionHash: { __type: 'StringOperationFilterInput' },
  },
  NotarizationSortInput: {
    blockHash: { __type: 'SortEnumType' },
    date: { __type: 'SortEnumType' },
    id: { __type: 'SortEnumType' },
    transactionHash: { __type: 'SortEnumType' },
  },
  NotarizationsCollectionSegment: {
    __typename: { __type: 'String!' },
    items: { __type: '[Notarization!]' },
    pageInfo: { __type: 'CollectionSegmentInfo!' },
    totalCount: { __type: 'Int!' },
  },
  NullableOfEtdFormulaOperationFilterInput: {
    eq: { __type: 'EtdFormula' },
    in: { __type: '[EtdFormula]' },
    neq: { __type: 'EtdFormula' },
    nin: { __type: '[EtdFormula]' },
  },
  NullableOfParameterOperationFilterInput: {
    eq: { __type: 'Parameter' },
    in: { __type: '[Parameter]' },
    neq: { __type: 'Parameter' },
    nin: { __type: '[Parameter]' },
  },
  OgcGeometryTypeOperationFilterInput: {
    eq: { __type: 'OgcGeometryType' },
    in: { __type: '[OgcGeometryType!]' },
    neq: { __type: 'OgcGeometryType' },
    nin: { __type: '[OgcGeometryType!]' },
  },
  Operator: {
    __typename: { __type: 'String!' },
    deletedAt: { __type: 'Instant' },
    email: { __type: 'String' },
    firstName: { __type: 'String' },
    id: { __type: 'UUID!' },
    isDeleted: { __type: 'Boolean!' },
    isEnabled: { __type: 'Boolean!' },
    labels: { __type: '[Label!]!' },
    labelsIds: { __type: '[UUID!]!' },
    lastName: { __type: 'String' },
    projectsCount: { __type: 'Int!' },
    projectsIds: { __type: '[UUID!]!' },
    role: { __type: 'RoleName!' },
    search: { __type: 'String' },
    status: { __type: 'AccountStatus!' },
    unconfirmedEmail: { __type: 'String' },
  },
  OperatorFilterInput: {
    and: { __type: '[OperatorFilterInput!]' },
    deletedAt: { __type: 'ComparableNullableOfInstantOperationFilterInput' },
    email: { __type: 'StringOperationFilterInput' },
    firstName: { __type: 'StringOperationFilterInput' },
    id: { __type: 'UuidOperationFilterInput' },
    isDeleted: { __type: 'BooleanOperationFilterInput' },
    isEnabled: { __type: 'BooleanOperationFilterInput' },
    labelsIds: { __type: 'ListUuidOperationFilterInput' },
    lastName: { __type: 'StringOperationFilterInput' },
    or: { __type: '[OperatorFilterInput!]' },
    projectsCount: { __type: 'IntOperationFilterInput' },
    projectsIds: { __type: 'ListUuidOperationFilterInput' },
    role: { __type: 'RoleNameOperationFilterInput' },
    search: { __type: 'StringOperationFilterInput' },
    status: { __type: 'AccountStatusOperationFilterInput' },
    unconfirmedEmail: { __type: 'StringOperationFilterInput' },
  },
  OperatorSortInput: {
    deletedAt: { __type: 'SortEnumType' },
    email: { __type: 'SortEnumType' },
    firstName: { __type: 'SortEnumType' },
    id: { __type: 'SortEnumType' },
    isDeleted: { __type: 'SortEnumType' },
    isEnabled: { __type: 'SortEnumType' },
    lastName: { __type: 'SortEnumType' },
    projectsCount: { __type: 'SortEnumType' },
    role: { __type: 'SortEnumType' },
    search: { __type: 'SortEnumType' },
    status: { __type: 'SortEnumType' },
    unconfirmedEmail: { __type: 'SortEnumType' },
  },
  OperatorsCollectionSegment: {
    __typename: { __type: 'String!' },
    items: { __type: '[Operator!]' },
    pageInfo: { __type: 'CollectionSegmentInfo!' },
    totalCount: { __type: 'Int!' },
  },
  Organization: {
    __typename: { __type: 'String!' },
    additionalData: { __type: 'JSON' },
    address: { __type: 'Address' },
    certifiedEmailAddress: { __type: 'String' },
    createdAt: { __type: 'Instant!' },
    createdBy: { __type: 'Account' },
    createdById: { __type: 'UUID' },
    deletedAt: { __type: 'Instant' },
    email: { __type: 'String' },
    events: {
      __type: 'EventsCollectionSegment',
      __args: { skip: 'Int', take: 'Int' },
    },
    fiscalCode: { __type: 'String' },
    id: { __type: 'UUID!' },
    isDeleted: { __type: 'Boolean!' },
    labels: { __type: '[Label!]!' },
    legalName: { __type: 'String' },
    logo: { __type: 'Blob' },
    logoId: { __type: 'UUID' },
    name: { __type: 'String' },
    note: { __type: 'String' },
    phoneNumber: { __type: 'String' },
    pointOfContact: { __type: 'String' },
    projectsCount: { __type: 'Int!' },
    sdiCode: { __type: 'String' },
    search: { __type: 'String' },
    status: { __type: 'OrganizationStatus!' },
    updatedAt: { __type: 'Instant!' },
    updatedBy: { __type: 'Account' },
    updatedById: { __type: 'UUID' },
    vatNumber: { __type: 'String' },
  },
  OrganizationFilterInput: {
    additionalData: { __type: 'JsonElementFilterInput' },
    address: { __type: 'AddressFilterInput' },
    and: { __type: '[OrganizationFilterInput!]' },
    certifiedEmailAddress: { __type: 'StringOperationFilterInput' },
    createdAt: { __type: 'ComparableInstantOperationFilterInput' },
    createdBy: { __type: 'AccountFilterInput' },
    createdById: { __type: 'UuidOperationFilterInput' },
    deletedAt: { __type: 'ComparableNullableOfInstantOperationFilterInput' },
    email: { __type: 'StringOperationFilterInput' },
    fiscalCode: { __type: 'StringOperationFilterInput' },
    id: { __type: 'UuidOperationFilterInput' },
    isDeleted: { __type: 'BooleanOperationFilterInput' },
    labels: { __type: 'ListFilterInputTypeOfLabelFilterInput' },
    legalName: { __type: 'StringOperationFilterInput' },
    logo: { __type: 'BlobFilterInput' },
    logoId: { __type: 'UuidOperationFilterInput' },
    name: { __type: 'StringOperationFilterInput' },
    note: { __type: 'StringOperationFilterInput' },
    or: { __type: '[OrganizationFilterInput!]' },
    phoneNumber: { __type: 'StringOperationFilterInput' },
    pointOfContact: { __type: 'StringOperationFilterInput' },
    projectsCount: { __type: 'IntOperationFilterInput' },
    sdiCode: { __type: 'StringOperationFilterInput' },
    search: { __type: 'StringOperationFilterInput' },
    status: { __type: 'OrganizationStatusOperationFilterInput' },
    updatedAt: { __type: 'ComparableInstantOperationFilterInput' },
    updatedBy: { __type: 'AccountFilterInput' },
    updatedById: { __type: 'UuidOperationFilterInput' },
    vatNumber: { __type: 'StringOperationFilterInput' },
  },
  OrganizationSortInput: {
    additionalData: { __type: 'SortEnumType' },
    address: { __type: 'AddressSortInput' },
    certifiedEmailAddress: { __type: 'SortEnumType' },
    createdAt: { __type: 'SortEnumType' },
    createdBy: { __type: 'AccountSortInput' },
    createdById: { __type: 'SortEnumType' },
    deletedAt: { __type: 'SortEnumType' },
    email: { __type: 'SortEnumType' },
    fiscalCode: { __type: 'SortEnumType' },
    id: { __type: 'SortEnumType' },
    isDeleted: { __type: 'SortEnumType' },
    legalName: { __type: 'SortEnumType' },
    logo: { __type: 'BlobSortInput' },
    logoId: { __type: 'SortEnumType' },
    name: { __type: 'SortEnumType' },
    note: { __type: 'SortEnumType' },
    phoneNumber: { __type: 'SortEnumType' },
    pointOfContact: { __type: 'SortEnumType' },
    projectsCount: { __type: 'SortEnumType' },
    sdiCode: { __type: 'SortEnumType' },
    search: { __type: 'SortEnumType' },
    status: { __type: 'SortEnumType' },
    updatedAt: { __type: 'SortEnumType' },
    updatedBy: { __type: 'AccountSortInput' },
    updatedById: { __type: 'SortEnumType' },
    vatNumber: { __type: 'SortEnumType' },
  },
  OrganizationStatusOperationFilterInput: {
    eq: { __type: 'OrganizationStatus' },
    in: { __type: '[OrganizationStatus!]' },
    neq: { __type: 'OrganizationStatus' },
    nin: { __type: '[OrganizationStatus!]' },
  },
  OrganizationsCollectionSegment: {
    __typename: { __type: 'String!' },
    items: { __type: '[Organization!]' },
    pageInfo: { __type: 'CollectionSegmentInfo!' },
    totalCount: { __type: 'Int!' },
  },
  ParameterConfig: {
    __typename: { __type: 'String!' },
    etdFormula: { __type: 'EtdFormula' },
    etdGrain: { __type: 'Int' },
    iriGrain: { __type: 'Int' },
    maxEtd: { __type: 'Decimal' },
    maxIri: { __type: 'Decimal' },
    maxRut: { __type: 'Decimal' },
    mpdGrain: { __type: 'Int' },
    pciDistresses: { __type: '[PciDistress!]' },
    pciGrain: { __type: 'Int' },
    rutGrain: { __type: 'Int' },
  },
  ParameterConfigFilterInput: {
    and: { __type: '[ParameterConfigFilterInput!]' },
    etdFormula: { __type: 'NullableOfEtdFormulaOperationFilterInput' },
    etdGrain: { __type: 'IntOperationFilterInput' },
    iriGrain: { __type: 'IntOperationFilterInput' },
    maxEtd: { __type: 'DecimalOperationFilterInput' },
    maxIri: { __type: 'DecimalOperationFilterInput' },
    maxRut: { __type: 'DecimalOperationFilterInput' },
    mpdGrain: { __type: 'IntOperationFilterInput' },
    or: { __type: '[ParameterConfigFilterInput!]' },
    pciDistresses: { __type: 'ListPciDistressOperationFilterInput' },
    pciGrain: { __type: 'IntOperationFilterInput' },
    rutGrain: { __type: 'IntOperationFilterInput' },
  },
  ParameterConfigInput: {
    etdFormula: { __type: 'EtdFormula' },
    etdGrain: { __type: 'Int' },
    iriGrain: { __type: 'Int' },
    maxEtd: { __type: 'Decimal' },
    maxIri: { __type: 'Decimal' },
    maxRut: { __type: 'Decimal' },
    mpdGrain: { __type: 'Int' },
    pciDistresses: { __type: '[PciDistress!]' },
    pciGrain: { __type: 'Int' },
    rutGrain: { __type: 'Int' },
  },
  ParameterConfigSortInput: {
    etdFormula: { __type: 'SortEnumType' },
    etdGrain: { __type: 'SortEnumType' },
    iriGrain: { __type: 'SortEnumType' },
    maxEtd: { __type: 'SortEnumType' },
    maxIri: { __type: 'SortEnumType' },
    maxRut: { __type: 'SortEnumType' },
    mpdGrain: { __type: 'SortEnumType' },
    pciGrain: { __type: 'SortEnumType' },
    rutGrain: { __type: 'SortEnumType' },
  },
  ParameterOperationFilterInput: {
    eq: { __type: 'Parameter' },
    in: { __type: '[Parameter!]' },
    neq: { __type: 'Parameter' },
    nin: { __type: '[Parameter!]' },
  },
  ParametersComputationJob: {
    __typename: { __type: 'String!' },
    additionalData: { __type: 'JSON' },
    assetConfigs: { __type: '[AssetConfig!]!' },
    createdAt: { __type: 'Instant!' },
    createdBy: { __type: 'Account' },
    createdById: { __type: 'UUID' },
    csvFileId: { __type: 'UUID' },
    events: {
      __type: 'EventsCollectionSegment',
      __args: { skip: 'Int', take: 'Int' },
    },
    id: { __type: 'UUID!' },
    lastLogs: { __type: '[Log!]!', __args: { count: 'Int!' } },
    logs: { __type: '[Log!]!' },
    mfvDataFileId: { __type: 'UUID!' },
    parameterConfig: { __type: 'ParameterConfig!' },
    parametersZipId: { __type: 'UUID' },
    projectName: { __type: 'String' },
    search: { __type: 'String' },
    status: { __type: 'JobStatus!' },
    surveyDate: { __type: 'Instant' },
    surveyId: { __type: 'UUID' },
    type: { __type: 'JobType!' },
    updatedAt: { __type: 'Instant!' },
    updatedBy: { __type: 'Account' },
    updatedById: { __type: 'UUID' },
  },
  ParametersComputationJobFilterInput: {
    additionalData: { __type: 'JsonElementFilterInput' },
    and: { __type: '[ParametersComputationJobFilterInput!]' },
    assetConfigs: { __type: 'ListFilterInputTypeOfAssetConfigFilterInput' },
    createdAt: { __type: 'ComparableInstantOperationFilterInput' },
    createdBy: { __type: 'AccountFilterInput' },
    createdById: { __type: 'UuidOperationFilterInput' },
    csvFileId: { __type: 'UuidOperationFilterInput' },
    id: { __type: 'UuidOperationFilterInput' },
    mfvDataFileId: { __type: 'UuidOperationFilterInput' },
    or: { __type: '[ParametersComputationJobFilterInput!]' },
    parameterConfig: { __type: 'ParameterConfigFilterInput' },
    parametersZipId: { __type: 'UuidOperationFilterInput' },
    projectName: { __type: 'StringOperationFilterInput' },
    search: { __type: 'StringOperationFilterInput' },
    status: { __type: 'JobStatusOperationFilterInput' },
    surveyDate: { __type: 'ComparableNullableOfInstantOperationFilterInput' },
    surveyId: { __type: 'UuidOperationFilterInput' },
    type: { __type: 'JobTypeOperationFilterInput' },
    updatedAt: { __type: 'ComparableInstantOperationFilterInput' },
    updatedBy: { __type: 'AccountFilterInput' },
    updatedById: { __type: 'UuidOperationFilterInput' },
  },
  ParametersComputationJobSortInput: {
    additionalData: { __type: 'SortEnumType' },
    createdAt: { __type: 'SortEnumType' },
    createdBy: { __type: 'AccountSortInput' },
    createdById: { __type: 'SortEnumType' },
    csvFileId: { __type: 'SortEnumType' },
    id: { __type: 'SortEnumType' },
    mfvDataFileId: { __type: 'SortEnumType' },
    parameterConfig: { __type: 'ParameterConfigSortInput' },
    parametersZipId: { __type: 'SortEnumType' },
    projectName: { __type: 'SortEnumType' },
    search: { __type: 'SortEnumType' },
    status: { __type: 'SortEnumType' },
    surveyDate: { __type: 'SortEnumType' },
    surveyId: { __type: 'SortEnumType' },
    type: { __type: 'SortEnumType' },
    updatedAt: { __type: 'SortEnumType' },
    updatedBy: { __type: 'AccountSortInput' },
    updatedById: { __type: 'SortEnumType' },
  },
  ParametersComputationJobsCollectionSegment: {
    __typename: { __type: 'String!' },
    items: { __type: '[ParametersComputationJob!]' },
    pageInfo: { __type: 'CollectionSegmentInfo!' },
    totalCount: { __type: 'Int!' },
  },
  Path: {
    __typename: { __type: 'String!' },
    additionalData: { __type: 'JSON' },
    assetId: { __type: 'UUID!' },
    assetName: { __type: 'String!' },
    createdAt: { __type: 'Instant!' },
    createdBy: { __type: 'Account' },
    createdById: { __type: 'UUID' },
    events: {
      __type: 'EventsCollectionSegment',
      __args: { skip: 'Int', take: 'Int' },
    },
    geometry: { __type: 'GeoJSONLineStringType' },
    id: { __type: 'UUID!' },
    index: { __type: 'Int!' },
    isForward: { __type: 'Boolean!' },
    items: { __type: '[Item!]!' },
    length: { __type: 'Decimal!' },
    media: { __type: '[PathMedia!]!' },
    name: { __type: 'String!' },
    offset: { __type: 'Decimal' },
    points: { __type: '[PointConfig!]!' },
    search: { __type: 'String' },
    surveys: { __type: '[Survey!]!' },
    updatedAt: { __type: 'Instant!' },
    updatedBy: { __type: 'Account' },
    updatedById: { __type: 'UUID' },
  },
  PathConfig: {
    __typename: { __type: 'String!' },
    id: { __type: 'String' },
    isForward: { __type: 'Boolean!' },
    name: { __type: 'String!' },
    offset: { __type: 'Decimal' },
  },
  PathConfigFilterInput: {
    and: { __type: '[PathConfigFilterInput!]' },
    id: { __type: 'StringOperationFilterInput' },
    isForward: { __type: 'BooleanOperationFilterInput' },
    name: { __type: 'StringOperationFilterInput' },
    offset: { __type: 'DecimalOperationFilterInput' },
    or: { __type: '[PathConfigFilterInput!]' },
  },
  PathConfigInput: {
    id: { __type: 'String' },
    isForward: { __type: 'Boolean!' },
    name: { __type: 'String!' },
    offset: { __type: 'Decimal' },
  },
  PathFilterInput: {
    additionalData: { __type: 'JsonElementFilterInput' },
    and: { __type: '[PathFilterInput!]' },
    assetId: { __type: 'UuidOperationFilterInput' },
    assetName: { __type: 'StringOperationFilterInput' },
    createdAt: { __type: 'ComparableInstantOperationFilterInput' },
    createdBy: { __type: 'AccountFilterInput' },
    createdById: { __type: 'UuidOperationFilterInput' },
    geometry: { __type: 'LineStringFilterInput' },
    id: { __type: 'UuidOperationFilterInput' },
    index: { __type: 'IntOperationFilterInput' },
    isForward: { __type: 'BooleanOperationFilterInput' },
    items: { __type: 'ListFilterInputTypeOfItemFilterInput' },
    length: { __type: 'DecimalOperationFilterInput' },
    media: { __type: 'ListFilterInputTypeOfPathMediaFilterInput' },
    name: { __type: 'StringOperationFilterInput' },
    offset: { __type: 'DecimalOperationFilterInput' },
    or: { __type: '[PathFilterInput!]' },
    points: { __type: 'ListFilterInputTypeOfPointConfigFilterInput' },
    search: { __type: 'StringOperationFilterInput' },
    surveys: { __type: 'ListFilterInputTypeOfSurveyFilterInput' },
    updatedAt: { __type: 'ComparableInstantOperationFilterInput' },
    updatedBy: { __type: 'AccountFilterInput' },
    updatedById: { __type: 'UuidOperationFilterInput' },
  },
  PathMedia: {
    __typename: { __type: 'String!' },
    media: { __type: 'Media!' },
    mediaId: { __type: 'UUID!' },
    offset: { __type: 'Decimal!' },
    pathId: { __type: 'UUID!' },
  },
  PathMediaFilterInput: {
    and: { __type: '[PathMediaFilterInput!]' },
    media: { __type: 'MediaFilterInput' },
    mediaId: { __type: 'UuidOperationFilterInput' },
    offset: { __type: 'DecimalOperationFilterInput' },
    or: { __type: '[PathMediaFilterInput!]' },
    pathId: { __type: 'UuidOperationFilterInput' },
  },
  PathMediaSortInput: {
    media: { __type: 'MediaSortInput' },
    mediaId: { __type: 'SortEnumType' },
    offset: { __type: 'SortEnumType' },
    pathId: { __type: 'SortEnumType' },
  },
  PathRange: {
    __typename: { __type: 'String!' },
    end: { __type: 'Decimal!' },
    start: { __type: 'Decimal!' },
  },
  PathRangeFilterInput: {
    and: { __type: '[PathRangeFilterInput!]' },
    end: { __type: 'DecimalOperationFilterInput' },
    or: { __type: '[PathRangeFilterInput!]' },
    start: { __type: 'DecimalOperationFilterInput' },
  },
  PathRangeInput: {
    end: { __type: 'Decimal!' },
    start: { __type: 'Decimal!' },
  },
  PathSelection: {
    __typename: { __type: 'String!' },
    pathId: { __type: 'UUID!' },
    ranges: { __type: '[PathRange!]' },
  },
  PathSelectionFilterInput: {
    and: { __type: '[PathSelectionFilterInput!]' },
    or: { __type: '[PathSelectionFilterInput!]' },
    pathId: { __type: 'UuidOperationFilterInput' },
    ranges: { __type: 'ListFilterInputTypeOfPathRangeFilterInput' },
  },
  PathSelectionInput: {
    pathId: { __type: 'UUID!' },
    ranges: { __type: '[PathRangeInput!]' },
  },
  PathSortInput: {
    additionalData: { __type: 'SortEnumType' },
    assetId: { __type: 'SortEnumType' },
    assetName: { __type: 'SortEnumType' },
    createdAt: { __type: 'SortEnumType' },
    createdBy: { __type: 'AccountSortInput' },
    createdById: { __type: 'SortEnumType' },
    geometry: { __type: 'LineStringSortInput' },
    id: { __type: 'SortEnumType' },
    index: { __type: 'SortEnumType' },
    isForward: { __type: 'SortEnumType' },
    length: { __type: 'SortEnumType' },
    name: { __type: 'SortEnumType' },
    offset: { __type: 'SortEnumType' },
    search: { __type: 'SortEnumType' },
    updatedAt: { __type: 'SortEnumType' },
    updatedBy: { __type: 'AccountSortInput' },
    updatedById: { __type: 'SortEnumType' },
  },
  PciDistressOperationFilterInput: {
    eq: { __type: 'PciDistress' },
    in: { __type: '[PciDistress!]' },
    neq: { __type: 'PciDistress' },
    nin: { __type: '[PciDistress!]' },
  },
  PointConfig: {
    __typename: { __type: 'String!' },
    altitude: { __type: 'Decimal!' },
    latitude: { __type: 'Decimal!' },
    longitude: { __type: 'Decimal!' },
    rspId: { __type: 'String!' },
    rspIndex: { __type: 'Int!' },
    rspStart: { __type: 'Decimal' },
    toponym: { __type: 'String!' },
  },
  PointConfigFilterInput: {
    altitude: { __type: 'DecimalOperationFilterInput' },
    and: { __type: '[PointConfigFilterInput!]' },
    latitude: { __type: 'DecimalOperationFilterInput' },
    longitude: { __type: 'DecimalOperationFilterInput' },
    or: { __type: '[PointConfigFilterInput!]' },
    rspId: { __type: 'StringOperationFilterInput' },
    rspIndex: { __type: 'IntOperationFilterInput' },
    rspStart: { __type: 'DecimalOperationFilterInput' },
    toponym: { __type: 'StringOperationFilterInput' },
  },
  PointFilterInput: {
    and: { __type: '[PointFilterInput!]' },
    area: { __type: 'FloatOperationFilterInput' },
    boundary: { __type: 'GeometryFilterInput' },
    centroid: { __type: 'PointFilterInput' },
    contains: { __type: 'GeometryContainsOperationFilterInput' },
    dimension: { __type: 'DimensionOperationFilterInput' },
    distance: { __type: 'GeometryDistanceOperationFilterInput' },
    envelope: { __type: 'GeometryFilterInput' },
    geometryType: { __type: 'StringOperationFilterInput' },
    interiorPoint: { __type: 'PointFilterInput' },
    intersects: { __type: 'GeometryIntersectsOperationFilterInput' },
    isSimple: { __type: 'BooleanOperationFilterInput' },
    isValid: { __type: 'BooleanOperationFilterInput' },
    length: { __type: 'FloatOperationFilterInput' },
    m: { __type: 'FloatOperationFilterInput' },
    ncontains: { __type: 'GeometryContainsOperationFilterInput' },
    nintersects: { __type: 'GeometryIntersectsOperationFilterInput' },
    noverlaps: { __type: 'GeometryOverlapsOperationFilterInput' },
    ntouches: { __type: 'GeometryTouchesOperationFilterInput' },
    numPoints: { __type: 'IntOperationFilterInput' },
    nwithin: { __type: 'GeometryWithinOperationFilterInput' },
    ogcGeometryType: { __type: 'OgcGeometryTypeOperationFilterInput' },
    or: { __type: '[PointFilterInput!]' },
    overlaps: { __type: 'GeometryOverlapsOperationFilterInput' },
    pointOnSurface: { __type: 'PointFilterInput' },
    srid: { __type: 'IntOperationFilterInput' },
    touches: { __type: 'GeometryTouchesOperationFilterInput' },
    within: { __type: 'GeometryWithinOperationFilterInput' },
    x: { __type: 'FloatOperationFilterInput' },
    y: { __type: 'FloatOperationFilterInput' },
    z: { __type: 'FloatOperationFilterInput' },
  },
  PointSortInput: {
    area: { __type: 'SortEnumType' },
    boundaryDimension: { __type: 'SortEnumType' },
    centroid: { __type: 'PointSortInput' },
    coordinate: { __type: 'CoordinateSortInput' },
    coordinateSequence: { __type: 'CoordinateSequenceSortInput' },
    dimension: { __type: 'SortEnumType' },
    envelopeInternal: { __type: 'EnvelopeSortInput' },
    geometryType: { __type: 'SortEnumType' },
    interiorPoint: { __type: 'PointSortInput' },
    isEmpty: { __type: 'SortEnumType' },
    isRectangle: { __type: 'SortEnumType' },
    isSimple: { __type: 'SortEnumType' },
    isValid: { __type: 'SortEnumType' },
    length: { __type: 'SortEnumType' },
    m: { __type: 'SortEnumType' },
    numGeometries: { __type: 'SortEnumType' },
    numPoints: { __type: 'SortEnumType' },
    ogcGeometryType: { __type: 'SortEnumType' },
    pointOnSurface: { __type: 'PointSortInput' },
    precisionModel: { __type: 'PrecisionModelSortInput' },
    srid: { __type: 'SortEnumType' },
    x: { __type: 'SortEnumType' },
    y: { __type: 'SortEnumType' },
    z: { __type: 'SortEnumType' },
  },
  PolygonFilterInput: {
    and: { __type: '[PolygonFilterInput!]' },
    area: { __type: 'FloatOperationFilterInput' },
    boundary: { __type: 'GeometryFilterInput' },
    centroid: { __type: 'PointFilterInput' },
    contains: { __type: 'GeometryContainsOperationFilterInput' },
    dimension: { __type: 'DimensionOperationFilterInput' },
    distance: { __type: 'GeometryDistanceOperationFilterInput' },
    envelope: { __type: 'GeometryFilterInput' },
    geometryType: { __type: 'StringOperationFilterInput' },
    interiorPoint: { __type: 'PointFilterInput' },
    intersects: { __type: 'GeometryIntersectsOperationFilterInput' },
    isSimple: { __type: 'BooleanOperationFilterInput' },
    isValid: { __type: 'BooleanOperationFilterInput' },
    length: { __type: 'FloatOperationFilterInput' },
    ncontains: { __type: 'GeometryContainsOperationFilterInput' },
    nintersects: { __type: 'GeometryIntersectsOperationFilterInput' },
    noverlaps: { __type: 'GeometryOverlapsOperationFilterInput' },
    ntouches: { __type: 'GeometryTouchesOperationFilterInput' },
    numPoints: { __type: 'IntOperationFilterInput' },
    nwithin: { __type: 'GeometryWithinOperationFilterInput' },
    ogcGeometryType: { __type: 'OgcGeometryTypeOperationFilterInput' },
    or: { __type: '[PolygonFilterInput!]' },
    overlaps: { __type: 'GeometryOverlapsOperationFilterInput' },
    pointOnSurface: { __type: 'PointFilterInput' },
    srid: { __type: 'IntOperationFilterInput' },
    touches: { __type: 'GeometryTouchesOperationFilterInput' },
    within: { __type: 'GeometryWithinOperationFilterInput' },
  },
  PolygonSortInput: {
    area: { __type: 'SortEnumType' },
    boundaryDimension: { __type: 'SortEnumType' },
    centroid: { __type: 'PointSortInput' },
    coordinate: { __type: 'CoordinateSortInput' },
    dimension: { __type: 'SortEnumType' },
    envelopeInternal: { __type: 'EnvelopeSortInput' },
    exteriorRing: { __type: 'LineStringSortInput' },
    geometryType: { __type: 'SortEnumType' },
    interiorPoint: { __type: 'PointSortInput' },
    isEmpty: { __type: 'SortEnumType' },
    isRectangle: { __type: 'SortEnumType' },
    isSimple: { __type: 'SortEnumType' },
    isValid: { __type: 'SortEnumType' },
    length: { __type: 'SortEnumType' },
    numGeometries: { __type: 'SortEnumType' },
    numInteriorRings: { __type: 'SortEnumType' },
    numPoints: { __type: 'SortEnumType' },
    ogcGeometryType: { __type: 'SortEnumType' },
    pointOnSurface: { __type: 'PointSortInput' },
    precisionModel: { __type: 'PrecisionModelSortInput' },
    srid: { __type: 'SortEnumType' },
  },
  PrecisionModelSortInput: {
    gridSize: { __type: 'SortEnumType' },
    isFloating: { __type: 'SortEnumType' },
    maximumSignificantDigits: { __type: 'SortEnumType' },
    precisionModelType: { __type: 'SortEnumType' },
    scale: { __type: 'SortEnumType' },
  },
  Project: {
    __typename: { __type: 'String!' },
    additionalData: { __type: 'JSON' },
    assetsCount: { __type: 'Int!' },
    bounds: { __type: 'Bounds' },
    cig: { __type: 'String' },
    completedSurveysCount: { __type: 'Int!' },
    createdAt: { __type: 'Instant!' },
    createdBy: { __type: 'Account' },
    createdById: { __type: 'UUID' },
    cup: { __type: 'String' },
    email: { __type: 'String' },
    events: {
      __type: 'EventsCollectionSegment',
      __args: { skip: 'Int', take: 'Int' },
    },
    id: { __type: 'UUID!' },
    labels: { __type: '[Label!]!' },
    lastSurvey: { __type: 'SurveyInfo' },
    name: { __type: 'String!' },
    nextSurvey: { __type: 'SurveyInfo' },
    note: { __type: 'String' },
    operators: { __type: '[Operator!]!' },
    operatorsCount: { __type: 'Int!' },
    organization: { __type: 'Organization' },
    organizationId: { __type: 'UUID' },
    pciCurvesFileId: { __type: 'UUID' },
    phoneNumber: { __type: 'String' },
    pointOfContact: { __type: 'String' },
    projectValue: { __type: 'Float' },
    search: { __type: 'String' },
    styles: { __type: '[CustomStyle!]!' },
    surveys: { __type: '[Survey!]!' },
    surveysCount: { __type: 'Int!' },
    updatedAt: { __type: 'Instant!' },
    updatedBy: { __type: 'Account' },
    updatedById: { __type: 'UUID' },
  },
  ProjectConfiguration: {
    __typename: { __type: 'String!' },
    additionalData: { __type: 'JSON' },
    baseCostPerCmMq: { __type: 'Decimal!' },
    baseThicknessCm: { __type: 'Decimal!' },
    binderCostPerCmMq: { __type: 'Decimal!' },
    binderThicknessCm: { __type: 'Decimal!' },
    createdAt: { __type: 'Instant!' },
    createdBy: { __type: 'Account' },
    createdById: { __type: 'UUID' },
    events: {
      __type: 'EventsCollectionSegment',
      __args: { skip: 'Int', take: 'Int' },
    },
    foundationCostPerCmMq: { __type: 'Decimal!' },
    foundationThicknessCm: { __type: 'Decimal!' },
    id: { __type: 'UUID!' },
    isGlobalConfiguration: { __type: 'Boolean!' },
    laneWidth: { __type: 'Decimal!' },
    projectId: { __type: 'UUID' },
    rpPciThreshold: { __type: 'Decimal!' },
    rs1PciThreshold: { __type: 'Decimal!' },
    rs2PciThreshold: { __type: 'Decimal!' },
    rssPciThreshold: { __type: 'Decimal!' },
    search: { __type: 'String' },
    tgm: { __type: 'Tgm!' },
    updatedAt: { __type: 'Instant!' },
    updatedBy: { __type: 'Account' },
    updatedById: { __type: 'UUID' },
    wearCostPerCmMq: { __type: 'Decimal!' },
    wearThicknessCm: { __type: 'Decimal!' },
  },
  ProjectConfigurationFilterInput: {
    additionalData: { __type: 'JsonElementFilterInput' },
    and: { __type: '[ProjectConfigurationFilterInput!]' },
    baseCostPerCmMq: { __type: 'DecimalOperationFilterInput' },
    baseThicknessCm: { __type: 'DecimalOperationFilterInput' },
    binderCostPerCmMq: { __type: 'DecimalOperationFilterInput' },
    binderThicknessCm: { __type: 'DecimalOperationFilterInput' },
    createdAt: { __type: 'ComparableInstantOperationFilterInput' },
    createdBy: { __type: 'AccountFilterInput' },
    createdById: { __type: 'UuidOperationFilterInput' },
    foundationCostPerCmMq: { __type: 'DecimalOperationFilterInput' },
    foundationThicknessCm: { __type: 'DecimalOperationFilterInput' },
    id: { __type: 'UuidOperationFilterInput' },
    isGlobalConfiguration: { __type: 'BooleanOperationFilterInput' },
    laneWidth: { __type: 'DecimalOperationFilterInput' },
    or: { __type: '[ProjectConfigurationFilterInput!]' },
    projectId: { __type: 'UuidOperationFilterInput' },
    rpPciThreshold: { __type: 'DecimalOperationFilterInput' },
    rs1PciThreshold: { __type: 'DecimalOperationFilterInput' },
    rs2PciThreshold: { __type: 'DecimalOperationFilterInput' },
    rssPciThreshold: { __type: 'DecimalOperationFilterInput' },
    search: { __type: 'StringOperationFilterInput' },
    tgm: { __type: 'TgmOperationFilterInput' },
    updatedAt: { __type: 'ComparableInstantOperationFilterInput' },
    updatedBy: { __type: 'AccountFilterInput' },
    updatedById: { __type: 'UuidOperationFilterInput' },
    wearCostPerCmMq: { __type: 'DecimalOperationFilterInput' },
    wearThicknessCm: { __type: 'DecimalOperationFilterInput' },
  },
  ProjectConfigurationSortInput: {
    additionalData: { __type: 'SortEnumType' },
    baseCostPerCmMq: { __type: 'SortEnumType' },
    baseThicknessCm: { __type: 'SortEnumType' },
    binderCostPerCmMq: { __type: 'SortEnumType' },
    binderThicknessCm: { __type: 'SortEnumType' },
    createdAt: { __type: 'SortEnumType' },
    createdBy: { __type: 'AccountSortInput' },
    createdById: { __type: 'SortEnumType' },
    foundationCostPerCmMq: { __type: 'SortEnumType' },
    foundationThicknessCm: { __type: 'SortEnumType' },
    id: { __type: 'SortEnumType' },
    isGlobalConfiguration: { __type: 'SortEnumType' },
    laneWidth: { __type: 'SortEnumType' },
    projectId: { __type: 'SortEnumType' },
    rpPciThreshold: { __type: 'SortEnumType' },
    rs1PciThreshold: { __type: 'SortEnumType' },
    rs2PciThreshold: { __type: 'SortEnumType' },
    rssPciThreshold: { __type: 'SortEnumType' },
    search: { __type: 'SortEnumType' },
    tgm: { __type: 'SortEnumType' },
    updatedAt: { __type: 'SortEnumType' },
    updatedBy: { __type: 'AccountSortInput' },
    updatedById: { __type: 'SortEnumType' },
    wearCostPerCmMq: { __type: 'SortEnumType' },
    wearThicknessCm: { __type: 'SortEnumType' },
  },
  ProjectConfigurationsCollectionSegment: {
    __typename: { __type: 'String!' },
    items: { __type: '[ProjectConfiguration!]' },
    pageInfo: { __type: 'CollectionSegmentInfo!' },
    totalCount: { __type: 'Int!' },
  },
  ProjectFilterInput: {
    additionalData: { __type: 'JsonElementFilterInput' },
    and: { __type: '[ProjectFilterInput!]' },
    assetsCount: { __type: 'IntOperationFilterInput' },
    bounds: { __type: 'BoundsFilterInput' },
    cig: { __type: 'StringOperationFilterInput' },
    completedSurveysCount: { __type: 'IntOperationFilterInput' },
    createdAt: { __type: 'ComparableInstantOperationFilterInput' },
    createdBy: { __type: 'AccountFilterInput' },
    createdById: { __type: 'UuidOperationFilterInput' },
    cup: { __type: 'StringOperationFilterInput' },
    email: { __type: 'StringOperationFilterInput' },
    id: { __type: 'UuidOperationFilterInput' },
    labels: { __type: 'ListFilterInputTypeOfLabelFilterInput' },
    lastSurvey: { __type: 'SurveyInfoFilterInput' },
    name: { __type: 'StringOperationFilterInput' },
    nextSurvey: { __type: 'SurveyInfoFilterInput' },
    note: { __type: 'StringOperationFilterInput' },
    operators: { __type: 'ListFilterInputTypeOfOperatorFilterInput' },
    operatorsCount: { __type: 'IntOperationFilterInput' },
    or: { __type: '[ProjectFilterInput!]' },
    organization: { __type: 'OrganizationFilterInput' },
    organizationId: { __type: 'UuidOperationFilterInput' },
    pciCurvesFileId: { __type: 'UuidOperationFilterInput' },
    phoneNumber: { __type: 'StringOperationFilterInput' },
    pointOfContact: { __type: 'StringOperationFilterInput' },
    projectValue: { __type: 'FloatOperationFilterInput' },
    search: { __type: 'StringOperationFilterInput' },
    styles: { __type: 'ListFilterInputTypeOfCustomStyleFilterInput' },
    surveys: { __type: 'ListFilterInputTypeOfSurveyFilterInput' },
    surveysCount: { __type: 'IntOperationFilterInput' },
    updatedAt: { __type: 'ComparableInstantOperationFilterInput' },
    updatedBy: { __type: 'AccountFilterInput' },
    updatedById: { __type: 'UuidOperationFilterInput' },
  },
  ProjectSortInput: {
    additionalData: { __type: 'SortEnumType' },
    assetsCount: { __type: 'SortEnumType' },
    bounds: { __type: 'BoundsSortInput' },
    cig: { __type: 'SortEnumType' },
    completedSurveysCount: { __type: 'SortEnumType' },
    createdAt: { __type: 'SortEnumType' },
    createdBy: { __type: 'AccountSortInput' },
    createdById: { __type: 'SortEnumType' },
    cup: { __type: 'SortEnumType' },
    email: { __type: 'SortEnumType' },
    id: { __type: 'SortEnumType' },
    lastSurvey: { __type: 'SurveyInfoSortInput' },
    name: { __type: 'SortEnumType' },
    nextSurvey: { __type: 'SurveyInfoSortInput' },
    note: { __type: 'SortEnumType' },
    operatorsCount: { __type: 'SortEnumType' },
    organization: { __type: 'OrganizationSortInput' },
    organizationId: { __type: 'SortEnumType' },
    pciCurvesFileId: { __type: 'SortEnumType' },
    phoneNumber: { __type: 'SortEnumType' },
    pointOfContact: { __type: 'SortEnumType' },
    projectValue: { __type: 'SortEnumType' },
    search: { __type: 'SortEnumType' },
    surveysCount: { __type: 'SortEnumType' },
    updatedAt: { __type: 'SortEnumType' },
    updatedBy: { __type: 'AccountSortInput' },
    updatedById: { __type: 'SortEnumType' },
  },
  ProjectsCollectionSegment: {
    __typename: { __type: 'String!' },
    items: { __type: '[Project!]' },
    pageInfo: { __type: 'CollectionSegmentInfo!' },
    totalCount: { __type: 'Int!' },
  },
  Report: {
    __typename: { __type: 'String!' },
    additionalData: { __type: 'JSON' },
    createdAt: { __type: 'Instant!' },
    createdBy: { __type: 'Account' },
    createdById: { __type: 'UUID' },
    events: {
      __type: 'EventsCollectionSegment',
      __args: { skip: 'Int', take: 'Int' },
    },
    id: { __type: 'UUID!' },
    labels: { __type: '[Label!]!' },
    name: { __type: 'String!' },
    pdfFile: { __type: 'Blob' },
    pdfFileId: { __type: 'UUID' },
    projectId: { __type: 'UUID!' },
    search: { __type: 'String' },
    status: { __type: 'ReportStatus!' },
    surveyId: { __type: 'UUID!' },
    surveyName: { __type: 'String!' },
    updatedAt: { __type: 'Instant!' },
    updatedBy: { __type: 'Account' },
    updatedById: { __type: 'UUID' },
  },
  ReportFilterInput: {
    additionalData: { __type: 'JsonElementFilterInput' },
    and: { __type: '[ReportFilterInput!]' },
    createdAt: { __type: 'ComparableInstantOperationFilterInput' },
    createdBy: { __type: 'AccountFilterInput' },
    createdById: { __type: 'UuidOperationFilterInput' },
    id: { __type: 'UuidOperationFilterInput' },
    labels: { __type: 'ListFilterInputTypeOfLabelFilterInput' },
    name: { __type: 'StringOperationFilterInput' },
    or: { __type: '[ReportFilterInput!]' },
    pdfFile: { __type: 'BlobFilterInput' },
    pdfFileId: { __type: 'UuidOperationFilterInput' },
    projectId: { __type: 'UuidOperationFilterInput' },
    search: { __type: 'StringOperationFilterInput' },
    status: { __type: 'ReportStatusOperationFilterInput' },
    surveyId: { __type: 'UuidOperationFilterInput' },
    surveyName: { __type: 'StringOperationFilterInput' },
    updatedAt: { __type: 'ComparableInstantOperationFilterInput' },
    updatedBy: { __type: 'AccountFilterInput' },
    updatedById: { __type: 'UuidOperationFilterInput' },
  },
  ReportGenerationJob: {
    __typename: { __type: 'String!' },
    additionalData: { __type: 'JSON' },
    createdAt: { __type: 'Instant!' },
    createdBy: { __type: 'Account' },
    createdById: { __type: 'UUID' },
    events: {
      __type: 'EventsCollectionSegment',
      __args: { skip: 'Int', take: 'Int' },
    },
    id: { __type: 'UUID!' },
    interventions: { __type: '[Intervention!]!' },
    lastLogs: { __type: '[Log!]!', __args: { count: 'Int!' } },
    logs: { __type: '[Log!]!' },
    projectName: { __type: 'String' },
    reportName: { __type: 'String!' },
    reportType: { __type: 'ReportType!' },
    search: { __type: 'String' },
    sectionsSelection: { __type: '[String!]!' },
    selections: { __type: '[AssetSelection!]!' },
    status: { __type: 'JobStatus!' },
    surveyId: { __type: 'UUID' },
    type: { __type: 'JobType!' },
    updatedAt: { __type: 'Instant!' },
    updatedBy: { __type: 'Account' },
    updatedById: { __type: 'UUID' },
  },
  ReportGenerationJobFilterInput: {
    additionalData: { __type: 'JsonElementFilterInput' },
    and: { __type: '[ReportGenerationJobFilterInput!]' },
    createdAt: { __type: 'ComparableInstantOperationFilterInput' },
    createdBy: { __type: 'AccountFilterInput' },
    createdById: { __type: 'UuidOperationFilterInput' },
    id: { __type: 'UuidOperationFilterInput' },
    interventions: { __type: 'ListFilterInputTypeOfInterventionFilterInput' },
    or: { __type: '[ReportGenerationJobFilterInput!]' },
    projectName: { __type: 'StringOperationFilterInput' },
    reportName: { __type: 'StringOperationFilterInput' },
    reportType: { __type: 'ReportTypeOperationFilterInput' },
    search: { __type: 'StringOperationFilterInput' },
    sectionsSelection: { __type: 'ListStringOperationFilterInput' },
    selections: { __type: 'ListFilterInputTypeOfAssetSelectionFilterInput' },
    status: { __type: 'JobStatusOperationFilterInput' },
    surveyId: { __type: 'UuidOperationFilterInput' },
    type: { __type: 'JobTypeOperationFilterInput' },
    updatedAt: { __type: 'ComparableInstantOperationFilterInput' },
    updatedBy: { __type: 'AccountFilterInput' },
    updatedById: { __type: 'UuidOperationFilterInput' },
  },
  ReportGenerationJobSortInput: {
    additionalData: { __type: 'SortEnumType' },
    createdAt: { __type: 'SortEnumType' },
    createdBy: { __type: 'AccountSortInput' },
    createdById: { __type: 'SortEnumType' },
    id: { __type: 'SortEnumType' },
    projectName: { __type: 'SortEnumType' },
    reportName: { __type: 'SortEnumType' },
    reportType: { __type: 'SortEnumType' },
    search: { __type: 'SortEnumType' },
    status: { __type: 'SortEnumType' },
    surveyId: { __type: 'SortEnumType' },
    type: { __type: 'SortEnumType' },
    updatedAt: { __type: 'SortEnumType' },
    updatedBy: { __type: 'AccountSortInput' },
    updatedById: { __type: 'SortEnumType' },
  },
  ReportGenerationJobsCollectionSegment: {
    __typename: { __type: 'String!' },
    items: { __type: '[ReportGenerationJob!]' },
    pageInfo: { __type: 'CollectionSegmentInfo!' },
    totalCount: { __type: 'Int!' },
  },
  ReportSortInput: {
    additionalData: { __type: 'SortEnumType' },
    createdAt: { __type: 'SortEnumType' },
    createdBy: { __type: 'AccountSortInput' },
    createdById: { __type: 'SortEnumType' },
    id: { __type: 'SortEnumType' },
    name: { __type: 'SortEnumType' },
    pdfFile: { __type: 'BlobSortInput' },
    pdfFileId: { __type: 'SortEnumType' },
    projectId: { __type: 'SortEnumType' },
    search: { __type: 'SortEnumType' },
    status: { __type: 'SortEnumType' },
    surveyId: { __type: 'SortEnumType' },
    surveyName: { __type: 'SortEnumType' },
    updatedAt: { __type: 'SortEnumType' },
    updatedBy: { __type: 'AccountSortInput' },
    updatedById: { __type: 'SortEnumType' },
  },
  ReportStatusOperationFilterInput: {
    eq: { __type: 'ReportStatus' },
    in: { __type: '[ReportStatus!]' },
    neq: { __type: 'ReportStatus' },
    nin: { __type: '[ReportStatus!]' },
  },
  ReportTypeOperationFilterInput: {
    eq: { __type: 'ReportType' },
    in: { __type: '[ReportType!]' },
    neq: { __type: 'ReportType' },
    nin: { __type: '[ReportType!]' },
  },
  ReportsCollectionSegment: {
    __typename: { __type: 'String!' },
    items: { __type: '[Report!]' },
    pageInfo: { __type: 'CollectionSegmentInfo!' },
    totalCount: { __type: 'Int!' },
  },
  ResendAccountInvitationError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$ResendAccountInvitationError!' },
  },
  ResendAccountInvitationInput: { accountId: { __type: 'UUID!' } },
  ResendAccountInvitationPayload: {
    __typename: { __type: 'String!' },
    account: { __type: 'Account' },
    errors: { __type: '[ResendAccountInvitationError!]' },
  },
  RoleNameOperationFilterInput: {
    eq: { __type: 'RoleName' },
    in: { __type: '[RoleName!]' },
    neq: { __type: 'RoleName' },
    nin: { __type: '[RoleName!]' },
  },
  SelectionLabelCount: {
    __typename: { __type: 'String!' },
    itemCount: { __type: 'Int!' },
    labelId: { __type: 'UUID!' },
  },
  SelectionLabelStates: {
    __typename: { __type: 'String!' },
    labels: { __type: '[SelectionLabelCount!]!' },
    totalItems: { __type: 'Int!' },
  },
  SetOperatorProjectsError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$SetOperatorProjectsError!' },
  },
  SetOperatorProjectsInput: {
    operatorId: { __type: 'UUID!' },
    projectIds: { __type: '[UUID!]!' },
  },
  SetOperatorProjectsPayload: {
    __typename: { __type: 'String!' },
    errors: { __type: '[SetOperatorProjectsError!]' },
    operator: { __type: 'Operator' },
  },
  StopJobError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$StopJobError!' },
  },
  StopJobInput: { id: { __type: 'UUID!' } },
  StopJobPayload: {
    __typename: { __type: 'String!' },
    boolean: { __type: 'Boolean' },
    errors: { __type: '[StopJobError!]' },
  },
  StringOperationFilterInput: {
    and: { __type: '[StringOperationFilterInput!]' },
    contains: { __type: 'String' },
    endsWith: { __type: 'String' },
    eq: { __type: 'String' },
    in: { __type: '[String]' },
    ncontains: { __type: 'String' },
    nendsWith: { __type: 'String' },
    neq: { __type: 'String' },
    nin: { __type: '[String]' },
    nstartsWith: { __type: 'String' },
    or: { __type: '[StringOperationFilterInput!]' },
    startsWith: { __type: 'String' },
  },
  Survey: {
    __typename: { __type: 'String!' },
    additionalData: { __type: 'JSON' },
    backgroundJobs: { __type: '[BackgroundJob!]!' },
    createdAt: { __type: 'Instant!' },
    createdBy: { __type: 'Account' },
    createdById: { __type: 'UUID' },
    endDate: { __type: 'LocalDate!' },
    events: {
      __type: 'EventsCollectionSegment',
      __args: { skip: 'Int', take: 'Int' },
    },
    id: { __type: 'UUID!' },
    labels: { __type: '[Label!]!' },
    maxTileZoom: { __type: 'Int' },
    minTileZoom: { __type: 'Int' },
    name: { __type: 'String!' },
    projectId: { __type: 'UUID!' },
    search: { __type: 'String' },
    startDate: { __type: 'LocalDate!' },
    status: { __type: 'SurveyStatus!' },
    surveyDate: { __type: 'Instant' },
    updatedAt: { __type: 'Instant!' },
    updatedBy: { __type: 'Account' },
    updatedById: { __type: 'UUID' },
  },
  SurveyDataBulkUploadJob: {
    __typename: { __type: 'String!' },
    additionalData: { __type: 'JSON' },
    createdAt: { __type: 'Instant!' },
    createdBy: { __type: 'Account' },
    createdById: { __type: 'UUID' },
    csvFileId: { __type: 'UUID!' },
    events: {
      __type: 'EventsCollectionSegment',
      __args: { skip: 'Int', take: 'Int' },
    },
    id: { __type: 'UUID!' },
    lastLogs: { __type: '[Log!]!', __args: { count: 'Int!' } },
    logs: { __type: '[Log!]!' },
    projectName: { __type: 'String' },
    search: { __type: 'String' },
    status: { __type: 'JobStatus!' },
    surveyId: { __type: 'UUID' },
    type: { __type: 'JobType!' },
    updatedAt: { __type: 'Instant!' },
    updatedBy: { __type: 'Account' },
    updatedById: { __type: 'UUID' },
  },
  SurveyDataBulkUploadJobFilterInput: {
    additionalData: { __type: 'JsonElementFilterInput' },
    and: { __type: '[SurveyDataBulkUploadJobFilterInput!]' },
    createdAt: { __type: 'ComparableInstantOperationFilterInput' },
    createdBy: { __type: 'AccountFilterInput' },
    createdById: { __type: 'UuidOperationFilterInput' },
    csvFileId: { __type: 'UuidOperationFilterInput' },
    id: { __type: 'UuidOperationFilterInput' },
    or: { __type: '[SurveyDataBulkUploadJobFilterInput!]' },
    projectName: { __type: 'StringOperationFilterInput' },
    search: { __type: 'StringOperationFilterInput' },
    status: { __type: 'JobStatusOperationFilterInput' },
    surveyId: { __type: 'UuidOperationFilterInput' },
    type: { __type: 'JobTypeOperationFilterInput' },
    updatedAt: { __type: 'ComparableInstantOperationFilterInput' },
    updatedBy: { __type: 'AccountFilterInput' },
    updatedById: { __type: 'UuidOperationFilterInput' },
  },
  SurveyDataBulkUploadJobSortInput: {
    additionalData: { __type: 'SortEnumType' },
    createdAt: { __type: 'SortEnumType' },
    createdBy: { __type: 'AccountSortInput' },
    createdById: { __type: 'SortEnumType' },
    csvFileId: { __type: 'SortEnumType' },
    id: { __type: 'SortEnumType' },
    projectName: { __type: 'SortEnumType' },
    search: { __type: 'SortEnumType' },
    status: { __type: 'SortEnumType' },
    surveyId: { __type: 'SortEnumType' },
    type: { __type: 'SortEnumType' },
    updatedAt: { __type: 'SortEnumType' },
    updatedBy: { __type: 'AccountSortInput' },
    updatedById: { __type: 'SortEnumType' },
  },
  SurveyDataBulkUploadJobsCollectionSegment: {
    __typename: { __type: 'String!' },
    items: { __type: '[SurveyDataBulkUploadJob!]' },
    pageInfo: { __type: 'CollectionSegmentInfo!' },
    totalCount: { __type: 'Int!' },
  },
  SurveyDataDeletionJob: {
    __typename: { __type: 'String!' },
    additionalData: { __type: 'JSON' },
    createdAt: { __type: 'Instant!' },
    createdBy: { __type: 'Account' },
    createdById: { __type: 'UUID' },
    events: {
      __type: 'EventsCollectionSegment',
      __args: { skip: 'Int', take: 'Int' },
    },
    id: { __type: 'UUID!' },
    lastLogs: { __type: '[Log!]!', __args: { count: 'Int!' } },
    logs: { __type: '[Log!]!' },
    projectName: { __type: 'String' },
    search: { __type: 'String' },
    status: { __type: 'JobStatus!' },
    surveyId: { __type: 'UUID' },
    type: { __type: 'JobType!' },
    updatedAt: { __type: 'Instant!' },
    updatedBy: { __type: 'Account' },
    updatedById: { __type: 'UUID' },
  },
  SurveyDataDeletionJobFilterInput: {
    additionalData: { __type: 'JsonElementFilterInput' },
    and: { __type: '[SurveyDataDeletionJobFilterInput!]' },
    createdAt: { __type: 'ComparableInstantOperationFilterInput' },
    createdBy: { __type: 'AccountFilterInput' },
    createdById: { __type: 'UuidOperationFilterInput' },
    id: { __type: 'UuidOperationFilterInput' },
    or: { __type: '[SurveyDataDeletionJobFilterInput!]' },
    projectName: { __type: 'StringOperationFilterInput' },
    search: { __type: 'StringOperationFilterInput' },
    status: { __type: 'JobStatusOperationFilterInput' },
    surveyId: { __type: 'UuidOperationFilterInput' },
    type: { __type: 'JobTypeOperationFilterInput' },
    updatedAt: { __type: 'ComparableInstantOperationFilterInput' },
    updatedBy: { __type: 'AccountFilterInput' },
    updatedById: { __type: 'UuidOperationFilterInput' },
  },
  SurveyDataDeletionJobSortInput: {
    additionalData: { __type: 'SortEnumType' },
    createdAt: { __type: 'SortEnumType' },
    createdBy: { __type: 'AccountSortInput' },
    createdById: { __type: 'SortEnumType' },
    id: { __type: 'SortEnumType' },
    projectName: { __type: 'SortEnumType' },
    search: { __type: 'SortEnumType' },
    status: { __type: 'SortEnumType' },
    surveyId: { __type: 'SortEnumType' },
    type: { __type: 'SortEnumType' },
    updatedAt: { __type: 'SortEnumType' },
    updatedBy: { __type: 'AccountSortInput' },
    updatedById: { __type: 'SortEnumType' },
  },
  SurveyDataDeletionJobsCollectionSegment: {
    __typename: { __type: 'String!' },
    items: { __type: '[SurveyDataDeletionJob!]' },
    pageInfo: { __type: 'CollectionSegmentInfo!' },
    totalCount: { __type: 'Int!' },
  },
  SurveyFilterInput: {
    additionalData: { __type: 'JsonElementFilterInput' },
    and: { __type: '[SurveyFilterInput!]' },
    backgroundJobs: { __type: 'ListFilterInputTypeOfBackgroundJobFilterInput' },
    createdAt: { __type: 'ComparableInstantOperationFilterInput' },
    createdBy: { __type: 'AccountFilterInput' },
    createdById: { __type: 'UuidOperationFilterInput' },
    endDate: { __type: 'LocalDateOperationFilterInput' },
    id: { __type: 'UuidOperationFilterInput' },
    labels: { __type: 'ListFilterInputTypeOfLabelFilterInput' },
    maxTileZoom: { __type: 'IntOperationFilterInput' },
    minTileZoom: { __type: 'IntOperationFilterInput' },
    name: { __type: 'StringOperationFilterInput' },
    or: { __type: '[SurveyFilterInput!]' },
    projectId: { __type: 'UuidOperationFilterInput' },
    search: { __type: 'StringOperationFilterInput' },
    startDate: { __type: 'LocalDateOperationFilterInput' },
    status: { __type: 'SurveyStatusOperationFilterInput' },
    surveyDate: { __type: 'ComparableNullableOfInstantOperationFilterInput' },
    updatedAt: { __type: 'ComparableInstantOperationFilterInput' },
    updatedBy: { __type: 'AccountFilterInput' },
    updatedById: { __type: 'UuidOperationFilterInput' },
  },
  SurveyInfo: {
    __typename: { __type: 'String!' },
    endDate: { __type: 'LocalDate!' },
    id: { __type: 'UUID!' },
    name: { __type: 'String!' },
    startDate: { __type: 'LocalDate!' },
  },
  SurveyInfoFilterInput: {
    and: { __type: '[SurveyInfoFilterInput!]' },
    endDate: { __type: 'LocalDateOperationFilterInput' },
    id: { __type: 'UuidOperationFilterInput' },
    name: { __type: 'StringOperationFilterInput' },
    or: { __type: '[SurveyInfoFilterInput!]' },
    startDate: { __type: 'LocalDateOperationFilterInput' },
  },
  SurveyInfoSortInput: {
    endDate: { __type: 'SortEnumType' },
    id: { __type: 'SortEnumType' },
    name: { __type: 'SortEnumType' },
    startDate: { __type: 'SortEnumType' },
  },
  SurveySortInput: {
    additionalData: { __type: 'SortEnumType' },
    createdAt: { __type: 'SortEnumType' },
    createdBy: { __type: 'AccountSortInput' },
    createdById: { __type: 'SortEnumType' },
    endDate: { __type: 'SortEnumType' },
    id: { __type: 'SortEnumType' },
    maxTileZoom: { __type: 'SortEnumType' },
    minTileZoom: { __type: 'SortEnumType' },
    name: { __type: 'SortEnumType' },
    projectId: { __type: 'SortEnumType' },
    search: { __type: 'SortEnumType' },
    startDate: { __type: 'SortEnumType' },
    status: { __type: 'SortEnumType' },
    surveyDate: { __type: 'SortEnumType' },
    updatedAt: { __type: 'SortEnumType' },
    updatedBy: { __type: 'AccountSortInput' },
    updatedById: { __type: 'SortEnumType' },
  },
  SurveyStatusOperationFilterInput: {
    eq: { __type: 'SurveyStatus' },
    in: { __type: '[SurveyStatus!]' },
    neq: { __type: 'SurveyStatus' },
    nin: { __type: '[SurveyStatus!]' },
  },
  SurveysCollectionSegment: {
    __typename: { __type: 'String!' },
    items: { __type: '[Survey!]' },
    pageInfo: { __type: 'CollectionSegmentInfo!' },
    totalCount: { __type: 'Int!' },
  },
  TgmOperationFilterInput: {
    eq: { __type: 'Tgm' },
    in: { __type: '[Tgm!]' },
    neq: { __type: 'Tgm' },
    nin: { __type: '[Tgm!]' },
  },
  UnassignProjectError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$UnassignProjectError!' },
  },
  UnassignProjectInput: {
    operatorsIds: { __type: '[UUID!]!' },
    projectId: { __type: 'UUID!' },
  },
  UnassignProjectPayload: {
    __typename: { __type: 'String!' },
    errors: { __type: '[UnassignProjectError!]' },
    int: { __type: 'Int' },
  },
  UnauthorizedError: {
    __typename: { __type: 'String!' },
    message: { __type: 'String!' },
  },
  UpdateAccountError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$UpdateAccountError!' },
  },
  UpdateAccountInput: {
    firstName: { __type: 'String' },
    id: { __type: 'UUID!' },
    labelsIds: { __type: '[UUID!]' },
    lastName: { __type: 'String' },
  },
  UpdateAccountPayload: {
    __typename: { __type: 'String!' },
    account: { __type: 'Account' },
    errors: { __type: '[UpdateAccountError!]' },
  },
  UpdateAssetError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$UpdateAssetError!' },
  },
  UpdateAssetInput: {
    additionalData: { __type: 'JSON' },
    id: { __type: 'UUID!' },
    labelsIds: { __type: '[UUID!]' },
    name: { __type: 'String' },
    tgm: { __type: 'Tgm' },
  },
  UpdateAssetPayload: {
    __typename: { __type: 'String!' },
    asset: { __type: 'Asset' },
    errors: { __type: '[UpdateAssetError!]' },
  },
  UpdateBlobError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$UpdateBlobError!' },
  },
  UpdateBlobInput: {
    additionalData: { __type: 'JSON' },
    id: { __type: 'UUID!' },
  },
  UpdateBlobPayload: {
    __typename: { __type: 'String!' },
    blob: { __type: 'Blob' },
    errors: { __type: '[UpdateBlobError!]' },
  },
  UpdateCustomStyleError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$UpdateCustomStyleError!' },
  },
  UpdateCustomStyleInput: {
    additionalData: { __type: 'JSON' },
    id: { __type: 'UUID!' },
    name: { __type: 'String' },
    parameter: { __type: 'Parameter' },
    style: { __type: 'JSON' },
  },
  UpdateCustomStylePayload: {
    __typename: { __type: 'String!' },
    customStyle: { __type: 'CustomStyle' },
    errors: { __type: '[UpdateCustomStyleError!]' },
  },
  UpdateGlobalConfigInput: { pciCurvesFileId: { __type: 'UUID' } },
  UpdateGlobalConfigPayload: {
    __typename: { __type: 'String!' },
    globalConfig: { __type: 'GlobalConfig' },
  },
  UpdateInterventionError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$UpdateInterventionError!' },
  },
  UpdateInterventionInput: {
    actualCost: { __type: 'Decimal' },
    additionalData: { __type: 'JSON' },
    category: { __type: 'InterventionCategory' },
    effectiveEndDate: { __type: 'LocalDate' },
    effectiveStartDate: { __type: 'LocalDate' },
    estimatedCost: { __type: 'Decimal' },
    id: { __type: 'UUID!' },
    labelsIds: { __type: '[UUID!]' },
    name: { __type: 'String' },
    notes: { __type: 'String' },
    plannedEndDate: { __type: 'LocalDate' },
    plannedStartDate: { __type: 'LocalDate' },
    selections: { __type: '[AssetSelectionInput!]' },
    status: { __type: 'InterventionStatus' },
  },
  UpdateInterventionPayload: {
    __typename: { __type: 'String!' },
    errors: { __type: '[UpdateInterventionError!]' },
    intervention: { __type: 'Intervention' },
  },
  UpdateLabelError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$UpdateLabelError!' },
  },
  UpdateLabelInput: {
    additionalData: { __type: 'JSON' },
    id: { __type: 'UUID!' },
    isAdminLabel: { __type: 'Boolean' },
    name: { __type: 'String' },
  },
  UpdateLabelPayload: {
    __typename: { __type: 'String!' },
    errors: { __type: '[UpdateLabelError!]' },
    label: { __type: 'Label' },
  },
  UpdateMediaUploadJobError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$UpdateMediaUploadJobError!' },
  },
  UpdateMediaUploadJobInput: {
    additionalData: { __type: 'JSON' },
    id: { __type: 'UUID!' },
  },
  UpdateMediaUploadJobPayload: {
    __typename: { __type: 'String!' },
    errors: { __type: '[UpdateMediaUploadJobError!]' },
    mediaUploadJob: { __type: 'MediaUploadJob' },
  },
  UpdateOrganizationError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$UpdateOrganizationError!' },
  },
  UpdateOrganizationInput: {
    additionalData: { __type: 'JSON' },
    address: { __type: 'AddressInput' },
    certifiedEmailAddress: { __type: 'String' },
    email: { __type: 'String' },
    fiscalCode: { __type: 'String' },
    id: { __type: 'UUID!' },
    labelsIds: { __type: '[UUID!]' },
    legalName: { __type: 'String' },
    logoId: { __type: 'UUID' },
    name: { __type: 'String' },
    note: { __type: 'String' },
    phoneNumber: { __type: 'String' },
    pointOfContact: { __type: 'String' },
    sDICode: { __type: 'String' },
    status: { __type: 'OrganizationStatus' },
    vatNumber: { __type: 'String' },
  },
  UpdateOrganizationPayload: {
    __typename: { __type: 'String!' },
    errors: { __type: '[UpdateOrganizationError!]' },
    organization: { __type: 'Organization' },
  },
  UpdateParametersComputationJobError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$UpdateParametersComputationJobError!' },
  },
  UpdateParametersComputationJobInput: {
    additionalData: { __type: 'JSON' },
    id: { __type: 'UUID!' },
  },
  UpdateParametersComputationJobPayload: {
    __typename: { __type: 'String!' },
    errors: { __type: '[UpdateParametersComputationJobError!]' },
    parametersComputationJob: { __type: 'ParametersComputationJob' },
  },
  UpdatePendingAccountEmailError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$UpdatePendingAccountEmailError!' },
  },
  UpdatePendingAccountEmailInput: {
    email: { __type: 'String!' },
    id: { __type: 'UUID!' },
  },
  UpdatePendingAccountEmailPayload: {
    __typename: { __type: 'String!' },
    account: { __type: 'Account' },
    errors: { __type: '[UpdatePendingAccountEmailError!]' },
  },
  UpdateProjectConfigurationError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$UpdateProjectConfigurationError!' },
  },
  UpdateProjectConfigurationInput: {
    additionalData: { __type: 'JSON' },
    baseCostPerCmMq: { __type: 'Decimal' },
    baseThicknessCm: { __type: 'Decimal' },
    binderCostPerCmMq: { __type: 'Decimal' },
    binderThicknessCm: { __type: 'Decimal' },
    foundationCostPerCmMq: { __type: 'Decimal' },
    foundationThicknessCm: { __type: 'Decimal' },
    id: { __type: 'UUID!' },
    laneWidth: { __type: 'Decimal' },
    rpPciThreshold: { __type: 'Decimal' },
    rs1PciThreshold: { __type: 'Decimal' },
    rs2PciThreshold: { __type: 'Decimal' },
    rssPciThreshold: { __type: 'Decimal' },
    wearCostPerCmMq: { __type: 'Decimal' },
    wearThicknessCm: { __type: 'Decimal' },
  },
  UpdateProjectConfigurationPayload: {
    __typename: { __type: 'String!' },
    errors: { __type: '[UpdateProjectConfigurationError!]' },
    projectConfiguration: { __type: 'ProjectConfiguration' },
  },
  UpdateProjectError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$UpdateProjectError!' },
  },
  UpdateProjectInput: {
    additionalData: { __type: 'JSON' },
    cIG: { __type: 'String' },
    cUP: { __type: 'String' },
    email: { __type: 'String' },
    id: { __type: 'UUID!' },
    labelsIds: { __type: '[UUID!]' },
    name: { __type: 'String' },
    note: { __type: 'String' },
    organizationId: { __type: 'UUID' },
    pciCurvesFileId: { __type: 'UUID' },
    phoneNumber: { __type: 'String' },
    pointOfContact: { __type: 'String' },
    projectValue: { __type: 'Float' },
  },
  UpdateProjectPayload: {
    __typename: { __type: 'String!' },
    errors: { __type: '[UpdateProjectError!]' },
    project: { __type: 'Project' },
  },
  UpdateReportError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$UpdateReportError!' },
  },
  UpdateReportInput: {
    additionalData: { __type: 'JSON' },
    id: { __type: 'UUID!' },
    labelsIds: { __type: '[UUID!]' },
    name: { __type: 'String' },
  },
  UpdateReportPayload: {
    __typename: { __type: 'String!' },
    errors: { __type: '[UpdateReportError!]' },
    report: { __type: 'Report' },
  },
  UpdateSurveyError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$UpdateSurveyError!' },
  },
  UpdateSurveyInput: {
    additionalData: { __type: 'JSON' },
    endDate: { __type: 'LocalDate' },
    id: { __type: 'UUID!' },
    labelsIds: { __type: '[UUID!]' },
    name: { __type: 'String' },
    startDate: { __type: 'LocalDate' },
    status: { __type: 'SurveyStatus' },
  },
  UpdateSurveyPayload: {
    __typename: { __type: 'String!' },
    errors: { __type: '[UpdateSurveyError!]' },
    survey: { __type: 'Survey' },
  },
  UploadBlobError: {
    __typename: { __type: 'String!' },
    $on: { __type: '$UploadBlobError!' },
  },
  UploadBlobInput: {
    data: { __type: 'JSON' },
    file: { __type: 'Upload!' },
    labelsIds: { __type: '[UUID!]' },
  },
  UploadBlobPayload: {
    __typename: { __type: 'String!' },
    blob: { __type: 'Blob' },
    errors: { __type: '[UploadBlobError!]' },
  },
  UuidOperationFilterInput: {
    eq: { __type: 'UUID' },
    gt: { __type: 'UUID' },
    gte: { __type: 'UUID' },
    in: { __type: '[UUID]' },
    lt: { __type: 'UUID' },
    lte: { __type: 'UUID' },
    neq: { __type: 'UUID' },
    ngt: { __type: 'UUID' },
    ngte: { __type: 'UUID' },
    nin: { __type: '[UUID]' },
    nlt: { __type: 'UUID' },
    nlte: { __type: 'UUID' },
  },
  mutation: {
    __typename: { __type: 'String!' },
    applyLabelsToSelection: {
      __type: 'ApplyLabelsToSelectionPayload!',
      __args: { input: 'ApplyLabelsToSelectionInput!' },
    },
    bulkAssignProjectsToOperators: {
      __type: 'BulkAssignProjectsToOperatorsPayload!',
      __args: { input: 'BulkAssignProjectsToOperatorsInput!' },
    },
    bulkAssignProjectsToOrganization: {
      __type: 'BulkAssignProjectsToOrganizationPayload!',
      __args: { input: 'BulkAssignProjectsToOrganizationInput!' },
    },
    bulkDeleteAccount: {
      __type: 'BulkDeleteAccountPayload!',
      __args: { input: 'BulkDeleteAccountInput!' },
    },
    bulkSetAccountStatus: {
      __type: 'BulkSetAccountStatusPayload!',
      __args: { input: 'BulkSetAccountStatusInput!' },
    },
    bulkSetLabels: {
      __type: 'BulkSetLabelsPayload!',
      __args: { input: 'BulkSetLabelsInput!' },
    },
    bulkUnassignOrganizationProjects: {
      __type: 'BulkUnassignOrganizationProjectsPayload!',
      __args: { input: 'BulkUnassignOrganizationProjectsInput!' },
    },
    cloneProject: {
      __type: 'CloneProjectPayload!',
      __args: { input: 'CloneProjectInput!' },
    },
    confirmAccount: {
      __type: 'ConfirmAccountPayload!',
      __args: { input: 'ConfirmAccountInput!' },
    },
    confirmEmailAddress: {
      __type: 'ConfirmEmailAddressPayload!',
      __args: { input: 'ConfirmEmailAddressInput!' },
    },
    createApiKey: { __type: 'CreateApiKeyPayload!' },
    createBlockchainNotarizationJob: {
      __type: 'CreateBlockchainNotarizationJobPayload!',
      __args: { input: 'CreateBlockchainNotarizationJobInput!' },
    },
    createCustomLayerUploadJob: {
      __type: 'CreateCustomLayerUploadJobPayload!',
      __args: { input: 'CreateCustomLayerUploadJobInput!' },
    },
    createCustomStyle: {
      __type: 'CreateCustomStylePayload!',
      __args: { input: 'CreateCustomStyleInput!' },
    },
    createDatasetPreparationJob: {
      __type: 'CreateDatasetPreparationJobPayload!',
      __args: { input: 'CreateDatasetPreparationJobInput!' },
    },
    createIntervention: {
      __type: 'CreateInterventionPayload!',
      __args: { input: 'CreateInterventionInput!' },
    },
    createLabel: {
      __type: 'CreateLabelPayload!',
      __args: { input: 'CreateLabelInput!' },
    },
    createMediaUploadJob: {
      __type: 'CreateMediaUploadJobPayload!',
      __args: { input: 'CreateMediaUploadJobInput!' },
    },
    createOrganization: {
      __type: 'CreateOrganizationPayload!',
      __args: { input: 'CreateOrganizationInput!' },
    },
    createParametersComputationJob: {
      __type: 'CreateParametersComputationJobPayload!',
      __args: { input: 'CreateParametersComputationJobInput!' },
    },
    createProject: {
      __type: 'CreateProjectPayload!',
      __args: { input: 'CreateProjectInput!' },
    },
    createProjectConfiguration: {
      __type: 'CreateProjectConfigurationPayload!',
      __args: { input: 'CreateProjectConfigurationInput!' },
    },
    createReportGenerationJob: {
      __type: 'CreateReportGenerationJobPayload!',
      __args: { input: 'CreateReportGenerationJobInput!' },
    },
    createSurvey: {
      __type: 'CreateSurveyPayload!',
      __args: { input: 'CreateSurveyInput!' },
    },
    createSurveyDataBulkUploadJob: {
      __type: 'CreateSurveyDataBulkUploadJobPayload!',
      __args: { input: 'CreateSurveyDataBulkUploadJobInput!' },
    },
    createSurveyDataDeletionJob: {
      __type: 'CreateSurveyDataDeletionJobPayload!',
      __args: { input: 'CreateSurveyDataDeletionJobInput!' },
    },
    deleteAccount: {
      __type: 'DeleteAccountPayload!',
      __args: { input: 'DeleteAccountInput!' },
    },
    deleteApiKey: {
      __type: 'DeleteApiKeyPayload!',
      __args: { input: 'DeleteApiKeyInput!' },
    },
    deleteAsset: {
      __type: 'DeleteAssetPayload!',
      __args: { input: 'DeleteAssetInput!' },
    },
    deleteBlob: {
      __type: 'DeleteBlobPayload!',
      __args: { input: 'DeleteBlobInput!' },
    },
    deleteBlockchainNotarizationJob: {
      __type: 'DeleteBlockchainNotarizationJobPayload!',
      __args: { input: 'DeleteBlockchainNotarizationJobInput!' },
    },
    deleteCustomLayer: {
      __type: 'DeleteCustomLayerPayload!',
      __args: { input: 'DeleteCustomLayerInput!' },
    },
    deleteCustomLayerItem: {
      __type: 'DeleteCustomLayerItemPayload!',
      __args: { input: 'DeleteCustomLayerItemInput!' },
    },
    deleteCustomLayerUploadJob: {
      __type: 'DeleteCustomLayerUploadJobPayload!',
      __args: { input: 'DeleteCustomLayerUploadJobInput!' },
    },
    deleteCustomStyle: {
      __type: 'DeleteCustomStylePayload!',
      __args: { input: 'DeleteCustomStyleInput!' },
    },
    deleteDatasetPreparationJob: {
      __type: 'DeleteDatasetPreparationJobPayload!',
      __args: { input: 'DeleteDatasetPreparationJobInput!' },
    },
    deleteEvent: {
      __type: 'DeleteEventPayload!',
      __args: { input: 'DeleteEventInput!' },
    },
    deleteIntervention: {
      __type: 'DeleteInterventionPayload!',
      __args: { input: 'DeleteInterventionInput!' },
    },
    deleteItem: {
      __type: 'DeleteItemPayload!',
      __args: { input: 'DeleteItemInput!' },
    },
    deleteLabel: {
      __type: 'DeleteLabelPayload!',
      __args: { input: 'DeleteLabelInput!' },
    },
    deleteMediaUploadJob: {
      __type: 'DeleteMediaUploadJobPayload!',
      __args: { input: 'DeleteMediaUploadJobInput!' },
    },
    deleteOrganization: {
      __type: 'DeleteOrganizationPayload!',
      __args: { input: 'DeleteOrganizationInput!' },
    },
    deleteParametersComputationJob: {
      __type: 'DeleteParametersComputationJobPayload!',
      __args: { input: 'DeleteParametersComputationJobInput!' },
    },
    deletePath: {
      __type: 'DeletePathPayload!',
      __args: { input: 'DeletePathInput!' },
    },
    deleteProject: {
      __type: 'DeleteProjectPayload!',
      __args: { input: 'DeleteProjectInput!' },
    },
    deleteProjectConfiguration: {
      __type: 'DeleteProjectConfigurationPayload!',
      __args: { input: 'DeleteProjectConfigurationInput!' },
    },
    deleteReport: {
      __type: 'DeleteReportPayload!',
      __args: { input: 'DeleteReportInput!' },
    },
    deleteReportGenerationJob: {
      __type: 'DeleteReportGenerationJobPayload!',
      __args: { input: 'DeleteReportGenerationJobInput!' },
    },
    deleteSurvey: {
      __type: 'DeleteSurveyPayload!',
      __args: { input: 'DeleteSurveyInput!' },
    },
    deleteSurveyDataBulkUploadJob: {
      __type: 'DeleteSurveyDataBulkUploadJobPayload!',
      __args: { input: 'DeleteSurveyDataBulkUploadJobInput!' },
    },
    deleteSurveyDataDeletionJob: {
      __type: 'DeleteSurveyDataDeletionJobPayload!',
      __args: { input: 'DeleteSurveyDataDeletionJobInput!' },
    },
    forceDeleteCustomStyle: {
      __type: 'ForceDeleteCustomStylePayload!',
      __args: { input: 'ForceDeleteCustomStyleInput!' },
    },
    forcePasswordReset: {
      __type: 'ForcePasswordResetPayload!',
      __args: { input: 'ForcePasswordResetInput!' },
    },
    initUpdateEmailAddress: {
      __type: 'InitUpdateEmailAddressPayload!',
      __args: { input: 'InitUpdateEmailAddressInput!' },
    },
    inviteNewAccount: {
      __type: 'InviteNewAccountPayload!',
      __args: { input: 'InviteNewAccountInput!' },
    },
    resendAccountInvitation: {
      __type: 'ResendAccountInvitationPayload!',
      __args: { input: 'ResendAccountInvitationInput!' },
    },
    setOperatorProjects: {
      __type: 'SetOperatorProjectsPayload!',
      __args: { input: 'SetOperatorProjectsInput!' },
    },
    stopJob: { __type: 'StopJobPayload!', __args: { input: 'StopJobInput!' } },
    unassignProject: {
      __type: 'UnassignProjectPayload!',
      __args: { input: 'UnassignProjectInput!' },
    },
    updateAccount: {
      __type: 'UpdateAccountPayload!',
      __args: { input: 'UpdateAccountInput!' },
    },
    updateAsset: {
      __type: 'UpdateAssetPayload!',
      __args: { input: 'UpdateAssetInput!' },
    },
    updateBlob: {
      __type: 'UpdateBlobPayload!',
      __args: { input: 'UpdateBlobInput!' },
    },
    updateCustomStyle: {
      __type: 'UpdateCustomStylePayload!',
      __args: { input: 'UpdateCustomStyleInput!' },
    },
    updateGlobalConfig: {
      __type: 'UpdateGlobalConfigPayload!',
      __args: { input: 'UpdateGlobalConfigInput!' },
    },
    updateIntervention: {
      __type: 'UpdateInterventionPayload!',
      __args: { input: 'UpdateInterventionInput!' },
    },
    updateLabel: {
      __type: 'UpdateLabelPayload!',
      __args: { input: 'UpdateLabelInput!' },
    },
    updateMediaUploadJob: {
      __type: 'UpdateMediaUploadJobPayload!',
      __args: { input: 'UpdateMediaUploadJobInput!' },
    },
    updateOrganization: {
      __type: 'UpdateOrganizationPayload!',
      __args: { input: 'UpdateOrganizationInput!' },
    },
    updateParametersComputationJob: {
      __type: 'UpdateParametersComputationJobPayload!',
      __args: { input: 'UpdateParametersComputationJobInput!' },
    },
    updatePendingAccountEmail: {
      __type: 'UpdatePendingAccountEmailPayload!',
      __args: { input: 'UpdatePendingAccountEmailInput!' },
    },
    updateProject: {
      __type: 'UpdateProjectPayload!',
      __args: { input: 'UpdateProjectInput!' },
    },
    updateProjectConfiguration: {
      __type: 'UpdateProjectConfigurationPayload!',
      __args: { input: 'UpdateProjectConfigurationInput!' },
    },
    updateReport: {
      __type: 'UpdateReportPayload!',
      __args: { input: 'UpdateReportInput!' },
    },
    updateSurvey: {
      __type: 'UpdateSurveyPayload!',
      __args: { input: 'UpdateSurveyInput!' },
    },
    uploadBlob: {
      __type: 'UploadBlobPayload!',
      __args: { input: 'UploadBlobInput!' },
    },
  },
  query: {
    __typename: { __type: 'String!' },
    admin: { __type: 'Admin', __args: { id: 'UUID!' } },
    adminOverview: { __type: 'GetAdminOverviewPayload!' },
    admins: {
      __type: 'AdminsCollectionSegment',
      __args: {
        order: '[AdminSortInput!]',
        skip: 'Int',
        take: 'Int',
        where: 'AdminFilterInput',
      },
    },
    apiKey: { __type: 'ApiKey', __args: { id: 'UUID!' } },
    apiKeys: {
      __type: 'ApiKeysCollectionSegment',
      __args: {
        order: '[ApiKeySortInput!]',
        skip: 'Int',
        take: 'Int',
        where: 'ApiKeyFilterInput',
      },
    },
    asset: { __type: 'Asset', __args: { id: 'UUID!' } },
    assets: {
      __type: 'AssetsCollectionSegment',
      __args: {
        order: '[AssetSortInput!]',
        skip: 'Int',
        take: 'Int',
        where: 'AssetFilterInput',
      },
    },
    backgroundJobs: {
      __type: 'BackgroundJobsCollectionSegment',
      __args: {
        jobStatus: 'JobStatus',
        orderDirection: 'OrderDirection',
        skip: 'Int',
        surveyId: 'UUID',
        take: 'Int',
      },
    },
    blob: { __type: 'Blob', __args: { id: 'UUID!' } },
    blobs: {
      __type: 'BlobsCollectionSegment',
      __args: {
        order: '[BlobSortInput!]',
        skip: 'Int',
        take: 'Int',
        where: 'BlobFilterInput',
      },
    },
    blockchainNotarizationJob: {
      __type: 'BlockchainNotarizationJob',
      __args: { id: 'UUID!' },
    },
    blockchainNotarizationJobs: {
      __type: 'BlockchainNotarizationJobsCollectionSegment',
      __args: {
        order: '[BlockchainNotarizationJobSortInput!]',
        skip: 'Int',
        take: 'Int',
        where: 'BlockchainNotarizationJobFilterInput',
      },
    },
    customLayer: { __type: 'CustomLayer', __args: { id: 'UUID!' } },
    customLayerItem: { __type: 'CustomLayerItem', __args: { id: 'UUID!' } },
    customLayerItems: {
      __type: 'CustomLayerItemsCollectionSegment',
      __args: {
        order: '[CustomLayerItemSortInput!]',
        skip: 'Int',
        take: 'Int',
        where: 'CustomLayerItemFilterInput',
      },
    },
    customLayerUploadJob: {
      __type: 'CustomLayerUploadJob',
      __args: { id: 'UUID!' },
    },
    customLayerUploadJobs: {
      __type: 'CustomLayerUploadJobsCollectionSegment',
      __args: {
        order: '[CustomLayerUploadJobSortInput!]',
        skip: 'Int',
        take: 'Int',
        where: 'CustomLayerUploadJobFilterInput',
      },
    },
    customLayers: {
      __type: 'CustomLayersCollectionSegment',
      __args: {
        order: '[CustomLayerSortInput!]',
        skip: 'Int',
        take: 'Int',
        where: 'CustomLayerFilterInput',
      },
    },
    customStyle: { __type: 'CustomStyle', __args: { id: 'UUID!' } },
    customStyles: {
      __type: 'CustomStylesCollectionSegment',
      __args: {
        order: '[CustomStyleSortInput!]',
        skip: 'Int',
        take: 'Int',
        where: 'CustomStyleFilterInput',
      },
    },
    datasetPreparationJob: {
      __type: 'DatasetPreparationJob',
      __args: { id: 'UUID!' },
    },
    datasetPreparationJobs: {
      __type: 'DatasetPreparationJobsCollectionSegment',
      __args: {
        order: '[DatasetPreparationJobSortInput!]',
        skip: 'Int',
        take: 'Int',
        where: 'DatasetPreparationJobFilterInput',
      },
    },
    event: { __type: 'Event', __args: { id: 'UUID!' } },
    events: {
      __type: 'EventsCollectionSegment',
      __args: {
        order: '[EventSortInput!]',
        skip: 'Int',
        take: 'Int',
        where: 'EventFilterInput',
      },
    },
    globalConfig: { __type: 'GlobalConfig' },
    intervention: { __type: 'Intervention', __args: { id: 'UUID!' } },
    interventions: {
      __type: 'InterventionsCollectionSegment',
      __args: {
        order: '[InterventionSortInput!]',
        skip: 'Int',
        take: 'Int',
        where: 'InterventionFilterInput',
      },
    },
    invitationByToken: {
      __type: 'GetInvitationByTokenPayload!',
      __args: { token: 'String!' },
    },
    item: { __type: 'Item', __args: { id: 'UUID!' } },
    items: {
      __type: '[Item!]!',
      __args: { order: '[ItemSortInput!]', where: 'ItemFilterInput' },
    },
    label: { __type: 'Label', __args: { id: 'UUID!' } },
    labels: {
      __type: 'LabelsCollectionSegment',
      __args: {
        order: '[LabelSortInput!]',
        skip: 'Int',
        take: 'Int',
        where: 'LabelFilterInput',
      },
    },
    me: { __type: 'Account' },
    media: { __type: 'Media', __args: { id: 'UUID!' } },
    mediaUploadJob: { __type: 'MediaUploadJob', __args: { id: 'UUID!' } },
    mediaUploadJobs: {
      __type: 'MediaUploadJobsCollectionSegment',
      __args: {
        order: '[MediaUploadJobSortInput!]',
        skip: 'Int',
        take: 'Int',
        where: 'MediaUploadJobFilterInput',
      },
    },
    medias: {
      __type: '[Media!]!',
      __args: { order: '[MediaSortInput!]', where: 'MediaFilterInput' },
    },
    notarization: { __type: 'Notarization', __args: { id: 'UUID!' } },
    notarizations: {
      __type: 'NotarizationsCollectionSegment',
      __args: {
        order: '[NotarizationSortInput!]',
        skip: 'Int',
        take: 'Int',
        where: 'NotarizationFilterInput',
      },
    },
    operator: { __type: 'Operator', __args: { id: 'UUID!' } },
    operatorOverview: { __type: 'GetOperatorOverviewPayload!' },
    operators: {
      __type: 'OperatorsCollectionSegment',
      __args: {
        order: '[OperatorSortInput!]',
        skip: 'Int',
        take: 'Int',
        where: 'OperatorFilterInput',
      },
    },
    organization: { __type: 'Organization', __args: { id: 'UUID!' } },
    organizations: {
      __type: 'OrganizationsCollectionSegment',
      __args: {
        order: '[OrganizationSortInput!]',
        skip: 'Int',
        take: 'Int',
        where: 'OrganizationFilterInput',
      },
    },
    parametersComputationJob: {
      __type: 'ParametersComputationJob',
      __args: { id: 'UUID!' },
    },
    parametersComputationJobs: {
      __type: 'ParametersComputationJobsCollectionSegment',
      __args: {
        order: '[ParametersComputationJobSortInput!]',
        skip: 'Int',
        take: 'Int',
        where: 'ParametersComputationJobFilterInput',
      },
    },
    path: { __type: 'Path', __args: { id: 'UUID!' } },
    pathMedia: { __type: 'PathMedia', __args: { id: 'UUID!' } },
    pathMedias: {
      __type: '[PathMedia!]!',
      __args: { order: '[PathMediaSortInput!]', where: 'PathMediaFilterInput' },
    },
    paths: {
      __type: '[Path!]!',
      __args: {
        order: '[PathSortInput!]',
        tolerance: 'Float',
        where: 'PathFilterInput',
      },
    },
    project: { __type: 'Project', __args: { id: 'UUID!' } },
    projectConfiguration: {
      __type: 'ProjectConfiguration',
      __args: { id: 'UUID!' },
    },
    projectConfigurations: {
      __type: 'ProjectConfigurationsCollectionSegment',
      __args: {
        order: '[ProjectConfigurationSortInput!]',
        skip: 'Int',
        take: 'Int',
        where: 'ProjectConfigurationFilterInput',
      },
    },
    projects: {
      __type: 'ProjectsCollectionSegment',
      __args: {
        order: '[ProjectSortInput!]',
        skip: 'Int',
        take: 'Int',
        where: 'ProjectFilterInput',
      },
    },
    report: { __type: 'Report', __args: { id: 'UUID!' } },
    reportGenerationJob: {
      __type: 'ReportGenerationJob',
      __args: { id: 'UUID!' },
    },
    reportGenerationJobs: {
      __type: 'ReportGenerationJobsCollectionSegment',
      __args: {
        order: '[ReportGenerationJobSortInput!]',
        skip: 'Int',
        take: 'Int',
        where: 'ReportGenerationJobFilterInput',
      },
    },
    reports: {
      __type: 'ReportsCollectionSegment',
      __args: {
        order: '[ReportSortInput!]',
        skip: 'Int',
        take: 'Int',
        where: 'ReportFilterInput',
      },
    },
    selectionEstimatedCost: {
      __type: 'Decimal!',
      __args: { assetSelections: '[AssetSelectionInput!]!', surveyId: 'UUID!' },
    },
    selectionLabelStates: {
      __type: 'SelectionLabelStates!',
      __args: { assetSelections: '[AssetSelectionInput!]!', surveyId: 'UUID!' },
    },
    survey: { __type: 'Survey', __args: { id: 'UUID!' } },
    surveyDataBulkUploadJob: {
      __type: 'SurveyDataBulkUploadJob',
      __args: { id: 'UUID!' },
    },
    surveyDataBulkUploadJobs: {
      __type: 'SurveyDataBulkUploadJobsCollectionSegment',
      __args: {
        order: '[SurveyDataBulkUploadJobSortInput!]',
        skip: 'Int',
        take: 'Int',
        where: 'SurveyDataBulkUploadJobFilterInput',
      },
    },
    surveyDataDeletionJob: {
      __type: 'SurveyDataDeletionJob',
      __args: { id: 'UUID!' },
    },
    surveyDataDeletionJobs: {
      __type: 'SurveyDataDeletionJobsCollectionSegment',
      __args: {
        order: '[SurveyDataDeletionJobSortInput!]',
        skip: 'Int',
        take: 'Int',
        where: 'SurveyDataDeletionJobFilterInput',
      },
    },
    surveys: {
      __type: 'SurveysCollectionSegment',
      __args: {
        order: '[SurveySortInput!]',
        skip: 'Int',
        take: 'Int',
        where: 'SurveyFilterInput',
      },
    },
  },
  subscription: {
    __typename: { __type: 'String!' },
    logs: { __type: 'Log!', __args: { loggableId: 'String!' } },
    onEvent: {
      __type: 'Event!',
      __args: { targetId: 'UUID', targetType: 'String', type: 'String' },
    },
  },
  [SchemaUnionsKey]: {
    ApplyLabelsToSelectionError: [
      'BadRequestError',
      'ForbiddenError',
      'NotFoundError',
    ],
    IBackgroundJob: [
      'BackgroundJob',
      'BlockchainNotarizationJob',
      'CustomLayerUploadJob',
      'DatasetPreparationJob',
      'MediaUploadJob',
      'ParametersComputationJob',
      'ReportGenerationJob',
      'SurveyDataBulkUploadJob',
      'SurveyDataDeletionJob',
    ],
    Error: [
      'BadRequestError',
      'ConflictError',
      'ForbiddenError',
      'NotFoundError',
      'UnauthorizedError',
    ],
    BulkAssignProjectsToOperatorsError: ['NotFoundError'],
    BulkAssignProjectsToOrganizationError: ['NotFoundError'],
    BulkSetLabelsError: [
      'BadRequestError',
      'ConflictError',
      'ForbiddenError',
      'NotFoundError',
    ],
    BulkUnassignOrganizationProjectsError: ['NotFoundError'],
    CloneProjectError: ['NotFoundError'],
    ConfirmAccountError: ['UnauthorizedError'],
    ConfirmEmailAddressError: [
      'ConflictError',
      'ForbiddenError',
      'UnauthorizedError',
    ],
    CreateApiKeyError: ['NotFoundError'],
    CreateBlockchainNotarizationJobError: [
      'BadRequestError',
      'ConflictError',
      'UnauthorizedError',
    ],
    CreateCustomLayerUploadJobError: [
      'BadRequestError',
      'ConflictError',
      'UnauthorizedError',
    ],
    CreateCustomStyleError: [
      'BadRequestError',
      'ConflictError',
      'UnauthorizedError',
    ],
    CreateDatasetPreparationJobError: [
      'BadRequestError',
      'ConflictError',
      'UnauthorizedError',
    ],
    CreateInterventionError: [
      'BadRequestError',
      'ConflictError',
      'UnauthorizedError',
    ],
    CreateLabelError: ['BadRequestError', 'ConflictError', 'UnauthorizedError'],
    CreateMediaUploadJobError: [
      'BadRequestError',
      'ConflictError',
      'UnauthorizedError',
    ],
    CreateOrganizationError: [
      'BadRequestError',
      'ConflictError',
      'UnauthorizedError',
    ],
    CreateParametersComputationJobError: [
      'BadRequestError',
      'ConflictError',
      'UnauthorizedError',
    ],
    CreateProjectConfigurationError: [
      'BadRequestError',
      'ConflictError',
      'UnauthorizedError',
    ],
    CreateProjectError: [
      'BadRequestError',
      'ConflictError',
      'UnauthorizedError',
    ],
    CreateReportGenerationJobError: [
      'BadRequestError',
      'ConflictError',
      'UnauthorizedError',
    ],
    CreateSurveyDataBulkUploadJobError: [
      'BadRequestError',
      'ConflictError',
      'UnauthorizedError',
    ],
    CreateSurveyDataDeletionJobError: [
      'BadRequestError',
      'ConflictError',
      'UnauthorizedError',
    ],
    CreateSurveyError: [
      'BadRequestError',
      'ConflictError',
      'UnauthorizedError',
    ],
    DeleteAccountError: ['NotFoundError'],
    DeleteApiKeyError: ['NotFoundError', 'UnauthorizedError'],
    DeleteAssetError: ['NotFoundError', 'UnauthorizedError'],
    DeleteBlobError: ['NotFoundError', 'UnauthorizedError'],
    DeleteBlockchainNotarizationJobError: [
      'NotFoundError',
      'UnauthorizedError',
    ],
    DeleteCustomLayerError: ['NotFoundError', 'UnauthorizedError'],
    DeleteCustomLayerItemError: ['NotFoundError', 'UnauthorizedError'],
    DeleteCustomLayerUploadJobError: ['NotFoundError', 'UnauthorizedError'],
    DeleteCustomStyleError: ['NotFoundError', 'UnauthorizedError'],
    DeleteDatasetPreparationJobError: ['NotFoundError', 'UnauthorizedError'],
    DeleteEventError: ['NotFoundError', 'UnauthorizedError'],
    DeleteInterventionError: ['NotFoundError', 'UnauthorizedError'],
    DeleteItemError: ['NotFoundError', 'UnauthorizedError'],
    DeleteLabelError: ['NotFoundError', 'UnauthorizedError'],
    DeleteMediaUploadJobError: ['NotFoundError', 'UnauthorizedError'],
    DeleteOrganizationError: ['NotFoundError'],
    DeleteParametersComputationJobError: ['NotFoundError', 'UnauthorizedError'],
    DeletePathError: ['NotFoundError', 'UnauthorizedError'],
    DeleteProjectConfigurationError: ['NotFoundError', 'UnauthorizedError'],
    DeleteProjectError: ['NotFoundError', 'UnauthorizedError'],
    DeleteReportError: ['NotFoundError', 'UnauthorizedError'],
    DeleteReportGenerationJobError: ['NotFoundError', 'UnauthorizedError'],
    DeleteSurveyDataBulkUploadJobError: ['NotFoundError', 'UnauthorizedError'],
    DeleteSurveyDataDeletionJobError: ['NotFoundError', 'UnauthorizedError'],
    DeleteSurveyError: ['NotFoundError', 'UnauthorizedError'],
    ForcePasswordResetError: ['NotFoundError'],
    GeoJSONInterface: [
      'GeoJSONLineStringType',
      'GeoJSONMultiLineStringType',
      'GeoJSONMultiPointType',
      'GeoJSONMultiPolygonType',
      'GeoJSONPointType',
      'GeoJSONPolygonType',
    ],
    InitUpdateEmailAddressError: [
      'ConflictError',
      'NotFoundError',
      'UnauthorizedError',
    ],
    InviteNewAccountError: ['ConflictError', 'UnauthorizedError'],
    ResendAccountInvitationError: [
      'ConflictError',
      'NotFoundError',
      'UnauthorizedError',
    ],
    SetOperatorProjectsError: ['NotFoundError'],
    StopJobError: ['NotFoundError'],
    UnassignProjectError: ['NotFoundError'],
    UpdateAccountError: ['NotFoundError'],
    UpdateAssetError: [
      'BadRequestError',
      'ConflictError',
      'ForbiddenError',
      'NotFoundError',
      'UnauthorizedError',
    ],
    UpdateBlobError: [
      'BadRequestError',
      'ConflictError',
      'ForbiddenError',
      'NotFoundError',
      'UnauthorizedError',
    ],
    UpdateCustomStyleError: [
      'BadRequestError',
      'ConflictError',
      'ForbiddenError',
      'NotFoundError',
      'UnauthorizedError',
    ],
    UpdateInterventionError: [
      'BadRequestError',
      'ConflictError',
      'ForbiddenError',
      'NotFoundError',
      'UnauthorizedError',
    ],
    UpdateLabelError: [
      'BadRequestError',
      'ConflictError',
      'ForbiddenError',
      'NotFoundError',
      'UnauthorizedError',
    ],
    UpdateMediaUploadJobError: [
      'BadRequestError',
      'ConflictError',
      'ForbiddenError',
      'NotFoundError',
      'UnauthorizedError',
    ],
    UpdateOrganizationError: [
      'BadRequestError',
      'ConflictError',
      'ForbiddenError',
      'NotFoundError',
      'UnauthorizedError',
    ],
    UpdateParametersComputationJobError: [
      'BadRequestError',
      'ConflictError',
      'ForbiddenError',
      'NotFoundError',
      'UnauthorizedError',
    ],
    UpdatePendingAccountEmailError: [
      'ConflictError',
      'NotFoundError',
      'UnauthorizedError',
    ],
    UpdateProjectConfigurationError: [
      'BadRequestError',
      'ConflictError',
      'ForbiddenError',
      'NotFoundError',
      'UnauthorizedError',
    ],
    UpdateProjectError: [
      'BadRequestError',
      'ConflictError',
      'ForbiddenError',
      'NotFoundError',
      'UnauthorizedError',
    ],
    UpdateReportError: [
      'BadRequestError',
      'ConflictError',
      'ForbiddenError',
      'NotFoundError',
      'UnauthorizedError',
    ],
    UpdateSurveyError: [
      'BadRequestError',
      'ConflictError',
      'ForbiddenError',
      'NotFoundError',
      'UnauthorizedError',
    ],
    UploadBlobError: ['BadRequestError', 'UnauthorizedError'],
  },
} as const;

export interface Account {
  __typename?: 'Account';
  deletedAt?: Maybe<ScalarsEnums['Instant']>;
  email?: Maybe<ScalarsEnums['String']>;
  firstName?: Maybe<ScalarsEnums['String']>;
  id: ScalarsEnums['UUID'];
  isDeleted: ScalarsEnums['Boolean'];
  isEnabled: ScalarsEnums['Boolean'];
  lastName?: Maybe<ScalarsEnums['String']>;
  role: ScalarsEnums['RoleName'];
  search?: Maybe<ScalarsEnums['String']>;
  status: ScalarsEnums['AccountStatus'];
  unconfirmedEmail?: Maybe<ScalarsEnums['String']>;
}

export interface Address {
  __typename?: 'Address';
  /**
   * Province / Region
   */
  administrativeArea?: Maybe<ScalarsEnums['String']>;
  country?: Maybe<ScalarsEnums['String']>;
  /**
   * City / Town
   */
  locality?: Maybe<ScalarsEnums['String']>;
  postalCode?: Maybe<ScalarsEnums['String']>;
  streetAddress?: Maybe<ScalarsEnums['String']>;
  streetNumber?: Maybe<ScalarsEnums['String']>;
}

export interface Admin {
  __typename?: 'Admin';
  deletedAt?: Maybe<ScalarsEnums['Instant']>;
  email?: Maybe<ScalarsEnums['String']>;
  firstName?: Maybe<ScalarsEnums['String']>;
  id: ScalarsEnums['UUID'];
  isDeleted: ScalarsEnums['Boolean'];
  isEnabled: ScalarsEnums['Boolean'];
  labels: Array<Label>;
  labelsIds: Array<ScalarsEnums['UUID']>;
  lastName?: Maybe<ScalarsEnums['String']>;
  role: ScalarsEnums['RoleName'];
  search?: Maybe<ScalarsEnums['String']>;
  status: ScalarsEnums['AccountStatus'];
  unconfirmedEmail?: Maybe<ScalarsEnums['String']>;
}

/**
 * A segment of a collection.
 */
export interface AdminsCollectionSegment {
  __typename?: 'AdminsCollectionSegment';
  /**
   * A flattened list of the items.
   */
  items?: Maybe<Array<Admin>>;
  /**
   * Information to aid in pagination.
   */
  pageInfo: CollectionSegmentInfo;
  totalCount: ScalarsEnums['Int'];
}

export interface ApiKey {
  __typename?: 'ApiKey';
  additionalData?: Maybe<ScalarsEnums['JSON']>;
  createdAt: ScalarsEnums['Instant'];
  createdBy?: Maybe<Account>;
  createdById?: Maybe<ScalarsEnums['UUID']>;
  events: (args?: {
    skip?: Maybe<ScalarsEnums['Int']>;
    take?: Maybe<ScalarsEnums['Int']>;
  }) => Maybe<EventsCollectionSegment>;
  id: ScalarsEnums['UUID'];
  key: ScalarsEnums['String'];
  ownerId: ScalarsEnums['UUID'];
  search?: Maybe<ScalarsEnums['String']>;
  updatedAt: ScalarsEnums['Instant'];
  updatedBy?: Maybe<Account>;
  updatedById?: Maybe<ScalarsEnums['UUID']>;
}

/**
 * A segment of a collection.
 */
export interface ApiKeysCollectionSegment {
  __typename?: 'ApiKeysCollectionSegment';
  /**
   * A flattened list of the items.
   */
  items?: Maybe<Array<ApiKey>>;
  /**
   * Information to aid in pagination.
   */
  pageInfo: CollectionSegmentInfo;
  totalCount: ScalarsEnums['Int'];
}

export interface ApplyLabelsToSelectionError {
  __typename?: 'BadRequestError' | 'ForbiddenError' | 'NotFoundError';
  $on: $ApplyLabelsToSelectionError;
}

export interface ApplyLabelsToSelectionPayload {
  __typename?: 'ApplyLabelsToSelectionPayload';
  applyLabelsToSelectionResult?: Maybe<ApplyLabelsToSelectionResult>;
  errors?: Maybe<Array<ApplyLabelsToSelectionError>>;
}

export interface ApplyLabelsToSelectionResult {
  __typename?: 'ApplyLabelsToSelectionResult';
  affectedItemCount: ScalarsEnums['Int'];
}

export interface Asset {
  __typename?: 'Asset';
  additionalData?: Maybe<ScalarsEnums['JSON']>;
  associatedSurveysIds: Array<ScalarsEnums['UUID']>;
  bounds?: Maybe<Bounds>;
  createdAt: ScalarsEnums['Instant'];
  createdBy?: Maybe<Account>;
  createdById?: Maybe<ScalarsEnums['UUID']>;
  events: (args?: {
    skip?: Maybe<ScalarsEnums['Int']>;
    take?: Maybe<ScalarsEnums['Int']>;
  }) => Maybe<EventsCollectionSegment>;
  id: ScalarsEnums['UUID'];
  labels: Array<Label>;
  name: ScalarsEnums['String'];
  paths: Array<Path>;
  projectId: ScalarsEnums['UUID'];
  search?: Maybe<ScalarsEnums['String']>;
  tgm: ScalarsEnums['Tgm'];
  updatedAt: ScalarsEnums['Instant'];
  updatedBy?: Maybe<Account>;
  updatedById?: Maybe<ScalarsEnums['UUID']>;
}

export interface AssetConfig {
  __typename?: 'AssetConfig';
  name: ScalarsEnums['String'];
  pathConfigs: Array<PathConfig>;
  tgm: ScalarsEnums['Tgm'];
}

export interface AssetSelection {
  __typename?: 'AssetSelection';
  assetId: ScalarsEnums['UUID'];
  pathSelections?: Maybe<Array<PathSelection>>;
}

/**
 * A segment of a collection.
 */
export interface AssetsCollectionSegment {
  __typename?: 'AssetsCollectionSegment';
  /**
   * A flattened list of the items.
   */
  items?: Maybe<Array<Asset>>;
  /**
   * Information to aid in pagination.
   */
  pageInfo: CollectionSegmentInfo;
  totalCount: ScalarsEnums['Int'];
}

export interface BackgroundJob {
  __typename?: 'BackgroundJob';
  additionalData?: Maybe<ScalarsEnums['JSON']>;
  createdAt: ScalarsEnums['Instant'];
  createdBy?: Maybe<Account>;
  createdById?: Maybe<ScalarsEnums['UUID']>;
  events: (args?: {
    skip?: Maybe<ScalarsEnums['Int']>;
    take?: Maybe<ScalarsEnums['Int']>;
  }) => Maybe<EventsCollectionSegment>;
  id: ScalarsEnums['UUID'];
  lastLogs: (args: { count: ScalarsEnums['Int'] }) => Array<Log>;
  logs: Array<Log>;
  projectName?: Maybe<ScalarsEnums['String']>;
  search?: Maybe<ScalarsEnums['String']>;
  status: ScalarsEnums['JobStatus'];
  surveyId?: Maybe<ScalarsEnums['UUID']>;
  type: ScalarsEnums['JobType'];
  updatedAt: ScalarsEnums['Instant'];
  updatedBy?: Maybe<Account>;
  updatedById?: Maybe<ScalarsEnums['UUID']>;
}

/**
 * A segment of a collection.
 */
export interface BackgroundJobsCollectionSegment {
  __typename?: 'BackgroundJobsCollectionSegment';
  /**
   * A flattened list of the items.
   */
  items?: Maybe<Array<Maybe<IBackgroundJob>>>;
  /**
   * Information to aid in pagination.
   */
  pageInfo: CollectionSegmentInfo;
  totalCount: ScalarsEnums['Int'];
}

export interface BadRequestError {
  __typename?: 'BadRequestError';
  errors: Array<KeyValuePairOfStringAndString__>;
  message: ScalarsEnums['String'];
}

export interface Blob {
  __typename?: 'Blob';
  additionalData?: Maybe<ScalarsEnums['JSON']>;
  contentLength: ScalarsEnums['Long'];
  contentType: ScalarsEnums['String'];
  createdAt: ScalarsEnums['Instant'];
  createdBy?: Maybe<Account>;
  createdById?: Maybe<ScalarsEnums['UUID']>;
  events: (args?: {
    skip?: Maybe<ScalarsEnums['Int']>;
    take?: Maybe<ScalarsEnums['Int']>;
  }) => Maybe<EventsCollectionSegment>;
  fileName: ScalarsEnums['String'];
  id: ScalarsEnums['UUID'];
  search?: Maybe<ScalarsEnums['String']>;
  updatedAt: ScalarsEnums['Instant'];
  updatedBy?: Maybe<Account>;
  updatedById?: Maybe<ScalarsEnums['UUID']>;
  uri: ScalarsEnums['String'];
}

/**
 * A segment of a collection.
 */
export interface BlobsCollectionSegment {
  __typename?: 'BlobsCollectionSegment';
  /**
   * A flattened list of the items.
   */
  items?: Maybe<Array<Blob>>;
  /**
   * Information to aid in pagination.
   */
  pageInfo: CollectionSegmentInfo;
  totalCount: ScalarsEnums['Int'];
}

export interface BlockchainNotarizationJob {
  __typename?: 'BlockchainNotarizationJob';
  additionalData?: Maybe<ScalarsEnums['JSON']>;
  createdAt: ScalarsEnums['Instant'];
  createdBy?: Maybe<Account>;
  createdById?: Maybe<ScalarsEnums['UUID']>;
  events: (args?: {
    skip?: Maybe<ScalarsEnums['Int']>;
    take?: Maybe<ScalarsEnums['Int']>;
  }) => Maybe<EventsCollectionSegment>;
  id: ScalarsEnums['UUID'];
  lastLogs: (args: { count: ScalarsEnums['Int'] }) => Array<Log>;
  logs: Array<Log>;
  notarization?: Maybe<Notarization>;
  notarizationId?: Maybe<ScalarsEnums['UUID']>;
  projectName?: Maybe<ScalarsEnums['String']>;
  search?: Maybe<ScalarsEnums['String']>;
  status: ScalarsEnums['JobStatus'];
  surveyId?: Maybe<ScalarsEnums['UUID']>;
  type: ScalarsEnums['JobType'];
  updatedAt: ScalarsEnums['Instant'];
  updatedBy?: Maybe<Account>;
  updatedById?: Maybe<ScalarsEnums['UUID']>;
}

/**
 * A segment of a collection.
 */
export interface BlockchainNotarizationJobsCollectionSegment {
  __typename?: 'BlockchainNotarizationJobsCollectionSegment';
  /**
   * A flattened list of the items.
   */
  items?: Maybe<Array<BlockchainNotarizationJob>>;
  /**
   * Information to aid in pagination.
   */
  pageInfo: CollectionSegmentInfo;
  totalCount: ScalarsEnums['Int'];
}

export interface Bounds {
  __typename?: 'Bounds';
  maxLatitude?: Maybe<ScalarsEnums['Decimal']>;
  maxLongitude?: Maybe<ScalarsEnums['Decimal']>;
  minLatitude?: Maybe<ScalarsEnums['Decimal']>;
  minLongitude?: Maybe<ScalarsEnums['Decimal']>;
}

export interface BulkAssignProjectsToOperatorsError {
  __typename?: 'NotFoundError';
  $on: $BulkAssignProjectsToOperatorsError;
}

export interface BulkAssignProjectsToOperatorsPayload {
  __typename?: 'BulkAssignProjectsToOperatorsPayload';
  boolean?: Maybe<ScalarsEnums['Boolean']>;
  errors?: Maybe<Array<BulkAssignProjectsToOperatorsError>>;
}

export interface BulkAssignProjectsToOrganizationError {
  __typename?: 'NotFoundError';
  $on: $BulkAssignProjectsToOrganizationError;
}

export interface BulkAssignProjectsToOrganizationPayload {
  __typename?: 'BulkAssignProjectsToOrganizationPayload';
  errors?: Maybe<Array<BulkAssignProjectsToOrganizationError>>;
  organization?: Maybe<Organization>;
}

export interface BulkDeleteAccountPayload {
  __typename?: 'BulkDeleteAccountPayload';
  uuid?: Maybe<Array<ScalarsEnums['UUID']>>;
}

export interface BulkSetAccountStatusPayload {
  __typename?: 'BulkSetAccountStatusPayload';
  uuid?: Maybe<Array<ScalarsEnums['UUID']>>;
}

export interface BulkSetLabelsError {
  __typename?:
    | 'BadRequestError'
    | 'ConflictError'
    | 'ForbiddenError'
    | 'NotFoundError';
  $on: $BulkSetLabelsError;
}

export interface BulkSetLabelsPayload {
  __typename?: 'BulkSetLabelsPayload';
  errors?: Maybe<Array<BulkSetLabelsError>>;
  itemIds?: Maybe<ItemIds>;
}

export interface BulkUnassignOrganizationProjectsError {
  __typename?: 'NotFoundError';
  $on: $BulkUnassignOrganizationProjectsError;
}

export interface BulkUnassignOrganizationProjectsPayload {
  __typename?: 'BulkUnassignOrganizationProjectsPayload';
  errors?: Maybe<Array<BulkUnassignOrganizationProjectsError>>;
  int?: Maybe<ScalarsEnums['Int']>;
}

export interface CloneProjectError {
  __typename?: 'NotFoundError';
  $on: $CloneProjectError;
}

export interface CloneProjectPayload {
  __typename?: 'CloneProjectPayload';
  errors?: Maybe<Array<CloneProjectError>>;
  project?: Maybe<Project>;
}

/**
 * Information about the offset pagination.
 */
export interface CollectionSegmentInfo {
  __typename?: 'CollectionSegmentInfo';
  /**
   * Indicates whether more items exist following the set defined by the clients arguments.
   */
  hasNextPage: ScalarsEnums['Boolean'];
  /**
   * Indicates whether more items exist prior the set defined by the clients arguments.
   */
  hasPreviousPage: ScalarsEnums['Boolean'];
}

export interface ConfirmAccountError {
  __typename?: 'UnauthorizedError';
  $on: $ConfirmAccountError;
}

export interface ConfirmAccountPayload {
  __typename?: 'ConfirmAccountPayload';
  account?: Maybe<Account>;
  errors?: Maybe<Array<ConfirmAccountError>>;
}

export interface ConfirmEmailAddressError {
  __typename?: 'ConflictError' | 'ForbiddenError' | 'UnauthorizedError';
  $on: $ConfirmEmailAddressError;
}

export interface ConfirmEmailAddressPayload {
  __typename?: 'ConfirmEmailAddressPayload';
  account?: Maybe<Account>;
  errors?: Maybe<Array<ConfirmEmailAddressError>>;
}

export interface ConflictError {
  __typename?: 'ConflictError';
  message: ScalarsEnums['String'];
}

export interface CreateApiKeyError {
  __typename?: 'NotFoundError';
  $on: $CreateApiKeyError;
}

export interface CreateApiKeyPayload {
  __typename?: 'CreateApiKeyPayload';
  apiKey?: Maybe<ApiKey>;
  errors?: Maybe<Array<CreateApiKeyError>>;
}

export interface CreateBlockchainNotarizationJobError {
  __typename?: 'BadRequestError' | 'ConflictError' | 'UnauthorizedError';
  $on: $CreateBlockchainNotarizationJobError;
}

export interface CreateBlockchainNotarizationJobPayload {
  __typename?: 'CreateBlockchainNotarizationJobPayload';
  blockchainNotarizationJob?: Maybe<BlockchainNotarizationJob>;
  errors?: Maybe<Array<CreateBlockchainNotarizationJobError>>;
}

export interface CreateCustomLayerUploadJobError {
  __typename?: 'BadRequestError' | 'ConflictError' | 'UnauthorizedError';
  $on: $CreateCustomLayerUploadJobError;
}

export interface CreateCustomLayerUploadJobPayload {
  __typename?: 'CreateCustomLayerUploadJobPayload';
  customLayerUploadJob?: Maybe<CustomLayerUploadJob>;
  errors?: Maybe<Array<CreateCustomLayerUploadJobError>>;
}

export interface CreateCustomStyleError {
  __typename?: 'BadRequestError' | 'ConflictError' | 'UnauthorizedError';
  $on: $CreateCustomStyleError;
}

export interface CreateCustomStylePayload {
  __typename?: 'CreateCustomStylePayload';
  customStyle?: Maybe<CustomStyle>;
  errors?: Maybe<Array<CreateCustomStyleError>>;
}

export interface CreateDatasetPreparationJobError {
  __typename?: 'BadRequestError' | 'ConflictError' | 'UnauthorizedError';
  $on: $CreateDatasetPreparationJobError;
}

export interface CreateDatasetPreparationJobPayload {
  __typename?: 'CreateDatasetPreparationJobPayload';
  datasetPreparationJob?: Maybe<DatasetPreparationJob>;
  errors?: Maybe<Array<CreateDatasetPreparationJobError>>;
}

export interface CreateInterventionError {
  __typename?: 'BadRequestError' | 'ConflictError' | 'UnauthorizedError';
  $on: $CreateInterventionError;
}

export interface CreateInterventionPayload {
  __typename?: 'CreateInterventionPayload';
  errors?: Maybe<Array<CreateInterventionError>>;
  intervention?: Maybe<Intervention>;
}

export interface CreateLabelError {
  __typename?: 'BadRequestError' | 'ConflictError' | 'UnauthorizedError';
  $on: $CreateLabelError;
}

export interface CreateLabelPayload {
  __typename?: 'CreateLabelPayload';
  errors?: Maybe<Array<CreateLabelError>>;
  label?: Maybe<Label>;
}

export interface CreateMediaUploadJobError {
  __typename?: 'BadRequestError' | 'ConflictError' | 'UnauthorizedError';
  $on: $CreateMediaUploadJobError;
}

export interface CreateMediaUploadJobPayload {
  __typename?: 'CreateMediaUploadJobPayload';
  errors?: Maybe<Array<CreateMediaUploadJobError>>;
  mediaUploadJob?: Maybe<MediaUploadJob>;
}

export interface CreateOrganizationError {
  __typename?: 'BadRequestError' | 'ConflictError' | 'UnauthorizedError';
  $on: $CreateOrganizationError;
}

export interface CreateOrganizationPayload {
  __typename?: 'CreateOrganizationPayload';
  errors?: Maybe<Array<CreateOrganizationError>>;
  organization?: Maybe<Organization>;
}

export interface CreateParametersComputationJobError {
  __typename?: 'BadRequestError' | 'ConflictError' | 'UnauthorizedError';
  $on: $CreateParametersComputationJobError;
}

export interface CreateParametersComputationJobPayload {
  __typename?: 'CreateParametersComputationJobPayload';
  errors?: Maybe<Array<CreateParametersComputationJobError>>;
  parametersComputationJob?: Maybe<ParametersComputationJob>;
}

export interface CreateProjectConfigurationError {
  __typename?: 'BadRequestError' | 'ConflictError' | 'UnauthorizedError';
  $on: $CreateProjectConfigurationError;
}

export interface CreateProjectConfigurationPayload {
  __typename?: 'CreateProjectConfigurationPayload';
  errors?: Maybe<Array<CreateProjectConfigurationError>>;
  projectConfiguration?: Maybe<ProjectConfiguration>;
}

export interface CreateProjectError {
  __typename?: 'BadRequestError' | 'ConflictError' | 'UnauthorizedError';
  $on: $CreateProjectError;
}

export interface CreateProjectPayload {
  __typename?: 'CreateProjectPayload';
  errors?: Maybe<Array<CreateProjectError>>;
  project?: Maybe<Project>;
}

export interface CreateReportGenerationJobError {
  __typename?: 'BadRequestError' | 'ConflictError' | 'UnauthorizedError';
  $on: $CreateReportGenerationJobError;
}

export interface CreateReportGenerationJobPayload {
  __typename?: 'CreateReportGenerationJobPayload';
  errors?: Maybe<Array<CreateReportGenerationJobError>>;
  reportGenerationJob?: Maybe<ReportGenerationJob>;
}

export interface CreateSurveyDataBulkUploadJobError {
  __typename?: 'BadRequestError' | 'ConflictError' | 'UnauthorizedError';
  $on: $CreateSurveyDataBulkUploadJobError;
}

export interface CreateSurveyDataBulkUploadJobPayload {
  __typename?: 'CreateSurveyDataBulkUploadJobPayload';
  errors?: Maybe<Array<CreateSurveyDataBulkUploadJobError>>;
  surveyDataBulkUploadJob?: Maybe<SurveyDataBulkUploadJob>;
}

export interface CreateSurveyDataDeletionJobError {
  __typename?: 'BadRequestError' | 'ConflictError' | 'UnauthorizedError';
  $on: $CreateSurveyDataDeletionJobError;
}

export interface CreateSurveyDataDeletionJobPayload {
  __typename?: 'CreateSurveyDataDeletionJobPayload';
  errors?: Maybe<Array<CreateSurveyDataDeletionJobError>>;
  surveyDataDeletionJob?: Maybe<SurveyDataDeletionJob>;
}

export interface CreateSurveyError {
  __typename?: 'BadRequestError' | 'ConflictError' | 'UnauthorizedError';
  $on: $CreateSurveyError;
}

export interface CreateSurveyPayload {
  __typename?: 'CreateSurveyPayload';
  errors?: Maybe<Array<CreateSurveyError>>;
  survey?: Maybe<Survey>;
}

export interface CustomLayer {
  __typename?: 'CustomLayer';
  additionalData?: Maybe<ScalarsEnums['JSON']>;
  createdAt: ScalarsEnums['Instant'];
  createdBy?: Maybe<Account>;
  createdById?: Maybe<ScalarsEnums['UUID']>;
  events: (args?: {
    skip?: Maybe<ScalarsEnums['Int']>;
    take?: Maybe<ScalarsEnums['Int']>;
  }) => Maybe<EventsCollectionSegment>;
  id: ScalarsEnums['UUID'];
  items: Array<CustomLayerItem>;
  name: ScalarsEnums['String'];
  search?: Maybe<ScalarsEnums['String']>;
  surveyId: ScalarsEnums['UUID'];
  updatedAt: ScalarsEnums['Instant'];
  updatedBy?: Maybe<Account>;
  updatedById?: Maybe<ScalarsEnums['UUID']>;
}

export interface CustomLayerItem {
  __typename?: 'CustomLayerItem';
  additionalData?: Maybe<ScalarsEnums['JSON']>;
  color?: Maybe<ScalarsEnums['String']>;
  createdAt: ScalarsEnums['Instant'];
  createdBy?: Maybe<Account>;
  createdById?: Maybe<ScalarsEnums['UUID']>;
  customLayerId: ScalarsEnums['UUID'];
  events: (args?: {
    skip?: Maybe<ScalarsEnums['Int']>;
    take?: Maybe<ScalarsEnums['Int']>;
  }) => Maybe<EventsCollectionSegment>;
  geometryType: ScalarsEnums['String'];
  id: ScalarsEnums['UUID'];
  lineString?: Maybe<GeoJSONLineStringType>;
  note: ScalarsEnums['String'];
  outlineColor?: Maybe<ScalarsEnums['String']>;
  point?: Maybe<GeoJSONPointType>;
  polygon?: Maybe<GeoJSONPolygonType>;
  search?: Maybe<ScalarsEnums['String']>;
  updatedAt: ScalarsEnums['Instant'];
  updatedBy?: Maybe<Account>;
  updatedById?: Maybe<ScalarsEnums['UUID']>;
  value: ScalarsEnums['String'];
}

/**
 * A segment of a collection.
 */
export interface CustomLayerItemsCollectionSegment {
  __typename?: 'CustomLayerItemsCollectionSegment';
  /**
   * A flattened list of the items.
   */
  items?: Maybe<Array<CustomLayerItem>>;
  /**
   * Information to aid in pagination.
   */
  pageInfo: CollectionSegmentInfo;
  totalCount: ScalarsEnums['Int'];
}

export interface CustomLayerUploadJob {
  __typename?: 'CustomLayerUploadJob';
  additionalData?: Maybe<ScalarsEnums['JSON']>;
  createdAt: ScalarsEnums['Instant'];
  createdBy?: Maybe<Account>;
  createdById?: Maybe<ScalarsEnums['UUID']>;
  csvFileId: ScalarsEnums['UUID'];
  events: (args?: {
    skip?: Maybe<ScalarsEnums['Int']>;
    take?: Maybe<ScalarsEnums['Int']>;
  }) => Maybe<EventsCollectionSegment>;
  id: ScalarsEnums['UUID'];
  lastLogs: (args: { count: ScalarsEnums['Int'] }) => Array<Log>;
  layerName: ScalarsEnums['String'];
  logs: Array<Log>;
  projectName?: Maybe<ScalarsEnums['String']>;
  search?: Maybe<ScalarsEnums['String']>;
  status: ScalarsEnums['JobStatus'];
  styleId?: Maybe<ScalarsEnums['UUID']>;
  surveyId?: Maybe<ScalarsEnums['UUID']>;
  type: ScalarsEnums['JobType'];
  updatedAt: ScalarsEnums['Instant'];
  updatedBy?: Maybe<Account>;
  updatedById?: Maybe<ScalarsEnums['UUID']>;
}

/**
 * A segment of a collection.
 */
export interface CustomLayerUploadJobsCollectionSegment {
  __typename?: 'CustomLayerUploadJobsCollectionSegment';
  /**
   * A flattened list of the items.
   */
  items?: Maybe<Array<CustomLayerUploadJob>>;
  /**
   * Information to aid in pagination.
   */
  pageInfo: CollectionSegmentInfo;
  totalCount: ScalarsEnums['Int'];
}

/**
 * A segment of a collection.
 */
export interface CustomLayersCollectionSegment {
  __typename?: 'CustomLayersCollectionSegment';
  /**
   * A flattened list of the items.
   */
  items?: Maybe<Array<CustomLayer>>;
  /**
   * Information to aid in pagination.
   */
  pageInfo: CollectionSegmentInfo;
  totalCount: ScalarsEnums['Int'];
}

export interface CustomStyle {
  __typename?: 'CustomStyle';
  additionalData?: Maybe<ScalarsEnums['JSON']>;
  createdAt: ScalarsEnums['Instant'];
  createdBy?: Maybe<Account>;
  createdById?: Maybe<ScalarsEnums['UUID']>;
  events: (args?: {
    skip?: Maybe<ScalarsEnums['Int']>;
    take?: Maybe<ScalarsEnums['Int']>;
  }) => Maybe<EventsCollectionSegment>;
  id: ScalarsEnums['UUID'];
  isGlobal: ScalarsEnums['Boolean'];
  isKnownParameterStyle: ScalarsEnums['Boolean'];
  name: ScalarsEnums['String'];
  parameter?: Maybe<ScalarsEnums['Parameter']>;
  projectId?: Maybe<ScalarsEnums['UUID']>;
  search?: Maybe<ScalarsEnums['String']>;
  style: ScalarsEnums['JSON'];
  updatedAt: ScalarsEnums['Instant'];
  updatedBy?: Maybe<Account>;
  updatedById?: Maybe<ScalarsEnums['UUID']>;
}

/**
 * A segment of a collection.
 */
export interface CustomStylesCollectionSegment {
  __typename?: 'CustomStylesCollectionSegment';
  /**
   * A flattened list of the items.
   */
  items?: Maybe<Array<CustomStyle>>;
  /**
   * Information to aid in pagination.
   */
  pageInfo: CollectionSegmentInfo;
  totalCount: ScalarsEnums['Int'];
}

export interface DatasetPreparationJob {
  __typename?: 'DatasetPreparationJob';
  additionalData?: Maybe<ScalarsEnums['JSON']>;
  archiveFile: Blob;
  archiveFileId: ScalarsEnums['UUID'];
  createdAt: ScalarsEnums['Instant'];
  createdBy?: Maybe<Account>;
  createdById?: Maybe<ScalarsEnums['UUID']>;
  events: (args?: {
    skip?: Maybe<ScalarsEnums['Int']>;
    take?: Maybe<ScalarsEnums['Int']>;
  }) => Maybe<EventsCollectionSegment>;
  id: ScalarsEnums['UUID'];
  lastLogs: (args: { count: ScalarsEnums['Int'] }) => Array<Log>;
  logs: Array<Log>;
  outputCsvFile?: Maybe<Blob>;
  outputCsvFileId?: Maybe<ScalarsEnums['UUID']>;
  projectName?: Maybe<ScalarsEnums['String']>;
  resolveToponyms: ScalarsEnums['Boolean'];
  search?: Maybe<ScalarsEnums['String']>;
  status: ScalarsEnums['JobStatus'];
  surveyId?: Maybe<ScalarsEnums['UUID']>;
  type: ScalarsEnums['JobType'];
  updatedAt: ScalarsEnums['Instant'];
  updatedBy?: Maybe<Account>;
  updatedById?: Maybe<ScalarsEnums['UUID']>;
}

/**
 * A segment of a collection.
 */
export interface DatasetPreparationJobsCollectionSegment {
  __typename?: 'DatasetPreparationJobsCollectionSegment';
  /**
   * A flattened list of the items.
   */
  items?: Maybe<Array<DatasetPreparationJob>>;
  /**
   * Information to aid in pagination.
   */
  pageInfo: CollectionSegmentInfo;
  totalCount: ScalarsEnums['Int'];
}

export interface DeleteAccountError {
  __typename?: 'NotFoundError';
  $on: $DeleteAccountError;
}

export interface DeleteAccountPayload {
  __typename?: 'DeleteAccountPayload';
  account?: Maybe<Account>;
  errors?: Maybe<Array<DeleteAccountError>>;
}

export interface DeleteApiKeyError {
  __typename?: 'NotFoundError' | 'UnauthorizedError';
  $on: $DeleteApiKeyError;
}

export interface DeleteApiKeyPayload {
  __typename?: 'DeleteApiKeyPayload';
  deleted?: Maybe<Deleted>;
  errors?: Maybe<Array<DeleteApiKeyError>>;
}

export interface DeleteAssetError {
  __typename?: 'NotFoundError' | 'UnauthorizedError';
  $on: $DeleteAssetError;
}

export interface DeleteAssetPayload {
  __typename?: 'DeleteAssetPayload';
  deleted?: Maybe<Deleted>;
  errors?: Maybe<Array<DeleteAssetError>>;
}

export interface DeleteBlobError {
  __typename?: 'NotFoundError' | 'UnauthorizedError';
  $on: $DeleteBlobError;
}

export interface DeleteBlobPayload {
  __typename?: 'DeleteBlobPayload';
  deleted?: Maybe<Deleted>;
  errors?: Maybe<Array<DeleteBlobError>>;
}

export interface DeleteBlockchainNotarizationJobError {
  __typename?: 'NotFoundError' | 'UnauthorizedError';
  $on: $DeleteBlockchainNotarizationJobError;
}

export interface DeleteBlockchainNotarizationJobPayload {
  __typename?: 'DeleteBlockchainNotarizationJobPayload';
  deleted?: Maybe<Deleted>;
  errors?: Maybe<Array<DeleteBlockchainNotarizationJobError>>;
}

export interface DeleteCustomLayerError {
  __typename?: 'NotFoundError' | 'UnauthorizedError';
  $on: $DeleteCustomLayerError;
}

export interface DeleteCustomLayerItemError {
  __typename?: 'NotFoundError' | 'UnauthorizedError';
  $on: $DeleteCustomLayerItemError;
}

export interface DeleteCustomLayerItemPayload {
  __typename?: 'DeleteCustomLayerItemPayload';
  deleted?: Maybe<Deleted>;
  errors?: Maybe<Array<DeleteCustomLayerItemError>>;
}

export interface DeleteCustomLayerPayload {
  __typename?: 'DeleteCustomLayerPayload';
  deleted?: Maybe<Deleted>;
  errors?: Maybe<Array<DeleteCustomLayerError>>;
}

export interface DeleteCustomLayerUploadJobError {
  __typename?: 'NotFoundError' | 'UnauthorizedError';
  $on: $DeleteCustomLayerUploadJobError;
}

export interface DeleteCustomLayerUploadJobPayload {
  __typename?: 'DeleteCustomLayerUploadJobPayload';
  deleted?: Maybe<Deleted>;
  errors?: Maybe<Array<DeleteCustomLayerUploadJobError>>;
}

export interface DeleteCustomStyleError {
  __typename?: 'NotFoundError' | 'UnauthorizedError';
  $on: $DeleteCustomStyleError;
}

export interface DeleteCustomStylePayload {
  __typename?: 'DeleteCustomStylePayload';
  deleted?: Maybe<Deleted>;
  errors?: Maybe<Array<DeleteCustomStyleError>>;
}

export interface DeleteDatasetPreparationJobError {
  __typename?: 'NotFoundError' | 'UnauthorizedError';
  $on: $DeleteDatasetPreparationJobError;
}

export interface DeleteDatasetPreparationJobPayload {
  __typename?: 'DeleteDatasetPreparationJobPayload';
  deleted?: Maybe<Deleted>;
  errors?: Maybe<Array<DeleteDatasetPreparationJobError>>;
}

export interface DeleteEventError {
  __typename?: 'NotFoundError' | 'UnauthorizedError';
  $on: $DeleteEventError;
}

export interface DeleteEventPayload {
  __typename?: 'DeleteEventPayload';
  deleted?: Maybe<Deleted>;
  errors?: Maybe<Array<DeleteEventError>>;
}

export interface DeleteInterventionError {
  __typename?: 'NotFoundError' | 'UnauthorizedError';
  $on: $DeleteInterventionError;
}

export interface DeleteInterventionPayload {
  __typename?: 'DeleteInterventionPayload';
  deleted?: Maybe<Deleted>;
  errors?: Maybe<Array<DeleteInterventionError>>;
}

export interface DeleteItemError {
  __typename?: 'NotFoundError' | 'UnauthorizedError';
  $on: $DeleteItemError;
}

export interface DeleteItemPayload {
  __typename?: 'DeleteItemPayload';
  deleted?: Maybe<Deleted>;
  errors?: Maybe<Array<DeleteItemError>>;
}

export interface DeleteLabelError {
  __typename?: 'NotFoundError' | 'UnauthorizedError';
  $on: $DeleteLabelError;
}

export interface DeleteLabelPayload {
  __typename?: 'DeleteLabelPayload';
  deleted?: Maybe<Deleted>;
  errors?: Maybe<Array<DeleteLabelError>>;
}

export interface DeleteMediaUploadJobError {
  __typename?: 'NotFoundError' | 'UnauthorizedError';
  $on: $DeleteMediaUploadJobError;
}

export interface DeleteMediaUploadJobPayload {
  __typename?: 'DeleteMediaUploadJobPayload';
  deleted?: Maybe<Deleted>;
  errors?: Maybe<Array<DeleteMediaUploadJobError>>;
}

export interface DeleteOrganizationError {
  __typename?: 'NotFoundError';
  $on: $DeleteOrganizationError;
}

export interface DeleteOrganizationPayload {
  __typename?: 'DeleteOrganizationPayload';
  errors?: Maybe<Array<DeleteOrganizationError>>;
  organization?: Maybe<Organization>;
}

export interface DeleteParametersComputationJobError {
  __typename?: 'NotFoundError' | 'UnauthorizedError';
  $on: $DeleteParametersComputationJobError;
}

export interface DeleteParametersComputationJobPayload {
  __typename?: 'DeleteParametersComputationJobPayload';
  deleted?: Maybe<Deleted>;
  errors?: Maybe<Array<DeleteParametersComputationJobError>>;
}

export interface DeletePathError {
  __typename?: 'NotFoundError' | 'UnauthorizedError';
  $on: $DeletePathError;
}

export interface DeletePathPayload {
  __typename?: 'DeletePathPayload';
  deleted?: Maybe<Deleted>;
  errors?: Maybe<Array<DeletePathError>>;
}

export interface DeleteProjectConfigurationError {
  __typename?: 'NotFoundError' | 'UnauthorizedError';
  $on: $DeleteProjectConfigurationError;
}

export interface DeleteProjectConfigurationPayload {
  __typename?: 'DeleteProjectConfigurationPayload';
  deleted?: Maybe<Deleted>;
  errors?: Maybe<Array<DeleteProjectConfigurationError>>;
}

export interface DeleteProjectError {
  __typename?: 'NotFoundError' | 'UnauthorizedError';
  $on: $DeleteProjectError;
}

export interface DeleteProjectPayload {
  __typename?: 'DeleteProjectPayload';
  deleted?: Maybe<Deleted>;
  errors?: Maybe<Array<DeleteProjectError>>;
}

export interface DeleteReportError {
  __typename?: 'NotFoundError' | 'UnauthorizedError';
  $on: $DeleteReportError;
}

export interface DeleteReportGenerationJobError {
  __typename?: 'NotFoundError' | 'UnauthorizedError';
  $on: $DeleteReportGenerationJobError;
}

export interface DeleteReportGenerationJobPayload {
  __typename?: 'DeleteReportGenerationJobPayload';
  deleted?: Maybe<Deleted>;
  errors?: Maybe<Array<DeleteReportGenerationJobError>>;
}

export interface DeleteReportPayload {
  __typename?: 'DeleteReportPayload';
  deleted?: Maybe<Deleted>;
  errors?: Maybe<Array<DeleteReportError>>;
}

export interface DeleteSurveyDataBulkUploadJobError {
  __typename?: 'NotFoundError' | 'UnauthorizedError';
  $on: $DeleteSurveyDataBulkUploadJobError;
}

export interface DeleteSurveyDataBulkUploadJobPayload {
  __typename?: 'DeleteSurveyDataBulkUploadJobPayload';
  deleted?: Maybe<Deleted>;
  errors?: Maybe<Array<DeleteSurveyDataBulkUploadJobError>>;
}

export interface DeleteSurveyDataDeletionJobError {
  __typename?: 'NotFoundError' | 'UnauthorizedError';
  $on: $DeleteSurveyDataDeletionJobError;
}

export interface DeleteSurveyDataDeletionJobPayload {
  __typename?: 'DeleteSurveyDataDeletionJobPayload';
  deleted?: Maybe<Deleted>;
  errors?: Maybe<Array<DeleteSurveyDataDeletionJobError>>;
}

export interface DeleteSurveyError {
  __typename?: 'NotFoundError' | 'UnauthorizedError';
  $on: $DeleteSurveyError;
}

export interface DeleteSurveyPayload {
  __typename?: 'DeleteSurveyPayload';
  deleted?: Maybe<Deleted>;
  errors?: Maybe<Array<DeleteSurveyError>>;
}

export interface Deleted {
  __typename?: 'Deleted';
  deletedAt?: Maybe<ScalarsEnums['Instant']>;
  deletedById?: Maybe<ScalarsEnums['UUID']>;
  id: ScalarsEnums['UUID'];
}

export interface Error {
  __typename?:
    | 'BadRequestError'
    | 'ConflictError'
    | 'ForbiddenError'
    | 'NotFoundError'
    | 'UnauthorizedError';
  message: ScalarsEnums['String'];
  $on: $Error;
}

export interface Event {
  __typename?: 'Event';
  data?: Maybe<ScalarsEnums['JSON']>;
  firedAt: ScalarsEnums['Instant'];
  id: ScalarsEnums['UUID'];
  targetId?: Maybe<ScalarsEnums['UUID']>;
  targetType?: Maybe<ScalarsEnums['String']>;
  type: ScalarsEnums['String'];
}

/**
 * A segment of a collection.
 */
export interface EventsCollectionSegment {
  __typename?: 'EventsCollectionSegment';
  /**
   * A flattened list of the items.
   */
  items?: Maybe<Array<Event>>;
  /**
   * Information to aid in pagination.
   */
  pageInfo: CollectionSegmentInfo;
  totalCount: ScalarsEnums['Int'];
}

export interface ForbiddenError {
  __typename?: 'ForbiddenError';
  message: ScalarsEnums['String'];
}

export interface ForceDeleteCustomStylePayload {
  __typename?: 'ForceDeleteCustomStylePayload';
  int?: Maybe<ScalarsEnums['Int']>;
}

export interface ForcePasswordResetError {
  __typename?: 'NotFoundError';
  $on: $ForcePasswordResetError;
}

export interface ForcePasswordResetPayload {
  __typename?: 'ForcePasswordResetPayload';
  account?: Maybe<Account>;
  errors?: Maybe<Array<ForcePasswordResetError>>;
}

export interface GeoJSONInterface {
  __typename?:
    | 'GeoJSONLineStringType'
    | 'GeoJSONMultiLineStringType'
    | 'GeoJSONMultiPointType'
    | 'GeoJSONMultiPolygonType'
    | 'GeoJSONPointType'
    | 'GeoJSONPolygonType';
  /**
   * The minimum bounding box around the geometry object
   */
  bbox?: Maybe<Array<Maybe<ScalarsEnums['Float']>>>;
  /**
   * The coordinate reference system integer identifier
   */
  crs?: Maybe<ScalarsEnums['Int']>;
  /**
   * The geometry type of the GeoJson object
   */
  type: ScalarsEnums['GeoJSONGeometryType'];
  $on: $GeoJSONInterface;
}

export interface GeoJSONLineStringType {
  __typename?: 'GeoJSONLineStringType';
  /**
   * The minimum bounding box around the geometry object
   */
  bbox: Array<ScalarsEnums['Float']>;
  /**
   * The "coordinates" field is an array of two or more positions.
   */
  coordinates?: Maybe<Array<Maybe<ScalarsEnums['Position']>>>;
  /**
   * The coordinate reference system integer identifier
   */
  crs: ScalarsEnums['Int'];
  /**
   * The geometry type of the GeoJson object
   */
  type: ScalarsEnums['GeoJSONGeometryType'];
}

export interface GeoJSONMultiLineStringType {
  __typename?: 'GeoJSONMultiLineStringType';
  /**
   * The minimum bounding box around the geometry object
   */
  bbox: Array<ScalarsEnums['Float']>;
  /**
   * The "coordinates" field is an array of LineString coordinate arrays.
   */
  coordinates?: Maybe<Array<Maybe<ScalarsEnums['Position']>>>;
  /**
   * The coordinate reference system integer identifier
   */
  crs: ScalarsEnums['Int'];
  /**
   * The geometry type of the GeoJson object
   */
  type: ScalarsEnums['GeoJSONGeometryType'];
}

export interface GeoJSONMultiPointType {
  __typename?: 'GeoJSONMultiPointType';
  /**
   * The minimum bounding box around the geometry object
   */
  bbox: Array<ScalarsEnums['Float']>;
  /**
   * The "coordinates" field is an array of positions.
   */
  coordinates?: Maybe<Array<Maybe<ScalarsEnums['Position']>>>;
  /**
   * The coordinate reference system integer identifier
   */
  crs: ScalarsEnums['Int'];
  /**
   * The geometry type of the GeoJson object
   */
  type: ScalarsEnums['GeoJSONGeometryType'];
}

export interface GeoJSONMultiPolygonType {
  __typename?: 'GeoJSONMultiPolygonType';
  /**
   * The minimum bounding box around the geometry object
   */
  bbox: Array<ScalarsEnums['Float']>;
  /**
   * The "coordinates" field is an array of Polygon coordinate arrays.
   */
  coordinates?: Maybe<ScalarsEnums['Coordinates']>;
  /**
   * The coordinate reference system integer identifier
   */
  crs: ScalarsEnums['Int'];
  /**
   * The geometry type of the GeoJson object
   */
  type: ScalarsEnums['GeoJSONGeometryType'];
}

export interface GeoJSONPointType {
  __typename?: 'GeoJSONPointType';
  /**
   * The minimum bounding box around the geometry object
   */
  bbox: Array<ScalarsEnums['Float']>;
  /**
   * The "coordinates" field is a single position.
   */
  coordinates?: Maybe<ScalarsEnums['Position']>;
  /**
   * The coordinate reference system integer identifier
   */
  crs: ScalarsEnums['Int'];
  /**
   * The geometry type of the GeoJson object
   */
  type: ScalarsEnums['GeoJSONGeometryType'];
}

export interface GeoJSONPolygonType {
  __typename?: 'GeoJSONPolygonType';
  /**
   * The minimum bounding box around the geometry object
   */
  bbox: Array<ScalarsEnums['Float']>;
  /**
   * The "coordinates" field MUST be an array of linear ring coordinate arrays. For Polygons with more than one of these rings, the first MUST be the exterior ring, and any others MUST be interior rings. The exterior ring bounds the surface, and the interior rings (if present) bound holes within the surface.
   */
  coordinates?: Maybe<Array<Maybe<[Position]>>>;
  /**
   * The coordinate reference system integer identifier
   */
  crs: ScalarsEnums['Int'];
  /**
   * The geometry type of the GeoJson object
   */
  type: ScalarsEnums['GeoJSONGeometryType'];
}

export interface GetAdminOverviewPayload {
  __typename?: 'GetAdminOverviewPayload';
  accountsCount: ScalarsEnums['Int'];
  lastSurvey?: Maybe<Survey>;
  nextSurvey?: Maybe<Survey>;
  organizationsCount: ScalarsEnums['Int'];
  projectsCount: ScalarsEnums['Int'];
}

export interface GetInvitationByTokenPayload {
  __typename?: 'GetInvitationByTokenPayload';
  email: ScalarsEnums['String'];
}

export interface GetOperatorOverviewPayload {
  __typename?: 'GetOperatorOverviewPayload';
  lastSurvey?: Maybe<Survey>;
  nextSurvey?: Maybe<Survey>;
  projectsCount: ScalarsEnums['Int'];
}

export interface GlobalConfig {
  __typename?: 'GlobalConfig';
  pciCurvesFileId?: Maybe<ScalarsEnums['UUID']>;
}

export interface IBackgroundJob {
  __typename?:
    | 'BackgroundJob'
    | 'BlockchainNotarizationJob'
    | 'CustomLayerUploadJob'
    | 'DatasetPreparationJob'
    | 'MediaUploadJob'
    | 'ParametersComputationJob'
    | 'ReportGenerationJob'
    | 'SurveyDataBulkUploadJob'
    | 'SurveyDataDeletionJob';
  additionalData?: Maybe<ScalarsEnums['JSON']>;
  createdAt: ScalarsEnums['Instant'];
  createdBy?: Maybe<Account>;
  createdById?: Maybe<ScalarsEnums['UUID']>;
  id: ScalarsEnums['UUID'];
  lastLogs: (args: { count: ScalarsEnums['Int'] }) => Array<Log>;
  logs: Array<Log>;
  projectName?: Maybe<ScalarsEnums['String']>;
  search?: Maybe<ScalarsEnums['String']>;
  status: ScalarsEnums['JobStatus'];
  surveyId?: Maybe<ScalarsEnums['UUID']>;
  type: ScalarsEnums['JobType'];
  updatedAt: ScalarsEnums['Instant'];
  updatedBy?: Maybe<Account>;
  updatedById?: Maybe<ScalarsEnums['UUID']>;
  $on: $IBackgroundJob;
}

export interface InitUpdateEmailAddressError {
  __typename?: 'ConflictError' | 'NotFoundError' | 'UnauthorizedError';
  $on: $InitUpdateEmailAddressError;
}

export interface InitUpdateEmailAddressPayload {
  __typename?: 'InitUpdateEmailAddressPayload';
  account?: Maybe<Account>;
  errors?: Maybe<Array<InitUpdateEmailAddressError>>;
}

export interface Intervention {
  __typename?: 'Intervention';
  actualCost: ScalarsEnums['Decimal'];
  additionalData?: Maybe<ScalarsEnums['JSON']>;
  category: ScalarsEnums['InterventionCategory'];
  createdAt: ScalarsEnums['Instant'];
  createdBy?: Maybe<Account>;
  createdById?: Maybe<ScalarsEnums['UUID']>;
  effectiveEndDate: ScalarsEnums['LocalDate'];
  effectiveStartDate: ScalarsEnums['LocalDate'];
  estimatedCost: ScalarsEnums['Decimal'];
  events: (args?: {
    skip?: Maybe<ScalarsEnums['Int']>;
    take?: Maybe<ScalarsEnums['Int']>;
  }) => Maybe<EventsCollectionSegment>;
  id: ScalarsEnums['UUID'];
  labels: Array<Label>;
  name: ScalarsEnums['String'];
  notes: ScalarsEnums['String'];
  organizationId?: Maybe<ScalarsEnums['UUID']>;
  plannedEndDate: ScalarsEnums['LocalDate'];
  plannedStartDate: ScalarsEnums['LocalDate'];
  projectId?: Maybe<ScalarsEnums['UUID']>;
  search?: Maybe<ScalarsEnums['String']>;
  selections: Array<AssetSelection>;
  status: ScalarsEnums['InterventionStatus'];
  surveyId?: Maybe<ScalarsEnums['UUID']>;
  updatedAt: ScalarsEnums['Instant'];
  updatedBy?: Maybe<Account>;
  updatedById?: Maybe<ScalarsEnums['UUID']>;
}

/**
 * A segment of a collection.
 */
export interface InterventionsCollectionSegment {
  __typename?: 'InterventionsCollectionSegment';
  /**
   * A flattened list of the items.
   */
  items?: Maybe<Array<Intervention>>;
  /**
   * Information to aid in pagination.
   */
  pageInfo: CollectionSegmentInfo;
  totalCount: ScalarsEnums['Int'];
}

export interface InviteNewAccountError {
  __typename?: 'ConflictError' | 'UnauthorizedError';
  $on: $InviteNewAccountError;
}

export interface InviteNewAccountPayload {
  __typename?: 'InviteNewAccountPayload';
  account?: Maybe<Account>;
  errors?: Maybe<Array<InviteNewAccountError>>;
}

export interface Item {
  __typename?: 'Item';
  additionalData?: Maybe<ScalarsEnums['JSON']>;
  assetId: ScalarsEnums['UUID'];
  createdAt: ScalarsEnums['Instant'];
  createdBy?: Maybe<Account>;
  createdById?: Maybe<ScalarsEnums['UUID']>;
  end: ScalarsEnums['Decimal'];
  events: (args?: {
    skip?: Maybe<ScalarsEnums['Int']>;
    take?: Maybe<ScalarsEnums['Int']>;
  }) => Maybe<EventsCollectionSegment>;
  geometry?: Maybe<GeoJSONLineStringType>;
  grain: ScalarsEnums['Decimal'];
  id: ScalarsEnums['UUID'];
  index: ScalarsEnums['Int'];
  isForward: ScalarsEnums['Boolean'];
  length: ScalarsEnums['Decimal'];
  parameter: ScalarsEnums['Parameter'];
  pathId: ScalarsEnums['UUID'];
  projectId: ScalarsEnums['UUID'];
  search?: Maybe<ScalarsEnums['String']>;
  simplifiedGeometry?: Maybe<GeoJSONLineStringType>;
  start: ScalarsEnums['Decimal'];
  surveyId: ScalarsEnums['UUID'];
  updatedAt: ScalarsEnums['Instant'];
  updatedBy?: Maybe<Account>;
  updatedById?: Maybe<ScalarsEnums['UUID']>;
  value: ScalarsEnums['Decimal'];
}

export interface ItemIds {
  __typename?: 'ItemIds';
  ids: Array<ScalarsEnums['UUID']>;
}

export interface KeyValuePairOfStringAndString__ {
  __typename?: 'KeyValuePairOfStringAndString__';
  key: ScalarsEnums['String'];
  value: Array<ScalarsEnums['String']>;
}

export interface Label {
  __typename?: 'Label';
  additionalData?: Maybe<ScalarsEnums['JSON']>;
  createdAt: ScalarsEnums['Instant'];
  createdBy?: Maybe<Account>;
  createdById?: Maybe<ScalarsEnums['UUID']>;
  events: (args?: {
    skip?: Maybe<ScalarsEnums['Int']>;
    take?: Maybe<ScalarsEnums['Int']>;
  }) => Maybe<EventsCollectionSegment>;
  id: ScalarsEnums['UUID'];
  isAdminLabel: ScalarsEnums['Boolean'];
  name: ScalarsEnums['String'];
  projectId?: Maybe<ScalarsEnums['UUID']>;
  targetType?: Maybe<ScalarsEnums['String']>;
  updatedAt: ScalarsEnums['Instant'];
  updatedBy?: Maybe<Account>;
  updatedById?: Maybe<ScalarsEnums['UUID']>;
}

/**
 * A segment of a collection.
 */
export interface LabelsCollectionSegment {
  __typename?: 'LabelsCollectionSegment';
  /**
   * A flattened list of the items.
   */
  items?: Maybe<Array<Label>>;
  /**
   * Information to aid in pagination.
   */
  pageInfo: CollectionSegmentInfo;
  totalCount: ScalarsEnums['Int'];
}

export interface Log {
  __typename?: 'Log';
  exception?: Maybe<ScalarsEnums['String']>;
  id: ScalarsEnums['UUID'];
  loggedAt: ScalarsEnums['Instant'];
  message: ScalarsEnums['String'];
  severity: ScalarsEnums['LogSeverity'];
}

export interface Media {
  __typename?: 'Media';
  blob: Blob;
  blobId: ScalarsEnums['UUID'];
  mediaType: ScalarsEnums['MediaType'];
  rspId: ScalarsEnums['String'];
  surveyId: ScalarsEnums['UUID'];
}

export interface MediaUploadJob {
  __typename?: 'MediaUploadJob';
  additionalData?: Maybe<ScalarsEnums['JSON']>;
  createdAt: ScalarsEnums['Instant'];
  createdBy?: Maybe<Account>;
  createdById?: Maybe<ScalarsEnums['UUID']>;
  events: (args?: {
    skip?: Maybe<ScalarsEnums['Int']>;
    take?: Maybe<ScalarsEnums['Int']>;
  }) => Maybe<EventsCollectionSegment>;
  id: ScalarsEnums['UUID'];
  lastLogs: (args: { count: ScalarsEnums['Int'] }) => Array<Log>;
  logs: Array<Log>;
  mfvDataFileId: ScalarsEnums['UUID'];
  projectName?: Maybe<ScalarsEnums['String']>;
  search?: Maybe<ScalarsEnums['String']>;
  status: ScalarsEnums['JobStatus'];
  surveyId?: Maybe<ScalarsEnums['UUID']>;
  type: ScalarsEnums['JobType'];
  updatedAt: ScalarsEnums['Instant'];
  updatedBy?: Maybe<Account>;
  updatedById?: Maybe<ScalarsEnums['UUID']>;
}

/**
 * A segment of a collection.
 */
export interface MediaUploadJobsCollectionSegment {
  __typename?: 'MediaUploadJobsCollectionSegment';
  /**
   * A flattened list of the items.
   */
  items?: Maybe<Array<MediaUploadJob>>;
  /**
   * Information to aid in pagination.
   */
  pageInfo: CollectionSegmentInfo;
  totalCount: ScalarsEnums['Int'];
}

export interface NotFoundError {
  __typename?: 'NotFoundError';
  message: ScalarsEnums['String'];
}

export interface Notarization {
  __typename?: 'Notarization';
  blockHash: ScalarsEnums['String'];
  data: Array<ScalarsEnums['Byte']>;
  date: ScalarsEnums['Instant'];
  hash: Array<ScalarsEnums['Byte']>;
  id: ScalarsEnums['UUID'];
  payload: Array<ScalarsEnums['Byte']>;
  transactionHash: ScalarsEnums['String'];
}

/**
 * A segment of a collection.
 */
export interface NotarizationsCollectionSegment {
  __typename?: 'NotarizationsCollectionSegment';
  /**
   * A flattened list of the items.
   */
  items?: Maybe<Array<Notarization>>;
  /**
   * Information to aid in pagination.
   */
  pageInfo: CollectionSegmentInfo;
  totalCount: ScalarsEnums['Int'];
}

export interface Operator {
  __typename?: 'Operator';
  deletedAt?: Maybe<ScalarsEnums['Instant']>;
  email?: Maybe<ScalarsEnums['String']>;
  firstName?: Maybe<ScalarsEnums['String']>;
  id: ScalarsEnums['UUID'];
  isDeleted: ScalarsEnums['Boolean'];
  isEnabled: ScalarsEnums['Boolean'];
  labels: Array<Label>;
  labelsIds: Array<ScalarsEnums['UUID']>;
  lastName?: Maybe<ScalarsEnums['String']>;
  projectsCount: ScalarsEnums['Int'];
  projectsIds: Array<ScalarsEnums['UUID']>;
  role: ScalarsEnums['RoleName'];
  search?: Maybe<ScalarsEnums['String']>;
  status: ScalarsEnums['AccountStatus'];
  unconfirmedEmail?: Maybe<ScalarsEnums['String']>;
}

/**
 * A segment of a collection.
 */
export interface OperatorsCollectionSegment {
  __typename?: 'OperatorsCollectionSegment';
  /**
   * A flattened list of the items.
   */
  items?: Maybe<Array<Operator>>;
  /**
   * Information to aid in pagination.
   */
  pageInfo: CollectionSegmentInfo;
  totalCount: ScalarsEnums['Int'];
}

export interface Organization {
  __typename?: 'Organization';
  additionalData?: Maybe<ScalarsEnums['JSON']>;
  address?: Maybe<Address>;
  certifiedEmailAddress?: Maybe<ScalarsEnums['String']>;
  createdAt: ScalarsEnums['Instant'];
  createdBy?: Maybe<Account>;
  createdById?: Maybe<ScalarsEnums['UUID']>;
  deletedAt?: Maybe<ScalarsEnums['Instant']>;
  email?: Maybe<ScalarsEnums['String']>;
  events: (args?: {
    skip?: Maybe<ScalarsEnums['Int']>;
    take?: Maybe<ScalarsEnums['Int']>;
  }) => Maybe<EventsCollectionSegment>;
  fiscalCode?: Maybe<ScalarsEnums['String']>;
  id: ScalarsEnums['UUID'];
  isDeleted: ScalarsEnums['Boolean'];
  labels: Array<Label>;
  legalName?: Maybe<ScalarsEnums['String']>;
  logo?: Maybe<Blob>;
  logoId?: Maybe<ScalarsEnums['UUID']>;
  name?: Maybe<ScalarsEnums['String']>;
  note?: Maybe<ScalarsEnums['String']>;
  phoneNumber?: Maybe<ScalarsEnums['String']>;
  pointOfContact?: Maybe<ScalarsEnums['String']>;
  projectsCount: ScalarsEnums['Int'];
  sdiCode?: Maybe<ScalarsEnums['String']>;
  search?: Maybe<ScalarsEnums['String']>;
  status: ScalarsEnums['OrganizationStatus'];
  updatedAt: ScalarsEnums['Instant'];
  updatedBy?: Maybe<Account>;
  updatedById?: Maybe<ScalarsEnums['UUID']>;
  vatNumber?: Maybe<ScalarsEnums['String']>;
}

/**
 * A segment of a collection.
 */
export interface OrganizationsCollectionSegment {
  __typename?: 'OrganizationsCollectionSegment';
  /**
   * A flattened list of the items.
   */
  items?: Maybe<Array<Organization>>;
  /**
   * Information to aid in pagination.
   */
  pageInfo: CollectionSegmentInfo;
  totalCount: ScalarsEnums['Int'];
}

export interface ParameterConfig {
  __typename?: 'ParameterConfig';
  etdFormula?: Maybe<ScalarsEnums['EtdFormula']>;
  etdGrain?: Maybe<ScalarsEnums['Int']>;
  iriGrain?: Maybe<ScalarsEnums['Int']>;
  maxEtd?: Maybe<ScalarsEnums['Decimal']>;
  maxIri?: Maybe<ScalarsEnums['Decimal']>;
  maxRut?: Maybe<ScalarsEnums['Decimal']>;
  mpdGrain?: Maybe<ScalarsEnums['Int']>;
  pciDistresses?: Maybe<Array<ScalarsEnums['PciDistress']>>;
  pciGrain?: Maybe<ScalarsEnums['Int']>;
  rutGrain?: Maybe<ScalarsEnums['Int']>;
}

export interface ParametersComputationJob {
  __typename?: 'ParametersComputationJob';
  additionalData?: Maybe<ScalarsEnums['JSON']>;
  assetConfigs: Array<AssetConfig>;
  createdAt: ScalarsEnums['Instant'];
  createdBy?: Maybe<Account>;
  createdById?: Maybe<ScalarsEnums['UUID']>;
  csvFileId?: Maybe<ScalarsEnums['UUID']>;
  events: (args?: {
    skip?: Maybe<ScalarsEnums['Int']>;
    take?: Maybe<ScalarsEnums['Int']>;
  }) => Maybe<EventsCollectionSegment>;
  id: ScalarsEnums['UUID'];
  lastLogs: (args: { count: ScalarsEnums['Int'] }) => Array<Log>;
  logs: Array<Log>;
  mfvDataFileId: ScalarsEnums['UUID'];
  parameterConfig: ParameterConfig;
  parametersZipId?: Maybe<ScalarsEnums['UUID']>;
  projectName?: Maybe<ScalarsEnums['String']>;
  search?: Maybe<ScalarsEnums['String']>;
  status: ScalarsEnums['JobStatus'];
  surveyDate?: Maybe<ScalarsEnums['Instant']>;
  surveyId?: Maybe<ScalarsEnums['UUID']>;
  type: ScalarsEnums['JobType'];
  updatedAt: ScalarsEnums['Instant'];
  updatedBy?: Maybe<Account>;
  updatedById?: Maybe<ScalarsEnums['UUID']>;
}

/**
 * A segment of a collection.
 */
export interface ParametersComputationJobsCollectionSegment {
  __typename?: 'ParametersComputationJobsCollectionSegment';
  /**
   * A flattened list of the items.
   */
  items?: Maybe<Array<ParametersComputationJob>>;
  /**
   * Information to aid in pagination.
   */
  pageInfo: CollectionSegmentInfo;
  totalCount: ScalarsEnums['Int'];
}

export interface Path {
  __typename?: 'Path';
  additionalData?: Maybe<ScalarsEnums['JSON']>;
  assetId: ScalarsEnums['UUID'];
  assetName: ScalarsEnums['String'];
  createdAt: ScalarsEnums['Instant'];
  createdBy?: Maybe<Account>;
  createdById?: Maybe<ScalarsEnums['UUID']>;
  events: (args?: {
    skip?: Maybe<ScalarsEnums['Int']>;
    take?: Maybe<ScalarsEnums['Int']>;
  }) => Maybe<EventsCollectionSegment>;
  geometry?: Maybe<GeoJSONLineStringType>;
  id: ScalarsEnums['UUID'];
  index: ScalarsEnums['Int'];
  isForward: ScalarsEnums['Boolean'];
  items: Array<Item>;
  length: ScalarsEnums['Decimal'];
  media: Array<PathMedia>;
  name: ScalarsEnums['String'];
  offset?: Maybe<ScalarsEnums['Decimal']>;
  points: Array<PointConfig>;
  search?: Maybe<ScalarsEnums['String']>;
  surveys: Array<Survey>;
  updatedAt: ScalarsEnums['Instant'];
  updatedBy?: Maybe<Account>;
  updatedById?: Maybe<ScalarsEnums['UUID']>;
}

export interface PathConfig {
  __typename?: 'PathConfig';
  id?: Maybe<ScalarsEnums['String']>;
  isForward: ScalarsEnums['Boolean'];
  name: ScalarsEnums['String'];
  offset?: Maybe<ScalarsEnums['Decimal']>;
}

export interface PathMedia {
  __typename?: 'PathMedia';
  media: Media;
  mediaId: ScalarsEnums['UUID'];
  offset: ScalarsEnums['Decimal'];
  pathId: ScalarsEnums['UUID'];
}

export interface PathRange {
  __typename?: 'PathRange';
  end: ScalarsEnums['Decimal'];
  start: ScalarsEnums['Decimal'];
}

export interface PathSelection {
  __typename?: 'PathSelection';
  pathId: ScalarsEnums['UUID'];
  ranges?: Maybe<Array<PathRange>>;
}

export interface PointConfig {
  __typename?: 'PointConfig';
  altitude: ScalarsEnums['Decimal'];
  latitude: ScalarsEnums['Decimal'];
  longitude: ScalarsEnums['Decimal'];
  rspId: ScalarsEnums['String'];
  rspIndex: ScalarsEnums['Int'];
  rspStart?: Maybe<ScalarsEnums['Decimal']>;
  toponym: ScalarsEnums['String'];
}

export interface Project {
  __typename?: 'Project';
  additionalData?: Maybe<ScalarsEnums['JSON']>;
  assetsCount: ScalarsEnums['Int'];
  bounds?: Maybe<Bounds>;
  cig?: Maybe<ScalarsEnums['String']>;
  completedSurveysCount: ScalarsEnums['Int'];
  createdAt: ScalarsEnums['Instant'];
  createdBy?: Maybe<Account>;
  createdById?: Maybe<ScalarsEnums['UUID']>;
  cup?: Maybe<ScalarsEnums['String']>;
  email?: Maybe<ScalarsEnums['String']>;
  events: (args?: {
    skip?: Maybe<ScalarsEnums['Int']>;
    take?: Maybe<ScalarsEnums['Int']>;
  }) => Maybe<EventsCollectionSegment>;
  id: ScalarsEnums['UUID'];
  labels: Array<Label>;
  lastSurvey?: Maybe<SurveyInfo>;
  name: ScalarsEnums['String'];
  nextSurvey?: Maybe<SurveyInfo>;
  note?: Maybe<ScalarsEnums['String']>;
  operators: Array<Operator>;
  operatorsCount: ScalarsEnums['Int'];
  organization?: Maybe<Organization>;
  organizationId?: Maybe<ScalarsEnums['UUID']>;
  pciCurvesFileId?: Maybe<ScalarsEnums['UUID']>;
  phoneNumber?: Maybe<ScalarsEnums['String']>;
  pointOfContact?: Maybe<ScalarsEnums['String']>;
  projectValue?: Maybe<ScalarsEnums['Float']>;
  search?: Maybe<ScalarsEnums['String']>;
  styles: Array<CustomStyle>;
  surveys: Array<Survey>;
  surveysCount: ScalarsEnums['Int'];
  updatedAt: ScalarsEnums['Instant'];
  updatedBy?: Maybe<Account>;
  updatedById?: Maybe<ScalarsEnums['UUID']>;
}

export interface ProjectConfiguration {
  __typename?: 'ProjectConfiguration';
  additionalData?: Maybe<ScalarsEnums['JSON']>;
  baseCostPerCmMq: ScalarsEnums['Decimal'];
  baseThicknessCm: ScalarsEnums['Decimal'];
  binderCostPerCmMq: ScalarsEnums['Decimal'];
  binderThicknessCm: ScalarsEnums['Decimal'];
  createdAt: ScalarsEnums['Instant'];
  createdBy?: Maybe<Account>;
  createdById?: Maybe<ScalarsEnums['UUID']>;
  events: (args?: {
    skip?: Maybe<ScalarsEnums['Int']>;
    take?: Maybe<ScalarsEnums['Int']>;
  }) => Maybe<EventsCollectionSegment>;
  foundationCostPerCmMq: ScalarsEnums['Decimal'];
  foundationThicknessCm: ScalarsEnums['Decimal'];
  id: ScalarsEnums['UUID'];
  isGlobalConfiguration: ScalarsEnums['Boolean'];
  laneWidth: ScalarsEnums['Decimal'];
  projectId?: Maybe<ScalarsEnums['UUID']>;
  rpPciThreshold: ScalarsEnums['Decimal'];
  rs1PciThreshold: ScalarsEnums['Decimal'];
  rs2PciThreshold: ScalarsEnums['Decimal'];
  rssPciThreshold: ScalarsEnums['Decimal'];
  search?: Maybe<ScalarsEnums['String']>;
  tgm: ScalarsEnums['Tgm'];
  updatedAt: ScalarsEnums['Instant'];
  updatedBy?: Maybe<Account>;
  updatedById?: Maybe<ScalarsEnums['UUID']>;
  wearCostPerCmMq: ScalarsEnums['Decimal'];
  wearThicknessCm: ScalarsEnums['Decimal'];
}

/**
 * A segment of a collection.
 */
export interface ProjectConfigurationsCollectionSegment {
  __typename?: 'ProjectConfigurationsCollectionSegment';
  /**
   * A flattened list of the items.
   */
  items?: Maybe<Array<ProjectConfiguration>>;
  /**
   * Information to aid in pagination.
   */
  pageInfo: CollectionSegmentInfo;
  totalCount: ScalarsEnums['Int'];
}

/**
 * A segment of a collection.
 */
export interface ProjectsCollectionSegment {
  __typename?: 'ProjectsCollectionSegment';
  /**
   * A flattened list of the items.
   */
  items?: Maybe<Array<Project>>;
  /**
   * Information to aid in pagination.
   */
  pageInfo: CollectionSegmentInfo;
  totalCount: ScalarsEnums['Int'];
}

export interface Report {
  __typename?: 'Report';
  additionalData?: Maybe<ScalarsEnums['JSON']>;
  createdAt: ScalarsEnums['Instant'];
  createdBy?: Maybe<Account>;
  createdById?: Maybe<ScalarsEnums['UUID']>;
  events: (args?: {
    skip?: Maybe<ScalarsEnums['Int']>;
    take?: Maybe<ScalarsEnums['Int']>;
  }) => Maybe<EventsCollectionSegment>;
  id: ScalarsEnums['UUID'];
  labels: Array<Label>;
  name: ScalarsEnums['String'];
  pdfFile?: Maybe<Blob>;
  pdfFileId?: Maybe<ScalarsEnums['UUID']>;
  projectId: ScalarsEnums['UUID'];
  search?: Maybe<ScalarsEnums['String']>;
  status: ScalarsEnums['ReportStatus'];
  surveyId: ScalarsEnums['UUID'];
  surveyName: ScalarsEnums['String'];
  updatedAt: ScalarsEnums['Instant'];
  updatedBy?: Maybe<Account>;
  updatedById?: Maybe<ScalarsEnums['UUID']>;
}

export interface ReportGenerationJob {
  __typename?: 'ReportGenerationJob';
  additionalData?: Maybe<ScalarsEnums['JSON']>;
  createdAt: ScalarsEnums['Instant'];
  createdBy?: Maybe<Account>;
  createdById?: Maybe<ScalarsEnums['UUID']>;
  events: (args?: {
    skip?: Maybe<ScalarsEnums['Int']>;
    take?: Maybe<ScalarsEnums['Int']>;
  }) => Maybe<EventsCollectionSegment>;
  id: ScalarsEnums['UUID'];
  interventions: Array<Intervention>;
  lastLogs: (args: { count: ScalarsEnums['Int'] }) => Array<Log>;
  logs: Array<Log>;
  projectName?: Maybe<ScalarsEnums['String']>;
  reportName: ScalarsEnums['String'];
  reportType: ScalarsEnums['ReportType'];
  search?: Maybe<ScalarsEnums['String']>;
  sectionsSelection: Array<ScalarsEnums['String']>;
  selections: Array<AssetSelection>;
  status: ScalarsEnums['JobStatus'];
  surveyId?: Maybe<ScalarsEnums['UUID']>;
  type: ScalarsEnums['JobType'];
  updatedAt: ScalarsEnums['Instant'];
  updatedBy?: Maybe<Account>;
  updatedById?: Maybe<ScalarsEnums['UUID']>;
}

/**
 * A segment of a collection.
 */
export interface ReportGenerationJobsCollectionSegment {
  __typename?: 'ReportGenerationJobsCollectionSegment';
  /**
   * A flattened list of the items.
   */
  items?: Maybe<Array<ReportGenerationJob>>;
  /**
   * Information to aid in pagination.
   */
  pageInfo: CollectionSegmentInfo;
  totalCount: ScalarsEnums['Int'];
}

/**
 * A segment of a collection.
 */
export interface ReportsCollectionSegment {
  __typename?: 'ReportsCollectionSegment';
  /**
   * A flattened list of the items.
   */
  items?: Maybe<Array<Report>>;
  /**
   * Information to aid in pagination.
   */
  pageInfo: CollectionSegmentInfo;
  totalCount: ScalarsEnums['Int'];
}

export interface ResendAccountInvitationError {
  __typename?: 'ConflictError' | 'NotFoundError' | 'UnauthorizedError';
  $on: $ResendAccountInvitationError;
}

export interface ResendAccountInvitationPayload {
  __typename?: 'ResendAccountInvitationPayload';
  account?: Maybe<Account>;
  errors?: Maybe<Array<ResendAccountInvitationError>>;
}

export interface SelectionLabelCount {
  __typename?: 'SelectionLabelCount';
  itemCount: ScalarsEnums['Int'];
  labelId: ScalarsEnums['UUID'];
}

export interface SelectionLabelStates {
  __typename?: 'SelectionLabelStates';
  labels: Array<SelectionLabelCount>;
  totalItems: ScalarsEnums['Int'];
}

export interface SetOperatorProjectsError {
  __typename?: 'NotFoundError';
  $on: $SetOperatorProjectsError;
}

export interface SetOperatorProjectsPayload {
  __typename?: 'SetOperatorProjectsPayload';
  errors?: Maybe<Array<SetOperatorProjectsError>>;
  operator?: Maybe<Operator>;
}

export interface StopJobError {
  __typename?: 'NotFoundError';
  $on: $StopJobError;
}

export interface StopJobPayload {
  __typename?: 'StopJobPayload';
  boolean?: Maybe<ScalarsEnums['Boolean']>;
  errors?: Maybe<Array<StopJobError>>;
}

export interface Survey {
  __typename?: 'Survey';
  additionalData?: Maybe<ScalarsEnums['JSON']>;
  backgroundJobs: Array<BackgroundJob>;
  createdAt: ScalarsEnums['Instant'];
  createdBy?: Maybe<Account>;
  createdById?: Maybe<ScalarsEnums['UUID']>;
  endDate: ScalarsEnums['LocalDate'];
  events: (args?: {
    skip?: Maybe<ScalarsEnums['Int']>;
    take?: Maybe<ScalarsEnums['Int']>;
  }) => Maybe<EventsCollectionSegment>;
  id: ScalarsEnums['UUID'];
  labels: Array<Label>;
  maxTileZoom?: Maybe<ScalarsEnums['Int']>;
  minTileZoom?: Maybe<ScalarsEnums['Int']>;
  name: ScalarsEnums['String'];
  projectId: ScalarsEnums['UUID'];
  search?: Maybe<ScalarsEnums['String']>;
  startDate: ScalarsEnums['LocalDate'];
  status: ScalarsEnums['SurveyStatus'];
  surveyDate?: Maybe<ScalarsEnums['Instant']>;
  updatedAt: ScalarsEnums['Instant'];
  updatedBy?: Maybe<Account>;
  updatedById?: Maybe<ScalarsEnums['UUID']>;
}

export interface SurveyDataBulkUploadJob {
  __typename?: 'SurveyDataBulkUploadJob';
  additionalData?: Maybe<ScalarsEnums['JSON']>;
  createdAt: ScalarsEnums['Instant'];
  createdBy?: Maybe<Account>;
  createdById?: Maybe<ScalarsEnums['UUID']>;
  csvFileId: ScalarsEnums['UUID'];
  events: (args?: {
    skip?: Maybe<ScalarsEnums['Int']>;
    take?: Maybe<ScalarsEnums['Int']>;
  }) => Maybe<EventsCollectionSegment>;
  id: ScalarsEnums['UUID'];
  lastLogs: (args: { count: ScalarsEnums['Int'] }) => Array<Log>;
  logs: Array<Log>;
  projectName?: Maybe<ScalarsEnums['String']>;
  search?: Maybe<ScalarsEnums['String']>;
  status: ScalarsEnums['JobStatus'];
  surveyId?: Maybe<ScalarsEnums['UUID']>;
  type: ScalarsEnums['JobType'];
  updatedAt: ScalarsEnums['Instant'];
  updatedBy?: Maybe<Account>;
  updatedById?: Maybe<ScalarsEnums['UUID']>;
}

/**
 * A segment of a collection.
 */
export interface SurveyDataBulkUploadJobsCollectionSegment {
  __typename?: 'SurveyDataBulkUploadJobsCollectionSegment';
  /**
   * A flattened list of the items.
   */
  items?: Maybe<Array<SurveyDataBulkUploadJob>>;
  /**
   * Information to aid in pagination.
   */
  pageInfo: CollectionSegmentInfo;
  totalCount: ScalarsEnums['Int'];
}

export interface SurveyDataDeletionJob {
  __typename?: 'SurveyDataDeletionJob';
  additionalData?: Maybe<ScalarsEnums['JSON']>;
  createdAt: ScalarsEnums['Instant'];
  createdBy?: Maybe<Account>;
  createdById?: Maybe<ScalarsEnums['UUID']>;
  events: (args?: {
    skip?: Maybe<ScalarsEnums['Int']>;
    take?: Maybe<ScalarsEnums['Int']>;
  }) => Maybe<EventsCollectionSegment>;
  id: ScalarsEnums['UUID'];
  lastLogs: (args: { count: ScalarsEnums['Int'] }) => Array<Log>;
  logs: Array<Log>;
  projectName?: Maybe<ScalarsEnums['String']>;
  search?: Maybe<ScalarsEnums['String']>;
  status: ScalarsEnums['JobStatus'];
  surveyId?: Maybe<ScalarsEnums['UUID']>;
  type: ScalarsEnums['JobType'];
  updatedAt: ScalarsEnums['Instant'];
  updatedBy?: Maybe<Account>;
  updatedById?: Maybe<ScalarsEnums['UUID']>;
}

/**
 * A segment of a collection.
 */
export interface SurveyDataDeletionJobsCollectionSegment {
  __typename?: 'SurveyDataDeletionJobsCollectionSegment';
  /**
   * A flattened list of the items.
   */
  items?: Maybe<Array<SurveyDataDeletionJob>>;
  /**
   * Information to aid in pagination.
   */
  pageInfo: CollectionSegmentInfo;
  totalCount: ScalarsEnums['Int'];
}

export interface SurveyInfo {
  __typename?: 'SurveyInfo';
  endDate: ScalarsEnums['LocalDate'];
  id: ScalarsEnums['UUID'];
  name: ScalarsEnums['String'];
  startDate: ScalarsEnums['LocalDate'];
}

/**
 * A segment of a collection.
 */
export interface SurveysCollectionSegment {
  __typename?: 'SurveysCollectionSegment';
  /**
   * A flattened list of the items.
   */
  items?: Maybe<Array<Survey>>;
  /**
   * Information to aid in pagination.
   */
  pageInfo: CollectionSegmentInfo;
  totalCount: ScalarsEnums['Int'];
}

export interface UnassignProjectError {
  __typename?: 'NotFoundError';
  $on: $UnassignProjectError;
}

export interface UnassignProjectPayload {
  __typename?: 'UnassignProjectPayload';
  errors?: Maybe<Array<UnassignProjectError>>;
  int?: Maybe<ScalarsEnums['Int']>;
}

export interface UnauthorizedError {
  __typename?: 'UnauthorizedError';
  message: ScalarsEnums['String'];
}

export interface UpdateAccountError {
  __typename?: 'NotFoundError';
  $on: $UpdateAccountError;
}

export interface UpdateAccountPayload {
  __typename?: 'UpdateAccountPayload';
  account?: Maybe<Account>;
  errors?: Maybe<Array<UpdateAccountError>>;
}

export interface UpdateAssetError {
  __typename?:
    | 'BadRequestError'
    | 'ConflictError'
    | 'ForbiddenError'
    | 'NotFoundError'
    | 'UnauthorizedError';
  $on: $UpdateAssetError;
}

export interface UpdateAssetPayload {
  __typename?: 'UpdateAssetPayload';
  asset?: Maybe<Asset>;
  errors?: Maybe<Array<UpdateAssetError>>;
}

export interface UpdateBlobError {
  __typename?:
    | 'BadRequestError'
    | 'ConflictError'
    | 'ForbiddenError'
    | 'NotFoundError'
    | 'UnauthorizedError';
  $on: $UpdateBlobError;
}

export interface UpdateBlobPayload {
  __typename?: 'UpdateBlobPayload';
  blob?: Maybe<Blob>;
  errors?: Maybe<Array<UpdateBlobError>>;
}

export interface UpdateCustomStyleError {
  __typename?:
    | 'BadRequestError'
    | 'ConflictError'
    | 'ForbiddenError'
    | 'NotFoundError'
    | 'UnauthorizedError';
  $on: $UpdateCustomStyleError;
}

export interface UpdateCustomStylePayload {
  __typename?: 'UpdateCustomStylePayload';
  customStyle?: Maybe<CustomStyle>;
  errors?: Maybe<Array<UpdateCustomStyleError>>;
}

export interface UpdateGlobalConfigPayload {
  __typename?: 'UpdateGlobalConfigPayload';
  globalConfig?: Maybe<GlobalConfig>;
}

export interface UpdateInterventionError {
  __typename?:
    | 'BadRequestError'
    | 'ConflictError'
    | 'ForbiddenError'
    | 'NotFoundError'
    | 'UnauthorizedError';
  $on: $UpdateInterventionError;
}

export interface UpdateInterventionPayload {
  __typename?: 'UpdateInterventionPayload';
  errors?: Maybe<Array<UpdateInterventionError>>;
  intervention?: Maybe<Intervention>;
}

export interface UpdateLabelError {
  __typename?:
    | 'BadRequestError'
    | 'ConflictError'
    | 'ForbiddenError'
    | 'NotFoundError'
    | 'UnauthorizedError';
  $on: $UpdateLabelError;
}

export interface UpdateLabelPayload {
  __typename?: 'UpdateLabelPayload';
  errors?: Maybe<Array<UpdateLabelError>>;
  label?: Maybe<Label>;
}

export interface UpdateMediaUploadJobError {
  __typename?:
    | 'BadRequestError'
    | 'ConflictError'
    | 'ForbiddenError'
    | 'NotFoundError'
    | 'UnauthorizedError';
  $on: $UpdateMediaUploadJobError;
}

export interface UpdateMediaUploadJobPayload {
  __typename?: 'UpdateMediaUploadJobPayload';
  errors?: Maybe<Array<UpdateMediaUploadJobError>>;
  mediaUploadJob?: Maybe<MediaUploadJob>;
}

export interface UpdateOrganizationError {
  __typename?:
    | 'BadRequestError'
    | 'ConflictError'
    | 'ForbiddenError'
    | 'NotFoundError'
    | 'UnauthorizedError';
  $on: $UpdateOrganizationError;
}

export interface UpdateOrganizationPayload {
  __typename?: 'UpdateOrganizationPayload';
  errors?: Maybe<Array<UpdateOrganizationError>>;
  organization?: Maybe<Organization>;
}

export interface UpdateParametersComputationJobError {
  __typename?:
    | 'BadRequestError'
    | 'ConflictError'
    | 'ForbiddenError'
    | 'NotFoundError'
    | 'UnauthorizedError';
  $on: $UpdateParametersComputationJobError;
}

export interface UpdateParametersComputationJobPayload {
  __typename?: 'UpdateParametersComputationJobPayload';
  errors?: Maybe<Array<UpdateParametersComputationJobError>>;
  parametersComputationJob?: Maybe<ParametersComputationJob>;
}

export interface UpdatePendingAccountEmailError {
  __typename?: 'ConflictError' | 'NotFoundError' | 'UnauthorizedError';
  $on: $UpdatePendingAccountEmailError;
}

export interface UpdatePendingAccountEmailPayload {
  __typename?: 'UpdatePendingAccountEmailPayload';
  account?: Maybe<Account>;
  errors?: Maybe<Array<UpdatePendingAccountEmailError>>;
}

export interface UpdateProjectConfigurationError {
  __typename?:
    | 'BadRequestError'
    | 'ConflictError'
    | 'ForbiddenError'
    | 'NotFoundError'
    | 'UnauthorizedError';
  $on: $UpdateProjectConfigurationError;
}

export interface UpdateProjectConfigurationPayload {
  __typename?: 'UpdateProjectConfigurationPayload';
  errors?: Maybe<Array<UpdateProjectConfigurationError>>;
  projectConfiguration?: Maybe<ProjectConfiguration>;
}

export interface UpdateProjectError {
  __typename?:
    | 'BadRequestError'
    | 'ConflictError'
    | 'ForbiddenError'
    | 'NotFoundError'
    | 'UnauthorizedError';
  $on: $UpdateProjectError;
}

export interface UpdateProjectPayload {
  __typename?: 'UpdateProjectPayload';
  errors?: Maybe<Array<UpdateProjectError>>;
  project?: Maybe<Project>;
}

export interface UpdateReportError {
  __typename?:
    | 'BadRequestError'
    | 'ConflictError'
    | 'ForbiddenError'
    | 'NotFoundError'
    | 'UnauthorizedError';
  $on: $UpdateReportError;
}

export interface UpdateReportPayload {
  __typename?: 'UpdateReportPayload';
  errors?: Maybe<Array<UpdateReportError>>;
  report?: Maybe<Report>;
}

export interface UpdateSurveyError {
  __typename?:
    | 'BadRequestError'
    | 'ConflictError'
    | 'ForbiddenError'
    | 'NotFoundError'
    | 'UnauthorizedError';
  $on: $UpdateSurveyError;
}

export interface UpdateSurveyPayload {
  __typename?: 'UpdateSurveyPayload';
  errors?: Maybe<Array<UpdateSurveyError>>;
  survey?: Maybe<Survey>;
}

export interface UploadBlobError {
  __typename?: 'BadRequestError' | 'UnauthorizedError';
  $on: $UploadBlobError;
}

export interface UploadBlobPayload {
  __typename?: 'UploadBlobPayload';
  blob?: Maybe<Blob>;
  errors?: Maybe<Array<UploadBlobError>>;
}

export interface Mutation {
  __typename?: 'Mutation';
  applyLabelsToSelection: (args: {
    input: ApplyLabelsToSelectionInput;
  }) => ApplyLabelsToSelectionPayload;
  bulkAssignProjectsToOperators: (args: {
    input: BulkAssignProjectsToOperatorsInput;
  }) => BulkAssignProjectsToOperatorsPayload;
  bulkAssignProjectsToOrganization: (args: {
    input: BulkAssignProjectsToOrganizationInput;
  }) => BulkAssignProjectsToOrganizationPayload;
  bulkDeleteAccount: (args: {
    input: BulkDeleteAccountInput;
  }) => BulkDeleteAccountPayload;
  bulkSetAccountStatus: (args: {
    input: BulkSetAccountStatusInput;
  }) => BulkSetAccountStatusPayload;
  bulkSetLabels: (args: { input: BulkSetLabelsInput }) => BulkSetLabelsPayload;
  bulkUnassignOrganizationProjects: (args: {
    input: BulkUnassignOrganizationProjectsInput;
  }) => BulkUnassignOrganizationProjectsPayload;
  cloneProject: (args: { input: CloneProjectInput }) => CloneProjectPayload;
  confirmAccount: (args: {
    input: ConfirmAccountInput;
  }) => ConfirmAccountPayload;
  confirmEmailAddress: (args: {
    input: ConfirmEmailAddressInput;
  }) => ConfirmEmailAddressPayload;
  createApiKey: CreateApiKeyPayload;
  createBlockchainNotarizationJob: (args: {
    input: CreateBlockchainNotarizationJobInput;
  }) => CreateBlockchainNotarizationJobPayload;
  createCustomLayerUploadJob: (args: {
    input: CreateCustomLayerUploadJobInput;
  }) => CreateCustomLayerUploadJobPayload;
  createCustomStyle: (args: {
    input: CreateCustomStyleInput;
  }) => CreateCustomStylePayload;
  createDatasetPreparationJob: (args: {
    input: CreateDatasetPreparationJobInput;
  }) => CreateDatasetPreparationJobPayload;
  createIntervention: (args: {
    input: CreateInterventionInput;
  }) => CreateInterventionPayload;
  createLabel: (args: { input: CreateLabelInput }) => CreateLabelPayload;
  createMediaUploadJob: (args: {
    input: CreateMediaUploadJobInput;
  }) => CreateMediaUploadJobPayload;
  createOrganization: (args: {
    input: CreateOrganizationInput;
  }) => CreateOrganizationPayload;
  createParametersComputationJob: (args: {
    input: CreateParametersComputationJobInput;
  }) => CreateParametersComputationJobPayload;
  createProject: (args: { input: CreateProjectInput }) => CreateProjectPayload;
  createProjectConfiguration: (args: {
    input: CreateProjectConfigurationInput;
  }) => CreateProjectConfigurationPayload;
  createReportGenerationJob: (args: {
    input: CreateReportGenerationJobInput;
  }) => CreateReportGenerationJobPayload;
  createSurvey: (args: { input: CreateSurveyInput }) => CreateSurveyPayload;
  createSurveyDataBulkUploadJob: (args: {
    input: CreateSurveyDataBulkUploadJobInput;
  }) => CreateSurveyDataBulkUploadJobPayload;
  createSurveyDataDeletionJob: (args: {
    input: CreateSurveyDataDeletionJobInput;
  }) => CreateSurveyDataDeletionJobPayload;
  deleteAccount: (args: { input: DeleteAccountInput }) => DeleteAccountPayload;
  deleteApiKey: (args: { input: DeleteApiKeyInput }) => DeleteApiKeyPayload;
  deleteAsset: (args: { input: DeleteAssetInput }) => DeleteAssetPayload;
  deleteBlob: (args: { input: DeleteBlobInput }) => DeleteBlobPayload;
  deleteBlockchainNotarizationJob: (args: {
    input: DeleteBlockchainNotarizationJobInput;
  }) => DeleteBlockchainNotarizationJobPayload;
  deleteCustomLayer: (args: {
    input: DeleteCustomLayerInput;
  }) => DeleteCustomLayerPayload;
  deleteCustomLayerItem: (args: {
    input: DeleteCustomLayerItemInput;
  }) => DeleteCustomLayerItemPayload;
  deleteCustomLayerUploadJob: (args: {
    input: DeleteCustomLayerUploadJobInput;
  }) => DeleteCustomLayerUploadJobPayload;
  deleteCustomStyle: (args: {
    input: DeleteCustomStyleInput;
  }) => DeleteCustomStylePayload;
  deleteDatasetPreparationJob: (args: {
    input: DeleteDatasetPreparationJobInput;
  }) => DeleteDatasetPreparationJobPayload;
  deleteEvent: (args: { input: DeleteEventInput }) => DeleteEventPayload;
  deleteIntervention: (args: {
    input: DeleteInterventionInput;
  }) => DeleteInterventionPayload;
  deleteItem: (args: { input: DeleteItemInput }) => DeleteItemPayload;
  deleteLabel: (args: { input: DeleteLabelInput }) => DeleteLabelPayload;
  deleteMediaUploadJob: (args: {
    input: DeleteMediaUploadJobInput;
  }) => DeleteMediaUploadJobPayload;
  deleteOrganization: (args: {
    input: DeleteOrganizationInput;
  }) => DeleteOrganizationPayload;
  deleteParametersComputationJob: (args: {
    input: DeleteParametersComputationJobInput;
  }) => DeleteParametersComputationJobPayload;
  deletePath: (args: { input: DeletePathInput }) => DeletePathPayload;
  deleteProject: (args: { input: DeleteProjectInput }) => DeleteProjectPayload;
  deleteProjectConfiguration: (args: {
    input: DeleteProjectConfigurationInput;
  }) => DeleteProjectConfigurationPayload;
  deleteReport: (args: { input: DeleteReportInput }) => DeleteReportPayload;
  deleteReportGenerationJob: (args: {
    input: DeleteReportGenerationJobInput;
  }) => DeleteReportGenerationJobPayload;
  deleteSurvey: (args: { input: DeleteSurveyInput }) => DeleteSurveyPayload;
  deleteSurveyDataBulkUploadJob: (args: {
    input: DeleteSurveyDataBulkUploadJobInput;
  }) => DeleteSurveyDataBulkUploadJobPayload;
  deleteSurveyDataDeletionJob: (args: {
    input: DeleteSurveyDataDeletionJobInput;
  }) => DeleteSurveyDataDeletionJobPayload;
  forceDeleteCustomStyle: (args: {
    input: ForceDeleteCustomStyleInput;
  }) => ForceDeleteCustomStylePayload;
  forcePasswordReset: (args: {
    input: ForcePasswordResetInput;
  }) => ForcePasswordResetPayload;
  initUpdateEmailAddress: (args: {
    input: InitUpdateEmailAddressInput;
  }) => InitUpdateEmailAddressPayload;
  inviteNewAccount: (args: {
    input: InviteNewAccountInput;
  }) => InviteNewAccountPayload;
  resendAccountInvitation: (args: {
    input: ResendAccountInvitationInput;
  }) => ResendAccountInvitationPayload;
  setOperatorProjects: (args: {
    input: SetOperatorProjectsInput;
  }) => SetOperatorProjectsPayload;
  stopJob: (args: { input: StopJobInput }) => StopJobPayload;
  unassignProject: (args: {
    input: UnassignProjectInput;
  }) => UnassignProjectPayload;
  updateAccount: (args: { input: UpdateAccountInput }) => UpdateAccountPayload;
  updateAsset: (args: { input: UpdateAssetInput }) => UpdateAssetPayload;
  updateBlob: (args: { input: UpdateBlobInput }) => UpdateBlobPayload;
  updateCustomStyle: (args: {
    input: UpdateCustomStyleInput;
  }) => UpdateCustomStylePayload;
  updateGlobalConfig: (args: {
    input: UpdateGlobalConfigInput;
  }) => UpdateGlobalConfigPayload;
  updateIntervention: (args: {
    input: UpdateInterventionInput;
  }) => UpdateInterventionPayload;
  updateLabel: (args: { input: UpdateLabelInput }) => UpdateLabelPayload;
  updateMediaUploadJob: (args: {
    input: UpdateMediaUploadJobInput;
  }) => UpdateMediaUploadJobPayload;
  updateOrganization: (args: {
    input: UpdateOrganizationInput;
  }) => UpdateOrganizationPayload;
  updateParametersComputationJob: (args: {
    input: UpdateParametersComputationJobInput;
  }) => UpdateParametersComputationJobPayload;
  updatePendingAccountEmail: (args: {
    input: UpdatePendingAccountEmailInput;
  }) => UpdatePendingAccountEmailPayload;
  updateProject: (args: { input: UpdateProjectInput }) => UpdateProjectPayload;
  updateProjectConfiguration: (args: {
    input: UpdateProjectConfigurationInput;
  }) => UpdateProjectConfigurationPayload;
  updateReport: (args: { input: UpdateReportInput }) => UpdateReportPayload;
  updateSurvey: (args: { input: UpdateSurveyInput }) => UpdateSurveyPayload;
  uploadBlob: (args: { input: UploadBlobInput }) => UploadBlobPayload;
}

export interface Query {
  __typename?: 'Query';
  admin: (args: { id: ScalarsEnums['UUID'] }) => Maybe<Admin>;
  adminOverview: GetAdminOverviewPayload;
  admins: (args?: {
    order?: Maybe<Array<AdminSortInput>>;
    skip?: Maybe<ScalarsEnums['Int']>;
    take?: Maybe<ScalarsEnums['Int']>;
    where?: Maybe<AdminFilterInput>;
  }) => Maybe<AdminsCollectionSegment>;
  apiKey: (args: { id: ScalarsEnums['UUID'] }) => Maybe<ApiKey>;
  apiKeys: (args?: {
    order?: Maybe<Array<ApiKeySortInput>>;
    skip?: Maybe<ScalarsEnums['Int']>;
    take?: Maybe<ScalarsEnums['Int']>;
    where?: Maybe<ApiKeyFilterInput>;
  }) => Maybe<ApiKeysCollectionSegment>;
  asset: (args: { id: ScalarsEnums['UUID'] }) => Maybe<Asset>;
  assets: (args?: {
    order?: Maybe<Array<AssetSortInput>>;
    skip?: Maybe<ScalarsEnums['Int']>;
    take?: Maybe<ScalarsEnums['Int']>;
    where?: Maybe<AssetFilterInput>;
  }) => Maybe<AssetsCollectionSegment>;
  backgroundJobs: (args?: {
    jobStatus?: Maybe<JobStatus>;
    orderDirection?: Maybe<OrderDirection>;
    skip?: Maybe<ScalarsEnums['Int']>;
    surveyId?: Maybe<ScalarsEnums['UUID']>;
    take?: Maybe<ScalarsEnums['Int']>;
  }) => Maybe<BackgroundJobsCollectionSegment>;
  blob: (args: { id: ScalarsEnums['UUID'] }) => Maybe<Blob>;
  blobs: (args?: {
    order?: Maybe<Array<BlobSortInput>>;
    skip?: Maybe<ScalarsEnums['Int']>;
    take?: Maybe<ScalarsEnums['Int']>;
    where?: Maybe<BlobFilterInput>;
  }) => Maybe<BlobsCollectionSegment>;
  blockchainNotarizationJob: (args: {
    id: ScalarsEnums['UUID'];
  }) => Maybe<BlockchainNotarizationJob>;
  blockchainNotarizationJobs: (args?: {
    order?: Maybe<Array<BlockchainNotarizationJobSortInput>>;
    skip?: Maybe<ScalarsEnums['Int']>;
    take?: Maybe<ScalarsEnums['Int']>;
    where?: Maybe<BlockchainNotarizationJobFilterInput>;
  }) => Maybe<BlockchainNotarizationJobsCollectionSegment>;
  customLayer: (args: { id: ScalarsEnums['UUID'] }) => Maybe<CustomLayer>;
  customLayerItem: (args: {
    id: ScalarsEnums['UUID'];
  }) => Maybe<CustomLayerItem>;
  customLayerItems: (args?: {
    order?: Maybe<Array<CustomLayerItemSortInput>>;
    skip?: Maybe<ScalarsEnums['Int']>;
    take?: Maybe<ScalarsEnums['Int']>;
    where?: Maybe<CustomLayerItemFilterInput>;
  }) => Maybe<CustomLayerItemsCollectionSegment>;
  customLayerUploadJob: (args: {
    id: ScalarsEnums['UUID'];
  }) => Maybe<CustomLayerUploadJob>;
  customLayerUploadJobs: (args?: {
    order?: Maybe<Array<CustomLayerUploadJobSortInput>>;
    skip?: Maybe<ScalarsEnums['Int']>;
    take?: Maybe<ScalarsEnums['Int']>;
    where?: Maybe<CustomLayerUploadJobFilterInput>;
  }) => Maybe<CustomLayerUploadJobsCollectionSegment>;
  customLayers: (args?: {
    order?: Maybe<Array<CustomLayerSortInput>>;
    skip?: Maybe<ScalarsEnums['Int']>;
    take?: Maybe<ScalarsEnums['Int']>;
    where?: Maybe<CustomLayerFilterInput>;
  }) => Maybe<CustomLayersCollectionSegment>;
  customStyle: (args: { id: ScalarsEnums['UUID'] }) => Maybe<CustomStyle>;
  customStyles: (args?: {
    order?: Maybe<Array<CustomStyleSortInput>>;
    skip?: Maybe<ScalarsEnums['Int']>;
    take?: Maybe<ScalarsEnums['Int']>;
    where?: Maybe<CustomStyleFilterInput>;
  }) => Maybe<CustomStylesCollectionSegment>;
  datasetPreparationJob: (args: {
    id: ScalarsEnums['UUID'];
  }) => Maybe<DatasetPreparationJob>;
  datasetPreparationJobs: (args?: {
    order?: Maybe<Array<DatasetPreparationJobSortInput>>;
    skip?: Maybe<ScalarsEnums['Int']>;
    take?: Maybe<ScalarsEnums['Int']>;
    where?: Maybe<DatasetPreparationJobFilterInput>;
  }) => Maybe<DatasetPreparationJobsCollectionSegment>;
  event: (args: { id: ScalarsEnums['UUID'] }) => Maybe<Event>;
  events: (args?: {
    order?: Maybe<Array<EventSortInput>>;
    skip?: Maybe<ScalarsEnums['Int']>;
    take?: Maybe<ScalarsEnums['Int']>;
    where?: Maybe<EventFilterInput>;
  }) => Maybe<EventsCollectionSegment>;
  globalConfig?: Maybe<GlobalConfig>;
  intervention: (args: { id: ScalarsEnums['UUID'] }) => Maybe<Intervention>;
  interventions: (args?: {
    order?: Maybe<Array<InterventionSortInput>>;
    skip?: Maybe<ScalarsEnums['Int']>;
    take?: Maybe<ScalarsEnums['Int']>;
    where?: Maybe<InterventionFilterInput>;
  }) => Maybe<InterventionsCollectionSegment>;
  invitationByToken: (args: {
    token: ScalarsEnums['String'];
  }) => GetInvitationByTokenPayload;
  item: (args: { id: ScalarsEnums['UUID'] }) => Maybe<Item>;
  items: (args?: {
    order?: Maybe<Array<ItemSortInput>>;
    where?: Maybe<ItemFilterInput>;
  }) => Array<Item>;
  label: (args: { id: ScalarsEnums['UUID'] }) => Maybe<Label>;
  labels: (args?: {
    order?: Maybe<Array<LabelSortInput>>;
    skip?: Maybe<ScalarsEnums['Int']>;
    take?: Maybe<ScalarsEnums['Int']>;
    where?: Maybe<LabelFilterInput>;
  }) => Maybe<LabelsCollectionSegment>;
  me?: Maybe<Account>;
  media: (args: { id: ScalarsEnums['UUID'] }) => Maybe<Media>;
  mediaUploadJob: (args: { id: ScalarsEnums['UUID'] }) => Maybe<MediaUploadJob>;
  mediaUploadJobs: (args?: {
    order?: Maybe<Array<MediaUploadJobSortInput>>;
    skip?: Maybe<ScalarsEnums['Int']>;
    take?: Maybe<ScalarsEnums['Int']>;
    where?: Maybe<MediaUploadJobFilterInput>;
  }) => Maybe<MediaUploadJobsCollectionSegment>;
  medias: (args?: {
    order?: Maybe<Array<MediaSortInput>>;
    where?: Maybe<MediaFilterInput>;
  }) => Array<Media>;
  notarization: (args: { id: ScalarsEnums['UUID'] }) => Maybe<Notarization>;
  notarizations: (args?: {
    order?: Maybe<Array<NotarizationSortInput>>;
    skip?: Maybe<ScalarsEnums['Int']>;
    take?: Maybe<ScalarsEnums['Int']>;
    where?: Maybe<NotarizationFilterInput>;
  }) => Maybe<NotarizationsCollectionSegment>;
  operator: (args: { id: ScalarsEnums['UUID'] }) => Maybe<Operator>;
  operatorOverview: GetOperatorOverviewPayload;
  operators: (args?: {
    order?: Maybe<Array<OperatorSortInput>>;
    skip?: Maybe<ScalarsEnums['Int']>;
    take?: Maybe<ScalarsEnums['Int']>;
    where?: Maybe<OperatorFilterInput>;
  }) => Maybe<OperatorsCollectionSegment>;
  organization: (args: { id: ScalarsEnums['UUID'] }) => Maybe<Organization>;
  organizations: (args?: {
    order?: Maybe<Array<OrganizationSortInput>>;
    skip?: Maybe<ScalarsEnums['Int']>;
    take?: Maybe<ScalarsEnums['Int']>;
    where?: Maybe<OrganizationFilterInput>;
  }) => Maybe<OrganizationsCollectionSegment>;
  parametersComputationJob: (args: {
    id: ScalarsEnums['UUID'];
  }) => Maybe<ParametersComputationJob>;
  parametersComputationJobs: (args?: {
    order?: Maybe<Array<ParametersComputationJobSortInput>>;
    skip?: Maybe<ScalarsEnums['Int']>;
    take?: Maybe<ScalarsEnums['Int']>;
    where?: Maybe<ParametersComputationJobFilterInput>;
  }) => Maybe<ParametersComputationJobsCollectionSegment>;
  path: (args: { id: ScalarsEnums['UUID'] }) => Maybe<Path>;
  pathMedia: (args: { id: ScalarsEnums['UUID'] }) => Maybe<PathMedia>;
  pathMedias: (args?: {
    order?: Maybe<Array<PathMediaSortInput>>;
    where?: Maybe<PathMediaFilterInput>;
  }) => Array<PathMedia>;
  paths: (args?: {
    order?: Maybe<Array<PathSortInput>>;
    tolerance?: Maybe<ScalarsEnums['Float']>;
    where?: Maybe<PathFilterInput>;
  }) => Array<Path>;
  project: (args: { id: ScalarsEnums['UUID'] }) => Maybe<Project>;
  projectConfiguration: (args: {
    id: ScalarsEnums['UUID'];
  }) => Maybe<ProjectConfiguration>;
  projectConfigurations: (args?: {
    order?: Maybe<Array<ProjectConfigurationSortInput>>;
    skip?: Maybe<ScalarsEnums['Int']>;
    take?: Maybe<ScalarsEnums['Int']>;
    where?: Maybe<ProjectConfigurationFilterInput>;
  }) => Maybe<ProjectConfigurationsCollectionSegment>;
  projects: (args?: {
    order?: Maybe<Array<ProjectSortInput>>;
    skip?: Maybe<ScalarsEnums['Int']>;
    take?: Maybe<ScalarsEnums['Int']>;
    where?: Maybe<ProjectFilterInput>;
  }) => Maybe<ProjectsCollectionSegment>;
  report: (args: { id: ScalarsEnums['UUID'] }) => Maybe<Report>;
  reportGenerationJob: (args: {
    id: ScalarsEnums['UUID'];
  }) => Maybe<ReportGenerationJob>;
  reportGenerationJobs: (args?: {
    order?: Maybe<Array<ReportGenerationJobSortInput>>;
    skip?: Maybe<ScalarsEnums['Int']>;
    take?: Maybe<ScalarsEnums['Int']>;
    where?: Maybe<ReportGenerationJobFilterInput>;
  }) => Maybe<ReportGenerationJobsCollectionSegment>;
  reports: (args?: {
    order?: Maybe<Array<ReportSortInput>>;
    skip?: Maybe<ScalarsEnums['Int']>;
    take?: Maybe<ScalarsEnums['Int']>;
    where?: Maybe<ReportFilterInput>;
  }) => Maybe<ReportsCollectionSegment>;
  selectionEstimatedCost: (args: {
    assetSelections: Array<AssetSelectionInput>;
    surveyId: ScalarsEnums['UUID'];
  }) => ScalarsEnums['Decimal'];
  selectionLabelStates: (args: {
    assetSelections: Array<AssetSelectionInput>;
    surveyId: ScalarsEnums['UUID'];
  }) => SelectionLabelStates;
  survey: (args: { id: ScalarsEnums['UUID'] }) => Maybe<Survey>;
  surveyDataBulkUploadJob: (args: {
    id: ScalarsEnums['UUID'];
  }) => Maybe<SurveyDataBulkUploadJob>;
  surveyDataBulkUploadJobs: (args?: {
    order?: Maybe<Array<SurveyDataBulkUploadJobSortInput>>;
    skip?: Maybe<ScalarsEnums['Int']>;
    take?: Maybe<ScalarsEnums['Int']>;
    where?: Maybe<SurveyDataBulkUploadJobFilterInput>;
  }) => Maybe<SurveyDataBulkUploadJobsCollectionSegment>;
  surveyDataDeletionJob: (args: {
    id: ScalarsEnums['UUID'];
  }) => Maybe<SurveyDataDeletionJob>;
  surveyDataDeletionJobs: (args?: {
    order?: Maybe<Array<SurveyDataDeletionJobSortInput>>;
    skip?: Maybe<ScalarsEnums['Int']>;
    take?: Maybe<ScalarsEnums['Int']>;
    where?: Maybe<SurveyDataDeletionJobFilterInput>;
  }) => Maybe<SurveyDataDeletionJobsCollectionSegment>;
  surveys: (args?: {
    order?: Maybe<Array<SurveySortInput>>;
    skip?: Maybe<ScalarsEnums['Int']>;
    take?: Maybe<ScalarsEnums['Int']>;
    where?: Maybe<SurveyFilterInput>;
  }) => Maybe<SurveysCollectionSegment>;
}

export interface Subscription {
  __typename?: 'Subscription';
  logs: (args: { loggableId: ScalarsEnums['String'] }) => Log;
  onEvent: (args?: {
    targetId?: Maybe<ScalarsEnums['UUID']>;
    targetType?: Maybe<ScalarsEnums['String']>;
    type?: Maybe<ScalarsEnums['String']>;
  }) => Event;
}

export interface $ApplyLabelsToSelectionError {
  BadRequestError?: BadRequestError;
  ForbiddenError?: ForbiddenError;
  NotFoundError?: NotFoundError;
}

export interface $BulkAssignProjectsToOperatorsError {
  NotFoundError?: NotFoundError;
}

export interface $BulkAssignProjectsToOrganizationError {
  NotFoundError?: NotFoundError;
}

export interface $BulkSetLabelsError {
  BadRequestError?: BadRequestError;
  ConflictError?: ConflictError;
  ForbiddenError?: ForbiddenError;
  NotFoundError?: NotFoundError;
}

export interface $BulkUnassignOrganizationProjectsError {
  NotFoundError?: NotFoundError;
}

export interface $CloneProjectError {
  NotFoundError?: NotFoundError;
}

export interface $ConfirmAccountError {
  UnauthorizedError?: UnauthorizedError;
}

export interface $ConfirmEmailAddressError {
  ConflictError?: ConflictError;
  ForbiddenError?: ForbiddenError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $CreateApiKeyError {
  NotFoundError?: NotFoundError;
}

export interface $CreateBlockchainNotarizationJobError {
  BadRequestError?: BadRequestError;
  ConflictError?: ConflictError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $CreateCustomLayerUploadJobError {
  BadRequestError?: BadRequestError;
  ConflictError?: ConflictError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $CreateCustomStyleError {
  BadRequestError?: BadRequestError;
  ConflictError?: ConflictError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $CreateDatasetPreparationJobError {
  BadRequestError?: BadRequestError;
  ConflictError?: ConflictError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $CreateInterventionError {
  BadRequestError?: BadRequestError;
  ConflictError?: ConflictError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $CreateLabelError {
  BadRequestError?: BadRequestError;
  ConflictError?: ConflictError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $CreateMediaUploadJobError {
  BadRequestError?: BadRequestError;
  ConflictError?: ConflictError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $CreateOrganizationError {
  BadRequestError?: BadRequestError;
  ConflictError?: ConflictError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $CreateParametersComputationJobError {
  BadRequestError?: BadRequestError;
  ConflictError?: ConflictError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $CreateProjectConfigurationError {
  BadRequestError?: BadRequestError;
  ConflictError?: ConflictError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $CreateProjectError {
  BadRequestError?: BadRequestError;
  ConflictError?: ConflictError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $CreateReportGenerationJobError {
  BadRequestError?: BadRequestError;
  ConflictError?: ConflictError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $CreateSurveyDataBulkUploadJobError {
  BadRequestError?: BadRequestError;
  ConflictError?: ConflictError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $CreateSurveyDataDeletionJobError {
  BadRequestError?: BadRequestError;
  ConflictError?: ConflictError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $CreateSurveyError {
  BadRequestError?: BadRequestError;
  ConflictError?: ConflictError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $DeleteAccountError {
  NotFoundError?: NotFoundError;
}

export interface $DeleteApiKeyError {
  NotFoundError?: NotFoundError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $DeleteAssetError {
  NotFoundError?: NotFoundError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $DeleteBlobError {
  NotFoundError?: NotFoundError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $DeleteBlockchainNotarizationJobError {
  NotFoundError?: NotFoundError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $DeleteCustomLayerError {
  NotFoundError?: NotFoundError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $DeleteCustomLayerItemError {
  NotFoundError?: NotFoundError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $DeleteCustomLayerUploadJobError {
  NotFoundError?: NotFoundError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $DeleteCustomStyleError {
  NotFoundError?: NotFoundError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $DeleteDatasetPreparationJobError {
  NotFoundError?: NotFoundError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $DeleteEventError {
  NotFoundError?: NotFoundError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $DeleteInterventionError {
  NotFoundError?: NotFoundError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $DeleteItemError {
  NotFoundError?: NotFoundError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $DeleteLabelError {
  NotFoundError?: NotFoundError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $DeleteMediaUploadJobError {
  NotFoundError?: NotFoundError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $DeleteOrganizationError {
  NotFoundError?: NotFoundError;
}

export interface $DeleteParametersComputationJobError {
  NotFoundError?: NotFoundError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $DeletePathError {
  NotFoundError?: NotFoundError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $DeleteProjectConfigurationError {
  NotFoundError?: NotFoundError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $DeleteProjectError {
  NotFoundError?: NotFoundError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $DeleteReportError {
  NotFoundError?: NotFoundError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $DeleteReportGenerationJobError {
  NotFoundError?: NotFoundError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $DeleteSurveyDataBulkUploadJobError {
  NotFoundError?: NotFoundError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $DeleteSurveyDataDeletionJobError {
  NotFoundError?: NotFoundError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $DeleteSurveyError {
  NotFoundError?: NotFoundError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $Error {
  BadRequestError?: BadRequestError;
  ConflictError?: ConflictError;
  ForbiddenError?: ForbiddenError;
  NotFoundError?: NotFoundError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $ForcePasswordResetError {
  NotFoundError?: NotFoundError;
}

export interface $GeoJSONInterface {
  GeoJSONLineStringType?: GeoJSONLineStringType;
  GeoJSONMultiLineStringType?: GeoJSONMultiLineStringType;
  GeoJSONMultiPointType?: GeoJSONMultiPointType;
  GeoJSONMultiPolygonType?: GeoJSONMultiPolygonType;
  GeoJSONPointType?: GeoJSONPointType;
  GeoJSONPolygonType?: GeoJSONPolygonType;
}

export interface $IBackgroundJob {
  BackgroundJob?: BackgroundJob;
  BlockchainNotarizationJob?: BlockchainNotarizationJob;
  CustomLayerUploadJob?: CustomLayerUploadJob;
  DatasetPreparationJob?: DatasetPreparationJob;
  MediaUploadJob?: MediaUploadJob;
  ParametersComputationJob?: ParametersComputationJob;
  ReportGenerationJob?: ReportGenerationJob;
  SurveyDataBulkUploadJob?: SurveyDataBulkUploadJob;
  SurveyDataDeletionJob?: SurveyDataDeletionJob;
}

export interface $InitUpdateEmailAddressError {
  ConflictError?: ConflictError;
  NotFoundError?: NotFoundError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $InviteNewAccountError {
  ConflictError?: ConflictError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $ResendAccountInvitationError {
  ConflictError?: ConflictError;
  NotFoundError?: NotFoundError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $SetOperatorProjectsError {
  NotFoundError?: NotFoundError;
}

export interface $StopJobError {
  NotFoundError?: NotFoundError;
}

export interface $UnassignProjectError {
  NotFoundError?: NotFoundError;
}

export interface $UpdateAccountError {
  NotFoundError?: NotFoundError;
}

export interface $UpdateAssetError {
  BadRequestError?: BadRequestError;
  ConflictError?: ConflictError;
  ForbiddenError?: ForbiddenError;
  NotFoundError?: NotFoundError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $UpdateBlobError {
  BadRequestError?: BadRequestError;
  ConflictError?: ConflictError;
  ForbiddenError?: ForbiddenError;
  NotFoundError?: NotFoundError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $UpdateCustomStyleError {
  BadRequestError?: BadRequestError;
  ConflictError?: ConflictError;
  ForbiddenError?: ForbiddenError;
  NotFoundError?: NotFoundError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $UpdateInterventionError {
  BadRequestError?: BadRequestError;
  ConflictError?: ConflictError;
  ForbiddenError?: ForbiddenError;
  NotFoundError?: NotFoundError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $UpdateLabelError {
  BadRequestError?: BadRequestError;
  ConflictError?: ConflictError;
  ForbiddenError?: ForbiddenError;
  NotFoundError?: NotFoundError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $UpdateMediaUploadJobError {
  BadRequestError?: BadRequestError;
  ConflictError?: ConflictError;
  ForbiddenError?: ForbiddenError;
  NotFoundError?: NotFoundError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $UpdateOrganizationError {
  BadRequestError?: BadRequestError;
  ConflictError?: ConflictError;
  ForbiddenError?: ForbiddenError;
  NotFoundError?: NotFoundError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $UpdateParametersComputationJobError {
  BadRequestError?: BadRequestError;
  ConflictError?: ConflictError;
  ForbiddenError?: ForbiddenError;
  NotFoundError?: NotFoundError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $UpdatePendingAccountEmailError {
  ConflictError?: ConflictError;
  NotFoundError?: NotFoundError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $UpdateProjectConfigurationError {
  BadRequestError?: BadRequestError;
  ConflictError?: ConflictError;
  ForbiddenError?: ForbiddenError;
  NotFoundError?: NotFoundError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $UpdateProjectError {
  BadRequestError?: BadRequestError;
  ConflictError?: ConflictError;
  ForbiddenError?: ForbiddenError;
  NotFoundError?: NotFoundError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $UpdateReportError {
  BadRequestError?: BadRequestError;
  ConflictError?: ConflictError;
  ForbiddenError?: ForbiddenError;
  NotFoundError?: NotFoundError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $UpdateSurveyError {
  BadRequestError?: BadRequestError;
  ConflictError?: ConflictError;
  ForbiddenError?: ForbiddenError;
  NotFoundError?: NotFoundError;
  UnauthorizedError?: UnauthorizedError;
}

export interface $UploadBlobError {
  BadRequestError?: BadRequestError;
  UnauthorizedError?: UnauthorizedError;
}

export interface GeneratedSchema {
  query: Query;
  mutation: Mutation;
  subscription: Subscription;
}

export type ScalarsEnums = {
  [Key in keyof Scalars]: Scalars[Key] extends { output: unknown }
    ? Scalars[Key]['output']
    : never;
} & {
  AccountStatus: AccountStatus;
  ApplyPolicy: ApplyPolicy;
  Dimension: Dimension;
  EtdFormula: EtdFormula;
  GeoJSONGeometryType: GeoJSONGeometryType;
  InterventionCategory: InterventionCategory;
  InterventionStatus: InterventionStatus;
  JobStatus: JobStatus;
  JobType: JobType;
  JsonValueKind: JsonValueKind;
  LogSeverity: LogSeverity;
  MediaType: MediaType;
  OgcGeometryType: OgcGeometryType;
  OrderDirection: OrderDirection;
  OrganizationStatus: OrganizationStatus;
  Parameter: Parameter;
  PciDistress: PciDistress;
  ReportStatus: ReportStatus;
  ReportType: ReportType;
  RoleName: RoleName;
  SortEnumType: SortEnumType;
  SurveyStatus: SurveyStatus;
  Tgm: Tgm;
};
